@charset "UTF-8";

/* fakecss:/home/forge/node_modules/.pnpm/svelte-select@4.4.7/node_modules/svelte-select/src/Item.esbuild-svelte-fake-css */
.item.svelte-3e0qet {
  cursor: default;
  height: var(--height, 42px);
  line-height: var(--height, 42px);
  padding: var(--itemPadding, 0 20px);
  color: var(--itemColor, inherit);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.groupHeader.svelte-3e0qet {
  text-transform: var(--groupTitleTextTransform, uppercase);
}
.groupItem.svelte-3e0qet {
  padding-left: var(--groupItemPaddingLeft, 40px);
}
.item.svelte-3e0qet:active {
  background: var(--itemActiveBackground, #b9daff);
}
.item.active.svelte-3e0qet {
  background: var(--itemIsActiveBG, #007aff);
  color: var(--itemIsActiveColor, #fff);
}
.item.notSelectable.svelte-3e0qet {
  color: var(--itemIsNotSelectableColor, #999);
}
.item.first.svelte-3e0qet {
  border-radius: var(--itemFirstBorderRadius, 4px 4px 0 0);
}
.item.hover.svelte-3e0qet:not(.active) {
  background: var(--itemHoverBG, #e7f2ff);
  color: var(--itemHoverColor, inherit);
}

/* fakecss:/home/forge/node_modules/.pnpm/svelte-select@4.4.7/node_modules/svelte-select/src/List.esbuild-svelte-fake-css */
.listContainer.svelte-1uyqfml {
  box-shadow: var(--listShadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));
  border-radius: var(--listBorderRadius, 4px);
  max-height: var(--listMaxHeight, 250px);
  overflow-y: auto;
  background: var(--listBackground, #fff);
  border: var(--listBorder, none);
  position: var(--listPosition, absolute);
  z-index: var(--listZIndex, 2);
  width: 100%;
  left: var(--listLeft, 0);
  right: var(--listRight, 0);
}
.virtualList.svelte-1uyqfml {
  height: var(--virtualListHeight, 200px);
}
.listGroupTitle.svelte-1uyqfml {
  color: var(--groupTitleColor, #8f8f8f);
  cursor: default;
  font-size: var(--groupTitleFontSize, 12px);
  font-weight: var(--groupTitleFontWeight, 600);
  height: var(--height, 42px);
  line-height: var(--height, 42px);
  padding: var(--groupTitlePadding, 0 20px);
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  text-transform: var(--groupTitleTextTransform, uppercase);
}
.empty.svelte-1uyqfml {
  text-align: var(--listEmptyTextAlign, center);
  padding: var(--listEmptyPadding, 20px 0);
  color: var(--listEmptyColor, #78848f);
}

/* fakecss:/home/forge/node_modules/.pnpm/svelte-select@4.4.7/node_modules/svelte-select/src/Selection.esbuild-svelte-fake-css */
.selection.svelte-pu1q1n {
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}

/* fakecss:/home/forge/node_modules/.pnpm/svelte-select@4.4.7/node_modules/svelte-select/src/MultiSelection.esbuild-svelte-fake-css */
.multiSelectItem.svelte-liu9pa.svelte-liu9pa {
  background: var(--multiItemBG, #ebedef);
  margin: var(--multiItemMargin, 5px 5px 0 0);
  border-radius: var(--multiItemBorderRadius, 16px);
  height: var(--multiItemHeight, 32px);
  line-height: var(--multiItemHeight, 32px);
  display: flex;
  cursor: default;
  padding: var(--multiItemPadding, 0 10px 0 15px);
  max-width: 100%;
}
.multiSelectItem_label.svelte-liu9pa.svelte-liu9pa {
  margin: var(--multiLabelMargin, 0 5px 0 0);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.multiSelectItem.svelte-liu9pa.svelte-liu9pa:hover,
.multiSelectItem.active.svelte-liu9pa.svelte-liu9pa {
  background-color: var(--multiItemActiveBG, #006fff);
  color: var(--multiItemActiveColor, #fff);
}
.multiSelectItem.disabled.svelte-liu9pa.svelte-liu9pa:hover {
  background: var(--multiItemDisabledHoverBg, #ebedef);
  color: var(--multiItemDisabledHoverColor, #c1c6cc);
}
.multiSelectItem_clear.svelte-liu9pa.svelte-liu9pa {
  border-radius: var(--multiClearRadius, 50%);
  background: var(--multiClearBG, #52616f);
  min-width: var(--multiClearWidth, 16px);
  max-width: var(--multiClearWidth, 16px);
  height: var(--multiClearHeight, 16px);
  position: relative;
  top: var(--multiClearTop, 8px);
  text-align: var(--multiClearTextAlign, center);
  padding: var(--multiClearPadding, 1px);
}
.multiSelectItem_clear.svelte-liu9pa.svelte-liu9pa:hover,
.active.svelte-liu9pa .multiSelectItem_clear.svelte-liu9pa {
  background: var(--multiClearHoverBG, #fff);
}
.multiSelectItem_clear.svelte-liu9pa:hover svg.svelte-liu9pa,
.active.svelte-liu9pa .multiSelectItem_clear svg.svelte-liu9pa {
  fill: var(--multiClearHoverFill, #006fff);
}
.multiSelectItem_clear.svelte-liu9pa svg.svelte-liu9pa {
  fill: var(--multiClearFill, #ebedef);
  vertical-align: top;
}

/* fakecss:/home/forge/node_modules/.pnpm/svelte-select@4.4.7/node_modules/svelte-select/src/VirtualList.esbuild-svelte-fake-css */
svelte-virtual-list-viewport.svelte-g2cagw {
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: block;
}
svelte-virtual-list-contents.svelte-g2cagw,
svelte-virtual-list-row.svelte-g2cagw {
  display: block;
}
svelte-virtual-list-row.svelte-g2cagw {
  overflow: hidden;
}

/* fakecss:/home/forge/node_modules/.pnpm/svelte-select@4.4.7/node_modules/svelte-select/src/Select.esbuild-svelte-fake-css */
.selectContainer.svelte-17l1npl.svelte-17l1npl {
  --internalPadding:0 16px;
  border: var(--border, 1px solid #d8dbdf);
  border-radius: var(--borderRadius, 3px);
  box-sizing: border-box;
  height: var(--height, 42px);
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--padding, var(--internalPadding));
  background: var(--background, #fff);
  margin: var(--margin, 0);
}
.selectContainer.svelte-17l1npl input.svelte-17l1npl {
  cursor: default;
  border: none;
  color: var(--inputColor, #3f4f5f);
  height: var(--height, 42px);
  line-height: var(--height, 42px);
  padding: var(--inputPadding, var(--padding, var(--internalPadding)));
  width: 100%;
  background: transparent;
  font-size: var(--inputFontSize, 14px);
  letter-spacing: var(--inputLetterSpacing, -0.08px);
  position: absolute;
  left: var(--inputLeft, 0);
  margin: var(--inputMargin, 0);
}
.selectContainer.svelte-17l1npl input.svelte-17l1npl::placeholder {
  color: var(--placeholderColor, #78848f);
  opacity: var(--placeholderOpacity, 1);
}
.selectContainer.svelte-17l1npl input.svelte-17l1npl:focus {
  outline: none;
}
.selectContainer.svelte-17l1npl.svelte-17l1npl:hover {
  border-color: var(--borderHoverColor, #b2b8bf);
}
.selectContainer.focused.svelte-17l1npl.svelte-17l1npl {
  border-color: var(--borderFocusColor, #006fe8);
}
.selectContainer.disabled.svelte-17l1npl.svelte-17l1npl {
  background: var(--disabledBackground, #ebedef);
  border-color: var(--disabledBorderColor, #ebedef);
  color: var(--disabledColor, #c1c6cc);
}
.selectContainer.disabled.svelte-17l1npl input.svelte-17l1npl::placeholder {
  color: var(--disabledPlaceholderColor, #c1c6cc);
  opacity: var(--disabledPlaceholderOpacity, 1);
}
.selectedItem.svelte-17l1npl.svelte-17l1npl {
  line-height: var(--height, 42px);
  height: var(--height, 42px);
  overflow-x: hidden;
  padding: var(--selectedItemPadding, 0 20px 0 0);
}
.selectedItem.svelte-17l1npl.svelte-17l1npl:focus {
  outline: none;
}
.clearSelect.svelte-17l1npl.svelte-17l1npl {
  position: absolute;
  right: var(--clearSelectRight, 10px);
  top: var(--clearSelectTop, 11px);
  bottom: var(--clearSelectBottom, 11px);
  width: var(--clearSelectWidth, 20px);
  color: var(--clearSelectColor, #c5cacf);
  flex: none !important;
}
.clearSelect.svelte-17l1npl.svelte-17l1npl:hover {
  color: var(--clearSelectHoverColor, #2c3e50);
}
.selectContainer.focused.svelte-17l1npl .clearSelect.svelte-17l1npl {
  color: var(--clearSelectFocusColor, #3f4f5f);
}
.indicator.svelte-17l1npl.svelte-17l1npl {
  position: absolute;
  right: var(--indicatorRight, 10px);
  top: var(--indicatorTop, 11px);
  width: var(--indicatorWidth, 20px);
  height: var(--indicatorHeight, 20px);
  color: var(--indicatorColor, #c5cacf);
}
.indicator.svelte-17l1npl svg.svelte-17l1npl {
  display: inline-block;
  fill: var(--indicatorFill, currentcolor);
  line-height: 1;
  stroke: var(--indicatorStroke, currentcolor);
  stroke-width: 0;
}
.spinner.svelte-17l1npl.svelte-17l1npl {
  position: absolute;
  right: var(--spinnerRight, 10px);
  top: var(--spinnerLeft, 11px);
  width: var(--spinnerWidth, 20px);
  height: var(--spinnerHeight, 20px);
  color: var(--spinnerColor, #51ce6c);
  animation: svelte-17l1npl-rotate 0.75s linear infinite;
}
.spinner_icon.svelte-17l1npl.svelte-17l1npl {
  display: block;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  -webkit-transform: none;
}
.spinner_path.svelte-17l1npl.svelte-17l1npl {
  stroke-dasharray: 90;
  stroke-linecap: round;
}
.multiSelect.svelte-17l1npl.svelte-17l1npl {
  display: flex;
  padding: var(--multiSelectPadding, 0 35px 0 16px);
  height: auto;
  flex-wrap: wrap;
  align-items: stretch;
}
.multiSelect.svelte-17l1npl > .svelte-17l1npl {
  flex: 1 1 50px;
}
.selectContainer.multiSelect.svelte-17l1npl input.svelte-17l1npl {
  padding: var(--multiSelectInputPadding, 0);
  position: relative;
  margin: var(--multiSelectInputMargin, 0);
}
.hasError.svelte-17l1npl.svelte-17l1npl {
  border: var(--errorBorder, 1px solid #ff2d55);
  background: var(--errorBackground, #fff);
}
.a11yText.svelte-17l1npl.svelte-17l1npl {
  z-index: 9999;
  border: 0px;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  position: absolute;
  overflow: hidden;
  padding: 0px;
  white-space: nowrap;
}
@keyframes svelte-17l1npl-rotate {
  100% {
    transform: rotate(360deg);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Bootstrap/Modal.esbuild-svelte-fake-css */
.modal-content.svelte-1im6aa7 {
  max-height: 100%;
  display: flex;
  flex-flow: column nowrap;
}
.modal-body.svelte-1im6aa7 {
  overflow-x: none;
  flex-grow: 1;
}
.modal-close-btn.svelte-1im6aa7 {
  margin: 0 25px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/FilterModal.esbuild-svelte-fake-css */
.row-double.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;
}
.row-double.svelte-14cfzf1 > .modal-row.svelte-14cfzf1.svelte-14cfzf1 {
  width: 100%;
}
.searchbar.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  display: flex;
  width: 100%;
}
.searchbar.svelte-14cfzf1 > input.svelte-14cfzf1.svelte-14cfzf1 {
  flex-grow: 1;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  height: 30px;
  padding: 2px 12px;
  border: 1px solid var(--color-xert-gray);
  border-top-left-radius: var(--borderRadius) !important;
  border-bottom-left-radius: var(--borderRadius) !important;
  border-right: none !important;
  outline: none;
  color: var(--color-xert-gray-text);
}
.searchbar.svelte-14cfzf1 > button.svelte-14cfzf1.svelte-14cfzf1 {
  height: 30px;
  width: 30px;
  border: 1px solid var(--color-xert-gray-text);
  border-top-right-radius: var(--borderRadius) !important;
  border-bottom-right-radius: var(--borderRadius) !important;
  border-left: none !important;
  background-color: white;
}
.searchbar.svelte-14cfzf1 > button.svelte-14cfzf1 > i.svelte-14cfzf1 {
  color: #ddd;
}
.searchbar.svelte-14cfzf1 > button.svelte-14cfzf1:hover > i.svelte-14cfzf1 {
  color: var(--color-xert-blue);
}
input.number-input.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  width: calc((100% - 37.91px) / 2);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  height: 30px;
  padding: 2px 12px;
  border: 1px solid var(--color-xert-gray);
  border-radius: var(--borderRadius) !important;
  outline: none;
  color: var(--color-xert-gray-text);
}
.modal-row.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  --fontSize:16px;
  --height:30px;
  --padding:0 12px !important;
  --itemColor:var(--color-xert-gray-text);
  --border:1px solid var(--color-xert-gray);
  --borderFocusColor:var(--color-xert-gray);
  --borderHoverColor:var(--color-xert-blue);
  --borderRadius:3px !important;
  --listBorder:1px solid var(--color-xert-blue);
  --indicatorRight:20px;
  --indicatorTop:0;
  --indicatorHeight:0;
  --indicatorWidth:0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 5px auto;
}
.modal-row.svelte-14cfzf1 .input-row.svelte-14cfzf1.svelte-14cfzf1 {
  display: flex;
  gap: 10px;
}
.modal-row.svelte-14cfzf1 .input-row.svelte-14cfzf1 > p.svelte-14cfzf1 {
  margin: auto 0;
}
.modal-row.svelte-14cfzf1 > p.svelte-14cfzf1.svelte-14cfzf1 {
  text-align: left;
  margin: 10px 0 !important;
}
.source-selector.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1,
.like-dislike-selector.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1,
.activity-filters-selector.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  gap: 20px;
}
.source-selector.svelte-14cfzf1 > input.svelte-14cfzf1.svelte-14cfzf1,
.like-dislike-selector.svelte-14cfzf1 > input.svelte-14cfzf1.svelte-14cfzf1,
.activity-filters-selector.svelte-14cfzf1 > input.svelte-14cfzf1.svelte-14cfzf1 {
  margin: 0 !important;
}
.source-selector.svelte-14cfzf1 > label.svelte-14cfzf1.svelte-14cfzf1,
.like-dislike-selector.svelte-14cfzf1 > label.svelte-14cfzf1.svelte-14cfzf1,
.activity-filters-selector.svelte-14cfzf1 > label.svelte-14cfzf1.svelte-14cfzf1 {
  margin: 0 10px 0 0 !important;
}
.icon.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  display: flex;
  flex-direction: row;
  color: var(--color-xert-gray-text);
  margin: auto 0;
}
.icon.has-filter.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1 {
  color: red !important;
}
.icon.svelte-14cfzf1 > svg.svelte-14cfzf1.svelte-14cfzf1 {
  cursor: pointer;
}
.icon.svelte-14cfzf1 > p.svelte-14cfzf1.svelte-14cfzf1 {
  margin: auto 3px !important;
  cursor: pointer;
}
.icon.svelte-14cfzf1.svelte-14cfzf1.svelte-14cfzf1:hover {
  color: var(--color-xert-blue);
  cursor: default;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Avatar.esbuild-svelte-fake-css */
.avatar.svelte-cc6asa {
  display: inline-block;
  object-fit: cover;
  height: var(--avatar-height, 2em);
  width: var(--avatar-height, 2em);
  margin: var(--avatar-margin, 0);
  border-radius: 4px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/Matchstick.esbuild-svelte-fake-css */
.none.svelte-1l7axtc {
  background-color: grey;
}
.rest.svelte-1l7axtc {
  background-color: none;
}
.conflict.svelte-1l7axtc {
  background-color: #ff00ff;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/TrainingStatusGradient.esbuild-svelte-fake-css */
.gradient-container.svelte-155dwyg {
  width: 100%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/DatePicker.esbuild-svelte-fake-css */
.month-date.svelte-1xhskcv.svelte-1xhskcv {
  box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.1), 0px 1px 1px -1px rgba(0, 0, 0, 0.15);
}
.date-info.svelte-1xhskcv.svelte-1xhskcv {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.calendar-button.svelte-1xhskcv.svelte-1xhskcv {
  box-shadow: -2px 0px 3px 0 rgba(0, 0, 0, 0.15), -1px 0px 2px 0 rgba(0, 0, 0, 0.2);
}
.disabled.svelte-1xhskcv.svelte-1xhskcv {
  pointer-events: none;
}
.disabled.svelte-1xhskcv button.svelte-1xhskcv {
  background-color: #b4b4b4 !important;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/NumberInput.esbuild-svelte-fake-css */
.month-date.svelte-i1fvi0.svelte-i1fvi0 {
  box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.1);
}
.date-info.svelte-i1fvi0.svelte-i1fvi0 {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.input-button.svelte-i1fvi0.svelte-i1fvi0 {
  box-shadow: inset 0px 1px 0px 0 var(--tw-shadow-color), -1px 0px 3px rgba(0, 0, 0, 0.15);
}
.input-button.svelte-i1fvi0.svelte-i1fvi0:active {
  box-shadow: inset 0px -1px 0px 0 var(--tw-shadow-color), inset 1px 1px 1px rgba(0, 0, 0, 0.1);
}
.number-input.svelte-i1fvi0.svelte-i1fvi0 {
  -moz-appearance: textfield;
}
.number-input.svelte-i1fvi0.svelte-i1fvi0::-webkit-outer-spin-button,
.number-input.svelte-i1fvi0.svelte-i1fvi0::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.disabled.svelte-i1fvi0.svelte-i1fvi0 {
  pointer-events: none;
}
.disabled.svelte-i1fvi0 button.svelte-i1fvi0 {
  background-color: #b4b4b4 !important;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/SelectSlider.esbuild-svelte-fake-css */
.select-slider.svelte-184aahr {
  -webkit-appearance: none;
  appearance: none;
  background: var(--slider-background, var(--color-xert-teal));
  cursor: pointer;
  border-radius: 99px !important;
  height: 8px;
}
.select-slider.svelte-184aahr:focus {
  outline: none;
}
.select-slider.svelte-184aahr::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: var(--thumb-size, 30px);
  height: var(--thumb-size, 30px);
  background: #ffffff;
  border-radius: 50% !important;
  border: 1px solid rgba(172, 172, 172, 0.98);
  cursor: pointer;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
.select-slider.svelte-184aahr::-moz-range-thumb {
  width: var(--thumb-size, 30px);
  height: var(--thumb-size, 30px);
  background: #ffffff;
  border-radius: 50% !important;
  border: 1px solid rgba(193, 193, 193, 0.98);
  cursor: pointer;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  position: relative;
}
.select-slider.svelte-184aahr:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/XfaiBall.esbuild-svelte-fake-css */
#big-sparkle.svelte-5u263v {
  transform-box: fill-box;
  transform-origin: center;
}
#big-sparkle.sparkle.svelte-5u263v {
  opacity: 0.8;
  animation: svelte-5u263v-sparkle 5s linear 1.15s infinite;
}
#medium-sparkle.svelte-5u263v {
  transform-box: fill-box;
  transform-origin: center;
}
#medium-sparkle.sparkle.svelte-5u263v {
  opacity: 0.8;
  animation: svelte-5u263v-sparkle 5s linear infinite;
}
#small-sparkle.svelte-5u263v {
  transform-box: fill-box;
  transform-origin: center;
}
#small-sparkle.sparkle.svelte-5u263v {
  opacity: 0.8;
  animation: svelte-5u263v-sparkle 5s linear 0.5s infinite;
}
@keyframes svelte-5u263v-sparkle {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  25% {
    opacity: 1;
    transform: scale(1.4);
  }
  40%, 100% {
    opacity: 0.8;
    transform: scale(1);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/XataLogo.esbuild-svelte-fake-css */
#logo-xata.svelte-1vwz4mz {
  transform-box: fill-box;
  transform-origin: center;
}
#logo-xata.sparkle.svelte-1vwz4mz {
  animation: svelte-1vwz4mz-sparkle 6s linear infinite;
}
@keyframes svelte-1vwz4mz-sparkle {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.1);
  }
  40%, 100% {
    transform: scale(1);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/BannerHeader.esbuild-svelte-fake-css */
.header-background.svelte-1hd4lx0 {
  background:
    linear-gradient(
      0deg,
      rgba(var(--rgb-xert-teal), 0.75) 0%,
      rgba(var(--rgb-xert-teal), 0.75) 100%),
    url(../../assets/images/Hero-Carousel-4-bg.jpg);
  background-position: top right;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/StickyButtonBannerHeader.esbuild-svelte-fake-css */
.header-background.svelte-1hd4lx0 {
  background:
    linear-gradient(
      0deg,
      rgba(var(--rgb-xert-teal), 0.75) 0%,
      rgba(var(--rgb-xert-teal), 0.75) 100%),
    url(../../assets/images/Hero-Carousel-4-bg.jpg);
  background-position: top right;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/Accordion.esbuild-svelte-fake-css */
.accordion-trigger[data-state=open].svelte-1i8mvcg > i.svelte-1i8mvcg {
  transform: rotate(180deg);
}

/* fakecss:/home/forge/alpha/svelte-components/src/Bootstrap/ToggleButtonSmall.esbuild-svelte-fake-css */
input[type=checkbox].svelte-omhm9m {
  visibility: visible;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/CyclingProgress.esbuild-svelte-fake-css */
.road.svelte-ko9et6.svelte-ko9et6 {
  position: relative;
  height: 14px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12);
}
.road-fill.svelte-ko9et6.svelte-ko9et6 {
  height: 100%;
  border-radius: 999px;
  background-color: #00a5b5;
  background-image:
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.55) 0 14px,
      transparent 14px 28px);
  background-size: 28px 3px;
  background-repeat: repeat-x;
  background-position: 0 center;
  animation: svelte-ko9et6-road-roll 0.6s linear infinite;
}
.marker.svelte-ko9et6.svelte-ko9et6 {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: rgba(15, 23, 42, 0.18);
}
.rider.svelte-ko9et6.svelte-ko9et6 {
  position: absolute;
  top: 0;
  width: 96px;
  height: 58px;
  transform: translateX(-50%);
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  overflow: visible;
}
.rider.svelte-ko9et6 .tyre.svelte-ko9et6 {
  stroke: #1e293b;
  stroke-width: 2.6;
}
.rider.svelte-ko9et6 .rim.svelte-ko9et6 {
  stroke: #94a3b8;
  stroke-width: 1;
}
.rider.svelte-ko9et6 .spokes.svelte-ko9et6 {
  stroke: #94a3b8;
  stroke-width: 0.6;
  animation: svelte-ko9et6-wheel-spin 0.45s linear infinite;
}
.rider.svelte-ko9et6 .hub.svelte-ko9et6 {
  fill: #475569;
}
.rider.svelte-ko9et6 .frame.svelte-ko9et6 {
  stroke: #00a5b5;
  stroke-width: 2.6;
}
.rider.svelte-ko9et6 .saddle.svelte-ko9et6,
.rider.svelte-ko9et6 .bars.svelte-ko9et6 {
  stroke: #1e293b;
  stroke-width: 2.2;
}
.rider.svelte-ko9et6 .chainring.svelte-ko9et6 {
  stroke: #475569;
  stroke-width: 1.4;
}
.rider.svelte-ko9et6 .crank.svelte-ko9et6 {
  stroke: #334155;
  stroke-width: 1.8;
}
.rider.svelte-ko9et6 .leg.svelte-ko9et6 {
  stroke: #1e293b;
  stroke-width: 3.6;
}
.rider.svelte-ko9et6 .leg.far.svelte-ko9et6 {
  stroke: #94a3b8;
}
.rider.svelte-ko9et6 .torso.svelte-ko9et6 {
  stroke: #1e293b;
  stroke-width: 5;
}
.rider.svelte-ko9et6 .arm.svelte-ko9et6 {
  stroke: #1e293b;
  stroke-width: 2.6;
}
.rider.svelte-ko9et6 .head.svelte-ko9et6 {
  fill: #f1c7a3;
}
.rider.svelte-ko9et6 .helmet.svelte-ko9et6 {
  fill: #a4d233;
  stroke: #6f9a10;
  stroke-width: 0.6;
}
.rider.svelte-ko9et6 .upper-body.svelte-ko9et6 {
  animation: svelte-ko9et6-rider-bob 0.35s ease-in-out infinite alternate;
}
.rider.svelte-ko9et6 .speed-lines path.svelte-ko9et6 {
  stroke: #94a3b8;
  stroke-width: 1.4;
  opacity: 0;
  animation: svelte-ko9et6-speed-line 0.6s linear infinite;
}
.check.svelte-ko9et6.svelte-ko9et6 {
  width: 100%;
  height: 100%;
}
.check-circle.svelte-ko9et6.svelte-ko9et6 {
  fill: none;
  stroke: #a4d233;
  stroke-width: 3;
  stroke-dasharray: 151;
  stroke-dashoffset: 151;
  animation: svelte-ko9et6-draw 0.6s ease-out forwards;
}
.check-mark.svelte-ko9et6.svelte-ko9et6 {
  fill: none;
  stroke: #00a5b5;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 40;
  stroke-dashoffset: 40;
  animation: svelte-ko9et6-draw 0.4s 0.5s ease-out forwards;
}
.confetti.svelte-ko9et6.svelte-ko9et6 {
  position: absolute;
  left: 50%;
  top: 50%;
  width: var(--size);
  height: var(--size);
  opacity: 0;
  animation: svelte-ko9et6-confetti-burst 1.3s var(--delay) cubic-bezier(0.15, 0.7, 0.3, 1) forwards;
}
@keyframes svelte-ko9et6-road-roll {
  to {
    background-position: 28px center;
  }
}
@keyframes svelte-ko9et6-wheel-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes svelte-ko9et6-rider-bob {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(0.8px);
  }
}
@keyframes svelte-ko9et6-speed-line {
  0% {
    opacity: 0;
    transform: translateX(6px);
  }
  30% {
    opacity: 0.9;
  }
  100% {
    opacity: 0;
    transform: translateX(-6px);
  }
}
@keyframes svelte-ko9et6-draw {
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes svelte-ko9et6-confetti-burst {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) rotate(var(--angle)) translateX(0) scale(0.4);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) rotate(var(--angle)) translateX(var(--distance)) rotate(540deg) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .road-fill.svelte-ko9et6.svelte-ko9et6,
  .rider.svelte-ko9et6 .spokes.svelte-ko9et6,
  .rider.svelte-ko9et6 .upper-body.svelte-ko9et6,
  .rider.svelte-ko9et6 .speed-lines path.svelte-ko9et6,
  .confetti.svelte-ko9et6.svelte-ko9et6 {
    animation: none;
  }
  .rider.svelte-ko9et6 .speed-lines.svelte-ko9et6 {
    display: none;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/DifficultyDiamonds.esbuild-svelte-fake-css */
span.svelte-136puog {
  white-space: nowrap;
  --star-color:black;
  --star-background:lightgray;
}
span.svelte-136puog::before {
  content: "\25c6  \25c6  \25c6  \25c6  \25c6";
  background:
    linear-gradient(
      90deg,
      var(--star-color) var(--percent),
      var(--star-background) var(--percent));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Messaging/ThreadComposer.esbuild-svelte-fake-css */
.autogrow-wrap.svelte-w1b3kj.svelte-w1b3kj {
  display: grid;
}
.autogrow-wrap.svelte-w1b3kj.svelte-w1b3kj::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.autogrow-wrap.svelte-w1b3kj > textarea.svelte-w1b3kj,
.autogrow-wrap.svelte-w1b3kj.svelte-w1b3kj::after {
  grid-area: 1 / 1 / 2 / 2;
  padding: 0;
  border: 0;
  font: inherit;
  color: inherit;
  word-break: break-word;
}
.autogrow-wrap.svelte-w1b3kj > textarea.svelte-w1b3kj {
  resize: none;
  overflow: hidden;
  background: transparent;
  outline: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SessionScheduleButton.esbuild-svelte-fake-css */
.buttons.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  display: flex;
  align-items: center;
  margin: 0 -10px;
  max-width: 100%;
}
.schedule-modal-content.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.schedule-modal-content.svelte-sxeast .schedule-modal-element.svelte-sxeast.svelte-sxeast {
  display: flex;
  flex-direction: column;
  width: 150px;
  margin: 0 5px !important;
}
.schedule-modal-content.svelte-sxeast .schedule-modal-element.svelte-sxeast > p.svelte-sxeast {
  text-align: left;
  margin: 0 2px !important;
}
input.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  border: 1px solid var(--color-xert-gray);
  border-radius: 3px !important;
  background-color: white;
  padding: 4px 8px;
  color: var(--color-xert-gray-text);
}
input.svelte-sxeast.svelte-sxeast.svelte-sxeast:hover {
  border-color: var(--color-xert-blue);
}
button.styled-btn.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  display: flex;
  gap: 10px;
  justify-content: center;
  width: var(--xert-button-width, 130px);
  background: var(--color-xert-teal);
  border-radius: 4px !important;
  margin: 10px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px !important;
  text-align: center;
  letter-spacing: 0.48px;
  position: relative;
  text-align: center;
  letter-spacing: 0.48px;
  transition: background 0.4s;
  color: #FFFFFF;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
button.styled-btn.svelte-sxeast > p.svelte-sxeast.svelte-sxeast {
  margin: 0;
}
button.styled-btn.showPlay.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  background: var(--color-xert-blue);
}
button.styled-btn.showPlay.rightMargin.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  margin-right: 16px;
}
button.styled-btn.showPlay.svelte-sxeast.svelte-sxeast.svelte-sxeast:hover {
  background: var(--color-xert-lime);
}
button.styled-btn.showSchedule.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  background: var(--color-xert-blue);
}
button.styled-btn.showSchedule.svelte-sxeast.svelte-sxeast.svelte-sxeast:hover {
  background: var(--color-xert-lime);
}
button.styled-btn.clear.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  background: white;
  border: 1px solid var(--color-xert-blue);
  color: var(--color-xert-blue);
}
button.styled-btn.clear.svelte-sxeast.svelte-sxeast.svelte-sxeast:hover {
  background: var(--color-xert-blue) !important;
  color: white;
}
button.styled-btn.smaller-btn.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  width: var(--xert-button-width, 100px);
}
.timestamp.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  font-weight: 500 !important;
  font-size: 22px !important;
  margin: 0;
}
.timestamp.svelte-sxeast > a.svelte-sxeast.svelte-sxeast {
  color: #34495e;
}
.text.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.grouped-btn.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  min-width: 56.5px;
  gap: 10px;
  width: auto;
  height: 38px;
  background: var(--color-xert-blue);
  display: flex;
  justify-content: center;
  margin: 10px 0px;
  color: #FFFFFF;
  text-align: center;
  align-items: center;
  flex-grow: 1;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.grouped-btn.svelte-sxeast.svelte-sxeast.svelte-sxeast:hover {
  background: var(--color-xert-lime);
}
.btn-group.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  display: flex;
  max-width: var(--xert-button-width);
  width: 100%;
  flex-grow: 1;
  margin: 0px 10px;
}
.schedule-btn.svelte-sxeast.svelte-sxeast.svelte-sxeast {
  overflow: visible !important;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/HelpTooltip.esbuild-svelte-fake-css */
.message-body.svelte-152t2rk a {
  color: #2f7076;
  text-decoration: underline;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/ExerciseCardButtons.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
buttons.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy {
  display: inline-flex;
  height: fit-content;
  gap: 10px;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 10px 0;
}
a.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy {
  --border:1px solid var(--color-xert-gray);
  --borderRadius:5px !important;
  color: inherit;
  flex-shrink: 1;
}
a.svelte-gnwopy > button.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy {
  border: 1px solid var(--color-xert-gray-text);
  border-top-right-radius: var(--borderRadius) !important;
  border-bottom-right-radius: var(--borderRadius) !important;
  border-left: none !important;
  background-color: white;
}
a.svelte-gnwopy > button.svelte-gnwopy > span.svelte-gnwopy.svelte-gnwopy {
  vertical-align: text-bottom;
}
a.svelte-gnwopy > button.svelte-gnwopy > span.svelte-gnwopy > p.svelte-gnwopy {
  margin: 0;
  line-height: 12px;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  display: inline-block !important;
  vertical-align: middle;
}
a.svelte-gnwopy > button.svelte-gnwopy > span.svelte-gnwopy > i.svelte-gnwopy {
  vertical-align: middle;
  font-size: 14px;
}
a.svelte-gnwopy > button.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy,
a.svelte-gnwopy > button.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy:focus {
  border-radius: var(--borderRadius) !important;
  background-color: white;
  border: var(--border) !important;
}
a.svelte-gnwopy > button.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy:hover,
a.svelte-gnwopy > button.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy:active {
  color: var(--color-xert-teal);
  border-color: var(---color-xert-teal) !important;
  background-color: white;
}
a.svelte-gnwopy > svg.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy,
a.svelte-gnwopy > i.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy {
  color: inherit;
}
a.svelte-gnwopy > svg.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy:hover,
a.svelte-gnwopy > i.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy:hover {
  color: var(--color-xert-teal) !important;
}
.delete-session.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy.svelte-gnwopy {
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  padding-bottom: 4px;
}
.logo-garmin:before {
  mask-image: url(/assets/global/img/providers/garmin.svg);
  display: inline-block;
  background-color: white;
  height: 14px;
  width: 16px;
  mask-size: cover;
  margin-bottom: -3px;
  content: "";
  margin-right: 8px;
}
.logo-zwift:before {
  mask-image: url(/assets/global/img/providers/zwift.svg);
  display: inline-block;
  background-color: white;
  height: 14px;
  width: 16px;
  mask-size: cover;
  margin-bottom: -3px;
  content: "";
  margin-right: 8px;
}
.logo-wahoo:before {
  mask-image: url(/assets/global/img/providers/wahoo-elemnt.png);
  display: inline-block;
  background-color: white;
  height: 14px;
  width: 12px;
  margin-left: 2px;
  mask-size: cover;
  margin-bottom: -3px;
  content: "";
  margin-right: 10px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Slider.esbuild-svelte-fake-css */
flex-container.svelte-1ehq3j6 {
  display: flex;
  flex-direction: row;
  align-content: stretch;
  overflow: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}
flex-container.scrollbar.svelte-1ehq3j6 {
  overflow-x: scroll;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Carousel.esbuild-svelte-fake-css */
item.svelte-1dbdln8.svelte-1dbdln8 {
  margin: auto;
  height: 100%;
  width: 100%;
  flex-shrink: 0;
  scroll-snap-align: start;
}
carousel.svelte-1dbdln8.svelte-1dbdln8 {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}
scroll-bg.svelte-1dbdln8.svelte-1dbdln8 {
  margin: auto;
  font-size: 24px;
  display: block;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}
scroll-bg.svelte-1dbdln8.svelte-1dbdln8:after {
  content: var(--bg_dots);
}
scroll-bg.svelte-1dbdln8 scroll-indicator.svelte-1dbdln8 {
  position: absolute;
  transform: translateX(var(--scroll_offset));
  color: lightgray;
}
scroll-bg.svelte-1dbdln8 scroll-indicator.svelte-1dbdln8:before {
  content: var(--current_indicator);
}
button.svelte-1dbdln8.svelte-1dbdln8 {
  position: absolute;
  width: 60px;
  top: 0px;
  bottom: 34px;
  font-size: 20px;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0);
  border: unset;
  opacity: 0;
  transition: opacity 0.2s;
  background-repeat: repeat-x;
}
button.svelte-1dbdln8.svelte-1dbdln8:hover,
button.svelte-1dbdln8.svelte-1dbdln8:active {
  background-color: inherit;
  border: inherit;
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
  cursor: pointer;
}
button.left.svelte-1dbdln8.svelte-1dbdln8 {
  background-image:
    linear-gradient(
      to right,
      rgba(0, 0, 0, 0.5) 0,
      rgba(0, 0, 0, 0.0001) 100%);
  left: 0%;
}
button.left.svelte-1dbdln8 span.svelte-1dbdln8:before {
  content: "\e079";
}
button.right.svelte-1dbdln8.svelte-1dbdln8 {
  background-image:
    linear-gradient(
      to left,
      rgba(0, 0, 0, 0.5) 0,
      rgba(0, 0, 0, 0.0001) 100%);
  right: 0%;
}
button.right.svelte-1dbdln8 span.svelte-1dbdln8:before {
  content: "\e080";
}
button.svelte-1dbdln8 > span.svelte-1dbdln8 {
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  color: white;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/ExerciseImageCarousel.esbuild-svelte-fake-css */
img.svelte-1qrrvfz {
  width: 100%;
  object-fit: contain;
}
img.youtube.svelte-1qrrvfz {
  object-fit: cover !important;
}
.icon-container.svelte-1qrrvfz {
  width: 100%;
  height: 100%;
  container-type: inline-size;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  padding-bottom: 24px;
}
.icon-pic.svelte-1qrrvfz {
  font-size: 26cqw;
  color: #888888;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/ActivityBreakthrough.esbuild-svelte-fake-css */
.banner.svelte-zphre7.svelte-zphre7 {
  display: flex;
  flex-wrap: wrap;
  background-color: #F8F8F8;
  justify-content: space-evenly;
  border-radius: 5px;
  margin-bottom: 10px;
}
.banner.svelte-zphre7 .breakthrough.svelte-zphre7 {
  padding: 5px;
  margin: 0;
  width: 100%;
  color: floralwhite;
  border-radius: 5px;
  text-align: center;
  font-weight: 500;
}
.banner.svelte-zphre7 .activity-stats.svelte-zphre7 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  width: 100%;
}
.banner.svelte-zphre7 .divider.svelte-zphre7 {
  border-right: 1px solid #E4E4E4;
  margin: 7px 0 !important;
}
.banner.svelte-zphre7 span.svelte-zphre7 {
  margin: 7px 5px;
  white-space: nowrap;
}
.banner.svelte-zphre7 p.svelte-zphre7 {
  font-size: 14px;
  line-height: 12px;
  margin: 2px 0;
}
.banner.svelte-zphre7 b.svelte-zphre7 {
  font-size: 17px;
  font-weight: 500 !important;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/SessionVideoData.esbuild-svelte-fake-css */
svg.svelte-mo47ti.svelte-mo47ti {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
span.avatars.svelte-mo47ti.svelte-mo47ti {
  --avatar-height:24px;
  display: flex;
  gap: 4px;
  width: 100%;
  max-width: var(--xert-button-width, unset);
}
span.avatars.svelte-mo47ti > div.svelte-mo47ti {
  margin: auto 0;
}
span.avatars.svelte-mo47ti p.svelte-mo47ti {
  margin: 0;
  line-height: 1;
  color: var(--color-xert-gray-text);
}
h4.title.svelte-mo47ti.svelte-mo47ti {
  text-align: left;
}
a.logo.svelte-mo47ti.svelte-mo47ti {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.ellipsis.svelte-mo47ti.svelte-mo47ti {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SessionJoinButton.esbuild-svelte-fake-css */
button.svelte-hfael3.svelte-hfael3 {
  display: flex;
  justify-content: center;
  width: var(--xert-button-width, 200px);
  background: var(--color-xert-teal);
  margin: 10px 0px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.48px;
  position: relative;
  text-align: center;
  letter-spacing: 0.48px;
  transition: background 0.4s;
  color: #FFFFFF;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
button.svelte-hfael3 > svg.svelte-hfael3,
button.svelte-hfael3 > i.svelte-hfael3 {
  margin: 4px;
}
button.svelte-hfael3 > p.svelte-hfael3 {
  margin: 0;
  position: relative;
  top: 1px;
  padding: 0px 5px;
}
button.svelte-hfael3.svelte-hfael3:not(.waiting):not(.joined):hover {
  background: var(--color-xert-lime);
}
button:not(.waiting).inprog.svelte-hfael3.svelte-hfael3 {
  background: var(--color-xert-blue);
}
button:not(.waiting).joined.svelte-hfael3.svelte-hfael3 {
  background: var(--color-xert-lime);
}
button:not(.waiting).joined.starting_soon.svelte-hfael3.svelte-hfael3 {
  background: var(--color-xert-blue);
}
button:not(.waiting).joined.starting_soon.svelte-hfael3.svelte-hfael3:hover {
  background: var(--color-xert-lime);
}
button:not(.waiting).joined.svelte-hfael3:not(.starting_soon) > .btn-text-hover.svelte-hfael3 {
  display: none;
}
button:not(.waiting).joined.svelte-hfael3.svelte-hfael3:not(.starting_soon):hover {
  background: var(--color-xert-gray);
}
button:not(.waiting).joined.svelte-hfael3:not(.starting_soon):hover > .btn-text-normal.svelte-hfael3 {
  display: none;
}
button:not(.waiting).joined.svelte-hfael3:not(.starting_soon):hover > .btn-text-hover.svelte-hfael3 {
  display: unset !important;
}
.btn-leave.svelte-hfael3.svelte-hfael3 {
  background: white;
  border: 1px solid var(--color-xert-blue);
  color: var(--color-xert-blue);
}
.btn-leave.svelte-hfael3.svelte-hfael3:hover {
  background: var(--color-xert-blue) !important;
  color: white;
}
.btn-group.svelte-hfael3.svelte-hfael3 {
  display: flex;
  max-width: var(--xert-button-width);
  width: 100%;
  flex-grow: 1;
}
.grouped-btn.svelte-hfael3.svelte-hfael3 {
  width: auto;
  min-width: 56.5px;
  height: 38px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/SessionButtons.esbuild-svelte-fake-css */
.text.svelte-1afr2pc.svelte-1afr2pc {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.text.compact.svelte-1afr2pc.svelte-1afr2pc {
  justify-content: center;
}
.text.compact.svelte-1afr2pc > h4.svelte-1afr2pc {
  margin: 0;
  font-size: 14px !important;
}
.buttons.svelte-1afr2pc.svelte-1afr2pc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  --xert-button-width:210px;
}
.buttons.compact.svelte-1afr2pc.svelte-1afr2pc {
  --xert-button-width:auto;
}
.buttons.compact.svelte-1afr2pc.svelte-1afr2pc {
  gap: 10px;
  flex-direction: row;
}
.date.svelte-1afr2pc.svelte-1afr2pc {
  font-size: 18px !important;
  line-height: 21px !important;
  margin-bottom: 8px;
}
.timestamp.svelte-1afr2pc.svelte-1afr2pc {
  font-weight: 500 !important;
  font-size: 22px !important;
  margin: 0;
}
h4.svelte-1afr2pc.svelte-1afr2pc {
  margin: 0;
}
h3.blue-text.svelte-1afr2pc.svelte-1afr2pc {
  color: var(--color-xert-blue);
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/ExerciseCard.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
my-box.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  position: relative;
  background: white;
  mix-blend-mode: var(--session-card-mix-blend-mode, none);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: clip;
}
my-box.selectable.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  border: 1px solid gainsboro;
}
my-box.selectable.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8:hover {
  border: 1px solid rgb(170, 170, 170);
}
my-box.selectable.selected.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8,
my-box.selectable.selected.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8:hover {
  border: 3px solid var(--color-xert-teal) !important;
}
my-box.svelte-1tf3dt8 h3.title.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin: 15px 20px -5px 20px;
  line-height: 1.25;
  font-weight: 500;
}
my-box.svelte-1tf3dt8 .primary-content.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
}
my-box.svelte-1tf3dt8 .title.svelte-1tf3dt8 > a.svelte-1tf3dt8 {
  color: #34495e;
}
my-box.svelte-1tf3dt8 .title.svelte-1tf3dt8 > a.svelte-1tf3dt8:hover,
my-box.svelte-1tf3dt8 .title.svelte-1tf3dt8 > a.svelte-1tf3dt8:focus {
  text-decoration: none;
  color: var(--color-xert-teal);
  cursor: pointer;
}
.showBorder.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  border: 1px solid var(--color-xert-teal);
  border-radius: 5px;
}
.comments-button-anchor.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
}
.bottom.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
  margin: 0 20px 5px 20px;
  padding-top: 5px;
  border-top: 1px solid #E4E4E4;
}
.bottom.svelte-1tf3dt8 .buttons.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-direction: column;
  justify-content: right;
}
.bottom.svelte-1tf3dt8 .text.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 6px;
}
.bottom.svelte-1tf3dt8 .text.svelte-1tf3dt8 > h4.svelte-1tf3dt8 {
  margin: 0;
  font-size: 14px !important;
}
.bottom.svelte-1tf3dt8 .text.svelte-1tf3dt8 > h3.svelte-1tf3dt8 {
  margin: 0;
}
.description.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin: 0;
  margin-bottom: 7px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.big-activity-stats.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  gap: 40px;
  margin-bottom: 10px;
}
.big-activity-stats.svelte-1tf3dt8 p.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: inline;
  margin: 0;
}
.big-activity-stats.svelte-1tf3dt8 h3.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin: 0;
}
.middle.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  min-width: 0;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
}
.middle.svelte-1tf3dt8 .right.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-direction: row;
}
.middle.svelte-1tf3dt8 .left.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}
.content.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  position: relative;
}
.anchored.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  flex-shrink: 0;
}
.carousel.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin: 24px 20px 0 20px;
  min-height: 100px;
  display: flex;
}
.exercise-titles.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  min-width: 200px;
  flex-grow: 1;
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.exercise-titles.svelte-1tf3dt8 h2.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin-top: 0;
  margin-bottom: 7px;
  font-weight: 500;
  font-size: 20px;
}
.exercise-info.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  min-width: 200px;
  margin: 20px;
}
.exercise-info.svelte-1tf3dt8 b.svelte-1tf3dt8.svelte-1tf3dt8 {
  font-weight: 600 !important;
}
.duration-info.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: clip;
  margin: 20px;
  --xert-button-width:210px;
}
.duration-info.svelte-1tf3dt8 h4.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin: 0;
}
.duration-info.svelte-1tf3dt8 .activity-data.svelte-1tf3dt8.svelte-1tf3dt8 {
  font-size: 15px !important;
  margin-top: 5px;
}
.divider.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  border-right: 1px solid #E4E4E4;
  margin: 20px 0;
}
.card-data.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  margin-bottom: 10px;
}
.card-data.svelte-1tf3dt8 h4.svelte-1tf3dt8.svelte-1tf3dt8 {
  margin-top: 0;
  font-weight: 700;
}
.ellipsis.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.date.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  font-size: 18px !important;
  line-height: 21px !important;
}
.timestamp.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  font-weight: 500 !important;
  font-size: 22px !important;
  margin-top: 0;
}
.center.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  text-align: center;
  align-items: center;
}
.npeak.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  color: #F00;
}
.nlow.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  color: #0B5DBC;
}
.nhigh.svelte-1tf3dt8.svelte-1tf3dt8.svelte-1tf3dt8 {
  color: #F5A623;
}

/* fakecss:/home/forge/alpha/svelte-components/src/workouts/WorkoutPicker.esbuild-svelte-fake-css */
#workout-picker-container.svelte-857wb1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.workouts-container.svelte-857wb1 {
  border: 1px solid #ECECEC;
  border-radius: 5px;
  padding: 2px;
}
button.svelte-857wb1 {
  background: var(--color-xert-teal);
  flex-shrink: 0;
  color: white;
  border-radius: 4px !important;
  height: 37px;
  margin: 10px auto;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
button.svelte-857wb1:hover {
  background: var(--color-xert-lime);
  color: white;
}
button.svelte-857wb1:focus {
  color: white;
}

/* fakecss:/home/forge/alpha/svelte-components/src/InfiniteScroll.esbuild-svelte-fake-css */
progress-bar.svelte-18fo3oh.svelte-18fo3oh.svelte-18fo3oh {
  top: 0;
  width: 100%;
  height: 4px;
  background:
    linear-gradient(
      45deg,
      var(--color-xert-teal),
      darkturquoise);
  display: block;
  position: relative;
}
progress-cover.svelte-18fo3oh.svelte-18fo3oh.svelte-18fo3oh {
  height: 100%;
  right: 0;
  background: lightgray;
  position: absolute;
  display: block;
}
flex-container.svelte-18fo3oh.svelte-18fo3oh.svelte-18fo3oh {
  display: flex;
  flex-direction: column;
  align-content: stretch;
  height: 100%;
}
.fade-in.svelte-18fo3oh.svelte-18fo3oh.svelte-18fo3oh {
  animation: svelte-18fo3oh-fadeIn ease 0.2s;
}
@keyframes svelte-18fo3oh-fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
item-list.svelte-18fo3oh.svelte-18fo3oh.svelte-18fo3oh {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  display: flex;
  justify-content: center;
}
item-list.svelte-18fo3oh item-spacer.svelte-18fo3oh.svelte-18fo3oh {
  background: white;
  position: relative;
  display: block;
  width: 100%;
}
item-list.svelte-18fo3oh item-spacer.svelte-18fo3oh > div.svelte-18fo3oh {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ParticipantList.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
user-card.svelte-1n05bhg {
  position: relative;
  --avatar-height:56px;
  --avatar-margin:16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  margin: 9px;
  border: 1px solid rgba(236, 236, 236, 0.8);
  border-radius: 5px;
}
user-card.invited.svelte-1n05bhg,
user-card.scheduled.svelte-1n05bhg {
  border-color: var(--color-xert-teal);
}
user-card.scheduled.svelte-1n05bhg:before {
  position: absolute;
  right: 0;
  top: 0;
  content: "\f058";
  color: var(--color-xert-lime);
  font: normal normal normal 14px/1 FontAwesome;
  line-height: 1;
  font-size: 20px;
  text-rendering: auto;
  margin: 16px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyInput.esbuild-svelte-fake-css */
div.svelte-1wjeewn {
  position: relative;
  width: 100%;
}
div.svelte-1wjeewn:before {
  content: var(--units);
  position: absolute;
  right: 6px;
  top: 50%;
  height: 0;
  line-height: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  text-align: right;
  letter-spacing: 0.48px;
  color: #979797;
}
input.svelte-1wjeewn {
  margin: 0;
  width: 100%;
}
input.svelte-1wjeewn:disabled {
  color: initial;
}
input.svelte-1wjeewn::-webkit-outer-spin-button,
input.svelte-1wjeewn::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number].svelte-1wjeewn {
  -moz-appearance: textfield;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Bootstrap/Fileuploader.esbuild-svelte-fake-css */
div.fileuploader-popup {
  z-index: 9999;
}
.fileuploader-theme-dragdrop.fileuploader {
  margin: 24px 0;
  padding: 0;
  text-align: center;
  background: none;
}
.fileuploader-theme-dragdrop .fileuploader-input {
  display: block;
  padding: 16px;
  text-align: center;
  background: rgba(47, 112, 118, 0.05);
  border: 1px dashed #979797;
  box-sizing: border-box;
  border-radius: 3px;
}
.fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-button {
  background: #2F7076;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  width: 191px;
  height: 30px;
}
.fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-button > span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.48px;
  color: #FFFFFF;
}
.fileuploader-theme-dragdrop .fileuploader-input h3 {
  margin: 0;
  margin-bottom: 8px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.113198px;
  color: #3D3D3D;
}
.fileuploader-theme-dragdrop .fileuploader-input p {
  margin: 0;
  padding: 0;
  color: #90a0bc;
  margin-bottom: 12px;
}
.fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-inner > * {
  -webkit-transition: 500ms cubic-bezier(0.17, 0.67, 0, 1.01);
  transition: 500ms cubic-bezier(0.17, 0.67, 0, 1.01);
}
.fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-input-inner > * {
  transform: translateY(18px);
  opacity: 0;
}
.fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-icon-main {
  transform: translateY(30px) scale(1.2);
  opacity: 0.6;
}
.fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-input-caption {
  transform: translateY(30px);
  opacity: 0.6;
}
.fileuploader-theme-dragdrop .fileuploader-items {
  max-height: 250px;
  overflow: hidden auto;
}

/* fakecss:/home/forge/alpha/svelte-components/src/YouTube.esbuild-svelte-fake-css */
div.svelte-fxc20.svelte-fxc20 {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
div.svelte-fxc20 > #ytframe.svelte-fxc20 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/workouts/WorkoutTable.esbuild-svelte-fake-css */
.data-table.svelte-d6l4a7 {
  margin-bottom: 64px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/workouts/WorkoutDetails.esbuild-svelte-fake-css */
.workout-chart.svelte-cdrkrh {
  display: flex;
  flex-grow: 2;
  justify-content: center;
  margin: 20px;
  flex-basis: 66%;
}
.info.svelte-cdrkrh {
  margin: 20px;
  flex-grow: 1;
  flex-basis: 33%;
}
.top.svelte-cdrkrh {
  display: flex;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SessionEditor.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
.svelte-111dcsc.svelte-111dcsc::placeholder {
  opacity: 0.5;
}
.subtext.svelte-111dcsc.svelte-111dcsc {
  color: grey;
}
.content-center.svelte-111dcsc.svelte-111dcsc {
  position: relative;
  left: 50%;
  transform: translate(-50%);
}
.flex-container.svelte-111dcsc.svelte-111dcsc {
  display: flex;
  flex-direction: column;
  align-content: stretch;
}
row-container.svelte-111dcsc.svelte-111dcsc,
ul.svelte-111dcsc.svelte-111dcsc {
  display: flex;
  align-items: start;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
}
row-container.flex-centre.svelte-111dcsc.svelte-111dcsc {
  justify-content: center;
}
row-container.svelte-111dcsc > input.svelte-111dcsc,
row-container.svelte-111dcsc > .my-input.svelte-111dcsc {
  margin: 0;
  width: 100%;
}
row-container.svelte-111dcsc textarea.svelte-111dcsc {
  flex-grow: 1;
  max-width: 100%;
  color: #4A4A4A;
}
row-container.svelte-111dcsc .my-input.svelte-111dcsc {
  --height:33.2px;
  --multiClearTop:3px;
  --multiItemHeight:22px;
  --clearSelectTop:4px;
  --clearSelectBottom:4px;
  --padding:0.4em;
  --itemHoverBG:#4AA;
  --multiItemActiveBG:var(--color-xert-teal);
}
grid-4.svelte-111dcsc > row-container.svelte-111dcsc {
  grid-column: span 1;
}
grid-3.svelte-111dcsc.svelte-111dcsc {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media (max-width: 900px) {
  grid-3.svelte-111dcsc.svelte-111dcsc {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
.col.svelte-111dcsc.svelte-111dcsc {
  grid-column: span 1;
}
.col-fill.svelte-111dcsc.svelte-111dcsc {
  grid-column: 1/-1;
}
.col-new.svelte-111dcsc.svelte-111dcsc {
  grid-column: 1;
}
.col-2.svelte-111dcsc.svelte-111dcsc {
  grid-column: span 2;
}
.col-2-new.svelte-111dcsc.svelte-111dcsc {
  grid-column: 1/span 2;
}
radio-group.svelte-111dcsc.svelte-111dcsc {
  grid-column: span 1;
}
radio-group.svelte-111dcsc > input.svelte-111dcsc {
  margin: auto 0 auto 0;
}
radio-group.svelte-111dcsc > label.svelte-111dcsc {
  margin: auto 15px auto 5px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SessionScheduler.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
.svelte-5r86te.svelte-5r86te::placeholder {
  opacity: 0.5;
}
.subtext.svelte-5r86te.svelte-5r86te {
  color: grey;
}
.content-center.svelte-5r86te.svelte-5r86te {
  position: relative;
}
.flex-container.svelte-5r86te.svelte-5r86te {
  display: flex;
  flex-direction: column;
  align-content: stretch;
}
row-container.svelte-5r86te.svelte-5r86te,
ul.svelte-5r86te.svelte-5r86te {
  display: flex;
  align-items: start;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
}
row-container.svelte-5r86te > input.svelte-5r86te,
row-container.svelte-5r86te > .my-input.svelte-5r86te {
  margin: 0;
  width: 100%;
}
row-container.svelte-5r86te .my-input.svelte-5r86te {
  --height:33.2px;
  --multiClearTop:3px;
  --multiItemHeight:22px;
  --clearSelectTop:4px;
  --clearSelectBottom:4px;
  --padding:0.4em;
  --itemHoverBG:#4AA;
  --multiItemActiveBG:var(--color-xert-teal);
}
grid-4.svelte-5r86te > row-container.svelte-5r86te {
  grid-column: span 2;
}
grid-3.svelte-5r86te.svelte-5r86te {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media (max-width: 900px) {
  grid-3.svelte-5r86te.svelte-5r86te {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
.col.svelte-5r86te.svelte-5r86te {
  grid-column: span 2;
}
.col-fill.svelte-5r86te.svelte-5r86te {
  grid-column: span 4;
}
.col-2.svelte-5r86te.svelte-5r86te {
  grid-column: span 2;
}
radio-group.svelte-5r86te.svelte-5r86te {
  grid-column: span 1;
}
radio-group.svelte-5r86te > input.svelte-5r86te {
  margin: auto 0 auto 0;
}
radio-group.svelte-5r86te > label.svelte-5r86te {
  margin: auto 15px auto 5px;
}
.time-selector.svelte-5r86te.svelte-5r86te {
  background-color: #eee;
  border-radius: 12px !important;
  padding: 24px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SessionDetails.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
flex-container.svelte-k4nrwu.svelte-k4nrwu {
  display: flex;
  flex-direction: column;
  align-content: stretch;
}
flex-container.svelte-k4nrwu > div.desc-item.svelte-k4nrwu {
  flex: 1 0 200px;
}
flex-container.svelte-k4nrwu > img.workout-thumb.svelte-k4nrwu {
  display: inline-block;
  object-fit: contain;
  margin: 0 24px 0 0;
  border: 1px solid #ECECEC;
  border-radius: 4px;
}
flex-container.svelte-k4nrwu > img.club-logo.svelte-k4nrwu {
  display: inline-block;
  object-fit: contain;
  height: 80px;
  width: 80px;
  margin: 0 24px 0 0;
  border: 1px solid #ECECEC;
  border-radius: 4px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SessionBrowser.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 1100px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
@media (max-width: 1100px) {
}
ul.nav-tabs.svelte-hxgoky.svelte-hxgoky {
  display: flex;
  border-bottom: 1px solid #ECECEC;
  width: 100%;
  padding: 0px;
  margin: 0 0 24px 0;
  min-height: 40px;
  flex-wrap: wrap-reverse;
}
ul.nav-tabs.svelte-hxgoky > .tab-button.svelte-hxgoky {
  flex: 1 1 140px;
}
flex-container.svelte-hxgoky.svelte-hxgoky {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
flex-container.my-input.svelte-hxgoky.svelte-hxgoky {
  padding: 15px 26px 15px 26px;
  margin-bottom: 24px;
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #3D3D3D;
  font-size: 16px;
  line-height: 18px;
  --fontSize:16px;
  --height:30px;
  --padding:0 12px !important;
  --itemColor:var(--color-xert-gray-text);
  --border:1px solid var(--color-xert-gray);
  --borderFocusColor:var(--color-xert-gray);
  --borderHoverColor:var(--color-xert-blue);
  --borderRadius:3px !important;
  --listBorder:1px solid var(--color-xert-blue);
  --indicatorRight:20px;
  --indicatorTop:0;
  --indicatorHeight:0;
  --indicatorWidth:0;
}
flex-container.my-input.svelte-hxgoky > h3.svelte-hxgoky {
  margin: 0px;
}
flex-container.my-input.svelte-hxgoky > div.svelte-hxgoky {
  flex: 0 0 131px;
}
flex-container.my-input.svelte-hxgoky > button.svelte-hxgoky,
flex-container.my-input.svelte-hxgoky > button.svelte-hxgoky:focus {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #3D3D3D;
  font-size: 16px;
  line-height: 18px;
  border-radius: var(--borderRadius) !important;
  background-color: white;
  border: var(--border) !important;
  height: 30px;
}
flex-container.my-input.svelte-hxgoky > button.svelte-hxgoky:hover,
flex-container.my-input.svelte-hxgoky > button.svelte-hxgoky:active {
  border-color: var(--borderHoverColor) !important;
  background-color: white;
}
flex-container.svelte-hxgoky > div.svelte-hxgoky {
  max-width: 100%;
  flex: 1 1 100%;
}
button.btn-session.svelte-hxgoky.svelte-hxgoky {
  overflow: unset;
}

/* fakecss:/home/forge/alpha/svelte-components/src/XertTheme.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
root span.w500 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #3D3D3D;
}
root h1.w400 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 21px;
  letter-spacing: 0.27;
  color: #3D3D3D;
}
root h2.w500 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  letter-spacing: 0.266667px;
  color: #3D3D3D;
}
root h3.w500 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.266667px;
  color: #3D3D3D;
}
root h4.w500 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.266667px;
  color: #3D3D3D;
}
root h4.w400 {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #3D3D3D;
  mix-blend-mode: normal;
}
root h5.italic {
  font-family: Roboto;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #3D3D3D;
}
root .text-nowrap {
  text-overflow: clip;
}
root .text-centre {
  text-align: center;
}
root .tab-button {
  flex: 0.5 1 300px;
  text-align: center;
}
root spacer {
  flex: 1 0 0;
}
root .flex-row {
  flex-direction: row !important;
}
root .flex-wrap {
  flex-wrap: wrap;
}
root vr {
  padding: 3px 0;
  border-left: 1px solid #ECECEC;
}
root .margin-vcentre {
  margin: auto 0 auto 0;
}
root coarse-grid {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
@media (max-width: 750px) {
  root coarse-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
root grid-4 {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
@media (max-width: 900px) {
  root grid-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 500px) {
  root grid-4 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
root .col {
  grid-column: span 1;
}
root .col-fill {
  grid-column: 1/-1;
}
root .grid-outline {
  border: 1px solid #ECECEC;
  border-radius: 4px;
  padding: 24px;
}
root input,
root select,
root textarea {
  font-family: inherit;
  font-size: inherit;
  -webkit-padding: 0.4em 0;
  padding: 0.4em;
  margin: 0 0 0 0;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 2px;
}
root input:disabled {
  color: #ccc;
}
root ul.nav.nav-tabs > li.active > a,
root ul.nav.nav-tabs > li > a:hover {
  border: none;
  color: #016e79;
  background: transparent;
}
root ul.nav-tabs-style.sticky > li > a::after {
  content: "";
  background: #016e79;
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: -1px;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
root ul.nav-tabs-style > li > a:not(.nounderline)::after {
  content: "";
  background: #016e79;
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: -3px;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
root ul.nav-tabs-style > li.active > a::after,
root ul.nav-tabs-style > li:hover > a:not(.nounderline)::after {
  transform: scale(1);
}
root ul.nav-tabs {
  background: none;
  margin: 1px 0 0 0;
  display: inline-block;
  border: 0;
}
root ul.nav-tabs > li {
  margin: 0;
  padding: 0;
}
root ul.nav-tabs > li > a {
  font-family: Roboto;
  margin: 0;
  padding: 6px;
  font-size: 16px;
  color: #666;
  height: 37px;
  border: none;
}
root ul.nav-tabs > li.active > a,
root ul.nav-tabs > li:hover > a {
  margin: 0;
  background: none;
  color: #333;
}

/* fakecss:/home/forge/alpha/svelte-components/src/GroupCommunityIcon.esbuild-svelte-fake-css */
svg.svelte-16mdele {
  margin: auto;
}
p.svelte-16mdele {
  margin: 0 0 16px 0;
}
flex.svelte-16mdele {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/GroupCommunityPicker.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
h1.w400.svelte-1jsk856.svelte-1jsk856 {
  margin-bottom: 24px;
}
.medium.svelte-1jsk856.svelte-1jsk856 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #3D3D3D;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 24px;
}
.center.svelte-1jsk856.svelte-1jsk856 {
  text-align: center;
}
grid.svelte-1jsk856.svelte-1jsk856 {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 16px calc(50% - 250px);
}
grid.waiting.svelte-1jsk856.svelte-1jsk856 {
  opacity: 50%;
}
grid.svelte-1jsk856 > button.svelte-1jsk856 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #3D3D3D;
  font-size: 16px;
  line-height: 18px;
  color: #2F7076;
  aspect-ratio: 1;
  background: rgba(47, 112, 118, 0.2);
  border: unset;
  border-radius: 4px !important;
}
grid.svelte-1jsk856 > button.joined.svelte-1jsk856 {
  border: 2px solid #2F7076;
}

/* fakecss:/home/forge/alpha/svelte-components/src/GroupCommunityPickerModal.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
h4.w500.svelte-s86qcv.svelte-s86qcv {
  font-size: 20px;
}
.footer.svelte-s86qcv.svelte-s86qcv {
  display: flex;
  justify-content: end;
}
.footer.svelte-s86qcv > button.svelte-s86qcv {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #3D3D3D;
  font-size: 16px;
  line-height: 18px;
  height: 40px;
  padding: 10px;
  min-width: 104px;
  color: white;
  border: unset !important;
  background: #2F7076;
  border-radius: 4px !important;
}

/* fakecss:/home/forge/alpha/svelte-components/src/App.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
root.svelte-1hl2f3a .tab-button.svelte-1hl2f3a.svelte-1hl2f3a {
  flex: 0.5 1 300px;
  text-align: center;
}
root.svelte-1hl2f3a vr.svelte-1hl2f3a.svelte-1hl2f3a {
  padding: 3px 0;
  border-left: 1px solid #ECECEC;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
buttons.svelte-1hl2f3a.svelte-1hl2f3a.svelte-1hl2f3a {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  --xert-button-width:210px;
}
buttons.svelte-1hl2f3a > .btn-default.svelte-1hl2f3a.svelte-1hl2f3a {
  margin: 10px 0;
}
@media (max-width: 500px) {
  buttons.svelte-1hl2f3a.svelte-1hl2f3a.svelte-1hl2f3a {
    --xert-button-display-text:none;
    --xert-button-width:135px;
  }
  buttons.svelte-1hl2f3a > button.svelte-1hl2f3a > span.svelte-1hl2f3a,
  buttons.svelte-1hl2f3a > a.svelte-1hl2f3a > span.svelte-1hl2f3a {
    display: none;
  }
}
.link.svelte-1hl2f3a.svelte-1hl2f3a.svelte-1hl2f3a {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.129369px;
  color: #8B8B8B;
}
.link.svelte-1hl2f3a > svg.svelte-1hl2f3a.svelte-1hl2f3a {
  margin-right: 10px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Icon.esbuild-svelte-fake-css */
.xr-icon.svelte-1ournh1 {
  display: inline-block;
  flex: none;
  vertical-align: middle;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Badges.esbuild-svelte-fake-css */
.xr-badges.svelte-1ynknbl.svelte-1ynknbl {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.xr-chip.svelte-1ynknbl.svelte-1ynknbl {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  padding: 9px 18px 9px 14px;
  border-radius: 999px;
  background: var(--panel);
  border: 2px solid var(--chip, var(--faint));
  font-size: 22px;
  font-weight: 600;
  white-space: nowrap;
}
.xr-lg.svelte-1ynknbl .xr-chip.svelte-1ynknbl {
  font-size: 26px;
  padding: 11px 22px 11px 16px;
}
.xr-text.svelte-1ynknbl.svelte-1ynknbl {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 560px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Brand.esbuild-svelte-fake-css */
.xr-brand.svelte-xmjbxv.svelte-xmjbxv {
  display: flex;
  align-items: center;
  gap: 16px;
}
.xr-brand.svelte-xmjbxv img.svelte-xmjbxv {
  display: block;
  max-width: none;
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.35));
}
.xr-light.svelte-xmjbxv img.svelte-xmjbxv {
  filter: none;
}
.xr-tagline.svelte-xmjbxv.svelte-xmjbxv {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Diamonds.esbuild-svelte-fake-css */
.xr-diamonds.svelte-1ntd3w7 {
  display: inline-flex;
  align-items: center;
}
svg.svelte-1ntd3w7 {
  display: block;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Fill.esbuild-svelte-fake-css */
.xr-fill.svelte-3stwk9 {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
}
.xr-inner.svelte-3stwk9 {
  position: absolute;
  inset: 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Frame.esbuild-svelte-fake-css */
.xr-frame.svelte-121i2ng.svelte-121i2ng {
  position: relative;
  overflow: hidden;
  color: #f4f6f8;
  font-family:
    "Inter",
    system-ui,
    -apple-system,
    "Segoe UI",
    sans-serif;
  font-size: 28px;
  line-height: 1.2;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  --display:"Barlow Condensed",
    "Arial Narrow",
    sans-serif;
  --muted:rgba(244, 246, 248, 0.68);
  --faint:rgba(244, 246, 248, 0.14);
  --panel:rgba(255, 255, 255, 0.07);
  --good:#3ddc84;
  --bad:#ff5d6c;
}
.xr-frame.xr-light.svelte-121i2ng.svelte-121i2ng {
  color: #11181c;
  --muted:rgba(17, 24, 28, 0.6);
  --faint:rgba(17, 24, 28, 0.12);
  --panel:rgba(17, 24, 28, 0.05);
  --good:#12a150;
  --bad:#d6283b;
}
.xr-frame :is(div, span, h1, h2, h3, p, img, strong, small, em, i):not(svg *) {
  all: revert;
}
.xr-frame.svelte-121i2ng * {
  box-sizing: border-box;
}
.xr-frame.svelte-121i2ng h1,
.xr-frame.svelte-121i2ng h2,
.xr-frame.svelte-121i2ng h3,
.xr-frame.svelte-121i2ng p {
  margin: 0;
  padding: 0;
  font-weight: inherit;
  line-height: inherit;
}
.xr-layer.svelte-121i2ng.svelte-121i2ng {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.xr-stage.svelte-121i2ng.svelte-121i2ng {
  position: absolute;
  left: 0;
}
.xr-photo.svelte-121i2ng.svelte-121i2ng {
  object-fit: cover;
  max-width: none;
}
.xr-content.svelte-121i2ng.svelte-121i2ng {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: 64px 72px 56px;
}
.xr-square.svelte-121i2ng .xr-content.svelte-121i2ng {
  padding: 54px 64px 48px;
}
.xr-landscape.svelte-121i2ng .xr-content.svelte-121i2ng {
  padding: 60px 76px 54px;
}
.xr-content.svelte-121i2ng > * {
  flex-shrink: 0;
}
.xr-content.svelte-121i2ng .xr-layout > * {
  min-height: min-content;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/PowerChart.esbuild-svelte-fake-css */
.xr-chart.svelte-110wpi1 {
  display: block;
  overflow: visible;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Shield.esbuild-svelte-fake-css */
.xr-shield.svelte-1wukc0x {
  display: inline-block;
  flex: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/StatGrid.esbuild-svelte-fake-css */
.xr-grid.svelte-kxsuaq.svelte-kxsuaq {
  display: grid;
  row-gap: 28px;
}
.xr-stat.svelte-kxsuaq.svelte-kxsuaq {
  min-width: 0;
  padding: 0 20px;
}
.xr-grid.svelte-kxsuaq:not(.xr-center) .xr-stat.svelte-kxsuaq {
  padding-left: 0;
}
.xr-stat.xr-divided.svelte-kxsuaq.svelte-kxsuaq {
  border-left: 2px solid var(--faint);
  padding-left: 24px;
}
.xr-center.svelte-kxsuaq .xr-stat.svelte-kxsuaq {
  text-align: center;
}
.xr-center.svelte-kxsuaq .xr-label.svelte-kxsuaq {
  justify-content: center;
}
.xr-label.svelte-kxsuaq.svelte-kxsuaq {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-value.svelte-kxsuaq.svelte-kxsuaq {
  margin-top: 6px;
  font-family: var(--display);
  font-weight: 700;
  font-size: 64px;
  line-height: 1;
  white-space: nowrap;
}
.xr-sm.svelte-kxsuaq .xr-value.svelte-kxsuaq {
  font-size: 52px;
}
.xr-lg.svelte-kxsuaq .xr-value.svelte-kxsuaq {
  font-size: 84px;
}
.xr-lg.svelte-kxsuaq .xr-label.svelte-kxsuaq {
  font-size: 23px;
}
.xr-high.svelte-kxsuaq.svelte-kxsuaq {
  display: inline-flex;
  margin-left: 10px;
  vertical-align: -0.04em;
}
.xr-diamonds.svelte-kxsuaq.svelte-kxsuaq {
  margin-top: 10px;
  display: flex;
}
.xr-center.svelte-kxsuaq .xr-diamonds.svelte-kxsuaq {
  justify-content: center;
}
.xr-parts.svelte-kxsuaq.svelte-kxsuaq {
  display: flex;
  align-items: center;
  gap: 0.45em;
  font-size: 40px;
}
.xr-sm.svelte-kxsuaq .xr-parts.svelte-kxsuaq {
  font-size: 34px;
}
.xr-lg.svelte-kxsuaq .xr-parts.svelte-kxsuaq {
  font-size: 52px;
}
.xr-center.svelte-kxsuaq .xr-parts.svelte-kxsuaq {
  justify-content: center;
}
.xr-part.svelte-kxsuaq.svelte-kxsuaq {
  display: inline-flex;
  align-items: center;
  gap: 0.18em;
}
.xr-dot.svelte-kxsuaq.svelte-kxsuaq {
  width: 0.32em;
  height: 0.32em;
  border-radius: 50%;
  flex: none;
}
.xr-unit.svelte-kxsuaq.svelte-kxsuaq {
  margin-left: 6px;
  font-size: 0.5em;
  font-weight: 600;
  color: var(--muted);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/TitleBlock.esbuild-svelte-fake-css */
.xr-title.svelte-st6ifx.svelte-st6ifx {
  font-family: var(--display);
  font-weight: 700;
  font-size: 64px;
  line-height: 1.02;
  letter-spacing: 0.005em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}
.xr-lg.svelte-st6ifx .xr-title.svelte-st6ifx {
  font-size: 80px;
}
.xr-xl.svelte-st6ifx .xr-title.svelte-st6ifx {
  font-size: 104px;
  line-height: 0.98;
}
.xr-meta.svelte-st6ifx.svelte-st6ifx {
  margin-top: 12px !important;
  font-size: 26px;
  font-weight: 500;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-lg.svelte-st6ifx .xr-meta.svelte-st6ifx,
.xr-xl.svelte-st6ifx .xr-meta.svelte-st6ifx {
  font-size: 28px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/ActivityAnalysis.esbuild-svelte-fake-css */
.xr-layout.svelte-198lfcj.svelte-198lfcj {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top" "title" "xss" "cards" "chart" "stats" "badges";
  row-gap: 30px;
}
.xr-square .xr-layout.svelte-198lfcj.svelte-198lfcj {
  row-gap: 22px;
}
.xr-landscape .xr-layout.svelte-198lfcj.svelte-198lfcj {
  grid-template-columns: 620px minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "title chart" "xss chart" "cards chart" "cards stats" "badges badges";
  column-gap: 70px;
  row-gap: 28px;
}
.xr-title.svelte-198lfcj.svelte-198lfcj {
  grid-area: title;
  min-width: 0;
}
.xr-xss.svelte-198lfcj.svelte-198lfcj {
  grid-area: xss;
}
.xr-cards.svelte-198lfcj.svelte-198lfcj {
  grid-area: cards;
  align-self: start;
}
.xr-chart.svelte-198lfcj.svelte-198lfcj {
  grid-area: chart;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-198lfcj.svelte-198lfcj {
  grid-area: stats;
}
.xr-badges.svelte-198lfcj.svelte-198lfcj {
  grid-area: badges;
}
.xr-badges.svelte-198lfcj.svelte-198lfcj:empty {
  display: none;
}
.xr-square .xr-xss-num.svelte-198lfcj.svelte-198lfcj {
  font-size: 116px;
}
.xr-square .xr-card.svelte-198lfcj.svelte-198lfcj {
  padding: 14px 20px;
}
.xr-square .xr-v.svelte-198lfcj.svelte-198lfcj {
  font-size: 46px;
  min-height: 46px;
}
.xr-landscape .xr-xss-num.svelte-198lfcj.svelte-198lfcj {
  font-size: 124px;
}
.xr-landscape .xr-legend.svelte-198lfcj.svelte-198lfcj {
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 6px 22px;
}
.xr-landscape .xr-card.svelte-198lfcj.svelte-198lfcj {
  padding: 16px 18px;
}
.xr-landscape .xr-v.svelte-198lfcj.svelte-198lfcj {
  font-size: 42px;
  min-height: 42px;
}
.xr-top.svelte-198lfcj.svelte-198lfcj {
  grid-area: top;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-eyebrow.svelte-198lfcj.svelte-198lfcj {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-xss.svelte-198lfcj.svelte-198lfcj {
  display: flex;
  align-items: center;
  gap: 40px;
}
.xr-xss-total.svelte-198lfcj.svelte-198lfcj {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 0.85;
}
.xr-xss-num.svelte-198lfcj.svelte-198lfcj {
  font-family: var(--display);
  font-weight: 800;
  font-size: 150px;
}
.xr-xss-label.svelte-198lfcj.svelte-198lfcj {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.3em;
  color: var(--muted);
}
.xr-xss-break.svelte-198lfcj.svelte-198lfcj {
  flex: 1;
  min-width: 0;
}
.xr-bar.svelte-198lfcj.svelte-198lfcj {
  display: flex;
  gap: 6px;
  height: 34px;
  border-radius: 999px;
  overflow: hidden;
}
.xr-legend.svelte-198lfcj.svelte-198lfcj {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  font-size: 24px;
  color: var(--muted);
}
.xr-legend.svelte-198lfcj span.svelte-198lfcj {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.xr-legend.svelte-198lfcj i.svelte-198lfcj {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.xr-legend.svelte-198lfcj strong.svelte-198lfcj {
  color: #11181c;
  font-weight: 800;
}
.xr-legend.svelte-198lfcj em.svelte-198lfcj {
  font-style: normal;
}
.xr-cards.svelte-198lfcj.svelte-198lfcj {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.xr-card.svelte-198lfcj.svelte-198lfcj {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.7);
  border: 2px solid var(--faint);
  min-width: 0;
}
.xr-k.svelte-198lfcj.svelte-198lfcj {
  font-size: 19px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-v.svelte-198lfcj.svelte-198lfcj {
  display: flex;
  align-items: baseline;
  min-height: 56px;
  align-items: center;
  font-family: var(--display);
  font-weight: 800;
  font-size: 56px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-v.svelte-198lfcj small.svelte-198lfcj {
  margin-left: 8px;
  font-size: 0.42em;
  color: var(--muted);
}
.xr-s.svelte-198lfcj.svelte-198lfcj {
  font-size: 22px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/RouteMap.esbuild-svelte-fake-css */
.xr-route.svelte-ws5jjs {
  display: block;
  overflow: visible;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/ActivityPoster.esbuild-svelte-fake-css */
.xr-layout.svelte-vmjgo1 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top" "." "main" "stats" "badges";
}
.xr-landscape .xr-layout.svelte-vmjgo1 {
  grid-template-columns: minmax(0, 1fr) 560px;
  grid-template-rows: auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" ". ." "main stats" "badges badges";
  column-gap: 70px;
}
.xr-top.svelte-vmjgo1 {
  grid-area: top;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.xr-main.svelte-vmjgo1 {
  grid-area: main;
  min-width: 0;
}
.xr-stats.svelte-vmjgo1 {
  grid-area: stats;
}
.xr-landscape .xr-stats.svelte-vmjgo1 {
  align-self: end;
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
  padding-left: 50px;
  border-left: 2px solid var(--faint);
  padding-bottom: 14px;
}
.xr-badges.svelte-vmjgo1 {
  grid-area: badges;
}
.xr-square .xr-hero-value.svelte-vmjgo1 {
  font-size: 200px;
}
.xr-square .xr-hero-unit.svelte-vmjgo1 {
  font-size: 76px;
}
.xr-square .xr-stats.svelte-vmjgo1 {
  margin-top: 26px;
  padding-top: 22px;
}
.xr-square .xr-badges.svelte-vmjgo1 {
  margin-top: 22px;
}
.xr-mini-route.svelte-vmjgo1 {
  opacity: 0.9;
  filter: drop-shadow(0 4px 18px rgba(0, 0, 0, 0.5));
}
.xr-hero.svelte-vmjgo1 {
  display: flex;
  align-items: baseline;
  gap: 18px;
  margin-top: 18px;
  font-family: var(--display);
  font-weight: 800;
  font-style: italic;
  line-height: 0.85;
  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.4);
}
.xr-hero-value.svelte-vmjgo1 {
  font-size: 260px;
  letter-spacing: -0.01em;
}
.xr-hero-unit.svelte-vmjgo1 {
  font-size: 96px;
  color: var(--accent);
  text-transform: uppercase;
}
.xr-stats.svelte-vmjgo1 {
  margin-top: 34px;
  padding-top: 30px;
  border-top: 2px solid var(--faint);
}
.xr-badges.svelte-vmjgo1 {
  margin-top: 28px;
}
.xr-badges.svelte-vmjgo1:empty {
  display: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/ElevationProfile.esbuild-svelte-fake-css */
.xr-elev.svelte-53u7em {
  display: block;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/ActivityRoute.esbuild-svelte-fake-css */
.xr-grid.svelte-6a72c6 {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.045) 2px, transparent 2px),
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.045) 2px,
      transparent 2px);
  background-size: 90px 90px;
  background-position: -2px -2px;
  mask-image:
    radial-gradient(
      70% 55% at 50% 45%,
      black 30%,
      transparent 100%);
  -webkit-mask-image:
    radial-gradient(
      70% 55% at 50% 45%,
      black 30%,
      transparent 100%);
}
.xr-layout.svelte-6a72c6 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top" "graphic" "stats" "badges";
  row-gap: 30px;
}
.xr-square .xr-layout.svelte-6a72c6 {
  row-gap: 22px;
}
.xr-landscape .xr-layout.svelte-6a72c6 {
  grid-template-columns: 560px minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top graphic" "stats graphic" "badges graphic" "brand graphic";
  column-gap: 70px;
  row-gap: 30px;
}
.xr-top.svelte-6a72c6 {
  grid-area: top;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
  min-width: 0;
}
.xr-graphic.svelte-6a72c6 {
  grid-area: graphic;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-6a72c6 {
  grid-area: stats;
}
.xr-landscape .xr-stats.svelte-6a72c6 {
  align-self: end;
}
.xr-badges.svelte-6a72c6 {
  grid-area: badges;
}
.xr-badges.svelte-6a72c6:empty {
  display: none;
}
.xr-brand.svelte-6a72c6 {
  grid-area: brand;
}
.xr-elev.svelte-6a72c6 {
  display: flex;
  margin-top: 16px;
  border-bottom: 2px solid var(--faint);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/BtPoster.esbuild-svelte-fake-css */
.xr-layout.svelte-1d2jjhl.svelte-1d2jjhl {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr) auto auto auto auto;
  grid-template-areas: "top" "." "hero" "rest" "chart" "footer";
}
.xr-landscape .xr-layout.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top top" ". ." "hero rest" "chart chart" "footer footer";
  column-gap: 60px;
}
.xr-top.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: top;
}
.xr-hero.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: hero;
  min-width: 0;
}
.xr-rest.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: rest;
}
.xr-chart.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: chart;
  display: flex;
}
.xr-footer.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: footer;
}
.xr-footer-badges.svelte-1d2jjhl.svelte-1d2jjhl:empty {
  display: none;
}
.xr-top.svelte-1d2jjhl.svelte-1d2jjhl {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-ribbon.svelte-1d2jjhl.svelte-1d2jjhl {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 28px 14px 20px;
  border-radius: 999px;
  color: #11181c;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}
.xr-hero.svelte-1d2jjhl.svelte-1d2jjhl {
  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.45);
}
.xr-hero-value.svelte-1d2jjhl.svelte-1d2jjhl {
  display: flex;
  align-items: baseline;
  font-family: var(--display);
  font-weight: 800;
  font-style: italic;
  line-height: 0.82;
}
.xr-num.svelte-1d2jjhl.svelte-1d2jjhl {
  font-size: 300px;
  letter-spacing: -0.01em;
}
.xr-square .xr-num.svelte-1d2jjhl.svelte-1d2jjhl {
  font-size: 230px;
}
.xr-landscape .xr-num.svelte-1d2jjhl.svelte-1d2jjhl {
  font-size: 280px;
}
.xr-hero-unit.svelte-1d2jjhl.svelte-1d2jjhl {
  font-size: 110px;
  margin-left: 16px;
  color: var(--accent);
}
.xr-square .xr-hero-unit.svelte-1d2jjhl.svelte-1d2jjhl {
  font-size: 88px;
}
.xr-hero-label.svelte-1d2jjhl.svelte-1d2jjhl {
  margin-top: 14px;
  font-family: var(--display);
  font-weight: 700;
  font-size: 64px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.xr-hero-sub.svelte-1d2jjhl.svelte-1d2jjhl {
  margin-top: 6px;
  font-size: 30px;
  color: var(--muted);
}
.xr-hero-sub.svelte-1d2jjhl strong.svelte-1d2jjhl {
  color: #fff;
  font-weight: 700;
}
.xr-rest.svelte-1d2jjhl.svelte-1d2jjhl {
  display: flex;
  gap: 48px;
  margin-top: 28px;
}
.xr-square .xr-rest.svelte-1d2jjhl.svelte-1d2jjhl {
  margin-top: 22px;
}
.xr-landscape .xr-rest.svelte-1d2jjhl.svelte-1d2jjhl {
  flex-direction: column;
  justify-content: flex-end;
  gap: 30px;
  margin: 0 0 8px;
}
.xr-rest-item.svelte-1d2jjhl.svelte-1d2jjhl {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  border-left: 5px solid var(--accent);
}
.xr-rest-value.svelte-1d2jjhl.svelte-1d2jjhl {
  font-family: var(--display);
  font-weight: 700;
  font-size: 56px;
  line-height: 1;
}
.xr-rest-label.svelte-1d2jjhl.svelte-1d2jjhl {
  margin-top: 4px;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-chart.svelte-1d2jjhl.svelte-1d2jjhl {
  margin-top: 34px;
}
.xr-square .xr-chart.svelte-1d2jjhl.svelte-1d2jjhl {
  margin-top: 24px;
}
.xr-footer.svelte-1d2jjhl.svelte-1d2jjhl {
  display: flex;
  flex-direction: column;
  gap: 26px;
  margin-top: 34px;
  padding-top: 30px;
  border-top: 2px solid var(--faint);
}
.xr-square .xr-footer.svelte-1d2jjhl.svelte-1d2jjhl {
  gap: 20px;
  margin-top: 24px;
  padding-top: 22px;
}
.xr-landscape .xr-footer.svelte-1d2jjhl.svelte-1d2jjhl {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.3fr);
  grid-template-areas: "title stats" "badges badges";
  column-gap: 60px;
  row-gap: 22px;
  align-items: end;
}
.xr-landscape .xr-footer-title.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: title;
  min-width: 0;
}
.xr-landscape .xr-footer-stats.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: stats;
}
.xr-landscape .xr-footer-badges.svelte-1d2jjhl.svelte-1d2jjhl {
  grid-area: badges;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Medal.esbuild-svelte-fake-css */
.xr-medal.svelte-1j6974a {
  display: block;
  overflow: visible;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/BtSignature.esbuild-svelte-fake-css */
.xr-layout.svelte-xbdygm.svelte-xbdygm {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(96px, 1fr) auto auto;
  grid-template-areas: "top" "head" "rows" "chart" "stats" "badges";
  row-gap: 22px;
}
.xr-square .xr-layout.svelte-xbdygm.svelte-xbdygm {
  row-gap: 22px;
}
.xr-landscape .xr-layout.svelte-xbdygm.svelte-xbdygm {
  grid-template-columns: 560px minmax(0, 1fr);
  grid-template-rows: auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top rows" "head rows" ". chart" "stats chart" "badges brand";
  column-gap: 80px;
  row-gap: 26px;
}
.xr-top.svelte-xbdygm.svelte-xbdygm {
  grid-area: top;
}
.xr-head.svelte-xbdygm.svelte-xbdygm {
  grid-area: head;
  min-width: 0;
}
.xr-rows.svelte-xbdygm.svelte-xbdygm {
  grid-area: rows;
}
.xr-chart.svelte-xbdygm.svelte-xbdygm {
  grid-area: chart;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-xbdygm.svelte-xbdygm {
  grid-area: stats;
}
.xr-badges.svelte-xbdygm.svelte-xbdygm {
  grid-area: badges;
}
.xr-badges.svelte-xbdygm.svelte-xbdygm:empty {
  display: none;
}
.xr-brand.svelte-xbdygm.svelte-xbdygm {
  grid-area: brand;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.xr-top.svelte-xbdygm.svelte-xbdygm {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-badge.svelte-xbdygm.svelte-xbdygm {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.xr-headline.svelte-xbdygm.svelte-xbdygm {
  margin: 0 0 18px !important;
  font-family: var(--display);
  font-weight: 800;
  font-size: 132px;
  line-height: 0.88;
  text-transform: uppercase;
  letter-spacing: -0.005em;
}
.xr-portrait .xr-headline.svelte-xbdygm.svelte-xbdygm {
  font-size: 116px;
}
.xr-portrait .xr-after.svelte-xbdygm.svelte-xbdygm {
  font-size: 64px;
}
.xr-portrait .xr-before.svelte-xbdygm.svelte-xbdygm {
  font-size: 44px;
}
.xr-square .xr-headline.svelte-xbdygm.svelte-xbdygm {
  font-size: 96px;
  margin-bottom: 14px !important;
}
.xr-landscape .xr-headline.svelte-xbdygm.svelte-xbdygm {
  font-size: 124px;
}
.xr-rows.svelte-xbdygm.svelte-xbdygm {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 4px 0;
}
.xr-square .xr-rows.svelte-xbdygm.svelte-xbdygm {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 30px;
  margin: 6px 0;
}
.xr-square .xr-row-values.svelte-xbdygm.svelte-xbdygm {
  flex-wrap: wrap;
  column-gap: 10px;
}
.xr-square .xr-row-head.svelte-xbdygm.svelte-xbdygm {
  flex-direction: column;
  align-items: flex-start;
}
.xr-square .xr-before.svelte-xbdygm.svelte-xbdygm {
  font-size: 36px;
}
.xr-square .xr-arrow.svelte-xbdygm.svelte-xbdygm {
  font-size: 30px;
}
.xr-square .xr-after.svelte-xbdygm.svelte-xbdygm {
  font-size: 60px;
}
.xr-square .xr-row-pct.svelte-xbdygm.svelte-xbdygm {
  font-size: 38px;
}
.xr-square .xr-row-label.svelte-xbdygm.svelte-xbdygm {
  font-size: 20px;
}
.xr-landscape .xr-rows.svelte-xbdygm.svelte-xbdygm {
  gap: 34px;
  margin: 0;
}
.xr-row-head.svelte-xbdygm.svelte-xbdygm {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.xr-row-label.svelte-xbdygm.svelte-xbdygm {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-row-pct.svelte-xbdygm.svelte-xbdygm {
  font-family: var(--display);
  font-weight: 700;
  font-size: 44px;
  color: var(--good);
}
.xr-row-pct.xr-down.svelte-xbdygm.svelte-xbdygm {
  color: var(--bad);
}
.xr-row-values.svelte-xbdygm.svelte-xbdygm {
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin-top: -4px;
  font-family: var(--display);
  font-weight: 700;
  line-height: 1;
}
.xr-before.svelte-xbdygm.svelte-xbdygm {
  font-size: 48px;
  color: var(--muted);
}
.xr-arrow.svelte-xbdygm.svelte-xbdygm {
  font-size: 40px;
  color: var(--muted);
}
.xr-after.svelte-xbdygm.svelte-xbdygm {
  font-size: 72px;
}
.xr-after.svelte-xbdygm small.svelte-xbdygm {
  font-size: 30px;
  margin-left: 6px;
  color: var(--muted);
}
.xr-track.svelte-xbdygm.svelte-xbdygm {
  margin-top: 12px;
  height: 12px;
  border-radius: 999px;
  background: var(--faint);
  overflow: hidden;
}
.xr-bar.svelte-xbdygm.svelte-xbdygm {
  height: 100%;
  border-radius: 999px;
  background: var(--accent);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/SignatureDeltas.esbuild-svelte-fake-css */
.xr-deltas.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}
.xr-cards.svelte-198zlwn .xr-item.svelte-198zlwn.svelte-198zlwn {
  padding: 22px 24px 24px;
  border-radius: 24px;
  background: var(--panel);
  border: 2px solid var(--faint);
}
.xr-inline.svelte-198zlwn .xr-item.svelte-198zlwn + .xr-item.svelte-198zlwn {
  border-left: 2px solid var(--faint);
  padding-left: 24px;
}
.xr-label.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-value.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  margin-top: 8px;
  font-family: var(--display);
  font-weight: 700;
  font-size: 72px;
  line-height: 1;
}
.xr-unit.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  margin-left: 6px;
  font-size: 0.45em;
  color: var(--muted);
}
.xr-delta.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  display: inline-block;
  margin-top: 12px;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 24px;
  font-weight: 700;
  background: var(--faint);
}
.xr-delta.xr-up.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  color: var(--good);
  background: color-mix(in srgb, var(--good) 16%, transparent);
}
.xr-delta.xr-down.svelte-198zlwn.svelte-198zlwn.svelte-198zlwn {
  color: var(--bad);
  background: color-mix(in srgb, var(--bad) 16%, transparent);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/BtSpotlight.esbuild-svelte-fake-css */
.xr-layout.svelte-8fljo8 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top" "title" "hero" "deltas" "chart" "stats" "badges";
  row-gap: 28px;
}
.xr-square .xr-layout.svelte-8fljo8 {
  row-gap: 22px;
}
.xr-landscape .xr-layout.svelte-8fljo8 {
  grid-template-columns: 600px minmax(0, 1fr);
  grid-template-rows: auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "title deltas" "hero chart" "stats chart" "badges chart";
  column-gap: 72px;
  row-gap: 30px;
}
.xr-top.svelte-8fljo8 {
  grid-area: top;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-title.svelte-8fljo8 {
  grid-area: title;
  min-width: 0;
}
.xr-hero.svelte-8fljo8 {
  grid-area: hero;
}
.xr-deltas.svelte-8fljo8 {
  grid-area: deltas;
}
.xr-chart.svelte-8fljo8 {
  grid-area: chart;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-8fljo8 {
  grid-area: stats;
}
.xr-badges.svelte-8fljo8 {
  grid-area: badges;
}
.xr-badges.svelte-8fljo8:empty {
  display: none;
}
.xr-eyebrow.svelte-8fljo8 {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 0.32em;
  text-transform: uppercase;
}
.xr-hero.svelte-8fljo8 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin: 8px 0;
}
.xr-landscape .xr-hero.svelte-8fljo8 {
  justify-content: flex-start;
  align-self: center;
  gap: 34px;
  margin: 0;
}
.xr-hero-text.svelte-8fljo8 {
  display: flex;
  flex-direction: column;
}
.xr-level.svelte-8fljo8 {
  font-family: var(--display);
  font-weight: 800;
  font-style: italic;
  font-size: 176px;
  line-height: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.01em;
}
.xr-square .xr-level.svelte-8fljo8 {
  font-size: 132px;
}
.xr-landscape .xr-level.svelte-8fljo8 {
  font-size: 150px;
}
.xr-kind.svelte-8fljo8 {
  font-family: var(--display);
  font-weight: 700;
  font-size: 58px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  margin-top: 8px;
}
.xr-square .xr-kind.svelte-8fljo8 {
  font-size: 46px;
}
.xr-landscape .xr-kind.svelte-8fljo8 {
  font-size: 48px;
  letter-spacing: 0.12em;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Avatar.esbuild-svelte-fake-css */
.xr-avatar.svelte-t99lhi {
  position: relative;
  flex: none;
  border-radius: 50%;
  overflow: hidden;
  background: #33424a;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}
.xr-pic.svelte-t99lhi {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  max-width: none;
}
.xr-initials.svelte-t99lhi {
  font-weight: 700;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/GroupLeaderboard.esbuild-svelte-fake-css */
.xr-layout.svelte-x4qgo2.svelte-x4qgo2 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top" "head" "placed" "board" "." "awards" "title" "badges";
  row-gap: 24px;
}
.xr-square .xr-layout.svelte-x4qgo2.svelte-x4qgo2 {
  row-gap: 16px;
}
.xr-landscape .xr-layout.svelte-x4qgo2.svelte-x4qgo2 {
  grid-template-columns: 560px minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "head board" "placed board" "awards board" "title board" "badges badges";
  column-gap: 70px;
  row-gap: 28px;
}
.xr-top.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: top;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-head.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: head;
  min-width: 0;
}
.xr-placed.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: placed;
}
.xr-board.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: board;
}
.xr-landscape .xr-board.svelte-x4qgo2.svelte-x4qgo2 {
  align-self: center;
}
.xr-awards.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: awards;
}
.xr-title.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: title;
  min-width: 0;
}
.xr-landscape .xr-title.svelte-x4qgo2.svelte-x4qgo2 {
  align-self: end;
}
.xr-badges.svelte-x4qgo2.svelte-x4qgo2 {
  grid-area: badges;
}
.xr-badges.svelte-x4qgo2.svelte-x4qgo2:empty {
  display: none;
}
.xr-square .xr-session.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 72px;
}
.xr-square .xr-placed-num.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 104px;
}
.xr-square .xr-placed-of.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 44px;
}
.xr-square .xr-board.svelte-x4qgo2.svelte-x4qgo2 {
  gap: 8px;
}
.xr-square .xr-board-row.svelte-x4qgo2.svelte-x4qgo2 {
  padding: 4px 20px;
  grid-template-columns: 48px 50px 1fr 120px 150px;
}
.xr-square .xr-board-head.svelte-x4qgo2.svelte-x4qgo2 {
  padding-left: 138px;
  grid-template-columns: 1fr 120px 150px;
}
.xr-square .xr-rank.svelte-x4qgo2.svelte-x4qgo2,
.xr-square .xr-num.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 38px;
}
.xr-square .xr-who.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 26px;
}
.xr-square .xr-award.svelte-x4qgo2.svelte-x4qgo2 {
  padding: 12px 20px;
}
.xr-landscape .xr-session.svelte-x4qgo2.svelte-x4qgo2 {
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 80px;
}
.xr-landscape .xr-awards.svelte-x4qgo2.svelte-x4qgo2 {
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
}
.xr-landscape .xr-award.svelte-x4qgo2.svelte-x4qgo2 {
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  gap: 20px;
  padding: 14px 22px;
}
.xr-eyebrow.svelte-x4qgo2.svelte-x4qgo2 {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.26em;
  text-transform: uppercase;
}
.xr-session.svelte-x4qgo2.svelte-x4qgo2 {
  font-family: var(--display);
  font-weight: 800;
  font-size: 84px;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-workout.svelte-x4qgo2.svelte-x4qgo2 {
  margin-top: 10px;
  font-size: 30px;
  color: var(--muted);
}
.xr-placed.svelte-x4qgo2.svelte-x4qgo2 {
  display: flex;
  align-items: baseline;
  gap: 20px;
}
.xr-placed-num.svelte-x4qgo2.svelte-x4qgo2 {
  font-family: var(--display);
  font-weight: 800;
  font-style: italic;
  font-size: 140px;
  line-height: 0.85;
  color: var(--accent);
}
.xr-placed-of.svelte-x4qgo2.svelte-x4qgo2 {
  font-family: var(--display);
  font-size: 54px;
  font-weight: 700;
  text-transform: uppercase;
}
.xr-board.svelte-x4qgo2.svelte-x4qgo2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.xr-board-head.svelte-x4qgo2.svelte-x4qgo2,
.xr-board-row.svelte-x4qgo2.svelte-x4qgo2 {
  display: grid;
  grid-template-columns: 56px 64px 1fr 130px 160px;
  align-items: center;
  column-gap: 18px;
}
.xr-board-head.svelte-x4qgo2.svelte-x4qgo2 {
  grid-template-columns: 1fr 130px 160px;
  padding: 0 22px 0 160px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-board-head.svelte-x4qgo2 span.svelte-x4qgo2:not(:first-child),
.xr-num.svelte-x4qgo2.svelte-x4qgo2 {
  text-align: right;
}
.xr-board-row.svelte-x4qgo2.svelte-x4qgo2 {
  padding: 8px 22px;
  border-radius: 18px;
  background: var(--panel);
}
.xr-board-row.xr-me.svelte-x4qgo2.svelte-x4qgo2 {
  background: rgba(var(--accent-rgb), 0.22);
  box-shadow: inset 0 0 0 3px var(--accent);
}
.xr-rank.svelte-x4qgo2.svelte-x4qgo2 {
  font-family: var(--display);
  font-size: 46px;
  font-weight: 800;
  text-align: center;
}
.xr-who.svelte-x4qgo2.svelte-x4qgo2 {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 30px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-num.svelte-x4qgo2.svelte-x4qgo2 {
  font-family: var(--display);
  font-size: 46px;
  font-weight: 700;
}
.xr-awards.svelte-x4qgo2.svelte-x4qgo2 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.xr-award.svelte-x4qgo2.svelte-x4qgo2 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 22px;
  border-radius: 18px;
  border: 2px solid var(--faint);
  min-width: 0;
}
.xr-k.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--accent);
}
.xr-v.svelte-x4qgo2.svelte-x4qgo2 {
  font-size: 28px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/GroupPeloton.esbuild-svelte-fake-css */
.xr-layout.svelte-18xext9.svelte-18xext9 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top" "head" "riders" "pull" "graphic" "stats" "title" "badges";
  row-gap: 28px;
}
.xr-square .xr-layout.svelte-18xext9.svelte-18xext9 {
  row-gap: 20px;
}
.xr-landscape .xr-layout.svelte-18xext9.svelte-18xext9 {
  grid-template-columns: 640px minmax(0, 1fr);
  grid-template-rows: auto auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "head graphic" "riders graphic" "pull graphic" ". graphic" "title stats" "badges badges";
  column-gap: 70px;
  row-gap: 28px;
}
.xr-top.svelte-18xext9.svelte-18xext9 {
  grid-area: top;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-head.svelte-18xext9.svelte-18xext9 {
  grid-area: head;
  min-width: 0;
}
.xr-riders.svelte-18xext9.svelte-18xext9 {
  grid-area: riders;
}
.xr-pull.svelte-18xext9.svelte-18xext9 {
  grid-area: pull;
}
.xr-graphic.svelte-18xext9.svelte-18xext9 {
  grid-area: graphic;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-18xext9.svelte-18xext9 {
  grid-area: stats;
}
.xr-title.svelte-18xext9.svelte-18xext9 {
  grid-area: title;
  min-width: 0;
}
.xr-landscape .xr-title.svelte-18xext9.svelte-18xext9,
.xr-landscape .xr-stats.svelte-18xext9.svelte-18xext9 {
  align-self: end;
}
.xr-badges.svelte-18xext9.svelte-18xext9 {
  grid-area: badges;
}
.xr-badges.svelte-18xext9.svelte-18xext9:empty {
  display: none;
}
.xr-square .xr-headline.svelte-18xext9.svelte-18xext9 {
  font-size: 92px;
}
.xr-landscape .xr-headline.svelte-18xext9.svelte-18xext9 {
  font-size: 104px;
}
.xr-square .xr-more.svelte-18xext9.svelte-18xext9 {
  font-size: 34px;
}
.xr-square .xr-names.svelte-18xext9.svelte-18xext9 {
  margin-top: 14px;
  font-size: 26px;
}
.xr-square .xr-pull.svelte-18xext9.svelte-18xext9 {
  padding: 12px 24px;
}
.xr-square .xr-pull-value.svelte-18xext9.svelte-18xext9 {
  font-size: 60px;
}
.xr-eyebrow.svelte-18xext9.svelte-18xext9 {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.26em;
  text-transform: uppercase;
}
.xr-headline.svelte-18xext9.svelte-18xext9 {
  font-family: var(--display);
  font-weight: 800;
  font-size: 116px;
  line-height: 0.92;
  text-transform: uppercase;
}
.xr-accent.svelte-18xext9.svelte-18xext9 {
  color: var(--accent);
}
.xr-squad.svelte-18xext9.svelte-18xext9 {
  margin-top: 12px;
  font-size: 32px;
  font-weight: 600;
  color: var(--muted);
}
.xr-crowd.svelte-18xext9.svelte-18xext9 {
  display: flex;
  align-items: center;
  gap: 34px;
}
.xr-stack.svelte-18xext9.svelte-18xext9 {
  display: flex;
  align-items: center;
}
.xr-slot.svelte-18xext9.svelte-18xext9 {
  margin-left: -14px;
}
.xr-slot.svelte-18xext9.svelte-18xext9:first-child {
  margin-left: 0;
}
.xr-more.svelte-18xext9.svelte-18xext9 {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: #0b1114;
  font-family: var(--display);
  font-size: 42px;
  font-weight: 800;
  box-shadow: 0 0 0 6px #0d1d1e;
}
.xr-names.svelte-18xext9.svelte-18xext9 {
  margin-top: 20px;
  font-size: 30px;
  color: var(--muted);
}
.xr-footnote.svelte-18xext9.svelte-18xext9 {
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  color: var(--muted);
}
.xr-pull.svelte-18xext9.svelte-18xext9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 26px;
  border-radius: 20px;
  background: var(--panel);
  border: 2px solid var(--faint);
}
.xr-pull-label.svelte-18xext9.svelte-18xext9 {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-pull-value.svelte-18xext9.svelte-18xext9 {
  font-family: var(--display);
  font-size: 72px;
  font-weight: 800;
  line-height: 1;
  color: var(--accent);
}
.xr-pull-value.svelte-18xext9 small.svelte-18xext9 {
  margin-left: 6px;
  font-size: 0.45em;
  color: var(--muted);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/WorkoutCard.esbuild-svelte-fake-css */
.xr-band.svelte-1h2t4uu.svelte-1h2t4uu {
  position: absolute;
  top: -260px;
  right: -320px;
  width: 900px;
  height: 640px;
  background: var(--accent);
  opacity: 0.16;
  transform: rotate(-24deg);
  border-radius: 60px;
}
.xr-mark.svelte-1h2t4uu.svelte-1h2t4uu {
  position: absolute;
  right: -120px;
  top: 330px;
  width: 560px;
  height: 560px;
  fill: var(--accent);
  opacity: 0.06;
}
.xr-layout.svelte-1h2t4uu.svelte-1h2t4uu {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top" "name" "diff" "." "tiles" "chart" "footer";
  row-gap: 24px;
}
.xr-portrait .xr-name.svelte-1h2t4uu.svelte-1h2t4uu {
  margin-top: 20px;
}
.xr-square .xr-layout.svelte-1h2t4uu.svelte-1h2t4uu {
  row-gap: 22px;
}
.xr-landscape .xr-layout.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-template-columns: minmax(0, 1fr) 680px;
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "name tiles" "diff tiles" ". tiles" "chart chart" "footer footer";
  column-gap: 70px;
  row-gap: 30px;
}
.xr-top.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-area: top;
}
.xr-name.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-area: name;
}
.xr-diff.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-area: diff;
}
.xr-tiles.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-area: tiles;
}
.xr-landscape .xr-tiles.svelte-1h2t4uu.svelte-1h2t4uu {
  align-self: center;
}
.xr-chart.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-area: chart;
}
.xr-footer.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-area: footer;
}
.xr-square .xr-name.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 118px;
}
.xr-square .xr-name.xr-long.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 92px;
}
.xr-square .xr-diff.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 44px;
}
.xr-portrait .xr-tile-value.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 76px;
}
.xr-square .xr-tiles.svelte-1h2t4uu.svelte-1h2t4uu {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.xr-square .xr-tile.svelte-1h2t4uu.svelte-1h2t4uu {
  padding: 16px 18px;
}
.xr-square .xr-tile-label.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 17px;
}
.xr-square .xr-tile-value.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 52px;
}
.xr-landscape .xr-tile-value.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 76px;
}
.xr-landscape .xr-name.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 140px;
}
.xr-landscape .xr-name.xr-long.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 110px;
}
.xr-top.svelte-1h2t4uu.svelte-1h2t4uu {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-stamp.svelte-1h2t4uu.svelte-1h2t4uu {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 26px 12px 18px;
  border-radius: 999px;
  background: var(--accent);
  color: #0b1114;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.xr-name.svelte-1h2t4uu.svelte-1h2t4uu {
  font-family: var(--display);
  font-weight: 800;
  font-style: italic;
  font-size: 150px;
  line-height: 0.86;
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  overflow-wrap: anywhere;
}
.xr-diff.svelte-1h2t4uu.svelte-1h2t4uu {
  display: flex;
  align-items: center;
  gap: 22px;
  font-family: var(--display);
  font-size: 52px;
  font-weight: 700;
  text-transform: uppercase;
}
.xr-name.xr-long.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 118px;
}
.xr-tiles.svelte-1h2t4uu.svelte-1h2t4uu {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}
.xr-tile.svelte-1h2t4uu.svelte-1h2t4uu {
  display: flex;
  flex-direction: column;
  padding: 22px 26px;
  border-radius: 22px;
  background: var(--panel);
  border: 2px solid var(--faint);
  min-width: 0;
}
.xr-tile-label.svelte-1h2t4uu.svelte-1h2t4uu {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-tile-value.svelte-1h2t4uu.svelte-1h2t4uu {
  margin-top: 6px;
  font-family: var(--display);
  font-weight: 800;
  font-size: 84px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-tile-value.svelte-1h2t4uu small.svelte-1h2t4uu {
  margin-left: 8px;
  font-size: 0.45em;
  color: var(--muted);
}
.xr-tile-sub.svelte-1h2t4uu.svelte-1h2t4uu {
  margin-top: 4px;
  font-size: 22px;
  color: var(--muted);
}
.xr-chart.svelte-1h2t4uu.svelte-1h2t4uu {
  display: flex;
}
.xr-footer.svelte-1h2t4uu.svelte-1h2t4uu {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/WorkoutIntervals.esbuild-svelte-fake-css */
.xr-layout.svelte-1y3bjge.svelte-1y3bjge {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top" "head" "rating" "chart" "stats" "meta" "badges";
  row-gap: 28px;
}
.xr-square .xr-layout.svelte-1y3bjge.svelte-1y3bjge {
  row-gap: 22px;
}
.xr-landscape .xr-layout.svelte-1y3bjge.svelte-1y3bjge {
  grid-template-columns: 560px minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "head chart" "rating chart" "stats chart" "meta chart" "badges badges";
  column-gap: 80px;
  row-gap: 28px;
}
.xr-top.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: top;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-head.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: head;
  min-width: 0;
}
.xr-rating.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: rating;
}
.xr-chart.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: chart;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: stats;
}
.xr-landscape .xr-stats.svelte-1y3bjge.svelte-1y3bjge {
  align-self: end;
}
.xr-meta.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: meta;
  min-width: 0;
}
.xr-badges.svelte-1y3bjge.svelte-1y3bjge {
  grid-area: badges;
}
.xr-badges.svelte-1y3bjge.svelte-1y3bjge:empty {
  display: none;
}
.xr-square .xr-name.svelte-1y3bjge.svelte-1y3bjge {
  font-size: 88px;
}
.xr-landscape .xr-name.svelte-1y3bjge.svelte-1y3bjge {
  font-size: 96px;
  -webkit-line-clamp: 3;
}
.xr-eyebrow.svelte-1y3bjge.svelte-1y3bjge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.28em;
  text-transform: uppercase;
}
.xr-name.svelte-1y3bjge.svelte-1y3bjge {
  font-family: var(--display);
  font-weight: 800;
  font-size: 108px;
  line-height: 0.92;
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
}
.xr-program.svelte-1y3bjge.svelte-1y3bjge {
  margin-top: 16px;
  font-size: 30px;
  font-weight: 600;
  color: var(--accent);
}
.xr-rating.svelte-1y3bjge.svelte-1y3bjge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 22px 48px;
}
.xr-diff.svelte-1y3bjge.svelte-1y3bjge {
  display: flex;
  align-items: center;
  gap: 18px;
}
.xr-diff-label.svelte-1y3bjge.svelte-1y3bjge {
  font-family: var(--display);
  font-size: 48px;
  font-weight: 700;
  text-transform: uppercase;
}
.xr-focus.svelte-1y3bjge.svelte-1y3bjge {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 30px;
  color: var(--muted);
}
.xr-focus.svelte-1y3bjge strong.svelte-1y3bjge {
  color: var(--accent);
  font-weight: 700;
}
.xr-legend.svelte-1y3bjge.svelte-1y3bjge {
  display: flex;
  gap: 28px;
  margin-bottom: 14px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-legend.svelte-1y3bjge span.svelte-1y3bjge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.xr-legend.svelte-1y3bjge i.svelte-1y3bjge {
  display: inline-block;
  width: 36px;
  height: 0;
}
.xr-dash.svelte-1y3bjge.svelte-1y3bjge {
  border-top: 4px dashed #fff;
}
.xr-solid.svelte-1y3bjge.svelte-1y3bjge {
  border-top: 6px solid var(--accent);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/XssTargets.esbuild-svelte-fake-css */
.xr-targets.svelte-p1uepl.svelte-p1uepl {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.xr-compact.svelte-p1uepl.svelte-p1uepl {
  gap: 16px;
}
.xr-head.svelte-p1uepl.svelte-p1uepl {
  display: flex;
  align-items: center;
  gap: 14px;
}
.xr-label.svelte-p1uepl.svelte-p1uepl {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  min-width: 110px;
}
.xr-dot.svelte-p1uepl.svelte-p1uepl {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.xr-nums.svelte-p1uepl.svelte-p1uepl {
  margin-left: auto;
  font-size: 26px;
}
.xr-nums.svelte-p1uepl strong.svelte-p1uepl {
  font-weight: 800;
}
.xr-of.svelte-p1uepl.svelte-p1uepl {
  color: var(--muted);
}
.xr-mark.svelte-p1uepl.svelte-p1uepl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: #0b1114;
}
.xr-mark.Good.svelte-p1uepl.svelte-p1uepl {
  background: var(--good);
}
.xr-mark.Warn.svelte-p1uepl.svelte-p1uepl {
  background: #ffcf0c;
}
.xr-mark.Alert.svelte-p1uepl.svelte-p1uepl {
  background: var(--bad);
  color: #fff;
}
.xr-track.svelte-p1uepl.svelte-p1uepl {
  position: relative;
  margin-top: 10px;
  height: 18px;
  border-radius: 999px;
  background: var(--faint);
}
.xr-compact.svelte-p1uepl .xr-track.svelte-p1uepl {
  height: 14px;
}
.xr-fill.svelte-p1uepl.svelte-p1uepl {
  height: 100%;
  border-radius: 999px;
}
.xr-tick.svelte-p1uepl.svelte-p1uepl {
  position: absolute;
  top: -7px;
  bottom: -7px;
  width: 5px;
  margin-left: -2.5px;
  border-radius: 3px;
  background: currentColor;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/XfaiPoster.esbuild-svelte-fake-css */
.xr-layout.svelte-1xi13n2.svelte-1xi13n2 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto auto minmax(0, 1fr) auto auto auto;
  grid-template-areas: "top" "plan" "." "progress" "outcome" "footer";
}
.xr-landscape .xr-layout.svelte-1xi13n2.svelte-1xi13n2 {
  grid-template-columns: minmax(0, 1fr) 640px;
  grid-template-rows: auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "plan plan" ". ." "progress outcome" "footer footer";
  column-gap: 80px;
}
.xr-top.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: top;
}
.xr-plan.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: plan;
}
.xr-progress.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: progress;
  min-width: 0;
}
.xr-outcome.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: outcome;
  min-width: 0;
}
.xr-landscape .xr-outcome.svelte-1xi13n2.svelte-1xi13n2 {
  align-self: end;
}
.xr-footer.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: footer;
}
.xr-footer-badges.svelte-1xi13n2.svelte-1xi13n2:empty {
  display: none;
}
.xr-square .xr-day-label.svelte-1xi13n2.svelte-1xi13n2 {
  font-size: 84px;
}
.xr-square .xr-day-num.svelte-1xi13n2.svelte-1xi13n2 {
  font-size: 210px;
}
.xr-square .xr-day-sub.svelte-1xi13n2.svelte-1xi13n2 {
  font-size: 44px;
  margin-top: 8px;
}
.xr-square .xr-plan-track.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 16px;
}
.xr-square .xr-result.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 24px;
}
.xr-square .xr-xss.svelte-1xi13n2 strong.svelte-1xi13n2 {
  font-size: 66px;
}
.xr-square .xr-targets.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 18px;
}
.xr-square .xr-footer.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 24px;
  padding-top: 22px;
  gap: 18px;
}
.xr-landscape .xr-day-num.svelte-1xi13n2.svelte-1xi13n2 {
  font-size: 270px;
}
.xr-landscape .xr-result.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 0;
}
.xr-landscape .xr-footer.svelte-1xi13n2.svelte-1xi13n2 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.3fr);
  grid-template-areas: "title stats" "badges badges";
  column-gap: 60px;
  row-gap: 22px;
  align-items: end;
}
.xr-landscape .xr-footer-title.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: title;
  min-width: 0;
}
.xr-landscape .xr-footer-stats.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: stats;
}
.xr-landscape .xr-footer-badges.svelte-1xi13n2.svelte-1xi13n2 {
  grid-area: badges;
}
.xr-top.svelte-1xi13n2.svelte-1xi13n2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-eyebrow.svelte-1xi13n2.svelte-1xi13n2 {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.26em;
  text-transform: uppercase;
}
.xr-plan.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 18px;
  font-size: 30px;
  font-weight: 600;
  color: var(--muted);
}
.xr-day.svelte-1xi13n2.svelte-1xi13n2 {
  display: flex;
  align-items: baseline;
  gap: 20px;
  font-family: var(--display);
  font-weight: 800;
  font-style: italic;
  text-transform: uppercase;
  line-height: 0.8;
  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.4);
}
.xr-day-label.svelte-1xi13n2.svelte-1xi13n2 {
  font-size: 110px;
  color: var(--accent);
}
.xr-day-num.svelte-1xi13n2.svelte-1xi13n2 {
  font-size: 290px;
}
.xr-day-sub.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 12px;
  font-family: var(--display);
  font-size: 54px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.xr-plan-track.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 22px;
  height: 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
}
.xr-plan-fill.svelte-1xi13n2.svelte-1xi13n2 {
  height: 100%;
  border-radius: 999px;
  background: var(--accent);
}
.xr-result.svelte-1xi13n2.svelte-1xi13n2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 34px;
}
.xr-verdict.svelte-1xi13n2.svelte-1xi13n2 {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 26px 12px 18px;
  border-radius: 999px;
  background: var(--accent);
  color: #0b1114;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.xr-xss.svelte-1xi13n2.svelte-1xi13n2 {
  margin-left: auto;
  font-family: var(--display);
  font-size: 46px;
  font-weight: 600;
  color: var(--muted);
}
.xr-xss.svelte-1xi13n2 strong.svelte-1xi13n2 {
  font-size: 80px;
  font-weight: 800;
  color: #fff;
}
.xr-targets.svelte-1xi13n2.svelte-1xi13n2 {
  margin-top: 24px;
}
.xr-footer.svelte-1xi13n2.svelte-1xi13n2 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 34px;
  padding-top: 28px;
  border-top: 2px solid var(--faint);
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/ProgressRing.esbuild-svelte-fake-css */
.xr-progress-ring.svelte-61fxm5 {
  position: relative;
  flex: none;
}
svg.svelte-61fxm5 {
  display: block;
}
.xr-center.svelte-61fxm5 {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.xr-label.svelte-61fxm5,
.xr-total.svelte-61fxm5 {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-value.svelte-61fxm5 {
  font-family: var(--display);
  font-weight: 800;
  font-size: 120px;
  line-height: 0.95;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/parts/Stars.esbuild-svelte-fake-css */
.xr-stars.svelte-dztwhn {
  display: inline-flex;
  align-items: center;
}
svg.svelte-dztwhn {
  display: block;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/templates/XfaiProgress.esbuild-svelte-fake-css */
.xr-layout.svelte-1asa2ga.svelte-1asa2ga {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-rows: auto auto auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "plan plan" "ring today" "status status" "title title" "chart chart" "stats stats" "badges badges";
  column-gap: 52px;
  row-gap: 28px;
}
.xr-layout.xr-no-ring.svelte-1asa2ga.svelte-1asa2ga {
  grid-template-areas: "top top" "plan plan" "today today" "status status" "title title" "chart chart" "stats stats" "badges badges";
}
.xr-square .xr-layout.svelte-1asa2ga.svelte-1asa2ga {
  column-gap: 44px;
  row-gap: 18px;
}
.xr-landscape .xr-layout.svelte-1asa2ga.svelte-1asa2ga,
.xr-landscape .xr-layout.xr-no-ring.svelte-1asa2ga.svelte-1asa2ga {
  grid-template-columns: 560px minmax(0, 1fr);
  grid-template-rows: auto auto auto minmax(0, 1fr) auto auto;
  grid-template-areas: "top top" "plan today" "ring title" "ring chart" "status stats" "badges badges";
  column-gap: 80px;
  row-gap: 28px;
}
.xr-top.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: top;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xr-plan.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: plan;
  min-width: 0;
}
.xr-ring.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: ring;
  display: flex;
  align-items: center;
}
.xr-landscape .xr-ring.svelte-1asa2ga.svelte-1asa2ga {
  justify-content: center;
}
.xr-today.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: today;
  min-width: 0;
  align-self: center;
}
.xr-status.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: status;
}
.xr-title.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: title;
  min-width: 0;
}
.xr-chart.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: chart;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.xr-stats.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: stats;
  align-self: end;
}
.xr-badges.svelte-1asa2ga.svelte-1asa2ga {
  grid-area: badges;
}
.xr-badges.svelte-1asa2ga.svelte-1asa2ga:empty {
  display: none;
}
.xr-eyebrow.svelte-1asa2ga.svelte-1asa2ga {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.26em;
  text-transform: uppercase;
}
.xr-plan-name.svelte-1asa2ga.svelte-1asa2ga {
  font-family: var(--display);
  font-weight: 800;
  font-size: 96px;
  line-height: 0.95;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.xr-plan-meta.svelte-1asa2ga.svelte-1asa2ga {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 12px;
  font-size: 28px;
  color: var(--muted);
}
.xr-phase.svelte-1asa2ga.svelte-1asa2ga {
  padding: 4px 16px;
  border-radius: 999px;
  border: 2px solid var(--accent);
  color: var(--accent);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  white-space: nowrap;
}
.xr-today-head.svelte-1asa2ga.svelte-1asa2ga {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 22px;
}
.xr-today-kind.svelte-1asa2ga.svelte-1asa2ga {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.xr-today-xss.svelte-1asa2ga.svelte-1asa2ga {
  font-family: var(--display);
  font-size: 40px;
  font-weight: 600;
  color: var(--muted);
}
.xr-today-xss.svelte-1asa2ga strong.svelte-1asa2ga {
  color: var(--accent);
  font-size: 64px;
  font-weight: 800;
}
.xr-status.svelte-1asa2ga.svelte-1asa2ga {
  display: flex;
  gap: 40px;
  padding: 24px 28px;
  border-radius: 24px;
  background: var(--panel);
  border: 2px solid var(--faint);
}
.xr-square .xr-status.svelte-1asa2ga.svelte-1asa2ga {
  padding: 18px 26px;
}
.xr-square .xr-plan-name.svelte-1asa2ga.svelte-1asa2ga {
  font-size: 76px;
}
.xr-landscape .xr-plan-name.svelte-1asa2ga.svelte-1asa2ga {
  font-size: 76px;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.xr-landscape .xr-plan-meta.svelte-1asa2ga.svelte-1asa2ga {
  flex-wrap: wrap;
  row-gap: 10px;
}
.xr-landscape .xr-status.svelte-1asa2ga.svelte-1asa2ga {
  flex-direction: column;
  gap: 18px;
  align-self: end;
}
.xr-landscape .xr-status-item + .xr-status-item.svelte-1asa2ga.svelte-1asa2ga {
  padding-left: 0;
  border-left: 0;
  padding-top: 18px;
  border-top: 2px solid var(--faint);
}
.xr-status-item.svelte-1asa2ga.svelte-1asa2ga {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.xr-status-item.svelte-1asa2ga + .xr-status-item.svelte-1asa2ga {
  padding-left: 40px;
  border-left: 2px solid var(--faint);
}
.xr-k.svelte-1asa2ga.svelte-1asa2ga {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
}
.xr-v.svelte-1asa2ga.svelte-1asa2ga {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 28px;
  font-weight: 600;
}
.xr-pill.svelte-1asa2ga.svelte-1asa2ga {
  padding: 4px 14px;
  border-radius: 999px;
  font-weight: 700;
  color: #fff;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SocialReports/ReportPreview.esbuild-svelte-fake-css */
.report-preview.svelte-6898n7 {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.report-preview-inner.svelte-6898n7 {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  pointer-events: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ExerciseCard/RaceCard.esbuild-svelte-fake-css */
.form-container.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  container: form-container/inline-size;
}
.race-card.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  width: 100%;
  height: max-content;
  padding: 22px;
  display: grid;
  gap: 24px;
  border: 1px solid transparent;
  border-radius: 0.4rem;
  -webkit-box-shadow: 0px 0px 14px 2px #D6D6D6;
  box-shadow: 0px 0px 14px 2px #D6D6D6;
  max-width: 930px;
  grid-template-columns: 200px 200px auto min-content 140px;
  grid-auto-flow: row;
}
.race-card.personal-activity.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  grid-template-columns: 200px 380px auto;
}
.desc.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  font-size: 12px;
  color: #707377;
  width: 100%;
}
.dist-elevation.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
}
.dist-elevation.svelte-i73wrj div.svelte-i73wrj.svelte-i73wrj {
  flex: 1 1 0px;
  border: 1px solid #ECECEC;
  border-radius: 5px;
  text-align: center;
  padding: 10px;
}
.dist-elevation.svelte-i73wrj div.svelte-i73wrj > .svelte-i73wrj {
  display: block;
}
.dist-elevation.svelte-i73wrj div strong.svelte-i73wrj.svelte-i73wrj {
  font-size: 30px;
  font-weight: bold;
}
.dist-elevation.svelte-i73wrj div strong small.svelte-i73wrj.svelte-i73wrj {
  font-size: 12px;
}
@container form-container (min-width: 750px) {
  .desc.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
    grid-area: 2/1/3/3;
  }
  .seperator.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
    grid-area: 1/3/3/4;
  }
  .date-and-btn.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
    grid-area: 1/4/3/5;
  }
  .race-card.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
    grid-template-columns: 200px auto min-content 140px;
  }
}
@container form-container (max-width: 750px) {
  .race-card.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
    display: flex;
    flex-direction: column;
  }
  .seperator.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
    display: none;
  }
}
.signature.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 4px;
}
.signature.svelte-i73wrj div.svelte-i73wrj.svelte-i73wrj {
  flex: 1 1 0px;
  text-align: center;
  padding: 10px;
}
.signature div.svelte-i73wrj strong.svelte-i73wrj.svelte-i73wrj {
  font-size: 20px;
  font-weight: bold;
}
.signature div.svelte-i73wrj strong small.svelte-i73wrj.svelte-i73wrj {
  font-size: 12px;
}
.npeak.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  color: #F00;
}
.nlow.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  color: #0B5DBC;
}
.nhigh.svelte-i73wrj.svelte-i73wrj.svelte-i73wrj {
  color: #F5A623;
}

/* fakecss:/home/forge/alpha/svelte-components/src/ActivitiesDashLegacy.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
.topbar.svelte-ugrivm.svelte-ugrivm.svelte-ugrivm {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #3D3D3D;
  font-size: 16px;
  line-height: 18px;
  --fontSize:16px;
  --height:30px;
  --padding:0 12px !important;
  --itemColor:var(--color-xert-gray-text);
  --border:1px solid var(--color-xert-gray);
  --borderFocusColor:var(--color-xert-gray);
  --borderHoverColor:var(--color-xert-blue);
  --borderRadius:3px !important;
  --listBorder:1px solid var(--color-xert-blue);
  --indicatorRight:20px;
  --indicatorTop:0;
  --indicatorHeight:0;
  --indicatorWidth:0;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  gap: 16px;
  padding: 15px 26px;
  border-radius: 4px;
  border: 1px solid #ECECEC;
}
.topbar.svelte-ugrivm p.svelte-ugrivm.svelte-ugrivm {
  white-space: nowrap;
  margin: 0 !important;
}
.topbar.svelte-ugrivm .selector.svelte-ugrivm.svelte-ugrivm {
  display: inline-block;
}
.topbar.svelte-ugrivm > #sort-by.svelte-ugrivm.svelte-ugrivm {
  width: unset !important;
  display: flex;
}
.topbar.svelte-ugrivm > spacer.svelte-ugrivm.svelte-ugrivm {
  flex: 1 0 0;
}
@media only screen and (max-width: 873px) and (min-width: 320px) {
  .box-solid.svelte-ugrivm.svelte-ugrivm.svelte-ugrivm {
    margin-bottom: 0;
  }
}
.searchbar.svelte-ugrivm.svelte-ugrivm.svelte-ugrivm {
  display: flex;
  flex: 10 1 200px;
  min-width: 200px;
}
.searchbar.svelte-ugrivm > input.svelte-ugrivm.svelte-ugrivm {
  min-width: 100px;
  flex-grow: 1;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  height: 30px;
  padding: 2px 12px;
  border: 1px solid var(--color-xert-gray);
  border-top-left-radius: var(--borderRadius) !important;
  border-bottom-left-radius: var(--borderRadius) !important;
  border-right: none !important;
  outline: none;
  color: var(--color-xert-gray-text);
}
.searchbar.svelte-ugrivm > button.svelte-ugrivm.svelte-ugrivm {
  height: 30px;
  width: 30px;
  border: 1px solid var(--color-xert-gray-text);
  border-top-right-radius: var(--borderRadius) !important;
  border-bottom-right-radius: var(--borderRadius) !important;
  border-left: none !important;
  background-color: white;
}
.searchbar.svelte-ugrivm > button.svelte-ugrivm > i.svelte-ugrivm {
  color: #ddd;
}
.searchbar.svelte-ugrivm > button.svelte-ugrivm:hover > i.svelte-ugrivm {
  color: var(--color-xert-blue);
}
.show-liked-only.svelte-ugrivm.svelte-ugrivm.svelte-ugrivm,
.show-disliked-only.svelte-ugrivm.svelte-ugrivm.svelte-ugrivm {
  margin: auto;
  white-space: nowrap;
}
.searchbar.svelte-ugrivm #searchbtn.svelte-ugrivm:hover > i.svelte-ugrivm {
  color: var(--color-xert-blue);
}
.pagenator.svelte-ugrivm.svelte-ugrivm.svelte-ugrivm {
  display: flex;
  justify-content: center;
}
.pagenator.svelte-ugrivm button.svelte-ugrivm.svelte-ugrivm {
  padding: 8px 10px;
  font-size: 14px;
  line-height: 12px;
  border: 1px solid #ddd;
  color: var(--color-xert-blue);
  background-color: #fff;
}
.pagenator.svelte-ugrivm button.svelte-ugrivm > i.svelte-ugrivm {
  color: var(--color-xert-blue);
}
.pagenator.svelte-ugrivm button.disabled.svelte-ugrivm.svelte-ugrivm {
  border-color: #ddd !important;
  background-color: #fff !important;
  color: gray !important;
  cursor: not-allowed;
}
.pagenator.svelte-ugrivm button.disabled.svelte-ugrivm > i.svelte-ugrivm {
  color: gray !important;
}
.pagenator.svelte-ugrivm button.selected.svelte-ugrivm.svelte-ugrivm {
  border-color: #ddd !important;
  background-color: #eee !important;
  color: var(--xert-gray-text) !important;
  pointer-events: none;
}
.pagenator.svelte-ugrivm button.selected.svelte-ugrivm > i.svelte-ugrivm {
  color: var(--xert-gray-text) !important;
}
.pagenator.svelte-ugrivm button.svelte-ugrivm.svelte-ugrivm:hover {
  border-color: #eee;
}
.pagenator.svelte-ugrivm button.svelte-ugrivm.svelte-ugrivm:active {
  border-color: var(--color-xert-blue);
  background-color: var(--color-xert-blue);
  color: white;
}
.pagenator.svelte-ugrivm button.svelte-ugrivm:active > i.svelte-ugrivm {
  color: white;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/XssDeficitGauge.esbuild-svelte-fake-css */
.animate-rotation.svelte-vvmtre {
  transition: transform 0.5s cubic-bezier(0.19, 1, 0.22, 1);
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/CalendarNotesCard.esbuild-svelte-fake-css */
.note-card.svelte-ms9e0b.svelte-ms9e0b {
  width: 100%;
  padding: 8px;
  background: #f2f2f2;
}
.note-card.svelte-ms9e0b .fa-calendar-lines-pen.svelte-ms9e0b:hover {
  cursor: pointer;
  opacity: 0.8;
}
.note-card.svelte-ms9e0b [class*=row].svelte-ms9e0b {
  display: flex;
  align-content: center;
  margin-top: 5px;
}
.note-card.svelte-ms9e0b [class*=row][class*=programType].svelte-ms9e0b {
  margin-top: 0px;
  max-height: 26px;
  justify-content: left;
  align-items: center;
  gap: 6px;
}
.note-card.svelte-ms9e0b [class*=row][class*=noteSnippet].svelte-ms9e0b {
  font-size: 10px;
  display: block;
  overflow: hidden;
}
.note-card.svelte-ms9e0b [class*=row][class*=statuses].svelte-ms9e0b {
  flex-direction: column;
}
.note-card.svelte-ms9e0b [class*=row].hide.svelte-ms9e0b {
  display: none;
}
.note-card.svelte-ms9e0b .program-text.svelte-ms9e0b {
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
}
.note-card.svelte-ms9e0b .status-container.svelte-ms9e0b {
  font-size: 10px;
  font-weight: 400;
}
.note-card.svelte-ms9e0b .status-container.hide.svelte-ms9e0b {
  display: none;
}
.note-card.svelte-ms9e0b hr.svelte-ms9e0b {
  margin: 8px 0px;
  border: 1px solid #d5d5d5;
  color: #d4d4d4;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/CalendarActivityCard.esbuild-svelte-fake-css */
.canDrop.svelte-bw1cgr {
  box-shadow: inset 0 0 10px rgba(126, 211, 33, 0.6);
}
.calendar-activity-card.svelte-bw1cgr.droppable {
  opacity: 0.5;
}
.calendar-activity-card.canDrop.svelte-bw1cgr * {
  pointer-events: none !important;
}
.dropDisabled.svelte-bw1cgr:not(.dragged) {
  pointer-events: none;
}
.calendar-activity-card.svelte-bw1cgr:not(.dropDisabled) {
  pointer-events: auto;
}
.calendar-activity-card.clickable.svelte-bw1cgr {
  transition: transform 150ms ease, box-shadow 150ms ease;
}
.calendar-activity-card.clickable.svelte-bw1cgr:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}
.calendar-activity-card.clickable.svelte-bw1cgr:active {
  transform: translateY(0);
  box-shadow: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/CalendarSummaryCard.esbuild-svelte-fake-css */
.clickable.svelte-3uo476 {
  transition: transform 150ms ease, box-shadow 150ms ease;
}
.clickable.svelte-3uo476:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}
.clickable.svelte-3uo476:active {
  transform: translateY(0);
  box-shadow: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/CalendarCard.esbuild-svelte-fake-css */
.cell-layout.svelte-18jtf9e.svelte-18jtf9e {
  height: 100%;
  width: 100%;
  padding: 10px 8px 0px;
  border: 1px solid #ECECEC;
}
.cell-layout.isLoading.svelte-18jtf9e.svelte-18jtf9e {
  pointer-events: none;
  filter: brightness(0.75);
  background-color: white;
}
.cell-layout.compact.svelte-18jtf9e.svelte-18jtf9e {
  padding: 10px 4px 0px;
}
.cell-layout.cell-today.svelte-18jtf9e.svelte-18jtf9e {
  background-color: #F5FEFF;
  border-top: 4px solid #016e79;
  padding-top: 6px;
}
.cell-header.svelte-18jtf9e.svelte-18jtf9e {
  display: flex;
  flex-direction: row;
  font-weight: 400;
  text-align: right;
}
.absoluteSpinner.svelte-18jtf9e.svelte-18jtf9e {
  position: absolute;
  top: 50%;
  left: calc(50% - 16px);
  transform: translate(-50%, -50%);
  color: #016e79;
  z-index: 1;
}
.weather-text.svelte-18jtf9e.svelte-18jtf9e {
  font-weight: 400;
  font-size: 10px;
  justify-content: center;
  max-width: 18px;
  margin-right: 8px;
}
.wind-text.svelte-18jtf9e.svelte-18jtf9e {
  font-weight: 400;
  font-size: 10px;
  justify-content: center;
  max-width: 28px;
}
.weather-icon.svelte-18jtf9e.svelte-18jtf9e {
  width: 20px;
  height: 20px;
  margin: 4px 4px 0px 0px;
}
.wind-icon.svelte-18jtf9e.svelte-18jtf9e {
  width: 14px;
  height: 14px;
  margin: 6px 4px 0px 0px;
}
.cell-layout.svelte-18jtf9e.droppable .svelte-18jtf9e {
  pointer-events: none !important;
}
.dropDisabled.svelte-18jtf9e.svelte-18jtf9e {
  pointer-events: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/LoadingAnimation.esbuild-svelte-fake-css */
.lds-ellipsis.svelte-15pv8fh.svelte-15pv8fh {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 13px;
}
.lds-ellipsis.svelte-15pv8fh i.svelte-15pv8fh {
  position: absolute;
  width: 13px;
  height: 13px;
  font-size: 13px;
  color: #D8D8D8;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis.svelte-15pv8fh i.svelte-15pv8fh:nth-child(1) {
  left: 8px;
  animation: svelte-15pv8fh-lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis.svelte-15pv8fh i.svelte-15pv8fh:nth-child(2) {
  left: 8px;
  animation: svelte-15pv8fh-lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis.svelte-15pv8fh i.svelte-15pv8fh:nth-child(3) {
  left: 32px;
  animation: svelte-15pv8fh-lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis.svelte-15pv8fh i.svelte-15pv8fh:nth-child(4) {
  left: 56px;
  animation: svelte-15pv8fh-lds-ellipsis3 0.6s infinite;
}
@keyframes svelte-15pv8fh-lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes svelte-15pv8fh-lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes svelte-15pv8fh-lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingStatus.esbuild-svelte-fake-css */
.title.svelte-rd7x10.svelte-rd7x10::after {
  content: "Training Status:";
}
@media screen and (max-width: 1200) {
  .title.svelte-rd7x10.svelte-rd7x10::after {
    content: "Status:";
  }
}
.star-rating.svelte-rd7x10.svelte-rd7x10,
.back-stars.svelte-rd7x10.svelte-rd7x10 {
  display: flex;
}
.star-rating.svelte-rd7x10.svelte-rd7x10 {
  align-items: left;
  justify-content: left;
  margin-top: 5px;
  margin-left: 4px;
  display: inline-block;
}
.star-rating.noMargin.svelte-rd7x10.svelte-rd7x10 {
  margin: 0;
}
.back-stars.svelte-rd7x10.svelte-rd7x10 {
  position: relative;
  gap: 4px;
  justify-content: space-between;
}
.back-stars.svelte-rd7x10 > div.svelte-rd7x10 {
  width: 18px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/StatsRow.esbuild-svelte-fake-css */
.stats-container.mobile.svelte-3opm62.svelte-3opm62 {
  margin-top: 13px;
  margin-bottom: 16px;
  border: 1px solid #ECECEC;
}
.side-button.svelte-3opm62.svelte-3opm62 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 44px;
  background-color: #F9F9F9;
  opacity: 0.9;
  border: none;
}
.hidden-button.svelte-3opm62.svelte-3opm62 {
  visibility: hidden;
}
.stats-row.svelte-3opm62.svelte-3opm62 {
  padding-left: 44px;
  padding-right: 44px;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 44px;
  overflow-x: auto;
  background-color: #F9F9F9;
}
.stats-row.mobile.svelte-3opm62.svelte-3opm62 {
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
  justify-content: unset;
}
.stats-row.mobile.compressed.svelte-3opm62.svelte-3opm62 {
  height: 44px;
  overflow: hidden;
}
.stat.svelte-3opm62.svelte-3opm62 {
  margin: auto;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  color: #3D3D3D;
  white-space: nowrap;
  text-align: center;
  font-weight: 400;
}
.mobile.svelte-3opm62 .stat.svelte-3opm62 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  height: 44px;
  border-bottom: 1px solid #E4E4E4;
  flex-grow: 1;
}
.hidden-scrollbar.svelte-3opm62.svelte-3opm62 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hidden-scrollbar.svelte-3opm62.svelte-3opm62::-webkit-scrollbar {
  display: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/RecommendedTraining.esbuild-svelte-fake-css */
.forecast-info-toggle.svelte-11024px.svelte-11024px.svelte-11024px {
  all: unset;
  padding: 0px 10px;
}
.forecast-info-toggle.svelte-11024px.svelte-11024px.svelte-11024px:hover,
.forecast-info-toggle.svelte-11024px.svelte-11024px.svelte-11024px:active,
.forecast-info-toggle.svelte-11024px.svelte-11024px.svelte-11024px:focus {
  all: unset;
  padding: 0px 10px;
  cursor: pointer;
  background: #b7b7b7;
}
.recc-training-buttons.svelte-11024px.svelte-11024px.svelte-11024px {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 15px;
}
.searchbar.svelte-11024px.svelte-11024px.svelte-11024px {
  display: flex;
  padding-top: 4px;
  flex: 10 1 150px;
  min-width: 150px;
}
.searchbar.svelte-11024px > input.svelte-11024px.svelte-11024px {
  min-width: 100px;
  flex-grow: 1;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  height: 30px;
  padding: 2px 12px;
  border: 1px solid var(--color-xert-gray);
  border-top-left-radius: var(--borderRadius) !important;
  border-bottom-left-radius: var(--borderRadius) !important;
  border-right: none !important;
  outline: none;
  color: var(--color-xert-gray-text);
  margin: 10px auto;
}
.searchbar.svelte-11024px > button.svelte-11024px.svelte-11024px {
  height: 30px;
  width: 30px;
  border: 1px solid var(--color-xert-gray-text);
  border-top-right-radius: var(--borderRadius) !important;
  border-bottom-right-radius: var(--borderRadius) !important;
  border-left: none !important;
  background-color: white;
  border-bottom-left-radius: 0px !important;
  border-top-left-radius: 0px !important;
}
.searchbar.svelte-11024px > button.svelte-11024px > i.svelte-11024px {
  color: #ddd;
}
.searchbar.svelte-11024px > button.svelte-11024px.svelte-11024px:hover {
  background-color: transparent;
}
.searchbar.svelte-11024px > button.svelte-11024px:hover > i.svelte-11024px {
  color: var(--color-xert-blue);
}
.portlet-title.svelte-11024px.svelte-11024px.svelte-11024px {
  display: flex;
  margin-bottom: 0;
  gap: 15px;
}
.portlet-title.svelte-11024px span.svelte-11024px.svelte-11024px {
  margin: auto 0;
  line-height: 14px;
}
.portlet-title.title-override.svelte-11024px.svelte-11024px.svelte-11024px {
  padding: 10px 7px;
}
.portlet-title.title-override.svelte-11024px.svelte-11024px.svelte-11024px::before {
  content: none;
}
.portlet-title.title-override.svelte-11024px.svelte-11024px.svelte-11024px::after {
  content: none;
}
.portlet-body.svelte-11024px.svelte-11024px.svelte-11024px {
  max-width: 100%;
}
button.svelte-11024px.svelte-11024px.svelte-11024px {
  background: var(--color-xert-teal);
  flex-shrink: 0;
  color: white;
  border-radius: 4px !important;
  height: 37px;
  margin: 10px auto;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
button.svelte-11024px.svelte-11024px.svelte-11024px:hover {
  background: var(--color-xert-lime);
  color: white;
}
.duration-selector.svelte-11024px.svelte-11024px.svelte-11024px {
  --height:35px;
  --padding:0 10px !important;
  --itemColor:var(--color-xert-gray-text);
  --border:1px solid var(--color-xert-gray);
  --borderFocusColor:var(--color-xert-gray);
  --borderHoverColor:var(--color-xert-blue);
  --borderRadius:3px !important;
  --listBorder:1px solid var(--color-xert-blue);
  --indicatorRight:20px;
  --indicatorTop:-1px;
  --indicatorHeight:0;
  --indicatorWidth:0;
  height: 35px;
  width: 140px;
  margin: auto 0;
}
tag.svelte-11024px.svelte-11024px.svelte-11024px {
  color: var(--color-xert-teal);
  border: 1px solid var(--color-xert-teal);
  background: rgba(47, 112, 118, 0.2);
  flex: 0 1 auto;
  border-radius: 90px;
  padding: 9px 18px;
  margin: 2px 0px;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0.48px;
  cursor: default;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
}
tag.workout.svelte-11024px.svelte-11024px.svelte-11024px {
  color: #5ca907 !important;
  border: 1px solid #5ca907 !important;
  background: rgba(126, 211, 33, 0.2) !important;
}
tag.outdoor.svelte-11024px.svelte-11024px.svelte-11024px {
  color: #ff2222 !important;
  border: 1px solid #ff2222 !important;
  background: rgba(255, 0, 0, 0.2) !important;
}
tag.virtual.svelte-11024px.svelte-11024px.svelte-11024px {
  color: #fb6418 !important;
  border: 1px solid #fb6418 !important;
  background: rgba(251, 100, 24, 0.2) !important;
}
tag.session.svelte-11024px.svelte-11024px.svelte-11024px {
  color: #0b5dbc !important;
  border: 1px solid #0b5dbc !important;
  background: rgba(74, 144, 226, 0.2) !important;
}
tag.not-selected.svelte-11024px.svelte-11024px.svelte-11024px {
  cursor: pointer !important;
  background: white !important;
}
.selector.svelte-11024px.svelte-11024px.svelte-11024px {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: min-content;
  justify-content: center;
  padding: 10px 15px;
  margin: auto;
  gap: 12px;
}
.toggle-manual-choose-btn.svelte-11024px.svelte-11024px.svelte-11024px {
  border: 1px solid #3D3D3D !important;
  border-radius: 4px;
  padding: 6px 16px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  width: auto;
  background-color: transparent;
  margin: 0;
  text-align: center;
  letter-spacing: 0.48px;
  color: #000000;
  cursor: pointer;
}
.toggle-manual-choose-btn.svelte-11024px.svelte-11024px.svelte-11024px:hover {
  background-color: transparent;
  color: black;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/XataTrainingStatus.esbuild-svelte-fake-css */
.npeak.svelte-1s3kcuw {
  color: var(--color-xpss);
}
.nlow.svelte-1s3kcuw {
  color: var(--color-xlss);
}
.nhigh.svelte-1s3kcuw {
  color: var(--color-xhss);
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/WeatherForecast.esbuild-svelte-fake-css */
.wind-icon.svelte-nw0snx.svelte-nw0snx {
  transform: scale(1.5);
}
.weather-table.svelte-nw0snx.svelte-nw0snx {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-item.svelte-nw0snx > a.svelte-nw0snx {
  color: var(--color-xert-gray);
}
.page-item.svelte-nw0snx > a.svelte-nw0snx:hover {
  opacity: 0.8;
}
.page-item.svelte-nw0snx.svelte-nw0snx {
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-table.svelte-nw0snx.svelte-nw0snx {
  width: 90%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/Weather.esbuild-svelte-fake-css */
.wind-icon.svelte-1s29oky {
  transform: scale(1.5);
  margin-right: 8px;
}
.weather-icon.svelte-1s29oky {
  margin-right: 3px;
}
.weather-group.svelte-1s29oky {
  display: flex;
  justify-content: center;
  align-items: center;
}
.weather-box.svelte-1s29oky {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 0px 10px 10px 10px;
}
.vertical-stack.svelte-1s29oky {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.vertical-stack-small.svelte-1s29oky {
  color: var(--color-xert-gray);
  font-size: 10px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Common/ForecastDescription.esbuild-svelte-fake-css */
br.svelte-1vua212 {
  display: block;
  margin: 12px 0 0;
  line-height: 22px;
  content: " ";
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingForecast/SimpleModal.esbuild-svelte-fake-css */
.simpleModal.svelte-1rsfo1m {
  --offset:var(--modal-offset, 5%);
  padding: 10px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 15px #000000;
  position: absolute;
  left: var(--offset);
  top: var(--offset);
  z-index: 50;
}
.simpleModal.modalRight.svelte-1rsfo1m {
  left: unset;
  right: var(--offset);
}
.simpleModal.modalCenterX.svelte-1rsfo1m {
  left: 50%;
  transform: translateX(-50%);
}
.simpleModal.modalBottom.svelte-1rsfo1m {
  top: unset;
  bottom: var(--offset);
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingForecast/XSSDetailsTable.esbuild-svelte-fake-css */
.xsstable.svelte-1dm0fas {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
}
p.svelte-1dm0fas {
  margin: 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingForecast/TrainingXSSDetailsCircle.esbuild-svelte-fake-css */
.difficulty.svelte-b2080b {
  flex-shrink: 0;
  width: 100px;
  aspect-ratio: 1/1;
  text-align: center;
  border-radius: 9999px;
  transition: filter 0.05s;
  border: 2px solid transparent;
}
.difficulty.small.svelte-b2080b {
  width: 50px;
}
.difficulty.svelte-b2080b:hover,
.difficulty.detailsOpen.svelte-b2080b {
  cursor: pointer;
  filter: brightness(75%);
  transition: filter 0.15s;
}
.difficulty.noTraining.svelte-b2080b {
  height: min-content;
}
.difficulty.noTraining.svelte-b2080b:hover {
  cursor: default;
  filter: brightness(100%);
}
.DeviationUnknown.svelte-b2080b,
.null.svelte-b2080b {
  background-color: #f2f2f2;
  border: 2px solid #707377;
}
.DeviationGood.svelte-b2080b {
  background-color: var(--color-xss-deviation-good);
  color: white;
}
.DeviationWarn.svelte-b2080b {
  background-color: var(--color-xss-deviation-warn);
  color: white;
}
.DeviationAlert.svelte-b2080b {
  background-color: var(--color-xss-deviation-alert);
  color: white;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/ForecastEventsBar.esbuild-svelte-fake-css */
:root {
  --color-xert-lime:#7ED321;
  --color-xert-teal:#2F7076;
  --color-xert-blue:#4A90E2;
  --color-xert-gray:#707377;
  --color-xert-gray-text:#808080;
  --rgb-xlss:11,
    93,
    188;
  --rgb-xhss:255,
    195,
    0;
  --rgb-xpss:224,
    63,
    66;
  --color-xlss:rgb(var(--rgb-xlss));
  --color-xhss:rgb(var(--rgb-xhss));
  --color-xpss:rgb(var(--rgb-xpss));
  --color-xss-deviation-good:#7ED321;
  --color-xss-deviation-warn:#ffaa00;
  --color-xss-deviation-alert:#d02224;
  --rgb-xert-teal:47,
    112,
    118;
}
@media (max-width: 750px) {
}
@media (max-width: 900px) {
}
@media (max-width: 500px) {
}
button.svelte-mzsybe {
  all: unset;
}
.card-action-row.svelte-mzsybe {
  width: 100%;
  border-top: 2px solid #aaa;
  position: relative;
  display: flex;
  justify-content: left;
  flex-direction: row;
}
.card-action-item.svelte-mzsybe {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  color: #34495e;
  text-decoration: none;
  margin: 5px 0%;
}
.card-action-divider.svelte-mzsybe {
  flex-grow: 1;
}
.card-action-item.svelte-mzsybe:hover {
  opacity: 0.8;
  cursor: pointer;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingForecast/TrainingCard.esbuild-svelte-fake-css */
.training-card.svelte-1nktfz.svelte-1nktfz {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  min-height: fit-content;
}
.isCalendarEventLoading.svelte-1nktfz.svelte-1nktfz {
  pointer-events: none;
  filter: brightness(0.75);
}
.absoluteSpinner.svelte-1nktfz.svelte-1nktfz {
  position: absolute;
  top: 50%;
  left: calc(50% - 16px);
  transform: translate(-50%, -50%);
  color: #016e79;
  z-index: 2;
}
.outer-grid.svelte-1nktfz.svelte-1nktfz {
  height: 100%;
  min-height: fit-content;
  display: flex;
  flex-flow: column;
}
.inner-grid.svelte-1nktfz.svelte-1nktfz {
  height: 100%;
  min-height: fit-content;
  display: flex;
  flex-flow: row nowrap;
}
.gradient-wrapper.svelte-1nktfz.svelte-1nktfz {
  width: 100%;
}
@supports (contain: inline-size) {
  @container cards-container (min-width: 600px) {
    .card-container.svelte-1nktfz.svelte-1nktfz {
      min-width: 0;
      flex-direction: row !important;
    }
    .card-container.svelte-1nktfz .card-topleft.svelte-1nktfz {
      max-width: 100% !important;
    }
    .card-container.svelte-1nktfz .card-topleft .difficulty-wrapper.svelte-1nktfz {
      padding: 0 !important;
    }
    .card-container.svelte-1nktfz .body-info.svelte-1nktfz {
      width: auto !important;
      margin: 0 !important;
      padding: 10px 12px !important;
    }
    .card-container.svelte-1nktfz .body-info.noTraining.svelte-1nktfz {
      text-align: center;
    }
    .card-container.svelte-1nktfz .body-info.noTraining.svelte-1nktfz:hover {
      cursor: default;
    }
  }
}
@supports not (contain: inline-size) {
  @media (min-width: 1860px), (max-width: 993px) and (min-width: 790px) {
    .card-container.svelte-1nktfz.svelte-1nktfz {
      min-width: 0;
      flex-direction: row !important;
    }
    .card-container.svelte-1nktfz .card-topleft.svelte-1nktfz {
      max-width: 100% !important;
    }
    .card-container.svelte-1nktfz .card-topleft .difficulty-wrapper.svelte-1nktfz {
      padding: 0 !important;
    }
    .card-container.svelte-1nktfz .body-info.svelte-1nktfz {
      width: auto !important;
      margin: 0 !important;
      padding: 10px 12px !important;
    }
    .card-container.svelte-1nktfz .body-info.noTraining.svelte-1nktfz {
      text-align: center;
    }
    .card-container.svelte-1nktfz .body-info.noTraining.svelte-1nktfz:hover {
      cursor: default;
    }
  }
  @media (min-width: 1860px) and (max-width: 2060px), (max-width: 993px) and (min-width: 790px) and (max-width: 2060px) {
    .card-container.svelte-1nktfz.svelte-1nktfz {
      min-width: 0;
      flex-direction: column !important;
    }
    .card-container.svelte-1nktfz .card-topleft.svelte-1nktfz {
      max-width: 100% !important;
      flex-grow: 0 !important;
    }
    .card-container.svelte-1nktfz .card-topleft .difficulty-wrapper.svelte-1nktfz {
      padding: 0 !important;
    }
    .card-container.svelte-1nktfz .body-info.svelte-1nktfz {
      width: auto !important;
      margin: 0 !important;
      padding: 10px 12px !important;
    }
    .card-container.svelte-1nktfz .body-info.noTraining.svelte-1nktfz {
      text-align: center;
    }
    .card-container.svelte-1nktfz .body-info.noTraining.svelte-1nktfz:hover {
      cursor: default;
    }
  }
}
.bold.svelte-1nktfz.svelte-1nktfz {
  font-weight: bold;
  color: black !important;
}
.card-container.svelte-1nktfz.svelte-1nktfz {
  display: flex !important;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 175px;
  height: 100%;
  min-height: fit-content;
  width: 100%;
  overflow: hidden;
}
.card-container.svelte-1nktfz .body-info.svelte-1nktfz {
  color: black !important;
  min-height: fit-content;
  padding: 4px 15px 4px 5px;
  min-width: 170px;
  flex: 9 1 170px;
}
.card-container.svelte-1nktfz .body-info .relativeWrapper.svelte-1nktfz {
  position: relative;
  padding: 0;
}
.card-container.svelte-1nktfz .card-topleft.svelte-1nktfz {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 155px;
  min-height: max-content;
  flex: 1 1 170px;
}
.card-container.svelte-1nktfz .card-topleft .difficulty-wrapper.svelte-1nktfz {
  padding: 10px 0 10px 10px;
  margin: 0 auto;
}
.workout-name.svelte-1nktfz.svelte-1nktfz {
  white-space: nowrap;
  max-height: 2.7rem;
  margin-bottom: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: black !important;
  margin-top: 5px;
}
.workout-name.svelte-1nktfz.svelte-1nktfz:hover {
  color: black !important;
}
.text-black.svelte-1nktfz.svelte-1nktfz {
  color: black;
}
.header.svelte-1nktfz.svelte-1nktfz {
  color: black;
  margin: 5px;
  padding: 5px;
}
.header.svelte-1nktfz .title.svelte-1nktfz {
  font-weight: bold;
}
.header.svelte-1nktfz .description.svelte-1nktfz {
  color: black !important;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.14px;
  opacity: 0.8;
}
a.clickable.svelte-1nktfz.svelte-1nktfz,
.clickable.svelte-1nktfz.svelte-1nktfz {
  padding: 5px;
  border-radius: 5px;
  transition: color 0.05s;
  display: block;
}
a.clickable.svelte-1nktfz.svelte-1nktfz:hover,
a.clickable.modalIsOpen.svelte-1nktfz.svelte-1nktfz,
.clickable.svelte-1nktfz.svelte-1nktfz:hover,
.clickable.modalIsOpen.svelte-1nktfz.svelte-1nktfz {
  cursor: pointer;
  transition: color 0.15s;
}
.XSSDetails.svelte-1nktfz.svelte-1nktfz {
  top: 5%;
  left: 100%;
}
button.svelte-1nktfz.svelte-1nktfz {
  all: unset;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingForecast/TrainingUpcomingCards.esbuild-svelte-fake-css */
.wrapper.svelte-1ot0bhy.svelte-1ot0bhy {
  height: max-content;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0 0 15px;
  container: cards-container/inline-size;
  position: relative;
}
.wrapper.svelte-1ot0bhy .training-cards-container.svelte-1ot0bhy {
  display: grid;
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: 4px;
  margin: 24px 0 0;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
}
.wrapper.svelte-1ot0bhy .training-cards-container.isLoading.svelte-1ot0bhy {
  filter: brightness(0.75);
  background: white;
}
.wrapper.svelte-1ot0bhy .training-cards-container.isLoading .absoluteSpinner.svelte-1ot0bhy {
  position: absolute;
  top: 50%;
  left: calc(50% - 16px);
  transform: translate(-50%, -50%);
  color: #016e79;
  z-index: 2;
}
.wrapper.svelte-1ot0bhy .training-cards-container.single-card.svelte-1ot0bhy {
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  width: auto;
  max-width: 599px;
}
@supports (contain: inline-size) {
  @container cards-container (min-width: 600px) {
    .wrapper.svelte-1ot0bhy.svelte-1ot0bhy {
      padding: 0 20px 15px;
    }
    .wrapper.svelte-1ot0bhy .training-cards-container.svelte-1ot0bhy {
      grid-template-rows: 1fr;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      width: auto;
    }
    .wrapper.svelte-1ot0bhy .training-cards-container.single-card.svelte-1ot0bhy {
      grid-template-rows: 1fr;
      grid-template-columns: 1fr;
      max-width: 599px;
    }
  }
}
@supports not (contain: inline-size) {
  @media (min-width: 1860px), (max-width: 993px) and (min-width: 790px) {
    .wrapper.svelte-1ot0bhy.svelte-1ot0bhy {
      padding: 0 20px 15px;
    }
    .wrapper.svelte-1ot0bhy .training-cards-container.svelte-1ot0bhy {
      grid-template-rows: 1fr;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      width: auto;
    }
    .wrapper.svelte-1ot0bhy .training-cards-container.single-card.svelte-1ot0bhy {
      grid-template-rows: 1fr;
      grid-template-columns: 1fr;
      max-width: 599px;
    }
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/RaceSelector.esbuild-svelte-fake-css */
.select-button.svelte-1gw076m:hover {
  transform: scale(1.05);
}
div.fileuploader-popup {
  z-index: 9999;
}
.fileuploader-theme-dragdrop.fileuploader {
  margin: 0;
  padding: 0;
  text-align: center;
  background: none;
  width: auto;
}
.fileuploader-theme-dragdrop .fileuploader-input {
  display: block;
  padding: 16px;
  text-align: center;
  background: rgba(47, 112, 118, 0.05);
  border: 1px dashed #979797;
  box-sizing: border-box;
  border-radius: 3px;
}
.fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-button {
  border-radius: 4px;
  margin: 0;
  padding: 0;
  width: 191px;
  height: 30px;
}
.fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-button > span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.48px;
  color: #FFFFFF;
}
.fileuploader-theme-dragdrop .fileuploader-input h3 {
  margin: 0;
  margin-bottom: 8px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.113198px;
  color: #3D3D3D;
}
.fileuploader-theme-dragdrop .fileuploader-input p {
  margin: 0;
  padding: 0;
  color: #90a0bc;
  margin-bottom: 12px;
}
.fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-inner > * {
  -webkit-transition: 500ms cubic-bezier(0.17, 0.67, 0, 1.01);
  transition: 500ms cubic-bezier(0.17, 0.67, 0, 1.01);
}
.fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-input-inner > * {
  transform: translateY(18px);
  opacity: 0;
}
.fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-icon-main {
  transform: translateY(30px) scale(1.2);
  opacity: 0.6;
}
.fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-input-caption {
  transform: translateY(30px);
  opacity: 0.6;
}
.fileuploader-theme-dragdrop .fileuploader-items {
  max-height: 250px;
  overflow: hidden;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/XataDetailsTable.esbuild-svelte-fake-css */
th.svelte-y1pb8h.svelte-y1pb8h {
  padding: 0 0 4px 0;
  text-align: center;
}
td.svelte-y1pb8h.svelte-y1pb8h {
  padding: 8px 0;
}
tr.svelte-y1pb8h:last-child td.svelte-y1pb8h {
  padding-bottom: 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/PlanFitSigTLTable.esbuild-svelte-fake-css */
th.svelte-1gui126.svelte-1gui126 {
  padding: 0 0 4px 0;
  vertical-align: bottom;
}
td.svelte-1gui126.svelte-1gui126 {
  padding: 8px 0;
}
.left-col-width.svelte-1gui126.svelte-1gui126 {
  width: 100px;
}
td.svelte-1gui126 + td.svelte-1gui126 {
  width: auto;
}
tr.svelte-1gui126:last-child td.svelte-1gui126 {
  padding-bottom: 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/PlanMeter.esbuild-svelte-fake-css */
.progress-ring__circle.svelte-1pzfdl3 {
  transition: 0.35s stroke-dashoffset linear;
  transform-origin: 50% 50%;
  transform: rotate(140deg);
  &.remaining {
    transform: rotate(40deg);
  }
}
.svg-text-middle.svelte-1pzfdl3 {
  dominant-baseline: middle;
  text-anchor: middle;
}
.marker-graph.svelte-1pzfdl3 {
  transition: 0.35s transform linear;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/XfaiGeneralSettings.esbuild-svelte-fake-css */
.compact.svelte-1oqvisy h4 {
  font-size: 1.1em;
  font-weight: 600;
  margin: 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/CalendarSettingsModal.esbuild-svelte-fake-css */
.row.svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab {
  margin: 16px 0px;
}
.modal-body.svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab {
  color: #3d3d3d;
  line-height: 24px;
  letter-spacing: 0.11px;
}
.settings-container.svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab {
  display: flex;
  gap: 15px 48px;
  align-items: center;
  flex-wrap: wrap;
}
.settings-dropdown.svelte-1jj7lab select.svelte-1jj7lab.svelte-1jj7lab {
  margin-top: 3px;
  border: 1px solid #979797;
  border-radius: 3px;
  background: white;
  height: 30px;
  width: 124px;
}
.stats-container.svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 3px;
}
.stats-container.svelte-1jj7lab input.svelte-1jj7lab.svelte-1jj7lab {
  display: none;
}
.stats-container.svelte-1jj7lab label.svelte-1jj7lab.svelte-1jj7lab {
  margin: 0px;
  padding: 5px 8px;
  background: rgba(47, 112, 118, 0.2);
  border-radius: 3px;
  color: #2F7076;
}
.stats-container.svelte-1jj7lab label.svelte-1jj7lab.svelte-1jj7lab:hover {
  cursor: pointer;
}
.stats-container.svelte-1jj7lab input.svelte-1jj7lab:checked + label.svelte-1jj7lab {
  background: #2F7076;
  color: white;
}
.toggle-wrapper.svelte-1jj7lab small.svelte-1jj7lab.svelte-1jj7lab {
  font-size: 14px;
  padding-left: 10px;
}
.btn.btn-default.svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab {
  padding: 8px 30px;
  border-radius: 4px;
  font-family: "Roboto";
  font-weight: 400;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.48px;
  float: none;
}
.btn.btn-default[type=submit].svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab {
  background: #2F7076;
  color: white;
}
.btn.btn-default[type=submit].svelte-1jj7lab.svelte-1jj7lab.svelte-1jj7lab:hover {
  background: #204d51;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/CalendarNotesModal.esbuild-svelte-fake-css */
#notes-modal.svelte-q2qe4h .modal-dialog.svelte-q2qe4h {
  display: flex;
  align-items: center;
  min-height: calc(100% - 60px);
}
#notes-modal.svelte-q2qe4h .modal-content.svelte-q2qe4h {
  max-height: 85vh;
}
#notes-modal.svelte-q2qe4h .modal-body.svelte-q2qe4h {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}
#notes-modal.svelte-q2qe4h .row.svelte-q2qe4h {
  margin: 0;
}
#update-notes.svelte-q2qe4h.svelte-q2qe4h {
  display: block;
  border: 1px solid #979797;
  border-radius: 3px;
  width: 100%;
  height: 199px;
}
label[for=update-notes].svelte-q2qe4h.svelte-q2qe4h {
  display: block;
}
.updates-segment.svelte-q2qe4h.svelte-q2qe4h {
  margin: 24px 0px;
}
.comments-row.svelte-q2qe4h.svelte-q2qe4h {
  margin-top: 24px;
}
.comments-row.svelte-q2qe4h label.svelte-q2qe4h {
  display: block;
}
.updates-title.svelte-q2qe4h.svelte-q2qe4h {
  line-height: 24px;
  color: #3d3d3d;
  letter-spacing: 0.11px;
  display: flex;
  justify-content: space-between;
}
.btn.btn-default.svelte-q2qe4h.svelte-q2qe4h {
  padding: 8px 30px;
  border-radius: 4px;
  font-family: "Roboto";
  font-weight: 400;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.48px;
  float: none;
}
.btn.btn-default[type=submit].svelte-q2qe4h.svelte-q2qe4h {
  background: #2F7076;
  color: white;
}
.btn.btn-default[type=submit].svelte-q2qe4h.svelte-q2qe4h:hover {
  background: #204d51;
}
.btn.btn-default.svelte-q2qe4h.svelte-q2qe4h:disabled {
  background-color: #eeeeee;
  cursor: not-allowed;
}
textarea.svelte-q2qe4h.svelte-q2qe4h {
  resize: vertical;
}
.inputfield.svelte-q2qe4h.svelte-q2qe4h {
  border: solid 1px #979797;
  border-radius: 3px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingForecast/ProgressionChart.esbuild-svelte-fake-css */
span.am5-stars {
  --star-color:black;
  --star-background:lightgray;
}
span.am5-stars::before {
  content: "\f005\f005\f005\f005\f005";
  background:
    linear-gradient(
      90deg,
      var(--star-color) var(--percent),
      var(--star-background) var(--percent));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.progression-chart.svelte-aa4ewd {
  height: 500px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/AdaptForecastDetails.esbuild-svelte-fake-css */
.details-scroll.svelte-1ncki1h {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 #f1f5f9;
}
.details-scroll.svelte-1ncki1h::-webkit-scrollbar {
  width: 10px;
}
.details-scroll.svelte-1ncki1h::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 5px;
}
.details-scroll.svelte-1ncki1h::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 5px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/StatsChart.esbuild-svelte-fake-css */
span.am5-stars {
  --star-color:black;
  --star-background:lightgray;
}
span.am5-stars::before {
  content: "\f005\f005\f005\f005\f005";
  background:
    linear-gradient(
      90deg,
      var(--star-color) var(--percent),
      var(--star-background) var(--percent));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.progression-chart.svelte-ed6jqf {
  height: 420px;
  min-height: 420px;
  max-width: 100%;
}
.legend-div.svelte-ed6jqf {
  height: 10px;
  width: 100%;
}
.legend-wrapper.svelte-ed6jqf {
  width: 100%;
}
.calendar-button.svelte-ed6jqf {
  display: flex;
  width: 110px;
  border: 1px solid #3D3D3D;
  border-radius: 3px;
  font-size: 12px;
  color: #3D3D3D;
  margin-left: auto;
  padding: 4px 8px;
}
.btn-text.svelte-ed6jqf {
  text-align: center;
  flex-grow: 1;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/StatsTable.esbuild-svelte-fake-css */
table.svelte-v36t0e {
  width: 100%;
}
th.svelte-v36t0e,
td.svelte-v36t0e {
  text-align: left;
  padding: 8px;
}
tr.svelte-v36t0e:nth-child(even) {
  background-color: #f2f2f2;
}
th.svelte-v36t0e {
  background-color: #016e79;
  color: white;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Today/TodayActivityCard.esbuild-svelte-fake-css */
.hidden-today-activity-card.svelte-gmxdvo {
  background:
    repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.03) 0px,
      rgba(0, 0, 0, 0.03) 3px,
      transparent 2px,
      transparent 8px);
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Calendar/Calendar.esbuild-svelte-fake-css */
#calendar-header.svelte-19467dd.svelte-19467dd {
  text-align: left;
  align-items: center;
}
#calendar-header.svelte-19467dd .header-row.svelte-19467dd {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex: 1;
}
#calendar-header.isSmallHeader.svelte-19467dd .extra-text.svelte-19467dd {
  display: none;
}
#calendar-header.isSmallHeader.svelte-19467dd #dateDiv.svelte-19467dd {
  justify-content: left;
}
#calendar-header.hideButtonText.svelte-19467dd .extra-text2.svelte-19467dd {
  display: none;
}
#day-of-week-row.svelte-19467dd.svelte-19467dd {
  background-color: white;
  padding: 6px 0;
  border-radius: 4px 4px 0px 0px;
}
.day-of-week.svelte-19467dd.svelte-19467dd {
  display: inline-block;
  width: 14.2857142857%;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #3D3D3D;
}
#calendar.svelte-19467dd.svelte-19467dd {
  overflow-y: scroll;
  height: 800px;
  position: relative;
  overflow-anchor: none;
}
#adapt-forecast-.svelte-19467dd.svelte-19467dd {
  position: relative;
}
.calendar-row.svelte-19467dd.svelte-19467dd {
  display: flex;
}
.calendar-row-wrapper.svelte-19467dd.svelte-19467dd {
  background: white;
  position: absolute;
  left: 0;
  width: calc(100% - 8px);
}
.cell.svelte-19467dd.svelte-19467dd {
  display: flex;
  flex-direction: column;
  width: 14.2857142857%;
  min-height: 136px;
}
.cell.compact.svelte-19467dd.svelte-19467dd {
  min-height: 60px;
}
.cell.mobile.svelte-19467dd.svelte-19467dd {
  flex-direction: row;
  width: 100%;
  margin-bottom: 0;
}
.training-status.svelte-19467dd.svelte-19467dd {
  height: 6px;
  width: 100%;
}
.training-status.mobile.svelte-19467dd.svelte-19467dd {
  height: 100%;
  width: 8px;
}
#dateDiv.svelte-19467dd.svelte-19467dd {
  display: flex;
  justify-content: center;
  align-items: center;
}
#dateLabel.svelte-19467dd.svelte-19467dd {
  display: flex;
  text-align: left;
  margin-left: 10px;
  width: 160px;
}
#scroll-to-today-btn.svelte-19467dd.svelte-19467dd {
  width: 55px;
  margin-left: 100px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-shift-btn.svelte-19467dd.svelte-19467dd {
  margin-left: 5px;
  margin: 5px;
}
.header-btn.svelte-19467dd.svelte-19467dd {
  width: 40px;
}
.justify-start.svelte-19467dd.svelte-19467dd {
  justify-self: left;
}
.calendar-button.svelte-19467dd.svelte-19467dd {
  background-color: #fff;
  border: 1px solid #3D3D3D;
  border-radius: 3px;
  font-size: 16px;
  color: #3D3D3D;
  margin-left: 16px;
  padding: 4px 8px;
}
.calendar-button.isMobile.svelte-19467dd.svelte-19467dd {
  margin-left: 6px;
}
.calendar-button.svelte-19467dd.svelte-19467dd:focus-visible {
  background-color: #e6e6e6;
}
@media (pointer: fine) {
  .calendar-button.svelte-19467dd.svelte-19467dd:hover {
    background-color: #e6e6e6;
  }
}
.calendar-button.svelte-19467dd.svelte-19467dd:active {
  background-color: #d4d4d4;
}
.icon-button.svelte-19467dd.svelte-19467dd {
  padding: 0;
  background-color: transparent;
  border: none;
}
#loading.svelte-19467dd.svelte-19467dd {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  padding-top: 20px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.5;
  z-index: 1000;
  background-color: #FFF;
}
.hidden-scrollbar.svelte-19467dd.svelte-19467dd {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hidden-scrollbar.svelte-19467dd.svelte-19467dd::-webkit-scrollbar {
  display: none;
}
.red-dot.svelte-19467dd.svelte-19467dd {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  top: 2px;
  right: 2px;
}
.dummy.svelte-19467dd.svelte-19467dd {
  height: 4096px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Today/UpcomingTraining.esbuild-svelte-fake-css */
.red-dot.svelte-zzyelv {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  top: 2px;
  right: 2px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Today/PrePlanCard.esbuild-svelte-fake-css */
.stream.svelte-1dy96vx {
  stroke-dasharray: 3 5;
  animation: svelte-1dy96vx-preplan-flow 0.5s linear infinite;
}
.grain.svelte-1dy96vx {
  opacity: 0;
  animation: svelte-1dy96vx-preplan-fall 1.2s linear infinite;
}
@keyframes svelte-1dy96vx-preplan-flow {
  to {
    stroke-dashoffset: -8;
  }
}
@keyframes svelte-1dy96vx-preplan-fall {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(var(--drop));
    opacity: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .stream.svelte-1dy96vx,
  .grain.svelte-1dy96vx {
    animation: none;
  }
  .grain.svelte-1dy96vx {
    opacity: 0;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/TrainPrefDayPicker.esbuild-svelte-fake-css */
.yellow-dot.svelte-1cw2yb3 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  right: calc(50% - 10px);
  background-color: rgb(255, 167, 0);
}
.this-grid.svelte-1cw2yb3 {
  display: grid;
  grid-template-columns: max-content auto max-content;
  grid-auto-flow: row;
  gap: 0.25rem;
  align-items: center;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/BBPeakSetupForm.esbuild-svelte-fake-css */
.slider-container.svelte-mhrn5b.svelte-mhrn5b {
  max-width: 100%;
  width: 100%;
}
.slider-container.svelte-mhrn5b span.svelte-mhrn5b {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  color: white;
  pointer-events: none;
}
.slider-container.svelte-mhrn5b span i.svelte-mhrn5b {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  color: inherit;
}
.slider-container.svelte-mhrn5b .select-slider.svelte-mhrn5b {
  -webkit-appearance: none;
  appearance: none;
  height: 30px;
  outline: none;
  border-radius: 4px !important;
  position: relative;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/CurrentTPDateSlider.esbuild-svelte-fake-css */
.slider-container.svelte-1728pp1.svelte-1728pp1 {
  max-width: 100%;
  width: 100%;
}
.slider-container.svelte-1728pp1 span.svelte-1728pp1 {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  color: white;
  pointer-events: none;
}
.slider-container.svelte-1728pp1.svelte-1728pp1:before {
  background: var(--tpDateSliderBG);
  mask-image: var(--maskBG);
  border-radius: 4px !important;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  content: "";
}
.select-slider.svelte-1728pp1.svelte-1728pp1 {
  -webkit-appearance: none;
  appearance: none;
  height: 30px;
  outline: none;
  position: relative;
  background: transparent;
}
.select-slider.svelte-1728pp1.svelte-1728pp1::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 10px;
  height: 40px;
  background: #ffffff;
  border-radius: 7px !important;
  cursor: pointer;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
}
.select-slider.svelte-1728pp1.svelte-1728pp1::-moz-range-thumb {
  width: 10px;
  height: 40px;
  background: #ffffff;
  border-radius: 7px !important;
  cursor: pointer;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
}
.select-slider.svelte-1728pp1.svelte-1728pp1:disabled {
  cursor: not-allowed;
}
.select-slider.svelte-1728pp1.svelte-1728pp1:disabled::-moz-range-thumb {
  background-color: #d7d7d7;
}
.select-slider.svelte-1728pp1.svelte-1728pp1:disabled::-webkit-slider-thumb {
  background-color: #d7d7d7;
}
.select-slider.svelte-1728pp1.svelte-1728pp1:focus {
  outline: none;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ResponsiveHalfView.esbuild-svelte-fake-css */
.half-flex.svelte-jpiveh {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  flex-wrap: nowrap;
  min-width: 40%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/CurrentProgram.esbuild-svelte-fake-css */
.half-flex.svelte-1qg200q.svelte-1qg200q {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  flex-wrap: nowrap;
  min-width: 40%;
}
.meter-container.svelte-1qg200q.svelte-1qg200q {
  flex: 1 1 0%;
  max-height: 152px;
}
.slider-label-btn.svelte-1qg200q.svelte-1qg200q {
  border-radius: 0.5rem;
  border: 0px;
  padding: 3px 5px;
  transition: background-color 0.2s ease-in;
  position: absolute;
  top: 68px;
  background: transparent;
}
.slider-label-btn.svelte-1qg200q.svelte-1qg200q:hover {
  background-color: #d6d6d6 !important;
}
.shift-xy.svelte-1qg200q.svelte-1qg200q {
  transform: translate(-50%, 50%);
}
.shift-x.svelte-1qg200q.svelte-1qg200q {
  transform: translateX(-50%);
}
.calendar-button.svelte-1qg200q.svelte-1qg200q {
  background-color: #fff;
  border: 1px solid #3D3D3D;
  border-radius: 3px;
  font-size: 16px;
  color: #3D3D3D;
  padding: 4px 8px;
}
.calendar-button.svelte-1qg200q.svelte-1qg200q:focus-visible {
  background-color: #e6e6e6;
}
@media (pointer: fine) {
  .calendar-button.svelte-1qg200q.svelte-1qg200q:hover {
    background-color: #e6e6e6;
  }
}
.calendar-button.svelte-1qg200q.svelte-1qg200q:active {
  background-color: #d4d4d4;
}
.slider-language.svelte-1qg200q.svelte-1qg200q {
  transition: all;
  animation: svelte-1qg200q-scale 1s ease-in-out 0s 1;
}
@keyframes svelte-1qg200q-scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.slider-container.svelte-1qg200q.svelte-1qg200q {
  container-type: inline-size;
}
.slider-container.svelte-1qg200q .legend-grid.svelte-1qg200q {
  grid-template-columns: min-content auto auto;
}
@container (width < 530px) {
  .slider-container.svelte-1qg200q .legend-grid.svelte-1qg200q {
    grid-template-columns: min-content auto;
  }
  .slider-container.svelte-1qg200q .legend-label.svelte-1qg200q {
    text-align: left !important;
  }
  .slider-container.svelte-1qg200q .hide-date.svelte-1qg200q {
    display: none;
  }
}
.program-info-cq.svelte-1qg200q.svelte-1qg200q {
  container-type: inline-size;
}
.program-info-cq.svelte-1qg200q .race-info-box.svelte-1qg200q {
  grid-template-columns: min-content auto;
}
.program-info-cq.svelte-1qg200q .event-info-box.svelte-1qg200q {
  grid-template-columns: 1fr 1fr;
}
.program-info-cq.svelte-1qg200q .race-plan-name.svelte-1qg200q {
  overflow-wrap: anywhere;
}
@container (width < 450px) {
  .program-info-cq.svelte-1qg200q .race-plan-name.svelte-1qg200q,
  .program-info-cq.svelte-1qg200q .race-plan-weights.svelte-1qg200q {
    grid-column-start: 1 !important;
  }
  .program-info-cq.svelte-1qg200q .race-plan-name.svelte-1qg200q {
    margin-top: 8px;
    align-self: auto !important;
  }
  .program-info-cq.svelte-1qg200q .race-info-box.svelte-1qg200q {
    grid-template-columns: auto;
  }
  .program-info-cq.svelte-1qg200q .event-info-box.svelte-1qg200q {
    grid-template-columns: min-content auto;
    gap: 16px 24px;
    grid-auto-flow: row;
    align-items: start;
  }
  .program-info-cq.svelte-1qg200q .event-info-box span.svelte-1qg200q:nth-child(3) {
    grid-area: 1/2/1/2;
  }
  .program-info-cq.svelte-1qg200q .event-info-box span.svelte-1qg200q:nth-child(4) {
    grid-area: 2/2/2/2;
  }
  .program-info-cq.svelte-1qg200q .event-info-box span.svelte-1qg200q:nth-child(5) {
    margin-top: 0px !important;
  }
  .program-info-cq.svelte-1qg200q .event-info-box span.svelte-1qg200q:nth-child(6) {
    margin-top: 0px !important;
  }
  .program-info-cq.svelte-1qg200q .event-info-box span.svelte-1qg200q:nth-child(7) {
    grid-area: 3/2/3/2;
  }
  .program-info-cq.svelte-1qg200q .event-info-box span.svelte-1qg200q:nth-child(8) {
    grid-area: 4/2/4/2;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramPage.esbuild-svelte-fake-css */
.target-button.svelte-ycc7ip input[type=radio].svelte-ycc7ip + label.svelte-ycc7ip.svelte-ycc7ip {
  background: rgba(var(--rgb-xert-teal), 0.2);
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -2px rgba(0, 0, 0, 0.2);
}
.target-button.svelte-ycc7ip input[type=radio].svelte-ycc7ip:checked + label.svelte-ycc7ip.svelte-ycc7ip {
  transform: scale(1.1);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -4px rgba(0, 0, 0, 0.2);
  font-weight: bold;
}
.target-button.svelte-ycc7ip input[type=radio].svelte-ycc7ip:checked + label.svelte-ycc7ip > i.svelte-ycc7ip {
  font-weight: bold;
}
.target-button.svelte-ycc7ip input[type=radio].svelte-ycc7ip:hover + label.svelte-ycc7ip.svelte-ycc7ip {
  transform: scale(1.1);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -4px rgba(0, 0, 0, 0.2);
  font-weight: bold;
  cursor: pointer;
}
.target-button.svelte-ycc7ip input[type=radio].svelte-ycc7ip:hover + label.svelte-ycc7ip > i.svelte-ycc7ip {
  font-weight: bold;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/ProfileSettingsInput.esbuild-svelte-fake-css */
.input-icon.svelte-132w0z.svelte-132w0z {
  position: relative;
}
.input-icon.svelte-132w0z input.svelte-132w0z {
  padding-left: 30px !important;
  padding-right: -30px !important;
  margin-right: 8px !important;
  width: 100%;
  -moz-appearance: textfield;
  appearance: textfield;
}
.input-icon.svelte-132w0z input.svelte-132w0z::-webkit-outer-spin-button,
.input-icon.svelte-132w0z input.svelte-132w0z::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input-icon.svelte-132w0z .icon-container.svelte-132w0z {
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
}
.input-icon.svelte-132w0z .help-block.svelte-132w0z {
  font-size: 85%;
  margin: 0;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/FitnessSignature.esbuild-svelte-fake-css */
.form-group.svelte-1kefypf.svelte-1kefypf {
  flex: 1 1 150px;
  margin: 0;
  position: relative;
}
.fs-container.svelte-1kefypf.svelte-1kefypf {
  container-name: fs-container;
  container-type: inline-size;
  width: 100%;
  height: 100%;
}
.fitness-signature-form.svelte-1kefypf.svelte-1kefypf {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(12, 1fr);
  height: 100%;
  align-items: center;
}
.fitness-signature-form.svelte-1kefypf > div.svelte-1kefypf {
  height: 100%;
}
.fitness-signature-form.svelte-1kefypf > div.svelte-1kefypf {
  margin: 0 4px;
}
.fitness-signature-form.svelte-1kefypf .ftp-div.svelte-1kefypf {
  grid-column: 1/span 4;
  grid-row: 1/span 12;
}
.fitness-signature-form.svelte-1kefypf .hie-div.svelte-1kefypf {
  grid-column: 5/span 4;
  grid-row: 1/span 12;
}
.fitness-signature-form.svelte-1kefypf .pp-div.svelte-1kefypf {
  grid-column: 9/span 4;
  grid-row: 1/span 12;
}
@container fs-container (max-width: 600px) {
  .fitness-signature-form.svelte-1kefypf.svelte-1kefypf {
    row-gap: 12px;
  }
  .fitness-signature-form.svelte-1kefypf .ftp-div.svelte-1kefypf {
    grid-row: 9/span 4 !important;
    grid-column: 1/span 12 !important;
  }
  .fitness-signature-form.svelte-1kefypf .hie-div.svelte-1kefypf {
    grid-row: 5/span 4 !important;
    grid-column: 1/span 12 !important;
  }
  .fitness-signature-form.svelte-1kefypf .pp-div.svelte-1kefypf {
    grid-row: 1/span 4 !important;
    grid-column: 1/span 12 !important;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .ltp-div.svelte-1kefypf {
    grid-row: 10/span 3 !important;
    grid-column: 1/span 12 !important;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .ftp-div.svelte-1kefypf {
    grid-row: 7/span 3 !important;
    grid-column: 1/span 12 !important;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .hie-div.svelte-1kefypf {
    grid-row: 4/span 3 !important;
    grid-column: 1/span 12 !important;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .pp-div.svelte-1kefypf {
    grid-row: 1/span 3 !important;
    grid-column: 1/span 12 !important;
  }
}
@container fs-container (min-width: 600px) {
  .fitness-signature-form.svelte-1kefypf > div.svelte-1kefypf {
    margin: 0 4px;
  }
  .fitness-signature-form.svelte-1kefypf .ftp-div.svelte-1kefypf {
    grid-column: 1/span 4;
    grid-row: 1/span 12;
  }
  .fitness-signature-form.svelte-1kefypf .hie-div.svelte-1kefypf {
    grid-column: 5/span 4;
    grid-row: 1/span 12;
  }
  .fitness-signature-form.svelte-1kefypf .pp-div.svelte-1kefypf {
    grid-column: 9/span 4;
    grid-row: 1/span 12;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .ltp-div.svelte-1kefypf {
    grid-column: 10/span 3;
    grid-row: 1/span 12;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .ftp-div.svelte-1kefypf {
    grid-column: 1/span 3;
    grid-row: 1/span 12;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .hie-div.svelte-1kefypf {
    grid-column: 4/span 3;
    grid-row: 1/span 12;
  }
  .fitness-signature-form.showLTP.svelte-1kefypf .pp-div.svelte-1kefypf {
    grid-column: 7/span 3;
    grid-row: 1/span 12;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/TrainingLoad.esbuild-svelte-fake-css */
.form-group.svelte-dzj4uz.svelte-dzj4uz {
  flex: 1 1 150px;
  margin: 0;
}
.tl-container.svelte-dzj4uz.svelte-dzj4uz {
  container-name: tl-container;
  container-type: inline-size;
  width: 100%;
  height: 100%;
}
.training-load-form.svelte-dzj4uz.svelte-dzj4uz {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(12, 1fr);
  height: 100%;
  align-items: center;
}
@container tl-container (max-width: 300px) {
  .training-load-form.svelte-dzj4uz.svelte-dzj4uz {
    row-gap: 12px;
  }
  .training-load-form.svelte-dzj4uz .ftp-div.svelte-dzj4uz {
    grid-row: 9/span 4 !important;
    grid-column: 1/span 12 !important;
  }
  .training-load-form.svelte-dzj4uz .hie-div.svelte-dzj4uz {
    grid-row: 5/span 4 !important;
    grid-column: 1/span 12 !important;
  }
  .training-load-form.svelte-dzj4uz .pp-div.svelte-dzj4uz {
    grid-row: 1/span 4 !important;
    grid-column: 1/span 12 !important;
  }
}
@container tl-container (min-width: 300px) {
  .training-load-form.svelte-dzj4uz > div.svelte-dzj4uz {
    margin: 0 4px;
  }
  .training-load-form.svelte-dzj4uz .ftp-div.svelte-dzj4uz {
    grid-column: 1/span 4;
    grid-row: 1/span 12;
  }
  .training-load-form.svelte-dzj4uz .hie-div.svelte-dzj4uz {
    grid-column: 5/span 4;
    grid-row: 1/span 12;
  }
  .training-load-form.svelte-dzj4uz .pp-div.svelte-dzj4uz {
    grid-column: 9/span 4;
    grid-row: 1/span 12;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/ActivityDetailsTable.esbuild-svelte-fake-css */
@container training-load-container (max-width: 723px) {
  .table-header.svelte-qo4x9n.svelte-qo4x9n {
    display: none !important;
  }
  .training-load-controls.svelte-qo4x9n.svelte-qo4x9n {
    grid-row: 1/span 2 !important;
    grid-column: 6/span 1 !important;
  }
  .training-load-activity-details.svelte-qo4x9n.svelte-qo4x9n {
    gap: 15px;
  }
  .name.svelte-qo4x9n.svelte-qo4x9n {
    grid-row: 2/span 1 !important;
    grid-column: 1/span 4 !important;
  }
  .date.svelte-qo4x9n.svelte-qo4x9n {
    grid-row: 1/span 1 !important;
    grid-column: 1/span 4 !important;
  }
  .training-load-activity-details.svelte-qo4x9n.svelte-qo4x9n {
    grid-row: 1/span 2 !important;
    grid-column: 1/span 6 !important;
  }
  .training-load.svelte-qo4x9n.svelte-qo4x9n {
    grid-row: 3/span 4 !important;
    grid-column: 1/span 6 !important;
  }
}
.training-load-controls.svelte-qo4x9n.svelte-qo4x9n {
  align-items: center;
  display: flex;
  gap: 8px;
  grid-column: 6/span 1;
  grid-row: 1/span 6;
}
.training-load-controls.svelte-qo4x9n div.svelte-qo4x9n {
  aspect-ratio: 1/1;
  height: 40px;
  display: flex;
  justify-content: center;
}
.training-load-controls.svelte-qo4x9n div i.svelte-qo4x9n {
  height: min-content;
  margin: auto 0;
}
.training-load-controls.svelte-qo4x9n div i.svelte-qo4x9n:hover {
  color: var(--color-xert-teal) !important;
}
.tl-row.svelte-qo4x9n.svelte-qo4x9n {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}
.name.svelte-qo4x9n.svelte-qo4x9n {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  grid-column: 2/span 1;
  grid-row: 1/span 6;
  align-content: center;
  padding: 0 4px;
}
.date.svelte-qo4x9n.svelte-qo4x9n {
  padding: 4px;
  grid-column: 1/span 1;
  grid-row: 1/span 6;
  align-content: center;
}
.training-load-activity-details.svelte-qo4x9n.svelte-qo4x9n {
  display: flex;
  flex-direction: row;
  margin: 4px;
  margin-top: auto;
  flex-grow: 1;
  flex-wrap: nowrap;
  grid-column: 1/span 2;
  grid-row: 1/span 6;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
}
.training-load-row.svelte-qo4x9n.svelte-qo4x9n {
  container: training-load-container;
  display: grid;
  grid-template-columns: 96px repeat(4, 1fr) 108px;
  grid-template-rows: repeat(6, 1fr);
  height: fit-content;
}
.training-load.svelte-qo4x9n.svelte-qo4x9n {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  grid-column: 3/span 3;
  grid-row: 1/span 6;
}
.form-group.svelte-qo4x9n.svelte-qo4x9n {
  margin: 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/FitnessSignatureTab.esbuild-svelte-fake-css */
#tab-grid-container.svelte-1equ2p4.svelte-1equ2p4 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(4, auto);
  column-gap: 20px;
  row-gap: 12px;
}
@media only screen and (min-width: 1250px) {
  #tab-grid-container.svelte-1equ2p4 #decay-method-portlet.svelte-1equ2p4 {
    grid-column: 1/span 2;
    grid-row: 2/span 1;
    align-self: end;
  }
  #tab-grid-container.svelte-1equ2p4 #power-curve-portlet.svelte-1equ2p4 {
    grid-column: 3/span 4;
    grid-row: span 4;
  }
  #tab-grid-container.svelte-1equ2p4 #cfs-portlet.svelte-1equ2p4 {
    grid-column: 1/span 2;
    grid-row: 1/span 1;
  }
}
@media only screen and (min-width: 700px) and (max-width: 1250px) {
  #tab-grid-container.svelte-1equ2p4 #decay-method-portlet.svelte-1equ2p4 {
    grid-column: 4/span 3;
    grid-row: 1/span 1;
    align-self: start;
  }
  #tab-grid-container.svelte-1equ2p4 #power-curve-portlet.svelte-1equ2p4 {
    grid-column: 1/span 6;
    grid-row: 2/span 3;
  }
  #tab-grid-container.svelte-1equ2p4 #cfs-portlet.svelte-1equ2p4 {
    grid-column: 1/span 3;
    grid-row: 1/span 1;
  }
}
@media only screen and (max-width: 700px) {
  #tab-grid-container.svelte-1equ2p4 #decay-method-portlet.svelte-1equ2p4 {
    grid-column: 1/span;
    grid-row: 2/span 1;
    align-self: end;
  }
  #tab-grid-container.svelte-1equ2p4 #power-curve-portlet.svelte-1equ2p4 {
    grid-column: 1/span;
    grid-row: span 4;
  }
  #tab-grid-container.svelte-1equ2p4 #cfs-portlet.svelte-1equ2p4 {
    grid-column: 1/span;
    grid-row: 1/span 1;
  }
}
@media only screen and (max-width: 873px) {
  .curve-portlet.svelte-1equ2p4.svelte-1equ2p4 {
    overflow-x: scroll;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/XPMCSettings.esbuild-svelte-fake-css */
#xpmc-settings-grid-container.svelte-m7rxaw.svelte-m7rxaw {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, auto);
  row-gap: 16px;
  column-gap: 16px;
}
#xpmc-tc-container.svelte-m7rxaw.svelte-m7rxaw {
  container-name: tc-container;
  container-type: inline-size;
}
#xpmc-training-responsiveness.svelte-m7rxaw.svelte-m7rxaw {
  height: fit-content;
}
@media only screen and (min-width: 530px) {
  #xpmc-table.svelte-m7rxaw.svelte-m7rxaw {
    grid-row: 3/span 1;
    grid-column: 1/span 2;
  }
  #xpmc-training-responsiveness.svelte-m7rxaw.svelte-m7rxaw {
    grid-row: 1/span 1;
    grid-column: 2/span 1;
  }
  #xpmc-tc-container.svelte-m7rxaw.svelte-m7rxaw {
    grid-row: 1/span 1;
    grid-column: 1/span 1;
  }
}
@media only screen and (max-width: 530px) {
  #xpmc-table.svelte-m7rxaw.svelte-m7rxaw {
    grid-row: 3/span 1;
    grid-column: 1/span 2;
  }
  #xpmc-training-responsiveness.svelte-m7rxaw.svelte-m7rxaw {
    grid-row: 1/span 1;
    grid-column: 1/span 2;
  }
  #xpmc-tc-container.svelte-m7rxaw.svelte-m7rxaw {
    grid-row: 2/span 1;
    grid-column: 1/span 2;
  }
}
@container tc-container (max-width: 600px) {
  #xpmc-time-constants.svelte-m7rxaw.svelte-m7rxaw {
    display: grid;
    grid-template-columns: repeat(2, fr);
    grid-template-rows: repeat(7, fr);
    column-gap: 8px;
  }
  #xpmc-time-constants.svelte-m7rxaw #xpmc-tc-title.svelte-m7rxaw {
    grid-column: 1/span 2;
    grid-row: 1/span 2;
  }
  #xpmc-time-constants.svelte-m7rxaw #xpmc-tc-tl.svelte-m7rxaw {
    display: block !important;
    grid-column: 1/span 1;
    grid-row: 3/span 4;
  }
  #xpmc-time-constants.svelte-m7rxaw #xpmc-tc-rl.svelte-m7rxaw {
    display: block !important;
    grid-column: 2/span 1;
    grid-row: 3/span 4;
  }
  #xpmc-time-constants.svelte-m7rxaw #xpmc-tc-save.svelte-m7rxaw {
    grid-column: 1/span 2;
    grid-row: 7/span 1;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/MovingTimeSettings.esbuild-svelte-fake-css */
.yellow-dot.svelte-1cw2yb3 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  right: calc(50% - 10px);
  background-color: rgb(255, 167, 0);
}
.this-grid.svelte-1cw2yb3 {
  display: grid;
  grid-template-columns: max-content auto max-content;
  grid-auto-flow: row;
  gap: 0.25rem;
  align-items: center;
}

/* fakecss:/home/forge/alpha/svelte-components/src/Program/ProgramElements/DurabilityMetricSettings.esbuild-svelte-fake-css */
.yellow-dot.svelte-1cw2yb3 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  right: calc(50% - 10px);
  background-color: rgb(255, 167, 0);
}
.this-grid.svelte-1cw2yb3 {
  display: grid;
  grid-template-columns: max-content auto max-content;
  grid-auto-flow: row;
  gap: 0.25rem;
  align-items: center;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/HeartRateDerivedMetrics.esbuild-svelte-fake-css */
.input-icon.svelte-1lpkx57.svelte-1lpkx57 {
  align-content: center;
}
.input-icon.svelte-1lpkx57 > input.svelte-1lpkx57 {
  padding-left: 30px !important;
  padding-right: -30px !important;
  margin-right: 8px !important;
}
.input-icon.svelte-1lpkx57 > i.svelte-1lpkx57 {
  margin: 8px 0 0 8px !important;
}
.form-group.svelte-1lpkx57.svelte-1lpkx57 {
  flex-grow: 1;
  min-width: 100px;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/ProfileSettings.esbuild-svelte-fake-css */
#program-page-container.svelte-1rm93c0 {
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
#program-settings-modal.svelte-1rm93c0::-webkit-scrollbar {
  display: none;
}
#program-settings-modal.svelte-1rm93c0 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
#program-settings-modal.svelte-1rm93c0 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.program-type-container.svelte-1rm93c0 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
}
.modal-body.svelte-1rm93c0 {
  padding: 0px;
}
#hr-params > div {
  flex-grow: 1;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Header.esbuild-svelte-fake-css */
.animated.svelte-1cy5su5 .svelte-1cy5su5 {
  transition-property:
    width,
    height,
    font-size,
    font-weight,
    color;
  transition-duration: 0.25s;
}
.compact.svelte-1cy5su5 .profile-img.svelte-1cy5su5 {
  width: 61.5px;
  height: auto;
}
.compact.svelte-1cy5su5 .username.svelte-1cy5su5 {
  font-size: 20px;
  font-weight: 700;
  color: #3D3D3D;
}
.compact.svelte-1cy5su5 .athlete_type.svelte-1cy5su5 {
  font-size: 14px;
  font-weight: 400;
  color: #3D3D3D;
}
.compact.svelte-1cy5su5 .stats_box.svelte-1cy5su5 {
  height: auto;
}
.compact.svelte-1cy5su5 .compact-hidden.svelte-1cy5su5 {
  display: none;
}
.compact.svelte-1cy5su5 .grid_container.svelte-1cy5su5 {
  display: flex;
  flex-direction: row;
}
.compact.svelte-1cy5su5 .xert_stats.svelte-1cy5su5 {
  justify-content: right;
}
.compact.svelte-1cy5su5 .substats-container.svelte-1cy5su5 {
  flex-direction: row;
  align-items: end;
}
#profile-wrapper.svelte-1cy5su5.svelte-1cy5su5 {
  display: flex;
}
.svelte-1cy5su5:not(.compact) > #profile-wrapper.svelte-1cy5su5 {
  max-width: 50%;
}
.substats-container.svelte-1cy5su5.svelte-1cy5su5 {
  display: flex;
  flex-direction: column;
}
.profile-img.svelte-1cy5su5.svelte-1cy5su5 {
  margin-right: 16px;
}
.truncate.svelte-1cy5su5.svelte-1cy5su5 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

/* fakecss:/home/forge/alpha/svelte-components/src/XertUpdates/XertNewsFeed.esbuild-svelte-fake-css */
.header-background.svelte-17kwqe8 {
  background:
    linear-gradient(
      0deg,
      rgba(var(--rgb-xert-teal), 0.75) 0%,
      rgba(var(--rgb-xert-teal), 0.75) 100%),
    url("../../assets/images/xfai/Road cyclist riding through a surreal, multi-dimensional universe.webp");
  background-position: right 38% top 43%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SetupWizards/WizardCard.esbuild-svelte-fake-css */
.header-background.svelte-jwo19a {
  background:
    linear-gradient(
      0deg,
      rgba(var(--rgb-xert-teal), 0.8) 0%,
      rgba(var(--rgb-xert-teal), 0.8) 100%),
    url("/assets/images/xfai/Road cyclist riding through a surreal, multi-dimensional universe.webp");
  background-position: top right 33%;
}

/* fakecss:/home/forge/node_modules/.pnpm/svelte-file-dropzone@2.0.9_svelte@4.2.20/node_modules/svelte-file-dropzone/dist/components/Dropzone.esbuild-svelte-fake-css */
.dropzone.svelte-817dg2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #eeeeee;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
}
.dropzone.svelte-817dg2:focus {
  border-color: #2196f3;
}

/* ../../node_modules/.pnpm/cropperjs@1.6.2/node_modules/cropperjs/dist/cropper.css */
.cropper-container {
  direction: ltr;
  font-size: 0;
  line-height: 0;
  position: relative;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.cropper-container img {
  backface-visibility: hidden;
  display: block;
  height: 100%;
  image-orientation: 0deg;
  max-height: none !important;
  max-width: none !important;
  min-height: 0 !important;
  min-width: 0 !important;
  width: 100%;
}
.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}
.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}
.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}
.cropper-view-box {
  display: block;
  height: 100%;
  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
  overflow: hidden;
  width: 100%;
}
.cropper-dashed {
  border: 0 dashed #eee;
  display: block;
  opacity: 0.5;
  position: absolute;
}
.cropper-dashed.dashed-h {
  border-bottom-width: 1px;
  border-top-width: 1px;
  height: calc(100% / 3);
  left: 0;
  top: calc(100% / 3);
  width: 100%;
}
.cropper-dashed.dashed-v {
  border-left-width: 1px;
  border-right-width: 1px;
  height: 100%;
  left: calc(100% / 3);
  top: 0;
  width: calc(100% / 3);
}
.cropper-center {
  display: block;
  height: 0;
  left: 50%;
  opacity: 0.75;
  position: absolute;
  top: 50%;
  width: 0;
}
.cropper-center::before,
.cropper-center::after {
  background-color: #eee;
  content: " ";
  display: block;
  position: absolute;
}
.cropper-center::before {
  height: 1px;
  left: -3px;
  top: 0;
  width: 7px;
}
.cropper-center::after {
  height: 7px;
  left: 0;
  top: -3px;
  width: 1px;
}
.cropper-face,
.cropper-line,
.cropper-point {
  display: block;
  height: 100%;
  opacity: 0.1;
  position: absolute;
  width: 100%;
}
.cropper-face {
  background-color: #fff;
  left: 0;
  top: 0;
}
.cropper-line {
  background-color: #39f;
}
.cropper-line.line-e {
  cursor: ew-resize;
  right: -3px;
  top: 0;
  width: 5px;
}
.cropper-line.line-n {
  cursor: ns-resize;
  height: 5px;
  left: 0;
  top: -3px;
}
.cropper-line.line-w {
  cursor: ew-resize;
  left: -3px;
  top: 0;
  width: 5px;
}
.cropper-line.line-s {
  bottom: -3px;
  cursor: ns-resize;
  height: 5px;
  left: 0;
}
.cropper-point {
  background-color: #39f;
  height: 5px;
  opacity: 0.75;
  width: 5px;
}
.cropper-point.point-e {
  cursor: ew-resize;
  margin-top: -3px;
  right: -3px;
  top: 50%;
}
.cropper-point.point-n {
  cursor: ns-resize;
  left: 50%;
  margin-left: -3px;
  top: -3px;
}
.cropper-point.point-w {
  cursor: ew-resize;
  left: -3px;
  margin-top: -3px;
  top: 50%;
}
.cropper-point.point-s {
  bottom: -3px;
  cursor: s-resize;
  left: 50%;
  margin-left: -3px;
}
.cropper-point.point-ne {
  cursor: nesw-resize;
  right: -3px;
  top: -3px;
}
.cropper-point.point-nw {
  cursor: nwse-resize;
  left: -3px;
  top: -3px;
}
.cropper-point.point-sw {
  bottom: -3px;
  cursor: nesw-resize;
  left: -3px;
}
.cropper-point.point-se {
  bottom: -3px;
  cursor: nwse-resize;
  height: 20px;
  opacity: 1;
  right: -3px;
  width: 20px;
}
@media (min-width: 768px) {
  .cropper-point.point-se {
    height: 15px;
    width: 15px;
  }
}
@media (min-width: 992px) {
  .cropper-point.point-se {
    height: 10px;
    width: 10px;
  }
}
@media (min-width: 1200px) {
  .cropper-point.point-se {
    height: 5px;
    opacity: 0.75;
    width: 5px;
  }
}
.cropper-point.point-se::before {
  background-color: #39f;
  bottom: -50%;
  content: " ";
  display: block;
  height: 200%;
  opacity: 0;
  position: absolute;
  right: -50%;
  width: 200%;
}
.cropper-invisible {
  opacity: 0;
}
.cropper-bg {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC);
}
.cropper-hide {
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}
.cropper-hidden {
  display: none !important;
}
.cropper-move {
  cursor: move;
}
.cropper-crop {
  cursor: crosshair;
}
.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SetupWizards/AvatarCropper.esbuild-svelte-fake-css */
.cropper-view-box,
.cropper-face {
  border-radius: 50%;
}

/* fakecss:/home/forge/alpha/svelte-components/src/SetupWizards/AccountSetupWizard.esbuild-svelte-fake-css */
.header-background.svelte-blsrl1 {
  background: url(/assets/images/Hero-Carousel-4-bg.jpg);
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Progression/ProgressionChart.esbuild-svelte-fake-css */
.am5-layer {
  font-family: inherit;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/Progression/SignatureCharts.esbuild-svelte-fake-css */
.am5-layer {
  font-family: inherit;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MyFitness/MyFitnessUnifiedPage.esbuild-svelte-fake-css */
.xert-svelte .tabs-trigger[data-state=active] {
  font-weight: 600;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MySeasons/SeasonControls.esbuild-svelte-fake-css */
.heading.svelte-zreyqq {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 16px;
  color: hsl(var(--muted-foreground));
}
.year-chip.svelte-zreyqq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  padding: 2px 12px;
  font-size: 12px;
  color: #6b7280;
  background: transparent;
  opacity: 0.7;
}
.year-chip.selected.svelte-zreyqq {
  border: 2px solid var(--year-color);
  background: color-mix(in srgb, var(--year-color) 12%, white);
  color: #111827;
  font-weight: 600;
  opacity: 1;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MySeasons/SeasonSummaryTable.esbuild-svelte-fake-css */
.season-table.svelte-e483lv {
  --group-border:#cbd5e1;
  overflow-x: auto;
}
.season-table.svelte-e483lv > div {
  width: max-content !important;
  max-width: 100% !important;
}
.season-table.svelte-e483lv {
  position: relative;
}
.season-table.more-right.svelte-e483lv::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 24px;
  pointer-events: none;
  background:
    linear-gradient(
      to right,
      transparent,
      hsl(var(--card)));
}
.season-table.svelte-e483lv .year-col {
  position: sticky;
  left: 0;
  z-index: 1;
  background: hsl(var(--card));
}
.season-table.svelte-e483lv .grp-l {
  border-left: 1px solid var(--group-border);
}
.season-table.svelte-e483lv .grp-r {
  border-right: 1px solid var(--group-border);
}
.season-table.svelte-e483lv .grp-b {
  border-bottom: 1px solid var(--group-border);
}
.season-table.svelte-e483lv .grp-head {
  border: 1px solid var(--group-border);
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
}

/* fakecss:/home/forge/alpha/svelte-components/src/MySeasons/MySeasons.esbuild-svelte-fake-css */
.view-label.svelte-1cqwvnu {
  background: transparent;
  border: 0;
  padding: 0;
  color: hsl(var(--muted-foreground));
}
.view-label.active.svelte-1cqwvnu {
  color: hsl(var(--foreground));
  font-weight: 600;
}

/* build/tailwind.css */
.xert-svelte *,
.xert-svelte ::before,
.xert-svelte ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-contain-size: ;
  --tw-contain-layout: ;
  --tw-contain-paint: ;
  --tw-contain-style: ;
}
.xert-svelte ::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-contain-size: ;
  --tw-contain-layout: ;
  --tw-contain-paint: ;
  --tw-contain-style: ;
}
.xert-svelte *:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *))::before,
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *))::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *))::before,
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *))::after {
  --tw-content: "";
}
.xert-svelte .twp:where(:not(.no-twp, .no-twp *)) {
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  -moz-tab-size: 4;
  tab-size: 4;
  font-family:
    Roboto,
    ui-sans-serif,
    system-ui,
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "Noto Color Emoji";
  font-feature-settings: normal;
  font-variation-settings: normal;
  -webkit-tap-highlight-color: transparent;
}
.xert-svelte .twp:where(:not(.no-twp, .no-twp *)) {
  margin: 0;
  line-height: inherit;
}
.xert-svelte hr:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  height: 0;
  color: inherit;
  border-top-width: 1px;
}
.xert-svelte abbr:where([title]):where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  text-decoration: underline dotted;
}
.xert-svelte h1:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h2:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h3:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h4:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h5:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h6:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  font-size: inherit;
  font-weight: inherit;
}
.xert-svelte a:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  color: inherit;
  text-decoration: inherit;
}
.xert-svelte b:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte strong:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  font-weight: bolder;
}
.xert-svelte code:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte kbd:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte samp:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte pre:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    "Liberation Mono",
    "Courier New",
    monospace;
  font-feature-settings: normal;
  font-variation-settings: normal;
  font-size: 1em;
}
.xert-svelte small:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  font-size: 80%;
}
.xert-svelte sub:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte sup:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
.xert-svelte sub:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  bottom: -0.25em;
}
.xert-svelte sup:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  top: -0.5em;
}
.xert-svelte table:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  text-indent: 0;
  border-color: inherit;
  border-collapse: collapse;
}
.xert-svelte button:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte input:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte optgroup:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte select:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte textarea:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  font-family: inherit;
  font-feature-settings: inherit;
  font-variation-settings: inherit;
  font-size: 100%;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  color: inherit;
  margin: 0;
  padding: 0;
}
.xert-svelte button:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte select:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  text-transform: none;
}
.xert-svelte button:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte input:where([type=button]):where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte input:where([type=reset]):where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte input:where([type=submit]):where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;
}
.xert-svelte :-moz-focusring:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  outline: auto;
}
.xert-svelte :-moz-ui-invalid:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  box-shadow: none;
}
.xert-svelte progress:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  vertical-align: baseline;
}
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) ::-webkit-inner-spin-button,
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) ::-webkit-outer-spin-button {
  height: auto;
}
.xert-svelte [type=search]:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) ::-webkit-search-decoration {
  -webkit-appearance: none;
}
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) ::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
.xert-svelte summary:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  display: list-item;
}
.xert-svelte blockquote:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte dl:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte dd:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h1:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h2:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h3:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h4:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h5:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte h6:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte hr:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte figure:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte p:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte pre:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  margin: 0;
}
.xert-svelte fieldset:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  margin: 0;
  padding: 0;
}
.xert-svelte legend:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  padding: 0;
}
.xert-svelte ol:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte ul:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte menu:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  list-style: none;
  margin: 0;
  padding: 0;
}
.xert-svelte dialog:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  padding: 0;
}
.xert-svelte textarea:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  resize: vertical;
}
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) input::placeholder,
.xert-svelte :where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) textarea::placeholder {
  opacity: 1;
  color: #9ca3af;
}
.xert-svelte button:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte [role=button]:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  cursor: pointer;
}
.xert-svelte :disabled:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  cursor: default;
}
.xert-svelte img:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte svg:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte video:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte canvas:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte audio:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte iframe:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte embed:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte object:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  display: block;
  vertical-align: middle;
}
.xert-svelte img:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)),
.xert-svelte video:where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  max-width: 100%;
  height: auto;
}
.xert-svelte [hidden]:where(:not([hidden=until-found])):where(.twp, .twp *):where(:not(.no-twp, .no-twp *)) {
  display: none;
}
.xert-svelte .container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px) {
  .xert-svelte .container {
    max-width: 1400px;
  }
}
.xert-svelte .btn-xfai {
  display: inline-flex;
  height: 2.25rem;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  transition-property:
    color,
    background-color,
    border-color,
    text-decoration-color,
    fill,
    stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.xert-svelte .btn-xfai:disabled {
  pointer-events: none;
  opacity: 0.5;
}
.xert-svelte .btn-xfai-sm {
  display: inline-flex;
  height: 2rem;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  transition-property:
    color,
    background-color,
    border-color,
    text-decoration-color,
    fill,
    stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.xert-svelte .btn-xfai-sm:disabled {
  pointer-events: none;
  opacity: 0.5;
}
.xert-svelte .btn-xfai-icon {
  display: inline-flex;
  height: 2.25rem;
  width: 2.25rem;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  transition-property:
    color,
    background-color,
    border-color,
    text-decoration-color,
    fill,
    stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.xert-svelte .btn-xfai-icon:disabled {
  pointer-events: none;
  opacity: 0.5;
}
.xert-svelte .input-xfai {
  margin: 0px;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
@keyframes hover-sparkle {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  20% {
    opacity: 0;
    transform: scale(1);
  }
  80% {
    opacity: 1;
    transform: scale(1.6);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
:root {
  --background: 0 0% 100%;
  --foreground: 185 43% 5%;
  --card: 0 0% 100%;
  --card-foreground: 185 43% 5%;
  --popover: 0 0% 100%;
  --popover-foreground: 185 43% 5%;
  --primary: 185 43% 32.4%;
  --primary-foreground: 185 15% 98%;
  --secondary: 185 15% 95%;
  --secondary-foreground: 185 22% 11%;
  --muted: 185 15% 95%;
  --muted-foreground: 185 4% 46%;
  --accent: 185 15% 95%;
  --accent-foreground: 185 22% 11%;
  --destructive: 0 50% 50%;
  --destructive-foreground: 185 15% 98%;
  --border: 185 15% 88%;
  --input: 185 15% 88%;
  --ring: 185 43% 32.4%;
  --radius: 0.5rem;
}
.xert-svelte .dark {
  --background: 185 10% 10%;
  --foreground: 185 0% 100%;
  --card: 185 0% 10%;
  --card-foreground: 185 0% 100%;
  --popover: 185 10% 5%;
  --popover-foreground: 185 0% 100%;
  --primary: 185 43% 32.4%;
  --primary-foreground: 0 0% 100%;
  --secondary: 185 10% 20%;
  --secondary-foreground: 0 0% 100%;
  --muted: 147 10% 25%;
  --muted-foreground: 185 0% 65%;
  --accent: 147 10% 25%;
  --accent-foreground: 185 0% 95%;
  --destructive: 0 50% 50%;
  --destructive-foreground: 185 0% 100%;
  --border: 185 20% 50%;
  --input: 185 20% 50%;
  --ring: 185 43% 32.4%;
  --radius: 0.5rem;
}
.xert-svelte .sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border-width: 0 !important;
}
.xert-svelte .pointer-events-none {
  pointer-events: none !important;
}
.xert-svelte .pointer-events-auto {
  pointer-events: auto !important;
}
.xert-svelte .\!visible {
  visibility: visible !important;
}
.xert-svelte .visible {
  visibility: visible !important;
}
.xert-svelte .invisible {
  visibility: hidden !important;
}
.xert-svelte .collapse {
  visibility: collapse !important;
}
.xert-svelte .static {
  position: static !important;
}
.xert-svelte .fixed {
  position: fixed !important;
}
.xert-svelte .absolute {
  position: absolute !important;
}
.xert-svelte .relative {
  position: relative !important;
}
.xert-svelte .sticky {
  position: sticky !important;
}
.xert-svelte .inset-0 {
  inset: 0px !important;
}
.xert-svelte .inset-\[32px\] {
  inset: 32px !important;
}
.xert-svelte .inset-x-0 {
  left: 0px !important;
  right: 0px !important;
}
.xert-svelte .inset-x-4 {
  left: 1rem !important;
  right: 1rem !important;
}
.xert-svelte .inset-y-0 {
  top: 0px !important;
  bottom: 0px !important;
}
.xert-svelte .inset-y-4 {
  top: 1rem !important;
  bottom: 1rem !important;
}
.xert-svelte .-bottom-0\.5 {
  bottom: -0.125rem !important;
}
.xert-svelte .-bottom-1 {
  bottom: -0.25rem !important;
}
.xert-svelte .-bottom-1\.5 {
  bottom: -0.375rem !important;
}
.xert-svelte .-bottom-4 {
  bottom: -1rem !important;
}
.xert-svelte .-left-16 {
  left: -4rem !important;
}
.xert-svelte .-left-2 {
  left: -0.5rem !important;
}
.xert-svelte .-right-0\.5 {
  right: -0.125rem !important;
}
.xert-svelte .-right-1 {
  right: -0.25rem !important;
}
.xert-svelte .-right-1\.5 {
  right: -0.375rem !important;
}
.xert-svelte .-right-12 {
  right: -3rem !important;
}
.xert-svelte .-right-4 {
  right: -1rem !important;
}
.xert-svelte .-top-1 {
  top: -0.25rem !important;
}
.xert-svelte .-top-1\.5 {
  top: -0.375rem !important;
}
.xert-svelte .-top-3\.5 {
  top: -0.875rem !important;
}
.xert-svelte .bottom-0 {
  bottom: 0px !important;
}
.xert-svelte .bottom-0\.5 {
  bottom: 0.125rem !important;
}
.xert-svelte .bottom-1 {
  bottom: 0.25rem !important;
}
.xert-svelte .bottom-1\/2 {
  bottom: 50% !important;
}
.xert-svelte .bottom-10 {
  bottom: 2.5rem !important;
}
.xert-svelte .bottom-12 {
  bottom: 3rem !important;
}
.xert-svelte .bottom-2 {
  bottom: 0.5rem !important;
}
.xert-svelte .bottom-4 {
  bottom: 1rem !important;
}
.xert-svelte .bottom-5 {
  bottom: 1.25rem !important;
}
.xert-svelte .bottom-\[25px\] {
  bottom: 25px !important;
}
.xert-svelte .bottom-full {
  bottom: 100% !important;
}
.xert-svelte .left-0 {
  left: 0px !important;
}
.xert-svelte .left-1 {
  left: 0.25rem !important;
}
.xert-svelte .left-1\.5 {
  left: 0.375rem !important;
}
.xert-svelte .left-1\/2 {
  left: 50% !important;
}
.xert-svelte .left-2 {
  left: 0.5rem !important;
}
.xert-svelte .left-3 {
  left: 0.75rem !important;
}
.xert-svelte .left-5 {
  left: 1.25rem !important;
}
.xert-svelte .left-6 {
  left: 1.5rem !important;
}
.xert-svelte .left-\[19\%\] {
  left: 19% !important;
}
.xert-svelte .left-\[50\%\] {
  left: 50% !important;
}
.xert-svelte .left-full {
  left: 100% !important;
}
.xert-svelte .right-0 {
  right: 0px !important;
}
.xert-svelte .right-0\.5 {
  right: 0.125rem !important;
}
.xert-svelte .right-1 {
  right: 0.25rem !important;
}
.xert-svelte .right-1\.5 {
  right: 0.375rem !important;
}
.xert-svelte .right-10 {
  right: 2.5rem !important;
}
.xert-svelte .right-2 {
  right: 0.5rem !important;
}
.xert-svelte .right-3 {
  right: 0.75rem !important;
}
.xert-svelte .right-4 {
  right: 1rem !important;
}
.xert-svelte .right-5 {
  right: 1.25rem !important;
}
.xert-svelte .right-\[-3px\] {
  right: -3px !important;
}
.xert-svelte .right-\[calc\(100\%-40px\)\] {
  right: calc(100% - 40px) !important;
}
.xert-svelte .top-0 {
  top: 0px !important;
}
.xert-svelte .top-0\.5 {
  top: 0.125rem !important;
}
.xert-svelte .top-1\.5 {
  top: 0.375rem !important;
}
.xert-svelte .top-1\/2 {
  top: 50% !important;
}
.xert-svelte .top-2 {
  top: 0.5rem !important;
}
.xert-svelte .top-3 {
  top: 0.75rem !important;
}
.xert-svelte .top-4 {
  top: 1rem !important;
}
.xert-svelte .top-6 {
  top: 1.5rem !important;
}
.xert-svelte .top-8 {
  top: 2rem !important;
}
.xert-svelte .top-\[-10px\] {
  top: -10px !important;
}
.xert-svelte .top-\[-3px\] {
  top: -3px !important;
}
.xert-svelte .top-\[-8px\] {
  top: -8px !important;
}
.xert-svelte .top-\[110\%\] {
  top: 110% !important;
}
.xert-svelte .top-\[165px\] {
  top: 165px !important;
}
.xert-svelte .top-\[240px\] {
  top: 240px !important;
}
.xert-svelte .top-\[2px\] {
  top: 2px !important;
}
.xert-svelte .top-\[46px\] {
  top: 46px !important;
}
.xert-svelte .top-\[50\%\] {
  top: 50% !important;
}
.xert-svelte .top-\[50\.2\%\] {
  top: 50.2% !important;
}
.xert-svelte .top-\[calc\(100\%\+25px\)\] {
  top: calc(100% + 25px) !important;
}
.xert-svelte .top-full {
  top: 100% !important;
}
.xert-svelte .z-0 {
  z-index: 0 !important;
}
.xert-svelte .z-10 {
  z-index: 10 !important;
}
.xert-svelte .z-20 {
  z-index: 20 !important;
}
.xert-svelte .z-40 {
  z-index: 40 !important;
}
.xert-svelte .z-50 {
  z-index: 50 !important;
}
.xert-svelte .z-\[1\] {
  z-index: 1 !important;
}
.xert-svelte .z-\[2000\] {
  z-index: 2000 !important;
}
.xert-svelte .z-\[60\] {
  z-index: 60 !important;
}
.xert-svelte .order-1 {
  order: 1 !important;
}
.xert-svelte .order-2 {
  order: 2 !important;
}
.xert-svelte .order-3 {
  order: 3 !important;
}
.xert-svelte .order-4 {
  order: 4 !important;
}
.xert-svelte .order-5 {
  order: 5 !important;
}
.xert-svelte .order-6 {
  order: 6 !important;
}
.xert-svelte .col-auto {
  grid-column: auto !important;
}
.xert-svelte .col-span-1 {
  grid-column: span 1 / span 1 !important;
}
.xert-svelte .col-span-12 {
  grid-column: span 12 / span 12 !important;
}
.xert-svelte .col-span-2 {
  grid-column: span 2 / span 2 !important;
}
.xert-svelte .col-span-3 {
  grid-column: span 3 / span 3 !important;
}
.xert-svelte .col-span-5 {
  grid-column: span 5 / span 5 !important;
}
.xert-svelte .col-span-full {
  grid-column: 1 / -1 !important;
}
.xert-svelte .col-start-1 {
  grid-column-start: 1 !important;
}
.xert-svelte .col-start-2 {
  grid-column-start: 2 !important;
}
.xert-svelte .col-start-3 {
  grid-column-start: 3 !important;
}
.xert-svelte .col-start-4 {
  grid-column-start: 4 !important;
}
.xert-svelte .col-start-5 {
  grid-column-start: 5 !important;
}
.xert-svelte .row-span-2 {
  grid-row: span 2 / span 2 !important;
}
.xert-svelte .row-span-3 {
  grid-row: span 3 / span 3 !important;
}
.xert-svelte .row-start-1 {
  grid-row-start: 1 !important;
}
.xert-svelte .row-start-2 {
  grid-row-start: 2 !important;
}
.xert-svelte .row-start-3 {
  grid-row-start: 3 !important;
}
.xert-svelte .row-start-4 {
  grid-row-start: 4 !important;
}
.xert-svelte .float-right {
  float: right !important;
}
.xert-svelte .m-0 {
  margin: 0px !important;
}
.xert-svelte .m-1 {
  margin: 0.25rem !important;
}
.xert-svelte .m-2 {
  margin: 0.5rem !important;
}
.xert-svelte .m-auto {
  margin: auto !important;
}
.xert-svelte .-mx-1 {
  margin-left: -0.25rem !important;
  margin-right: -0.25rem !important;
}
.xert-svelte .-mx-2 {
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}
.xert-svelte .-my-1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}
.xert-svelte .-my-2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}
.xert-svelte .mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.xert-svelte .mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.xert-svelte .mx-1\.5 {
  margin-left: 0.375rem !important;
  margin-right: 0.375rem !important;
}
.xert-svelte .mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.xert-svelte .mx-3 {
  margin-left: 0.75rem !important;
  margin-right: 0.75rem !important;
}
.xert-svelte .mx-4 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}
.xert-svelte .mx-6 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}
.xert-svelte .mx-\[4px\] {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.xert-svelte .mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.xert-svelte .my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.xert-svelte .my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.xert-svelte .my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.xert-svelte .my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.xert-svelte .my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.xert-svelte .my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.xert-svelte .my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.xert-svelte .my-\[5px\] {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.xert-svelte .my-\[8px\] {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.xert-svelte .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.xert-svelte .\!mt-1 {
  margin-top: 0.25rem !important;
}
.xert-svelte .-mb-4 {
  margin-bottom: -1rem !important;
}
.xert-svelte .-mb-px {
  margin-bottom: -1px !important;
}
.xert-svelte .-ml-1 {
  margin-left: -0.25rem !important;
}
.xert-svelte .-ml-2 {
  margin-left: -0.5rem !important;
}
.xert-svelte .-ml-3 {
  margin-left: -0.75rem !important;
}
.xert-svelte .-mr-1 {
  margin-right: -0.25rem !important;
}
.xert-svelte .-mt-0\.5 {
  margin-top: -0.125rem !important;
}
.xert-svelte .-mt-1 {
  margin-top: -0.25rem !important;
}
.xert-svelte .-mt-2 {
  margin-top: -0.5rem !important;
}
.xert-svelte .-mt-4 {
  margin-top: -1rem !important;
}
.xert-svelte .-mt-6 {
  margin-top: -1.5rem !important;
}
.xert-svelte .mb-0 {
  margin-bottom: 0px !important;
}
.xert-svelte .mb-1 {
  margin-bottom: 0.25rem !important;
}
.xert-svelte .mb-1\.5 {
  margin-bottom: 0.375rem !important;
}
.xert-svelte .mb-2 {
  margin-bottom: 0.5rem !important;
}
.xert-svelte .mb-3 {
  margin-bottom: 0.75rem !important;
}
.xert-svelte .mb-4 {
  margin-bottom: 1rem !important;
}
.xert-svelte .mb-5 {
  margin-bottom: 1.25rem !important;
}
.xert-svelte .mb-6 {
  margin-bottom: 1.5rem !important;
}
.xert-svelte .mb-7 {
  margin-bottom: 1.75rem !important;
}
.xert-svelte .mb-9 {
  margin-bottom: 2.25rem !important;
}
.xert-svelte .mb-\[-10px\] {
  margin-bottom: -10px !important;
}
.xert-svelte .mb-\[0\.95rem\] {
  margin-bottom: 0.95rem !important;
}
.xert-svelte .mb-\[1px\] {
  margin-bottom: 1px !important;
}
.xert-svelte .mb-\[40px\] {
  margin-bottom: 40px !important;
}
.xert-svelte .mb-\[5px\] {
  margin-bottom: 5px !important;
}
.xert-svelte .ml-0\.5 {
  margin-left: 0.125rem !important;
}
.xert-svelte .ml-1 {
  margin-left: 0.25rem !important;
}
.xert-svelte .ml-1\.5 {
  margin-left: 0.375rem !important;
}
.xert-svelte .ml-2 {
  margin-left: 0.5rem !important;
}
.xert-svelte .ml-3 {
  margin-left: 0.75rem !important;
}
.xert-svelte .ml-4 {
  margin-left: 1rem !important;
}
.xert-svelte .ml-5 {
  margin-left: 1.25rem !important;
}
.xert-svelte .ml-6 {
  margin-left: 1.5rem !important;
}
.xert-svelte .ml-\[10px\] {
  margin-left: 10px !important;
}
.xert-svelte .ml-\[12px\] {
  margin-left: 12px !important;
}
.xert-svelte .ml-\[15px\] {
  margin-left: 15px !important;
}
.xert-svelte .ml-\[3\.25rem\] {
  margin-left: 3.25rem !important;
}
.xert-svelte .ml-\[5px\] {
  margin-left: 5px !important;
}
.xert-svelte .ml-auto {
  margin-left: auto !important;
}
.xert-svelte .mr-0\.5 {
  margin-right: 0.125rem !important;
}
.xert-svelte .mr-1 {
  margin-right: 0.25rem !important;
}
.xert-svelte .mr-1\.5 {
  margin-right: 0.375rem !important;
}
.xert-svelte .mr-14 {
  margin-right: 3.5rem !important;
}
.xert-svelte .mr-2 {
  margin-right: 0.5rem !important;
}
.xert-svelte .mr-4 {
  margin-right: 1rem !important;
}
.xert-svelte .mr-5 {
  margin-right: 1.25rem !important;
}
.xert-svelte .mr-\[6px\] {
  margin-right: 6px !important;
}
.xert-svelte .mr-auto {
  margin-right: auto !important;
}
.xert-svelte .mt-0 {
  margin-top: 0px !important;
}
.xert-svelte .mt-0\.5 {
  margin-top: 0.125rem !important;
}
.xert-svelte .mt-1 {
  margin-top: 0.25rem !important;
}
.xert-svelte .mt-1\.5 {
  margin-top: 0.375rem !important;
}
.xert-svelte .mt-10 {
  margin-top: 2.5rem !important;
}
.xert-svelte .mt-2 {
  margin-top: 0.5rem !important;
}
.xert-svelte .mt-2\.5 {
  margin-top: 0.625rem !important;
}
.xert-svelte .mt-20 {
  margin-top: 5rem !important;
}
.xert-svelte .mt-24 {
  margin-top: 6rem !important;
}
.xert-svelte .mt-3 {
  margin-top: 0.75rem !important;
}
.xert-svelte .mt-4 {
  margin-top: 1rem !important;
}
.xert-svelte .mt-5 {
  margin-top: 1.25rem !important;
}
.xert-svelte .mt-6 {
  margin-top: 1.5rem !important;
}
.xert-svelte .mt-7 {
  margin-top: 1.75rem !important;
}
.xert-svelte .mt-8 {
  margin-top: 2rem !important;
}
.xert-svelte .mt-\[-4px\] {
  margin-top: -4px !important;
}
.xert-svelte .mt-\[-50px\] {
  margin-top: -50px !important;
}
.xert-svelte .mt-\[16px\] {
  margin-top: 16px !important;
}
.xert-svelte .mt-\[20px\] {
  margin-top: 20px !important;
}
.xert-svelte .mt-auto {
  margin-top: auto !important;
}
.xert-svelte .box-border {
  box-sizing: border-box !important;
}
.xert-svelte .box-content {
  box-sizing: content-box !important;
}
.xert-svelte .line-clamp-1 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 1 !important;
}
.xert-svelte .line-clamp-2 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;
}
.xert-svelte .block {
  display: block !important;
}
.xert-svelte .inline-block {
  display: inline-block !important;
}
.xert-svelte .inline {
  display: inline !important;
}
.xert-svelte .flex {
  display: flex !important;
}
.xert-svelte .inline-flex {
  display: inline-flex !important;
}
.xert-svelte .table {
  display: table !important;
}
.xert-svelte .table-caption {
  display: table-caption !important;
}
.xert-svelte .table-cell {
  display: table-cell !important;
}
.xert-svelte .table-row {
  display: table-row !important;
}
.xert-svelte .grid {
  display: grid !important;
}
.xert-svelte .inline-grid {
  display: inline-grid !important;
}
.xert-svelte .contents {
  display: contents !important;
}
.xert-svelte .list-item {
  display: list-item !important;
}
.xert-svelte .\!hidden {
  display: none !important;
}
.xert-svelte .hidden {
  display: none !important;
}
.xert-svelte .aspect-\[2\/1\] {
  aspect-ratio: 2/1 !important;
}
.xert-svelte .aspect-\[200\/112\] {
  aspect-ratio: 200/112 !important;
}
.xert-svelte .aspect-\[3\/1\] {
  aspect-ratio: 3/1 !important;
}
.xert-svelte .aspect-\[3\/2\] {
  aspect-ratio: 3/2 !important;
}
.xert-svelte .aspect-\[354\/200\] {
  aspect-ratio: 354/200 !important;
}
.xert-svelte .aspect-\[4\/5\] {
  aspect-ratio: 4/5 !important;
}
.xert-svelte .aspect-\[5\/1\] {
  aspect-ratio: 5/1 !important;
}
.xert-svelte .aspect-\[800\/360\] {
  aspect-ratio: 800/360 !important;
}
.xert-svelte .aspect-square {
  aspect-ratio: 1 / 1 !important;
}
.xert-svelte .aspect-video {
  aspect-ratio: 16 / 9 !important;
}
.xert-svelte .h-0 {
  height: 0px !important;
}
.xert-svelte .h-1 {
  height: 0.25rem !important;
}
.xert-svelte .h-1\.5 {
  height: 0.375rem !important;
}
.xert-svelte .h-10 {
  height: 2.5rem !important;
}
.xert-svelte .h-11 {
  height: 2.75rem !important;
}
.xert-svelte .h-12 {
  height: 3rem !important;
}
.xert-svelte .h-14 {
  height: 3.5rem !important;
}
.xert-svelte .h-16 {
  height: 4rem !important;
}
.xert-svelte .h-2 {
  height: 0.5rem !important;
}
.xert-svelte .h-2\.5 {
  height: 0.625rem !important;
}
.xert-svelte .h-20 {
  height: 5rem !important;
}
.xert-svelte .h-24 {
  height: 6rem !important;
}
.xert-svelte .h-28 {
  height: 7rem !important;
}
.xert-svelte .h-3 {
  height: 0.75rem !important;
}
.xert-svelte .h-3\.5 {
  height: 0.875rem !important;
}
.xert-svelte .h-32 {
  height: 8rem !important;
}
.xert-svelte .h-36 {
  height: 9rem !important;
}
.xert-svelte .h-4 {
  height: 1rem !important;
}
.xert-svelte .h-40 {
  height: 10rem !important;
}
.xert-svelte .h-48 {
  height: 12rem !important;
}
.xert-svelte .h-5 {
  height: 1.25rem !important;
}
.xert-svelte .h-56 {
  height: 14rem !important;
}
.xert-svelte .h-6 {
  height: 1.5rem !important;
}
.xert-svelte .h-60 {
  height: 15rem !important;
}
.xert-svelte .h-64 {
  height: 16rem !important;
}
.xert-svelte .h-7 {
  height: 1.75rem !important;
}
.xert-svelte .h-72 {
  height: 18rem !important;
}
.xert-svelte .h-8 {
  height: 2rem !important;
}
.xert-svelte .h-80 {
  height: 20rem !important;
}
.xert-svelte .h-9 {
  height: 2.25rem !important;
}
.xert-svelte .h-96 {
  height: 24rem !important;
}
.xert-svelte .h-\[0\.4rem\] {
  height: 0.4rem !important;
}
.xert-svelte .h-\[100dvh\] {
  height: 100dvh !important;
}
.xert-svelte .h-\[100px\] {
  height: 100px !important;
}
.xert-svelte .h-\[104px\] {
  height: 104px !important;
}
.xert-svelte .h-\[10px\] {
  height: 10px !important;
}
.xert-svelte .h-\[110px\] {
  height: 110px !important;
}
.xert-svelte .h-\[11px\] {
  height: 11px !important;
}
.xert-svelte .h-\[120px\] {
  height: 120px !important;
}
.xert-svelte .h-\[12px\] {
  height: 12px !important;
}
.xert-svelte .h-\[14px\] {
  height: 14px !important;
}
.xert-svelte .h-\[150px\] {
  height: 150px !important;
}
.xert-svelte .h-\[15px\] {
  height: 15px !important;
}
.xert-svelte .h-\[160px\] {
  height: 160px !important;
}
.xert-svelte .h-\[180px\] {
  height: 180px !important;
}
.xert-svelte .h-\[18px\] {
  height: 18px !important;
}
.xert-svelte .h-\[1px\] {
  height: 1px !important;
}
.xert-svelte .h-\[200px\] {
  height: 200px !important;
}
.xert-svelte .h-\[20px\] {
  height: 20px !important;
}
.xert-svelte .h-\[220px\] {
  height: 220px !important;
}
.xert-svelte .h-\[22px\] {
  height: 22px !important;
}
.xert-svelte .h-\[240px\] {
  height: 240px !important;
}
.xert-svelte .h-\[25px\] {
  height: 25px !important;
}
.xert-svelte .h-\[260px\] {
  height: 260px !important;
}
.xert-svelte .h-\[26px\] {
  height: 26px !important;
}
.xert-svelte .h-\[28px\] {
  height: 28px !important;
}
.xert-svelte .h-\[2px\] {
  height: 2px !important;
}
.xert-svelte .h-\[3\.75rem\] {
  height: 3.75rem !important;
}
.xert-svelte .h-\[300px\] {
  height: 300px !important;
}
.xert-svelte .h-\[340px\] {
  height: 340px !important;
}
.xert-svelte .h-\[34px\] {
  height: 34px !important;
}
.xert-svelte .h-\[360px\] {
  height: 360px !important;
}
.xert-svelte .h-\[400px\] {
  height: 400px !important;
}
.xert-svelte .h-\[40px\] {
  height: 40px !important;
}
.xert-svelte .h-\[420px\] {
  height: 420px !important;
}
.xert-svelte .h-\[44px\] {
  height: 44px !important;
}
.xert-svelte .h-\[460px\] {
  height: 460px !important;
}
.xert-svelte .h-\[480px\] {
  height: 480px !important;
}
.xert-svelte .h-\[500px\] {
  height: 500px !important;
}
.xert-svelte .h-\[50px\] {
  height: 50px !important;
}
.xert-svelte .h-\[52px\] {
  height: 52px !important;
}
.xert-svelte .h-\[540px\] {
  height: 540px !important;
}
.xert-svelte .h-\[56px\] {
  height: 56px !important;
}
.xert-svelte .h-\[6\.6\%\] {
  height: 6.6% !important;
}
.xert-svelte .h-\[6px\] {
  height: 6px !important;
}
.xert-svelte .h-\[70px\] {
  height: 70px !important;
}
.xert-svelte .h-\[92dvh\] {
  height: 92dvh !important;
}
.xert-svelte .h-\[95dvh\] {
  height: 95dvh !important;
}
.xert-svelte .h-\[96px\] {
  height: 96px !important;
}
.xert-svelte .h-\[9px\] {
  height: 9px !important;
}
.xert-svelte .h-\[calc\(100vh-46px\)\] {
  height: calc(100vh - 46px) !important;
}
.xert-svelte .h-auto {
  height: auto !important;
}
.xert-svelte .h-full {
  height: 100% !important;
}
.xert-svelte .h-max {
  height: max-content !important;
}
.xert-svelte .h-min {
  height: min-content !important;
}
.xert-svelte .h-px {
  height: 1px !important;
}
.xert-svelte .max-h-28 {
  max-height: 7rem !important;
}
.xert-svelte .max-h-40 {
  max-height: 10rem !important;
}
.xert-svelte .max-h-48 {
  max-height: 12rem !important;
}
.xert-svelte .max-h-60 {
  max-height: 15rem !important;
}
.xert-svelte .max-h-64 {
  max-height: 16rem !important;
}
.xert-svelte .max-h-80 {
  max-height: 20rem !important;
}
.xert-svelte .max-h-96 {
  max-height: 24rem !important;
}
.xert-svelte .max-h-\[100\%\] {
  max-height: 100% !important;
}
.xert-svelte .max-h-\[100dvh\] {
  max-height: 100dvh !important;
}
.xert-svelte .max-h-\[100px\] {
  max-height: 100px !important;
}
.xert-svelte .max-h-\[120px\] {
  max-height: 120px !important;
}
.xert-svelte .max-h-\[22px\] {
  max-height: 22px !important;
}
.xert-svelte .max-h-\[500px\] {
  max-height: 500px !important;
}
.xert-svelte .max-h-\[55dvh\] {
  max-height: 55dvh !important;
}
.xert-svelte .max-h-\[70vh\] {
  max-height: 70vh !important;
}
.xert-svelte .max-h-\[80vh\] {
  max-height: 80vh !important;
}
.xert-svelte .max-h-\[90dvh\] {
  max-height: 90dvh !important;
}
.xert-svelte .max-h-\[90vh\] {
  max-height: 90vh !important;
}
.xert-svelte .max-h-\[92dvh\] {
  max-height: 92dvh !important;
}
.xert-svelte .max-h-\[95dvh\] {
  max-height: 95dvh !important;
}
.xert-svelte .max-h-\[96\%\] {
  max-height: 96% !important;
}
.xert-svelte .max-h-full {
  max-height: 100% !important;
}
.xert-svelte .min-h-0 {
  min-height: 0px !important;
}
.xert-svelte .min-h-9 {
  min-height: 2.25rem !important;
}
.xert-svelte .min-h-\[100dvh\] {
  min-height: 100dvh !important;
}
.xert-svelte .min-h-\[100px\] {
  min-height: 100px !important;
}
.xert-svelte .min-h-\[11px\] {
  min-height: 11px !important;
}
.xert-svelte .min-h-\[132px\] {
  min-height: 132px !important;
}
.xert-svelte .min-h-\[150px\] {
  min-height: 150px !important;
}
.xert-svelte .min-h-\[190px\] {
  min-height: 190px !important;
}
.xert-svelte .min-h-\[2\.5rem\] {
  min-height: 2.5rem !important;
}
.xert-svelte .min-h-\[22px\] {
  min-height: 22px !important;
}
.xert-svelte .min-h-\[3\.5rem\] {
  min-height: 3.5rem !important;
}
.xert-svelte .min-h-\[36px\] {
  min-height: 36px !important;
}
.xert-svelte .min-h-\[400px\] {
  min-height: 400px !important;
}
.xert-svelte .min-h-\[450px\] {
  min-height: 450px !important;
}
.xert-svelte .min-h-\[52px\] {
  min-height: 52px !important;
}
.xert-svelte .min-h-\[60px\] {
  min-height: 60px !important;
}
.xert-svelte .min-h-\[60vh\] {
  min-height: 60vh !important;
}
.xert-svelte .min-h-\[min\(600px\,95dvh\)\] {
  min-height: min(600px, 95dvh) !important;
}
.xert-svelte .min-h-full {
  min-height: 100% !important;
}
.xert-svelte .min-h-screen {
  min-height: 100vh !important;
}
.xert-svelte .w-0 {
  width: 0px !important;
}
.xert-svelte .w-0\.5 {
  width: 0.125rem !important;
}
.xert-svelte .w-1\.5 {
  width: 0.375rem !important;
}
.xert-svelte .w-10 {
  width: 2.5rem !important;
}
.xert-svelte .w-11 {
  width: 2.75rem !important;
}
.xert-svelte .w-12 {
  width: 3rem !important;
}
.xert-svelte .w-14 {
  width: 3.5rem !important;
}
.xert-svelte .w-16 {
  width: 4rem !important;
}
.xert-svelte .w-2 {
  width: 0.5rem !important;
}
.xert-svelte .w-2\.5 {
  width: 0.625rem !important;
}
.xert-svelte .w-2\/3 {
  width: 66.666667% !important;
}
.xert-svelte .w-20 {
  width: 5rem !important;
}
.xert-svelte .w-24 {
  width: 6rem !important;
}
.xert-svelte .w-28 {
  width: 7rem !important;
}
.xert-svelte .w-3 {
  width: 0.75rem !important;
}
.xert-svelte .w-3\.5 {
  width: 0.875rem !important;
}
.xert-svelte .w-3\/4 {
  width: 75% !important;
}
.xert-svelte .w-32 {
  width: 8rem !important;
}
.xert-svelte .w-36 {
  width: 9rem !important;
}
.xert-svelte .w-4 {
  width: 1rem !important;
}
.xert-svelte .w-40 {
  width: 10rem !important;
}
.xert-svelte .w-44 {
  width: 11rem !important;
}
.xert-svelte .w-48 {
  width: 12rem !important;
}
.xert-svelte .w-5 {
  width: 1.25rem !important;
}
.xert-svelte .w-52 {
  width: 13rem !important;
}
.xert-svelte .w-56 {
  width: 14rem !important;
}
.xert-svelte .w-6 {
  width: 1.5rem !important;
}
.xert-svelte .w-60 {
  width: 15rem !important;
}
.xert-svelte .w-64 {
  width: 16rem !important;
}
.xert-svelte .w-7 {
  width: 1.75rem !important;
}
.xert-svelte .w-72 {
  width: 18rem !important;
}
.xert-svelte .w-8 {
  width: 2rem !important;
}
.xert-svelte .w-80 {
  width: 20rem !important;
}
.xert-svelte .w-9 {
  width: 2.25rem !important;
}
.xert-svelte .w-9\/12 {
  width: 75% !important;
}
.xert-svelte .w-\[0\.4rem\] {
  width: 0.4rem !important;
}
.xert-svelte .w-\[100px\] {
  width: 100px !important;
}
.xert-svelte .w-\[104px\] {
  width: 104px !important;
}
.xert-svelte .w-\[106px\] {
  width: 106px !important;
}
.xert-svelte .w-\[10px\] {
  width: 10px !important;
}
.xert-svelte .w-\[110px\] {
  width: 110px !important;
}
.xert-svelte .w-\[120px\] {
  width: 120px !important;
}
.xert-svelte .w-\[124px\] {
  width: 124px !important;
}
.xert-svelte .w-\[130px\] {
  width: 130px !important;
}
.xert-svelte .w-\[150px\] {
  width: 150px !important;
}
.xert-svelte .w-\[160px\] {
  width: 160px !important;
}
.xert-svelte .w-\[16px\] {
  width: 16px !important;
}
.xert-svelte .w-\[180px\] {
  width: 180px !important;
}
.xert-svelte .w-\[18px\] {
  width: 18px !important;
}
.xert-svelte .w-\[1px\] {
  width: 1px !important;
}
.xert-svelte .w-\[200px\] {
  width: 200px !important;
}
.xert-svelte .w-\[20px\] {
  width: 20px !important;
}
.xert-svelte .w-\[22px\] {
  width: 22px !important;
}
.xert-svelte .w-\[22rem\] {
  width: 22rem !important;
}
.xert-svelte .w-\[25\%\] {
  width: 25% !important;
}
.xert-svelte .w-\[26px\] {
  width: 26px !important;
}
.xert-svelte .w-\[30\%\] {
  width: 30% !important;
}
.xert-svelte .w-\[300px\] {
  width: 300px !important;
}
.xert-svelte .w-\[30px\] {
  width: 30px !important;
}
.xert-svelte .w-\[320px\] {
  width: 320px !important;
}
.xert-svelte .w-\[340px\] {
  width: 340px !important;
}
.xert-svelte .w-\[34px\] {
  width: 34px !important;
}
.xert-svelte .w-\[360px\] {
  width: 360px !important;
}
.xert-svelte .w-\[36px\] {
  width: 36px !important;
}
.xert-svelte .w-\[40\%\] {
  width: 40% !important;
}
.xert-svelte .w-\[40px\] {
  width: 40px !important;
}
.xert-svelte .w-\[42px\] {
  width: 42px !important;
}
.xert-svelte .w-\[47\%\] {
  width: 47% !important;
}
.xert-svelte .w-\[50px\] {
  width: 50px !important;
}
.xert-svelte .w-\[55px\] {
  width: 55px !important;
}
.xert-svelte .w-\[58px\] {
  width: 58px !important;
}
.xert-svelte .w-\[60\%\] {
  width: 60% !important;
}
.xert-svelte .w-\[600px\] {
  width: 600px !important;
}
.xert-svelte .w-\[62px\] {
  width: 62px !important;
}
.xert-svelte .w-\[80px\] {
  width: 80px !important;
}
.xert-svelte .w-\[85\%\] {
  width: 85% !important;
}
.xert-svelte .w-\[85px\] {
  width: 85px !important;
}
.xert-svelte .w-\[90px\] {
  width: 90px !important;
}
.xert-svelte .w-\[90vw\] {
  width: 90vw !important;
}
.xert-svelte .w-\[95vw\] {
  width: 95vw !important;
}
.xert-svelte .w-\[calc\(100vw-1\.5rem\)\] {
  width: calc(100vw - 1.5rem) !important;
}
.xert-svelte .w-\[min\(26rem\,calc\(100vw-1\.5rem\)\)\] {
  width: min(26rem, calc(100vw - 1.5rem)) !important;
}
.xert-svelte .w-auto {
  width: auto !important;
}
.xert-svelte .w-fit {
  width: fit-content !important;
}
.xert-svelte .w-full {
  width: 100% !important;
}
.xert-svelte .w-max {
  width: max-content !important;
}
.xert-svelte .w-min {
  width: min-content !important;
}
.xert-svelte .w-px {
  width: 1px !important;
}
.xert-svelte .min-w-0 {
  min-width: 0px !important;
}
.xert-svelte .min-w-28 {
  min-width: 7rem !important;
}
.xert-svelte .min-w-36 {
  min-width: 9rem !important;
}
.xert-svelte .min-w-4 {
  min-width: 1rem !important;
}
.xert-svelte .min-w-6 {
  min-width: 1.5rem !important;
}
.xert-svelte .min-w-72 {
  min-width: 18rem !important;
}
.xert-svelte .min-w-\[112px\] {
  min-width: 112px !important;
}
.xert-svelte .min-w-\[120px\] {
  min-width: 120px !important;
}
.xert-svelte .min-w-\[130px\] {
  min-width: 130px !important;
}
.xert-svelte .min-w-\[150px\] {
  min-width: 150px !important;
}
.xert-svelte .min-w-\[160px\] {
  min-width: 160px !important;
}
.xert-svelte .min-w-\[16rem\] {
  min-width: 16rem !important;
}
.xert-svelte .min-w-\[17rem\] {
  min-width: 17rem !important;
}
.xert-svelte .min-w-\[180px\] {
  min-width: 180px !important;
}
.xert-svelte .min-w-\[2\.25rem\] {
  min-width: 2.25rem !important;
}
.xert-svelte .min-w-\[2\.5rem\] {
  min-width: 2.5rem !important;
}
.xert-svelte .min-w-\[200px\] {
  min-width: 200px !important;
}
.xert-svelte .min-w-\[230px\] {
  min-width: 230px !important;
}
.xert-svelte .min-w-\[250px\] {
  min-width: 250px !important;
}
.xert-svelte .min-w-\[270px\] {
  min-width: 270px !important;
}
.xert-svelte .min-w-\[300px\] {
  min-width: 300px !important;
}
.xert-svelte .min-w-\[340px\] {
  min-width: 340px !important;
}
.xert-svelte .min-w-\[4\.5rem\] {
  min-width: 4.5rem !important;
}
.xert-svelte .min-w-\[58px\] {
  min-width: 58px !important;
}
.xert-svelte .min-w-\[70px\] {
  min-width: 70px !important;
}
.xert-svelte .min-w-\[80px\] {
  min-width: 80px !important;
}
.xert-svelte .min-w-\[8rem\] {
  min-width: 8rem !important;
}
.xert-svelte .min-w-full {
  min-width: 100% !important;
}
.xert-svelte .min-w-min {
  min-width: min-content !important;
}
.xert-svelte .max-w-2xl {
  max-width: 42rem !important;
}
.xert-svelte .max-w-4xl {
  max-width: 56rem !important;
}
.xert-svelte .max-w-5xl {
  max-width: 64rem !important;
}
.xert-svelte .max-w-6xl {
  max-width: 72rem !important;
}
.xert-svelte .max-w-\[1000px\] {
  max-width: 1000px !important;
}
.xert-svelte .max-w-\[10rem\] {
  max-width: 10rem !important;
}
.xert-svelte .max-w-\[1100px\] {
  max-width: 1100px !important;
}
.xert-svelte .max-w-\[1140px\] {
  max-width: 1140px !important;
}
.xert-svelte .max-w-\[1200px\] {
  max-width: 1200px !important;
}
.xert-svelte .max-w-\[120px\] {
  max-width: 120px !important;
}
.xert-svelte .max-w-\[1300px\] {
  max-width: 1300px !important;
}
.xert-svelte .max-w-\[13rem\] {
  max-width: 13rem !important;
}
.xert-svelte .max-w-\[1400px\] {
  max-width: 1400px !important;
}
.xert-svelte .max-w-\[140px\] {
  max-width: 140px !important;
}
.xert-svelte .max-w-\[14rem\] {
  max-width: 14rem !important;
}
.xert-svelte .max-w-\[1600px\] {
  max-width: 1600px !important;
}
.xert-svelte .max-w-\[1800px\] {
  max-width: 1800px !important;
}
.xert-svelte .max-w-\[180px\] {
  max-width: 180px !important;
}
.xert-svelte .max-w-\[220px\] {
  max-width: 220px !important;
}
.xert-svelte .max-w-\[24rem\] {
  max-width: 24rem !important;
}
.xert-svelte .max-w-\[270px\] {
  max-width: 270px !important;
}
.xert-svelte .max-w-\[280px\] {
  max-width: 280px !important;
}
.xert-svelte .max-w-\[300px\] {
  max-width: 300px !important;
}
.xert-svelte .max-w-\[30rem\] {
  max-width: 30rem !important;
}
.xert-svelte .max-w-\[320px\] {
  max-width: 320px !important;
}
.xert-svelte .max-w-\[330px\] {
  max-width: 330px !important;
}
.xert-svelte .max-w-\[350px\] {
  max-width: 350px !important;
}
.xert-svelte .max-w-\[400px\] {
  max-width: 400px !important;
}
.xert-svelte .max-w-\[420px\] {
  max-width: 420px !important;
}
.xert-svelte .max-w-\[455px\] {
  max-width: 455px !important;
}
.xert-svelte .max-w-\[480px\] {
  max-width: 480px !important;
}
.xert-svelte .max-w-\[500px\] {
  max-width: 500px !important;
}
.xert-svelte .max-w-\[600px\] {
  max-width: 600px !important;
}
.xert-svelte .max-w-\[640px\] {
  max-width: 640px !important;
}
.xert-svelte .max-w-\[660px\] {
  max-width: 660px !important;
}
.xert-svelte .max-w-\[720px\] {
  max-width: 720px !important;
}
.xert-svelte .max-w-\[75\%\] {
  max-width: 75% !important;
}
.xert-svelte .max-w-\[800px\] {
  max-width: 800px !important;
}
.xert-svelte .max-w-\[8rem\] {
  max-width: 8rem !important;
}
.xert-svelte .max-w-\[920px\] {
  max-width: 920px !important;
}
.xert-svelte .max-w-\[95vw\] {
  max-width: 95vw !important;
}
.xert-svelte .max-w-\[calc\(100vw-2rem\)\] {
  max-width: calc(100vw - 2rem) !important;
}
.xert-svelte .max-w-fit {
  max-width: fit-content !important;
}
.xert-svelte .max-w-full {
  max-width: 100% !important;
}
.xert-svelte .max-w-lg {
  max-width: 32rem !important;
}
.xert-svelte .max-w-max {
  max-width: max-content !important;
}
.xert-svelte .max-w-md {
  max-width: 28rem !important;
}
.xert-svelte .max-w-screen-2xl {
  max-width: 1536px !important;
}
.xert-svelte .max-w-sm {
  max-width: 24rem !important;
}
.xert-svelte .max-w-xl {
  max-width: 36rem !important;
}
.xert-svelte .max-w-xs {
  max-width: 20rem !important;
}
.xert-svelte .flex-1 {
  flex: 1 1 0% !important;
}
.xert-svelte .flex-initial {
  flex: 0 1 auto !important;
}
.xert-svelte .flex-none {
  flex: none !important;
}
.xert-svelte .flex-shrink {
  flex-shrink: 1 !important;
}
.xert-svelte .flex-shrink-0 {
  flex-shrink: 0 !important;
}
.xert-svelte .shrink {
  flex-shrink: 1 !important;
}
.xert-svelte .shrink-0 {
  flex-shrink: 0 !important;
}
.xert-svelte .flex-grow {
  flex-grow: 1 !important;
}
.xert-svelte .grow {
  flex-grow: 1 !important;
}
.xert-svelte .grow-0 {
  flex-grow: 0 !important;
}
.xert-svelte .basis-0 {
  flex-basis: 0px !important;
}
.xert-svelte .basis-1\/2 {
  flex-basis: 50% !important;
}
.xert-svelte .basis-2\/5 {
  flex-basis: 40% !important;
}
.xert-svelte .basis-3\/5 {
  flex-basis: 60% !important;
}
.xert-svelte .table-fixed {
  table-layout: fixed !important;
}
.xert-svelte .caption-bottom {
  caption-side: bottom !important;
}
.xert-svelte .border-collapse {
  border-collapse: collapse !important;
}
.xert-svelte .origin-bottom-right {
  transform-origin: bottom right !important;
}
.xert-svelte .origin-center {
  transform-origin: center !important;
}
.xert-svelte .origin-top {
  transform-origin: top !important;
}
.xert-svelte .-translate-x-1\/2 {
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .-translate-y-1 {
  --tw-translate-y: -0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .-translate-y-1\/2 {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .-translate-y-full {
  --tw-translate-y: -100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .translate-x-\[-50\%\] {
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .translate-y-0 {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .translate-y-\[-50\%\] {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .-rotate-90 {
  --tw-rotate: -90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .rotate-45 {
  --tw-rotate: 45deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .scale-110 {
  --tw-scale-x: 1.1 !important;
  --tw-scale-y: 1.1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .scale-\[0\.7\] {
  --tw-scale-x: 0.7 !important;
  --tw-scale-y: 0.7 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .scale-\[0\.8\] {
  --tw-scale-x: 0.8 !important;
  --tw-scale-y: 0.8 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .scale-\[1\.0\] {
  --tw-scale-x: 1.0 !important;
  --tw-scale-y: 1.0 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.xert-svelte .animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.xert-svelte .animate-spin {
  animation: spin 1s linear infinite !important;
}
.xert-svelte .cursor-auto {
  cursor: auto !important;
}
.xert-svelte .cursor-default {
  cursor: default !important;
}
.xert-svelte .cursor-grab {
  cursor: grab !important;
}
.xert-svelte .cursor-grabbing {
  cursor: grabbing !important;
}
.xert-svelte .cursor-not-allowed {
  cursor: not-allowed !important;
}
.xert-svelte .cursor-pointer {
  cursor: pointer !important;
}
.xert-svelte .cursor-zoom-in {
  cursor: zoom-in !important;
}
.xert-svelte .touch-none {
  touch-action: none !important;
}
.xert-svelte .select-none {
  user-select: none !important;
}
.xert-svelte .resize {
  resize: both !important;
}
.xert-svelte .snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness) !important;
}
.xert-svelte .snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness) !important;
}
.xert-svelte .snap-mandatory {
  --tw-scroll-snap-strictness: mandatory !important;
}
.xert-svelte .snap-start {
  scroll-snap-align: start !important;
}
.xert-svelte .snap-center {
  scroll-snap-align: center !important;
}
.xert-svelte .snap-always {
  scroll-snap-stop: always !important;
}
.xert-svelte .list-inside {
  list-style-position: inside !important;
}
.xert-svelte .list-\[circle\] {
  list-style-type: circle !important;
}
.xert-svelte .list-decimal {
  list-style-type: decimal !important;
}
.xert-svelte .list-disc {
  list-style-type: disc !important;
}
.xert-svelte .list-none {
  list-style-type: none !important;
}
.xert-svelte .auto-cols-max {
  grid-auto-columns: max-content !important;
}
.xert-svelte .grid-flow-row {
  grid-auto-flow: row !important;
}
.xert-svelte .grid-flow-col {
  grid-auto-flow: column !important;
}
.xert-svelte .auto-rows-max {
  grid-auto-rows: max-content !important;
}
.xert-svelte .grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-cols-\[18px\,1fr\,min-content\] {
  grid-template-columns: 18px 1fr min-content !important;
}
.xert-svelte .grid-cols-\[18px\,1fr\] {
  grid-template-columns: 18px 1fr !important;
}
.xert-svelte .grid-cols-\[1fr\,2rem\,1fr\] {
  grid-template-columns: 1fr 2rem 1fr !important;
}
.xert-svelte .grid-cols-\[1fr\,3fr\] {
  grid-template-columns: 1fr 3fr !important;
}
.xert-svelte .grid-cols-\[1fr\,7rem\] {
  grid-template-columns: 1fr 7rem !important;
}
.xert-svelte .grid-cols-\[1fr\,auto\] {
  grid-template-columns: 1fr auto !important;
}
.xert-svelte .grid-cols-\[2fr\,5fr\] {
  grid-template-columns: 2fr 5fr !important;
}
.xert-svelte .grid-cols-\[30px\,auto\] {
  grid-template-columns: 30px auto !important;
}
.xert-svelte .grid-cols-\[auto\,31px\] {
  grid-template-columns: auto 31px !important;
}
.xert-svelte .grid-cols-\[auto\,75px\] {
  grid-template-columns: auto 75px !important;
}
.xert-svelte .grid-cols-\[auto\,auto\] {
  grid-template-columns: auto auto !important;
}
.xert-svelte .grid-cols-\[auto_auto_1\.25rem\] {
  grid-template-columns: auto auto 1.25rem !important;
}
.xert-svelte .grid-cols-\[max-content\,auto\] {
  grid-template-columns: max-content auto !important;
}
.xert-svelte .grid-cols-\[min-content\,auto\,auto\] {
  grid-template-columns: min-content auto auto !important;
}
.xert-svelte .grid-cols-\[min-content\,auto\] {
  grid-template-columns: min-content auto !important;
}
.xert-svelte .grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
}
.xert-svelte .grid-rows-\[auto_minmax\(0\,1fr\)_auto\] {
  grid-template-rows: auto minmax(0, 1fr) auto !important;
}
.xert-svelte .grid-rows-\[min-content\,11rem\,1fr\] {
  grid-template-rows: min-content 11rem 1fr !important;
}
.xert-svelte .flex-row {
  flex-direction: row !important;
}
.xert-svelte .flex-row-reverse {
  flex-direction: row-reverse !important;
}
.xert-svelte .flex-col {
  flex-direction: column !important;
}
.xert-svelte .flex-col-reverse {
  flex-direction: column-reverse !important;
}
.xert-svelte .flex-wrap {
  flex-wrap: wrap !important;
}
.xert-svelte .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
.xert-svelte .flex-nowrap {
  flex-wrap: nowrap !important;
}
.xert-svelte .place-items-center {
  place-items: center !important;
}
.xert-svelte .content-center {
  align-content: center !important;
}
.xert-svelte .items-start {
  align-items: flex-start !important;
}
.xert-svelte .items-end {
  align-items: flex-end !important;
}
.xert-svelte .items-center {
  align-items: center !important;
}
.xert-svelte .items-baseline {
  align-items: baseline !important;
}
.xert-svelte .items-stretch {
  align-items: stretch !important;
}
.xert-svelte .justify-start {
  justify-content: flex-start !important;
}
.xert-svelte .justify-end {
  justify-content: flex-end !important;
}
.xert-svelte .justify-center {
  justify-content: center !important;
}
.xert-svelte .justify-between {
  justify-content: space-between !important;
}
.xert-svelte .justify-around {
  justify-content: space-around !important;
}
.xert-svelte .justify-evenly {
  justify-content: space-evenly !important;
}
.xert-svelte .justify-stretch {
  justify-content: stretch !important;
}
.xert-svelte .justify-items-start {
  justify-items: start !important;
}
.xert-svelte .justify-items-center {
  justify-items: center !important;
}
.xert-svelte .gap-0 {
  gap: 0px !important;
}
.xert-svelte .gap-0\.5 {
  gap: 0.125rem !important;
}
.xert-svelte .gap-1 {
  gap: 0.25rem !important;
}
.xert-svelte .gap-1\.5 {
  gap: 0.375rem !important;
}
.xert-svelte .gap-10 {
  gap: 2.5rem !important;
}
.xert-svelte .gap-12 {
  gap: 3rem !important;
}
.xert-svelte .gap-2 {
  gap: 0.5rem !important;
}
.xert-svelte .gap-2\.5 {
  gap: 0.625rem !important;
}
.xert-svelte .gap-3 {
  gap: 0.75rem !important;
}
.xert-svelte .gap-3\.5 {
  gap: 0.875rem !important;
}
.xert-svelte .gap-4 {
  gap: 1rem !important;
}
.xert-svelte .gap-5 {
  gap: 1.25rem !important;
}
.xert-svelte .gap-6 {
  gap: 1.5rem !important;
}
.xert-svelte .gap-7 {
  gap: 1.75rem !important;
}
.xert-svelte .gap-8 {
  gap: 2rem !important;
}
.xert-svelte .gap-\[0\.15rem\] {
  gap: 0.15rem !important;
}
.xert-svelte .gap-\[10px\] {
  gap: 10px !important;
}
.xert-svelte .gap-\[18px\] {
  gap: 18px !important;
}
.xert-svelte .gap-\[3px\] {
  gap: 3px !important;
}
.xert-svelte .gap-\[4px\] {
  gap: 4px !important;
}
.xert-svelte .gap-px {
  gap: 1px !important;
}
.xert-svelte .gap-x-1 {
  column-gap: 0.25rem !important;
}
.xert-svelte .gap-x-10 {
  column-gap: 2.5rem !important;
}
.xert-svelte .gap-x-14 {
  column-gap: 3.5rem !important;
}
.xert-svelte .gap-x-2 {
  column-gap: 0.5rem !important;
}
.xert-svelte .gap-x-3 {
  column-gap: 0.75rem !important;
}
.xert-svelte .gap-x-4 {
  column-gap: 1rem !important;
}
.xert-svelte .gap-x-5 {
  column-gap: 1.25rem !important;
}
.xert-svelte .gap-x-6 {
  column-gap: 1.5rem !important;
}
.xert-svelte .gap-x-7 {
  column-gap: 1.75rem !important;
}
.xert-svelte .gap-x-8 {
  column-gap: 2rem !important;
}
.xert-svelte .gap-y-0\.5 {
  row-gap: 0.125rem !important;
}
.xert-svelte .gap-y-1 {
  row-gap: 0.25rem !important;
}
.xert-svelte .gap-y-1\.5 {
  row-gap: 0.375rem !important;
}
.xert-svelte .gap-y-12 {
  row-gap: 3rem !important;
}
.xert-svelte .gap-y-2 {
  row-gap: 0.5rem !important;
}
.xert-svelte .gap-y-2\.5 {
  row-gap: 0.625rem !important;
}
.xert-svelte .gap-y-3 {
  row-gap: 0.75rem !important;
}
.xert-svelte .gap-y-4 {
  row-gap: 1rem !important;
}
.xert-svelte .gap-y-5 {
  row-gap: 1.25rem !important;
}
.xert-svelte .gap-y-6 {
  row-gap: 1.5rem !important;
}
.xert-svelte .gap-y-8 {
  row-gap: 2rem !important;
}
.xert-svelte .gap-y-9 {
  row-gap: 2.25rem !important;
}
.xert-svelte .-space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.xert-svelte .space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.xert-svelte .space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.xert-svelte .space-y-0\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-1\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-2\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.xert-svelte .divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0 !important;
  border-right-width: calc(1px * var(--tw-divide-x-reverse)) !important;
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse))) !important;
}
.xert-svelte .divide-x-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0 !important;
  border-right-width: calc(0px * var(--tw-divide-x-reverse)) !important;
  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse))) !important;
}
.xert-svelte .divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0 !important;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse))) !important;
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse)) !important;
}
.xert-svelte .divide-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0 !important;
  border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse))) !important;
  border-bottom-width: calc(0px * var(--tw-divide-y-reverse)) !important;
}
.xert-svelte .divide-solid > :not([hidden]) ~ :not([hidden]) {
  border-style: solid !important;
}
.xert-svelte .divide-border > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1 !important;
  border-color: hsl(var(--border) / var(--tw-divide-opacity, 1)) !important;
}
.xert-svelte .self-start {
  align-self: flex-start !important;
}
.xert-svelte .self-end {
  align-self: flex-end !important;
}
.xert-svelte .self-center {
  align-self: center !important;
}
.xert-svelte .self-stretch {
  align-self: stretch !important;
}
.xert-svelte .justify-self-start {
  justify-self: start !important;
}
.xert-svelte .justify-self-end {
  justify-self: end !important;
}
.xert-svelte .justify-self-center {
  justify-self: center !important;
}
.xert-svelte .overflow-auto {
  overflow: auto !important;
}
.xert-svelte .overflow-hidden {
  overflow: hidden !important;
}
.xert-svelte .overflow-clip {
  overflow: clip !important;
}
.xert-svelte .overflow-visible {
  overflow: visible !important;
}
.xert-svelte .overflow-x-auto {
  overflow-x: auto !important;
}
.xert-svelte .overflow-y-auto {
  overflow-y: auto !important;
}
.xert-svelte .overflow-x-hidden {
  overflow-x: hidden !important;
}
.xert-svelte .overflow-y-hidden {
  overflow-y: hidden !important;
}
.xert-svelte .overflow-x-clip {
  overflow-x: clip !important;
}
.xert-svelte .overflow-x-scroll {
  overflow-x: scroll !important;
}
.xert-svelte .overflow-y-scroll {
  overflow-y: scroll !important;
}
.xert-svelte .overscroll-contain {
  overscroll-behavior: contain !important;
}
.xert-svelte .scroll-smooth {
  scroll-behavior: smooth !important;
}
.xert-svelte .truncate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.xert-svelte .text-ellipsis {
  text-overflow: ellipsis !important;
}
.xert-svelte .\!whitespace-normal {
  white-space: normal !important;
}
.xert-svelte .whitespace-normal {
  white-space: normal !important;
}
.xert-svelte .whitespace-nowrap {
  white-space: nowrap !important;
}
.xert-svelte .whitespace-pre {
  white-space: pre !important;
}
.xert-svelte .whitespace-pre-line {
  white-space: pre-line !important;
}
.xert-svelte .whitespace-pre-wrap {
  white-space: pre-wrap !important;
}
.xert-svelte .text-wrap {
  text-wrap: wrap !important;
}
.xert-svelte .break-words {
  overflow-wrap: break-word !important;
}
.xert-svelte .rounded {
  border-radius: 0.25rem !important;
}
.xert-svelte .rounded-2xl {
  border-radius: 1rem !important;
}
.xert-svelte .rounded-\[2px\] {
  border-radius: 2px !important;
}
.xert-svelte .rounded-\[inherit\] {
  border-radius: inherit !important;
}
.xert-svelte .rounded-full {
  border-radius: 9999px !important;
}
.xert-svelte .rounded-lg {
  border-radius: var(--radius) !important;
}
.xert-svelte .rounded-md {
  border-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .rounded-none {
  border-radius: 0px !important;
}
.xert-svelte .rounded-sm {
  border-radius: calc(var(--radius) - 4px) !important;
}
.xert-svelte .rounded-xl {
  border-radius: 0.75rem !important;
}
.xert-svelte .rounded-b {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
.xert-svelte .rounded-b-2xl {
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}
.xert-svelte .rounded-b-lg {
  border-bottom-right-radius: var(--radius) !important;
  border-bottom-left-radius: var(--radius) !important;
}
.xert-svelte .rounded-b-md {
  border-bottom-right-radius: calc(var(--radius) - 2px) !important;
  border-bottom-left-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .rounded-b-none {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.xert-svelte .rounded-e-lg {
  border-start-end-radius: var(--radius) !important;
  border-end-end-radius: var(--radius) !important;
}
.xert-svelte .rounded-l-md {
  border-top-left-radius: calc(var(--radius) - 2px) !important;
  border-bottom-left-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .rounded-r-md {
  border-top-right-radius: calc(var(--radius) - 2px) !important;
  border-bottom-right-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .rounded-s-lg {
  border-start-start-radius: var(--radius) !important;
  border-end-start-radius: var(--radius) !important;
}
.xert-svelte .rounded-t {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
.xert-svelte .rounded-t-2xl {
  border-top-left-radius: 1rem !important;
  border-top-right-radius: 1rem !important;
}
.xert-svelte .rounded-t-\[10px\] {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}
.xert-svelte .rounded-t-md {
  border-top-left-radius: calc(var(--radius) - 2px) !important;
  border-top-right-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .rounded-br-3xl {
  border-bottom-right-radius: 1.5rem !important;
}
.xert-svelte .rounded-br-lg {
  border-bottom-right-radius: var(--radius) !important;
}
.xert-svelte .rounded-tr-lg {
  border-top-right-radius: var(--radius) !important;
}
.xert-svelte .border {
  border-width: 1px !important;
}
.xert-svelte .border-0 {
  border-width: 0px !important;
}
.xert-svelte .border-2 {
  border-width: 2px !important;
}
.xert-svelte .border-\[1\.5px\] {
  border-width: 1.5px !important;
}
.xert-svelte .border-\[1px\] {
  border-width: 1px !important;
}
.xert-svelte .border-\[2px\] {
  border-width: 2px !important;
}
.xert-svelte .border-x-0 {
  border-left-width: 0px !important;
  border-right-width: 0px !important;
}
.xert-svelte .border-x-2 {
  border-left-width: 2px !important;
  border-right-width: 2px !important;
}
.xert-svelte .border-x-\[7px\] {
  border-left-width: 7px !important;
  border-right-width: 7px !important;
}
.xert-svelte .border-b {
  border-bottom-width: 1px !important;
}
.xert-svelte .border-b-0 {
  border-bottom-width: 0px !important;
}
.xert-svelte .border-b-2 {
  border-bottom-width: 2px !important;
}
.xert-svelte .border-b-\[10px\] {
  border-bottom-width: 10px !important;
}
.xert-svelte .border-l {
  border-left-width: 1px !important;
}
.xert-svelte .border-l-0 {
  border-left-width: 0px !important;
}
.xert-svelte .border-l-2 {
  border-left-width: 2px !important;
}
.xert-svelte .border-l-4 {
  border-left-width: 4px !important;
}
.xert-svelte .border-l-\[3px\] {
  border-left-width: 3px !important;
}
.xert-svelte .border-r {
  border-right-width: 1px !important;
}
.xert-svelte .border-r-0 {
  border-right-width: 0px !important;
}
.xert-svelte .border-t {
  border-top-width: 1px !important;
}
.xert-svelte .border-t-0 {
  border-top-width: 0px !important;
}
.xert-svelte .border-t-2 {
  border-top-width: 2px !important;
}
.xert-svelte .border-t-4 {
  border-top-width: 4px !important;
}
.xert-svelte .border-t-\[5px\] {
  border-top-width: 5px !important;
}
.xert-svelte .border-solid {
  border-style: solid !important;
}
.xert-svelte .border-dashed {
  border-style: dashed !important;
}
.xert-svelte .border-none {
  border-style: none !important;
}
.xert-svelte .border-\[\#2f3336\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(47 51 54 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[\#707377\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(112 115 119 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[\#A8A9AD\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(168 169 173 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[\#B08D57\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 141 87 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[\#D4AF37\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(212 175 55 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[\#e4e4e4\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[\#e7deca\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(231 222 202 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-\[--color-xert-teal\] {
  border-color: var(--color-xert-teal) !important;
}
.xert-svelte .border-amber-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-amber-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-amber-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-amber-500\/40 {
  border-color: rgb(245 158 11 / 0.4) !important;
}
.xert-svelte .border-black\/10 {
  border-color: rgb(0 0 0 / 0.1) !important;
}
.xert-svelte .border-blue-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-blue-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-blue-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-border {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--border) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-border\/40 {
  border-color: hsl(var(--border) / 0.4) !important;
}
.xert-svelte .border-border\/60 {
  border-color: hsl(var(--border) / 0.6) !important;
}
.xert-svelte .border-current {
  border-color: currentColor !important;
}
.xert-svelte .border-destructive {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--destructive) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-destructive\/20 {
  border-color: hsl(var(--destructive) / 0.2) !important;
}
.xert-svelte .border-foreground {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--foreground) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-gray-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-gray-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-gray-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-gray-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-green-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-green-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-input {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--input) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-muted {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--muted) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-muted-foreground {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--muted-foreground) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-muted-foreground\/40 {
  border-color: hsl(var(--muted-foreground) / 0.4) !important;
}
.xert-svelte .border-neutral-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 229 229 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-orange-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-primary {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-primary\/50 {
  border-color: hsl(var(--primary) / 0.5) !important;
}
.xert-svelte .border-red-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-red-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-red-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-red-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-red-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-secondary-foreground {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--secondary-foreground) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-sky-300\/60 {
  border-color: rgb(125 211 252 / 0.6) !important;
}
.xert-svelte .border-slate-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-slate-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-slate-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-slate-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-transparent {
  border-color: transparent !important;
}
.xert-svelte .border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-white\/10 {
  border-color: rgb(255 255 255 / 0.1) !important;
}
.xert-svelte .border-white\/20 {
  border-color: rgb(255 255 255 / 0.2) !important;
}
.xert-svelte .border-white\/5 {
  border-color: rgb(255 255 255 / 0.05) !important;
}
.xert-svelte .border-xerteal-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(215 240 238 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-xerteal-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(86 166 171 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-xerteal-400\/10 {
  border-color: rgb(86 166 171 / 0.1) !important;
}
.xert-svelte .border-xerteal-600\/10 {
  border-color: rgb(47 112 118 / 0.1) !important;
}
.xert-svelte .border-xerteal-600\/30 {
  border-color: rgb(47 112 118 / 0.3) !important;
}
.xert-svelte .border-xerteal-600\/40 {
  border-color: rgb(47 112 118 / 0.4) !important;
}
.xert-svelte .border-xerteal-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(40 88 93 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-xerteal-800\/50 {
  border-color: rgb(36 70 75 / 0.5) !important;
}
.xert-svelte .border-zinc-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-zinc-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-zinc-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-zinc-800 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-x-transparent {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.xert-svelte .border-b-slate-700 {
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(51 65 85 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-l-amber-500 {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(245 158 11 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-l-green-600 {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(22 163 74 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-l-red-500 {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .border-l-transparent {
  border-left-color: transparent !important;
}
.xert-svelte .border-t-transparent {
  border-top-color: transparent !important;
}
.xert-svelte .bg-\[\#0b0c0d\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(11 12 13 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#25d366\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#64dfdf\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(100 223 223 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#F9F9F9\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#b4e4ee\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(180 228 238 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#e6e6e6\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 230 230 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#ecd5fd\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 213 253 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#ff00ffC0\] {
  background-color: #ff00ffC0 !important;
}
.xert-svelte .bg-\[\#ff00ff\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 0 255 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[\#ffa700\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 167 0 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[--color-xert-blue\] {
  background-color: var(--color-xert-blue) !important;
}
.xert-svelte .bg-\[--color-xert-lime\] {
  background-color: var(--color-xert-lime) !important;
}
.xert-svelte .bg-\[--color-xert-teal\] {
  background-color: var(--color-xert-teal) !important;
}
.xert-svelte .bg-\[rgb\(198\,170\,255\)\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(198 170 255 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[rgb\(8\,9\,10\)\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(8 9 10 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[rgba\(108\,186\,102\)\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(108, 186, 102, var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[rgba\(108\,186\,102\,0\.2\)\] {
  background-color: rgba(108, 186, 102, 0.2) !important;
}
.xert-svelte .bg-\[rgba\(126\,211\,33\,0\.2\)\] {
  background-color: rgba(126, 211, 33, 0.2) !important;
}
.xert-svelte .bg-\[rgba\(198\,170\,255\)\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(198, 170, 255, var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[rgba\(198\,170\,255\,0\.5\)\] {
  background-color: rgba(198, 170, 255, 0.5) !important;
}
.xert-svelte .bg-\[rgba\(255\,0\,0\,0\.2\)\] {
  background-color: rgba(255, 0, 0, 0.2) !important;
}
.xert-svelte .bg-\[rgba\(74\,144\,226\,0\.2\)\] {
  background-color: rgba(74, 144, 226, 0.2) !important;
}
.xert-svelte .bg-\[var\(--color-xss-deviation-alert\)\] {
  background-color: var(--color-xss-deviation-alert) !important;
}
.xert-svelte .bg-\[var\(--color-xss-deviation-good\)\] {
  background-color: var(--color-xss-deviation-good) !important;
}
.xert-svelte .bg-\[var\(--color-xss-deviation-warn\)\] {
  background-color: var(--color-xss-deviation-warn) !important;
}
.xert-svelte .bg-accent {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-accent\/60 {
  background-color: hsl(var(--accent) / 0.6) !important;
}
.xert-svelte .bg-amber-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-amber-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-amber-500\/20 {
  background-color: rgb(245 158 11 / 0.2) !important;
}
.xert-svelte .bg-amber-500\/5 {
  background-color: rgb(245 158 11 / 0.05) !important;
}
.xert-svelte .bg-background {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-background\/80 {
  background-color: hsl(var(--background) / 0.8) !important;
}
.xert-svelte .bg-background\/95 {
  background-color: hsl(var(--background) / 0.95) !important;
}
.xert-svelte .bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-black\/10 {
  background-color: rgb(0 0 0 / 0.1) !important;
}
.xert-svelte .bg-black\/30 {
  background-color: rgb(0 0 0 / 0.3) !important;
}
.xert-svelte .bg-black\/40 {
  background-color: rgb(0 0 0 / 0.4) !important;
}
.xert-svelte .bg-black\/5 {
  background-color: rgb(0 0 0 / 0.05) !important;
}
.xert-svelte .bg-black\/50 {
  background-color: rgb(0 0 0 / 0.5) !important;
}
.xert-svelte .bg-black\/60 {
  background-color: rgb(0 0 0 / 0.6) !important;
}
.xert-svelte .bg-black\/80 {
  background-color: rgb(0 0 0 / 0.8) !important;
}
.xert-svelte .bg-blue-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-blue-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-blue-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-blue-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-border {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--border) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-card {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--card) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-destructive {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--destructive) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-destructive\/10 {
  background-color: hsl(var(--destructive) / 0.1) !important;
}
.xert-svelte .bg-destructive\/40 {
  background-color: hsl(var(--destructive) / 0.4) !important;
}
.xert-svelte .bg-emerald-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-foreground {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--foreground) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-foreground\/25 {
  background-color: hsl(var(--foreground) / 0.25) !important;
}
.xert-svelte .bg-foreground\/70 {
  background-color: hsl(var(--foreground) / 0.7) !important;
}
.xert-svelte .bg-gray-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-gray-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-gray-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-gray-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-gray-50\/70 {
  background-color: rgb(249 250 251 / 0.7) !important;
}
.xert-svelte .bg-green-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-green-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-green-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-green-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-muted {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-muted-foreground\/30 {
  background-color: hsl(var(--muted-foreground) / 0.3) !important;
}
.xert-svelte .bg-muted-foreground\/50 {
  background-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.xert-svelte .bg-muted\/30 {
  background-color: hsl(var(--muted) / 0.3) !important;
}
.xert-svelte .bg-muted\/40 {
  background-color: hsl(var(--muted) / 0.4) !important;
}
.xert-svelte .bg-muted\/50 {
  background-color: hsl(var(--muted) / 0.5) !important;
}
.xert-svelte .bg-muted\/60 {
  background-color: hsl(var(--muted) / 0.6) !important;
}
.xert-svelte .bg-orange-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-orange-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-popover {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--popover) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-primary\/10 {
  background-color: hsl(var(--primary) / 0.1) !important;
}
.xert-svelte .bg-primary\/20 {
  background-color: hsl(var(--primary) / 0.2) !important;
}
.xert-svelte .bg-primary\/5 {
  background-color: hsl(var(--primary) / 0.05) !important;
}
.xert-svelte .bg-red-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-red-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-red-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-red-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-red-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-secondary {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--secondary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-slate-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-slate-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-slate-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-teal-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-transparent {
  background-color: transparent !important;
}
.xert-svelte .bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-white\/10 {
  background-color: rgb(255 255 255 / 0.1) !important;
}
.xert-svelte .bg-white\/15 {
  background-color: rgb(255 255 255 / 0.15) !important;
}
.xert-svelte .bg-white\/20 {
  background-color: rgb(255 255 255 / 0.2) !important;
}
.xert-svelte .bg-white\/85 {
  background-color: rgb(255 255 255 / 0.85) !important;
}
.xert-svelte .bg-white\/90 {
  background-color: rgb(255 255 255 / 0.9) !important;
}
.xert-svelte .bg-white\/\[0\.04\] {
  background-color: rgb(255 255 255 / 0.04) !important;
}
.xert-svelte .bg-xertblue {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 144 226 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-xerteal-100\/60 {
  background-color: rgb(215 240 238 / 0.6) !important;
}
.xert-svelte .bg-xerteal-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(176 223 222 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-xerteal-200\/50 {
  background-color: rgb(176 223 222 / 0.5) !important;
}
.xert-svelte .bg-xerteal-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(86 166 171 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-xerteal-400\/20 {
  background-color: rgb(86 166 171 / 0.2) !important;
}
.xert-svelte .bg-xerteal-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 250 249 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-xerteal-600\/10 {
  background-color: rgb(47 112 118 / 0.1) !important;
}
.xert-svelte .bg-xerteal-600\/20 {
  background-color: rgb(47 112 118 / 0.2) !important;
}
.xert-svelte .bg-xerteal-600\/5 {
  background-color: rgb(47 112 118 / 0.05) !important;
}
.xert-svelte .bg-xerteal-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(40 88 93 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-xertlime {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(126 211 33 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-yellow-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-yellow-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-yellow-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-zinc-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .bg-\[linear-gradient\(0deg\,rgba\(255\,255\,255\,0\.06\)_1px\,transparent_1px\)\,linear-gradient\(90deg\,rgba\(255\,255\,255\,0\.06\)_1px\,transparent_1px\)\] {
  background-image:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.06) 1px,
      transparent 1px),
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.06) 1px,
      transparent 1px) !important;
}
.xert-svelte .bg-\[linear-gradient\(135deg\,_\#64dfdf80_0\%\,_\#89c2d980_100\%\)\] {
  background-image:
    linear-gradient(
      135deg,
      #64dfdf80 0%,
      #89c2d980 100%) !important;
}
.xert-svelte .bg-\[linear-gradient\(135deg\,_\#64dfdf_0\%\,_\#89c2d9_100\%\)\] {
  background-image:
    linear-gradient(
      135deg,
      #64dfdf 0%,
      #89c2d9 100%) !important;
}
.xert-svelte .bg-\[linear-gradient\(135deg\,_rgba\(0\,0\,0\,0\.4\)\,_transparent_40\%\)\,_linear-gradient\(45deg\,_rgba\(0\,0\,0\,0\.35\)\,_transparent_40\%\)\] {
  background-image:
    linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.4),
      transparent 40%),
    linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.35),
      transparent 40%) !important;
}
.xert-svelte .bg-\[linear-gradient\(150deg\,\#0b1f2b_0\%\,\#0e3344_50\%\,\#0a2433_100\%\)\] {
  background-image:
    linear-gradient(
      150deg,
      #0b1f2b 0%,
      #0e3344 50%,
      #0a2433 100%) !important;
}
.xert-svelte .bg-\[linear-gradient\(160deg\,\#2a1f14_0\%\,\#3a2a1d_45\%\,\#2e2218_100\%\)\] {
  background-image:
    linear-gradient(
      160deg,
      #2a1f14 0%,
      #3a2a1d 45%,
      #2e2218 100%) !important;
}
.xert-svelte .bg-\[linear-gradient\(90deg\,\#FB5607_0\%\,\#FFD166_50\%\,\#06D6A0_100\%\)\] {
  background-image:
    linear-gradient(
      90deg,
      #FB5607 0%,
      #FFD166 50%,
      #06D6A0 100%) !important;
}
.xert-svelte .bg-\[linear-gradient\(90deg\,transparent_0_10px\,rgba\(255\,255\,255\,0\.08\)_10px_12px\)\] {
  background-image:
    linear-gradient(
      90deg,
      transparent 0 10px,
      rgba(255, 255, 255, 0.08) 10px 12px) !important;
}
.xert-svelte .bg-\[radial-gradient\(120\%_80\%_at_50\%_0\%\,\#0b1f2a_0\%\,\#0b2740_50\%\,\#081524_100\%\)\] {
  background-image:
    radial-gradient(
      120% 80% at 50% 0%,
      #0b1f2a 0%,
      #0b2740 50%,
      #081524 100%) !important;
}
.xert-svelte .bg-\[radial-gradient\(8px_8px_at_10\%_20\%\,rgba\(255\,255\,255\,0\.9\)_0_1px\,transparent_2px\)\,radial-gradient\(8px_8px_at_80\%_70\%\,rgba\(255\,255\,255\,0\.9\)_0_1px\,transparent_2px\)\] {
  background-image:
    radial-gradient(
      8px 8px at 10% 20%,
      rgba(255, 255, 255, 0.9) 0 1px,
      transparent 2px),
    radial-gradient(
      8px 8px at 80% 70%,
      rgba(255, 255, 255, 0.9) 0 1px,
      transparent 2px) !important;
}
.xert-svelte .bg-\[radial-gradient\(circle_at_80\%_10\%\,rgba\(255\,255\,255\,0\.06\)\,transparent_40\%\)\,radial-gradient\(circle_at_80\%_90\%\,rgba\(255\,255\,255\,0\.04\)\,transparent_40\%\)\,linear-gradient\(180deg\,rgba\(18\,20\,22\,0\.95\)\,rgba\(8\,9\,10\,0\.98\)\)\] {
  background-image:
    radial-gradient(
      circle at 80% 10%,
      rgba(255, 255, 255, 0.06),
      transparent 40%),
    radial-gradient(
      circle at 80% 90%,
      rgba(255, 255, 255, 0.04),
      transparent 40%),
    linear-gradient(
      180deg,
      rgba(18, 20, 22, 0.95),
      rgba(8, 9, 10, 0.98)) !important;
}
.xert-svelte .bg-\[radial-gradient\(ellipse_at_top_left\,_rgba\(94\,230\,232\,0\.25\)\,_transparent_60\%\)\,_radial-gradient\(ellipse_at_bottom_right\,_rgba\(255\,215\,0\,0\.18\)\,_transparent_60\%\)\] {
  background-image:
    radial-gradient(
      ellipse at top left,
      rgba(94, 230, 232, 0.25),
      transparent 60%),
    radial-gradient(
      ellipse at bottom right,
      rgba(255, 215, 0, 0.18),
      transparent 60%) !important;
}
.xert-svelte .bg-\[repeating-linear-gradient\(135deg\,transparent_0_6px\,rgba\(255\,255\,255\,0\.8\)_6px_7px\,transparent_7px_13px\)\] {
  background-image:
    repeating-linear-gradient(
      135deg,
      transparent 0 6px,
      rgba(255, 255, 255, 0.8) 6px 7px,
      transparent 7px 13px) !important;
}
.xert-svelte .bg-bronze-br {
  background-image:
    linear-gradient(
      to right,
      peru,
      saddlebrown) !important;
}
.xert-svelte .bg-fake-br {
  background-image:
    linear-gradient(
      to right,
      gray,
      black) !important;
}
.xert-svelte .bg-gold-br {
  background-image:
    linear-gradient(
      to right,
      gold,
      goldenrod) !important;
}
.xert-svelte .bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops)) !important;
}
.xert-svelte .bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops)) !important;
}
.xert-svelte .bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops)) !important;
}
.xert-svelte .bg-none {
  background-image: none !important;
}
.xert-svelte .bg-silver-br {
  background-image:
    linear-gradient(
      to right,
      silver,
      grey) !important;
}
.xert-svelte .from-\[\#0d3a46\] {
  --tw-gradient-from: #0d3a46 var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(13 58 70 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.xert-svelte .from-sky-50 {
  --tw-gradient-from: #f0f9ff var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.xert-svelte .from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.xert-svelte .from-white\/10 {
  --tw-gradient-from: rgb(255 255 255 / 0.1) var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.xert-svelte .from-xerteal-600\/10 {
  --tw-gradient-from: rgb(47 112 118 / 0.1) var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(47 112 118 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.xert-svelte .from-xerteal-700 {
  --tw-gradient-from: #28585d var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(40 88 93 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.xert-svelte .via-\[\#0b5666\] {
  --tw-gradient-to: rgb(11 86 102 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops:
    var(--tw-gradient-from),
    #0b5666 var(--tw-gradient-via-position),
    var(--tw-gradient-to) !important;
}
.xert-svelte .via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops:
    var(--tw-gradient-from),
    transparent var(--tw-gradient-via-position),
    var(--tw-gradient-to) !important;
}
.xert-svelte .via-xerteal-600 {
  --tw-gradient-to: rgb(47 112 118 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops:
    var(--tw-gradient-from),
    #2f7076 var(--tw-gradient-via-position),
    var(--tw-gradient-to) !important;
}
.xert-svelte .to-\[\#14808f\] {
  --tw-gradient-to: #14808f var(--tw-gradient-to-position) !important;
}
.xert-svelte .to-sky-100 {
  --tw-gradient-to: #e0f2fe var(--tw-gradient-to-position) !important;
}
.xert-svelte .to-slate-100 {
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position) !important;
}
.xert-svelte .to-white\/10 {
  --tw-gradient-to: rgb(255 255 255 / 0.1) var(--tw-gradient-to-position) !important;
}
.xert-svelte .to-xerteal-500 {
  --tw-gradient-to: #3c8a90 var(--tw-gradient-to-position) !important;
}
.xert-svelte .to-xerteal-600\/5 {
  --tw-gradient-to: rgb(47 112 118 / 0.05) var(--tw-gradient-to-position) !important;
}
.xert-svelte .bg-\[length\:16px_100\%\] {
  background-size: 16px 100% !important;
}
.xert-svelte .bg-\[size\:16px_16px\] {
  background-size: 16px 16px !important;
}
.xert-svelte .bg-cover {
  background-size: cover !important;
}
.xert-svelte .bg-center {
  background-position: center !important;
}
.xert-svelte .fill-current {
  fill: currentColor !important;
}
.xert-svelte .fill-foreground {
  fill: hsl(var(--foreground) / 1) !important;
}
.xert-svelte .fill-muted-foreground {
  fill: hsl(var(--muted-foreground) / 1) !important;
}
.xert-svelte .fill-none {
  fill: none !important;
}
.xert-svelte .fill-primary {
  fill: hsl(var(--primary) / 1) !important;
}
.xert-svelte .fill-transparent {
  fill: transparent !important;
}
.xert-svelte .fill-xerteal-600\/20 {
  fill: rgb(47 112 118 / 0.2) !important;
}
.xert-svelte .stroke-background {
  stroke: hsl(var(--background) / 1) !important;
}
.xert-svelte .stroke-border {
  stroke: hsl(var(--border) / 1) !important;
}
.xert-svelte .stroke-primary {
  stroke: hsl(var(--primary) / 1) !important;
}
.xert-svelte .object-contain {
  object-fit: contain !important;
}
.xert-svelte .object-cover {
  object-fit: cover !important;
}
.xert-svelte .object-fill {
  object-fit: fill !important;
}
.xert-svelte .p-0 {
  padding: 0px !important;
}
.xert-svelte .p-0\.5 {
  padding: 0.125rem !important;
}
.xert-svelte .p-1 {
  padding: 0.25rem !important;
}
.xert-svelte .p-1\.5 {
  padding: 0.375rem !important;
}
.xert-svelte .p-10 {
  padding: 2.5rem !important;
}
.xert-svelte .p-2 {
  padding: 0.5rem !important;
}
.xert-svelte .p-3 {
  padding: 0.75rem !important;
}
.xert-svelte .p-4 {
  padding: 1rem !important;
}
.xert-svelte .p-5 {
  padding: 1.25rem !important;
}
.xert-svelte .p-6 {
  padding: 1.5rem !important;
}
.xert-svelte .p-8 {
  padding: 2rem !important;
}
.xert-svelte .p-\[10px\] {
  padding: 10px !important;
}
.xert-svelte .p-\[12px\] {
  padding: 12px !important;
}
.xert-svelte .p-\[16px\] {
  padding: 16px !important;
}
.xert-svelte .p-\[1px\] {
  padding: 1px !important;
}
.xert-svelte .p-\[20px\] {
  padding: 20px !important;
}
.xert-svelte .p-\[8px\] {
  padding: 8px !important;
}
.xert-svelte .p-px {
  padding: 1px !important;
}
.xert-svelte .px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.xert-svelte .px-0\.5 {
  padding-left: 0.125rem !important;
  padding-right: 0.125rem !important;
}
.xert-svelte .px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.xert-svelte .px-1\.5 {
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}
.xert-svelte .px-10 {
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.xert-svelte .px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.xert-svelte .px-2\.5 {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}
.xert-svelte .px-20 {
  padding-left: 5rem !important;
  padding-right: 5rem !important;
}
.xert-svelte .px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.xert-svelte .px-3\.5 {
  padding-left: 0.875rem !important;
  padding-right: 0.875rem !important;
}
.xert-svelte .px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.xert-svelte .px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.xert-svelte .px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.xert-svelte .px-7 {
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
}
.xert-svelte .px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.xert-svelte .px-\[10px\] {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.xert-svelte .px-\[15px\] {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.xert-svelte .px-\[20px\] {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.xert-svelte .px-\[24px\] {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.xert-svelte .px-\[2px\] {
  padding-left: 2px !important;
  padding-right: 2px !important;
}
.xert-svelte .px-\[4px\] {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.xert-svelte .px-\[9px\] {
  padding-left: 9px !important;
  padding-right: 9px !important;
}
.xert-svelte .py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.xert-svelte .py-0\.5 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.xert-svelte .py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.xert-svelte .py-1\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.xert-svelte .py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.xert-svelte .py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.xert-svelte .py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}
.xert-svelte .py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.xert-svelte .py-2\.5 {
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.xert-svelte .py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.xert-svelte .py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.xert-svelte .py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.xert-svelte .py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.xert-svelte .py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.xert-svelte .py-\[10px\] {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.xert-svelte .py-\[15px\] {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.xert-svelte .py-\[3px\] {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}
.xert-svelte .py-\[4px\] {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.xert-svelte .py-\[5px\] {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.xert-svelte .py-\[8px\] {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.xert-svelte .py-px {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.xert-svelte .pb-0 {
  padding-bottom: 0px !important;
}
.xert-svelte .pb-0\.5 {
  padding-bottom: 0.125rem !important;
}
.xert-svelte .pb-1 {
  padding-bottom: 0.25rem !important;
}
.xert-svelte .pb-2 {
  padding-bottom: 0.5rem !important;
}
.xert-svelte .pb-2\.5 {
  padding-bottom: 0.625rem !important;
}
.xert-svelte .pb-3 {
  padding-bottom: 0.75rem !important;
}
.xert-svelte .pb-3\.5 {
  padding-bottom: 0.875rem !important;
}
.xert-svelte .pb-4 {
  padding-bottom: 1rem !important;
}
.xert-svelte .pb-5 {
  padding-bottom: 1.25rem !important;
}
.xert-svelte .pb-6 {
  padding-bottom: 1.5rem !important;
}
.xert-svelte .pb-8 {
  padding-bottom: 2rem !important;
}
.xert-svelte .pb-\[15px\] {
  padding-bottom: 15px !important;
}
.xert-svelte .pb-\[max\(0\.75rem\,env\(safe-area-inset-bottom\)\)\] {
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom)) !important;
}
.xert-svelte .pl-2 {
  padding-left: 0.5rem !important;
}
.xert-svelte .pl-3 {
  padding-left: 0.75rem !important;
}
.xert-svelte .pl-3\.5 {
  padding-left: 0.875rem !important;
}
.xert-svelte .pl-4 {
  padding-left: 1rem !important;
}
.xert-svelte .pl-5 {
  padding-left: 1.25rem !important;
}
.xert-svelte .pl-6 {
  padding-left: 1.5rem !important;
}
.xert-svelte .pl-8 {
  padding-left: 2rem !important;
}
.xert-svelte .pl-\[24px\] {
  padding-left: 24px !important;
}
.xert-svelte .pr-0 {
  padding-right: 0px !important;
}
.xert-svelte .pr-1 {
  padding-right: 0.25rem !important;
}
.xert-svelte .pr-1\.5 {
  padding-right: 0.375rem !important;
}
.xert-svelte .pr-10 {
  padding-right: 2.5rem !important;
}
.xert-svelte .pr-12 {
  padding-right: 3rem !important;
}
.xert-svelte .pr-2 {
  padding-right: 0.5rem !important;
}
.xert-svelte .pr-4 {
  padding-right: 1rem !important;
}
.xert-svelte .pr-5 {
  padding-right: 1.25rem !important;
}
.xert-svelte .pr-6 {
  padding-right: 1.5rem !important;
}
.xert-svelte .pr-8 {
  padding-right: 2rem !important;
}
.xert-svelte .pt-0 {
  padding-top: 0px !important;
}
.xert-svelte .pt-0\.5 {
  padding-top: 0.125rem !important;
}
.xert-svelte .pt-1 {
  padding-top: 0.25rem !important;
}
.xert-svelte .pt-14 {
  padding-top: 3.5rem !important;
}
.xert-svelte .pt-2 {
  padding-top: 0.5rem !important;
}
.xert-svelte .pt-3 {
  padding-top: 0.75rem !important;
}
.xert-svelte .pt-4 {
  padding-top: 1rem !important;
}
.xert-svelte .pt-5 {
  padding-top: 1.25rem !important;
}
.xert-svelte .pt-6 {
  padding-top: 1.5rem !important;
}
.xert-svelte .pt-8 {
  padding-top: 2rem !important;
}
.xert-svelte .pt-\[10px\] {
  padding-top: 10px !important;
}
.xert-svelte .pt-\[12px\] {
  padding-top: 12px !important;
}
.xert-svelte .pt-\[34px\] {
  padding-top: 34px !important;
}
.xert-svelte .pt-\[60px\] {
  padding-top: 60px !important;
}
.xert-svelte .text-left {
  text-align: left !important;
}
.xert-svelte .text-center {
  text-align: center !important;
}
.xert-svelte .text-right {
  text-align: right !important;
}
.xert-svelte .text-start {
  text-align: start !important;
}
.xert-svelte .align-top {
  vertical-align: top !important;
}
.xert-svelte .align-middle {
  vertical-align: middle !important;
}
.xert-svelte .align-bottom {
  vertical-align: bottom !important;
}
.xert-svelte .font-mono {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    "Liberation Mono",
    "Courier New",
    monospace !important;
}
.xert-svelte .text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.xert-svelte .text-3xl {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.xert-svelte .text-4xl {
  font-size: 2.25rem !important;
  line-height: 2.5rem !important;
}
.xert-svelte .text-5xl {
  font-size: 3rem !important;
  line-height: 1 !important;
}
.xert-svelte .text-6xl {
  font-size: 3.75rem !important;
  line-height: 1 !important;
}
.xert-svelte .text-7xl {
  font-size: 4.5rem !important;
  line-height: 1 !important;
}
.xert-svelte .text-9xl {
  font-size: 8rem !important;
  line-height: 1 !important;
}
.xert-svelte .text-\[0\.5rem\] {
  font-size: 0.5rem !important;
}
.xert-svelte .text-\[0\.6rem\] {
  font-size: 0.6rem !important;
}
.xert-svelte .text-\[0\.8rem\] {
  font-size: 0.8rem !important;
}
.xert-svelte .text-\[1\.1rem\] {
  font-size: 1.1rem !important;
}
.xert-svelte .text-\[10px\] {
  font-size: 10px !important;
}
.xert-svelte .text-\[11px\] {
  font-size: 11px !important;
}
.xert-svelte .text-\[12px\] {
  font-size: 12px !important;
}
.xert-svelte .text-\[13px\] {
  font-size: 13px !important;
}
.xert-svelte .text-\[14px\] {
  font-size: 14px !important;
}
.xert-svelte .text-\[15px\] {
  font-size: 15px !important;
}
.xert-svelte .text-\[18px\] {
  font-size: 18px !important;
}
.xert-svelte .text-\[5\.5rem\] {
  font-size: 5.5rem !important;
}
.xert-svelte .text-\[8px\] {
  font-size: 8px !important;
}
.xert-svelte .text-\[9px\] {
  font-size: 9px !important;
}
.xert-svelte .text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.xert-svelte .text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.xert-svelte .text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.xert-svelte .text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.xert-svelte .text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.xert-svelte .font-black {
  font-weight: 900 !important;
}
.xert-svelte .font-bold {
  font-weight: 700 !important;
}
.xert-svelte .font-light {
  font-weight: 300 !important;
}
.xert-svelte .font-medium {
  font-weight: 500 !important;
}
.xert-svelte .font-normal {
  font-weight: 400 !important;
}
.xert-svelte .font-semibold {
  font-weight: 600 !important;
}
.xert-svelte .uppercase {
  text-transform: uppercase !important;
}
.xert-svelte .capitalize {
  text-transform: capitalize !important;
}
.xert-svelte .italic {
  font-style: italic !important;
}
.xert-svelte .ordinal {
  --tw-ordinal: ordinal !important;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.xert-svelte .tabular-nums {
  --tw-numeric-spacing: tabular-nums !important;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.xert-svelte .\!leading-normal {
  line-height: 1.5 !important;
}
.xert-svelte .leading-4 {
  line-height: 1rem !important;
}
.xert-svelte .leading-5 {
  line-height: 1.25rem !important;
}
.xert-svelte .leading-\[22px\] {
  line-height: 22px !important;
}
.xert-svelte .leading-\[32px\] {
  line-height: 32px !important;
}
.xert-svelte .leading-none {
  line-height: 1 !important;
}
.xert-svelte .leading-normal {
  line-height: 1.5 !important;
}
.xert-svelte .leading-relaxed {
  line-height: 1.625 !important;
}
.xert-svelte .leading-snug {
  line-height: 1.375 !important;
}
.xert-svelte .leading-tight {
  line-height: 1.25 !important;
}
.xert-svelte .tracking-\[0\.12em\] {
  letter-spacing: 0.12em !important;
}
.xert-svelte .tracking-\[0\.15em\] {
  letter-spacing: 0.15em !important;
}
.xert-svelte .tracking-\[0\.2em\] {
  letter-spacing: 0.2em !important;
}
.xert-svelte .tracking-\[1px\] {
  letter-spacing: 1px !important;
}
.xert-svelte .tracking-tight {
  letter-spacing: -0.025em !important;
}
.xert-svelte .tracking-tighter {
  letter-spacing: -0.05em !important;
}
.xert-svelte .tracking-wide {
  letter-spacing: 0.025em !important;
}
.xert-svelte .tracking-wider {
  letter-spacing: 0.05em !important;
}
.xert-svelte .tracking-widest {
  letter-spacing: 0.1em !important;
}
.xert-svelte .text-\[\#008d8f\] {
  --tw-text-opacity: 1 !important;
  color: rgb(0 141 143 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#03d5e7\] {
  --tw-text-opacity: 1 !important;
  color: rgb(3 213 231 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#0B5DBC\] {
  --tw-text-opacity: 1 !important;
  color: rgb(11 93 188 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#1da851\] {
  --tw-text-opacity: 1 !important;
  color: rgb(29 168 81 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#2F7076\] {
  --tw-text-opacity: 1 !important;
  color: rgb(47 112 118 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#2f7076\] {
  --tw-text-opacity: 1 !important;
  color: rgb(47 112 118 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#34495e\] {
  --tw-text-opacity: 1 !important;
  color: rgb(52 73 94 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#5CA907\] {
  --tw-text-opacity: 1 !important;
  color: rgb(92 169 7 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#5ee6e8\] {
  --tw-text-opacity: 1 !important;
  color: rgb(94 230 232 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#6cba66\] {
  --tw-text-opacity: 1 !important;
  color: rgb(108 186 102 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#7934bf\] {
  --tw-text-opacity: 1 !important;
  color: rgb(121 52 191 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#7cff4d\] {
  --tw-text-opacity: 1 !important;
  color: rgb(124 255 77 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#7ed321\] {
  --tw-text-opacity: 1 !important;
  color: rgb(126 211 33 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#A01DE3\] {
  --tw-text-opacity: 1 !important;
  color: rgb(160 29 227 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#CD7F32\] {
  --tw-text-opacity: 1 !important;
  color: rgb(205 127 50 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#F04B2E\] {
  --tw-text-opacity: 1 !important;
  color: rgb(240 75 46 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#FF00FF\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 0 255 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#FF2222\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 34 34 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#cd7f32\] {
  --tw-text-opacity: 1 !important;
  color: rgb(205 127 50 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#d6d6d6\] {
  --tw-text-opacity: 1 !important;
  color: rgb(214 214 214 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#fea2c5\] {
  --tw-text-opacity: 1 !important;
  color: rgb(254 162 197 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[\#ff4dcd\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 77 205 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[--color-xert-teal\] {
  color: var(--color-xert-teal) !important;
}
.xert-svelte .text-\[--color-xhss\] {
  color: var(--color-xhss) !important;
}
.xert-svelte .text-\[--color-xlss\] {
  color: var(--color-xlss) !important;
}
.xert-svelte .text-\[--color-xpss\] {
  color: var(--color-xpss) !important;
}
.xert-svelte .text-\[gold\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 215 0 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[silver\] {
  --tw-text-opacity: 1 !important;
  color: rgb(192 192 192 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-\[var\(--color-xhss\)\] {
  color: var(--color-xhss) !important;
}
.xert-svelte .text-\[var\(--color-xlss\)\] {
  color: var(--color-xlss) !important;
}
.xert-svelte .text-\[var\(--color-xpss\)\] {
  color: var(--color-xpss) !important;
}
.xert-svelte .text-\[var\(--color-xss-deviation-alert\)\] {
  color: var(--color-xss-deviation-alert) !important;
}
.xert-svelte .text-\[var\(--color-xss-deviation-good\)\] {
  color: var(--color-xss-deviation-good) !important;
}
.xert-svelte .text-\[var\(--color-xss-deviation-warn\)\] {
  color: var(--color-xss-deviation-warn) !important;
}
.xert-svelte .text-accent-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-amber-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-background {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--background) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-black\/70 {
  color: rgb(0 0 0 / 0.7) !important;
}
.xert-svelte .text-black\/80 {
  color: rgb(0 0 0 / 0.8) !important;
}
.xert-svelte .text-blue-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-blue-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-blue-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-blue-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-blue-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-blue-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-card-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--card-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-current {
  color: currentColor !important;
}
.xert-svelte .text-destructive {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--destructive) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-destructive-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--destructive-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-destructive\/70 {
  color: hsl(var(--destructive) / 0.7) !important;
}
.xert-svelte .text-emerald-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-gray-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-gray-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-gray-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-green-950 {
  --tw-text-opacity: 1 !important;
  color: rgb(5 46 22 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-inherit {
  color: inherit !important;
}
.xert-svelte .text-muted-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-muted-foreground\/40 {
  color: hsl(var(--muted-foreground) / 0.4) !important;
}
.xert-svelte .text-muted-foreground\/50 {
  color: hsl(var(--muted-foreground) / 0.5) !important;
}
.xert-svelte .text-muted-foreground\/60 {
  color: hsl(var(--muted-foreground) / 0.6) !important;
}
.xert-svelte .text-muted-foreground\/70 {
  color: hsl(var(--muted-foreground) / 0.7) !important;
}
.xert-svelte .text-orange-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-orange-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-popover-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--popover-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-primary {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-primary-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-primary-foreground\/70 {
  color: hsl(var(--primary-foreground) / 0.7) !important;
}
.xert-svelte .text-purple-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-red-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-red-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-red-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-red-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-red-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-secondary-foreground {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--secondary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-sky-800\/80 {
  color: rgb(7 89 133 / 0.8) !important;
}
.xert-svelte .text-slate-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-slate-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-slate-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-slate-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-slate-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-transparent {
  color: transparent !important;
}
.xert-svelte .text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-white\/60 {
  color: rgb(255 255 255 / 0.6) !important;
}
.xert-svelte .text-white\/65 {
  color: rgb(255 255 255 / 0.65) !important;
}
.xert-svelte .text-white\/70 {
  color: rgb(255 255 255 / 0.7) !important;
}
.xert-svelte .text-white\/75 {
  color: rgb(255 255 255 / 0.75) !important;
}
.xert-svelte .text-white\/80 {
  color: rgb(255 255 255 / 0.8) !important;
}
.xert-svelte .text-white\/85 {
  color: rgb(255 255 255 / 0.85) !important;
}
.xert-svelte .text-white\/90 {
  color: rgb(255 255 255 / 0.9) !important;
}
.xert-svelte .text-xerteal-100 {
  --tw-text-opacity: 1 !important;
  color: rgb(215 240 238 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-200 {
  --tw-text-opacity: 1 !important;
  color: rgb(176 223 222 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-200\/30 {
  color: rgb(176 223 222 / 0.3) !important;
}
.xert-svelte .text-xerteal-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(128 199 200 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(86 166 171 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-50 {
  --tw-text-opacity: 1 !important;
  color: rgb(243 250 249 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(60 138 144 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(47 112 118 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(40 88 93 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(36 70 75 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(33 61 64 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerteal-950 {
  --tw-text-opacity: 1 !important;
  color: rgb(14 34 37 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xerthigh {
  --tw-text-opacity: 1 !important;
  color: rgb(245 166 35 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xertlow {
  --tw-text-opacity: 1 !important;
  color: rgb(11 93 188 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-xertpeak {
  --tw-text-opacity: 1 !important;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-yellow-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-yellow-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-yellow-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-yellow-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-zinc-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-zinc-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-zinc-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-zinc-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .text-zinc-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .underline {
  text-decoration-line: underline !important;
}
.xert-svelte .no-underline {
  text-decoration-line: none !important;
}
.xert-svelte .decoration-dotted {
  text-decoration-style: dotted !important;
}
.xert-svelte .decoration-1 {
  text-decoration-thickness: 1px !important;
}
.xert-svelte .underline-offset-2 {
  text-underline-offset: 2px !important;
}
.xert-svelte .underline-offset-4 {
  text-underline-offset: 4px !important;
}
.xert-svelte .antialiased {
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
.xert-svelte .accent-primary {
  accent-color: hsl(var(--primary) / 1) !important;
}
.xert-svelte .accent-xerteal-600 {
  accent-color: #2f7076 !important;
}
.xert-svelte .opacity-0 {
  opacity: 0 !important;
}
.xert-svelte .opacity-20 {
  opacity: 0.2 !important;
}
.xert-svelte .opacity-25 {
  opacity: 0.25 !important;
}
.xert-svelte .opacity-30 {
  opacity: 0.3 !important;
}
.xert-svelte .opacity-40 {
  opacity: 0.4 !important;
}
.xert-svelte .opacity-50 {
  opacity: 0.5 !important;
}
.xert-svelte .opacity-60 {
  opacity: 0.6 !important;
}
.xert-svelte .opacity-70 {
  opacity: 0.7 !important;
}
.xert-svelte .opacity-75 {
  opacity: 0.75 !important;
}
.xert-svelte .opacity-80 {
  opacity: 0.8 !important;
}
.xert-svelte .opacity-85 {
  opacity: 0.85 !important;
}
.xert-svelte .opacity-90 {
  opacity: 0.9 !important;
}
.xert-svelte .opacity-\[0\.06\] {
  opacity: 0.06 !important;
}
.xert-svelte .opacity-\[0\.08\] {
  opacity: 0.08 !important;
}
.xert-svelte .opacity-\[0\.18\] {
  opacity: 0.18 !important;
}
.xert-svelte .shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[0_0_30px_rgba\(0\,196\,154\,0\.12\)\] {
  --tw-shadow: 0 0 30px rgba(0,196,154,0.12) !important;
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[0_0_30px_rgba\(25\,130\,196\,0\.15\)\] {
  --tw-shadow: 0 0 30px rgba(25,130,196,0.15) !important;
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[0_0_30px_rgba\(251\,86\,7\,0\.12\)\] {
  --tw-shadow: 0 0 30px rgba(251,86,7,0.12) !important;
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[0_10px_30px_rgba\(0\,0\,0\,0\.35\)\] {
  --tw-shadow: 0 10px 30px rgba(0,0,0,0.35) !important;
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[0px_4px_4px_rgba\(0\,0\,0\,0\.25\)\] {
  --tw-shadow: 0px 4px 4px rgba(0,0,0,0.25) !important;
  --tw-shadow-colored: 0px 4px 4px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[inset_-20px_0_20px_0px_rgba\(249\,249\,249\,1\)\] {
  --tw-shadow: inset -20px 0 20px 0px rgba(249,249,249,1) !important;
  --tw-shadow-colored: inset -20px 0 20px 0px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[inset_0_1px_2px_rgba\(255\,255\,255\,0\.25\)\] {
  --tw-shadow: inset 0 1px 2px rgba(255,255,255,0.25) !important;
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[inset_20px_0_20px_0px_rgba\(249\,249\,249\,1\)\,inset_-20px_0_20px_0px_rgba\(249\,249\,249\,1\)\] {
  --tw-shadow: inset 20px 0 20px 0px rgba(249,249,249,1),inset -20px 0 20px 0px rgba(249,249,249,1) !important;
  --tw-shadow-colored: inset 20px 0 20px 0px var(--tw-shadow-color), inset -20px 0 20px 0px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-\[inset_20px_0_20px_0px_rgba\(249\,249\,249\,1\)\] {
  --tw-shadow: inset 20px 0 20px 0px rgba(249,249,249,1) !important;
  --tw-shadow-colored: inset 20px 0 20px 0px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .shadow-black\/10 {
  --tw-shadow-color: rgb(0 0 0 / 0.1) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.xert-svelte .shadow-black\/20 {
  --tw-shadow-color: rgb(0 0 0 / 0.2) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.xert-svelte .shadow-red-500\/40 {
  --tw-shadow-color: rgb(239 68 68 / 0.4) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.xert-svelte .shadow-xerteal-300\/40 {
  --tw-shadow-color: rgb(128 199 200 / 0.4) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.xert-svelte .shadow-xerteal-300\/50 {
  --tw-shadow-color: rgb(128 199 200 / 0.5) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.xert-svelte .shadow-xerteal-600\/10 {
  --tw-shadow-color: rgb(47 112 118 / 0.1) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.xert-svelte .outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.xert-svelte .outline {
  outline-style: solid !important;
}
.xert-svelte .ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .ring-background {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--background) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .ring-black\/10 {
  --tw-ring-color: rgb(0 0 0 / 0.1) !important;
}
.xert-svelte .ring-border {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--border) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .ring-card {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--card) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .ring-orange-500 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .ring-white {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .ring-white\/10 {
  --tw-ring-color: rgb(255 255 255 / 0.1) !important;
}
.xert-svelte .ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background) / 1) !important;
}
.xert-svelte .blur {
  --tw-blur: blur(8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .blur-\[0\.6px\] {
  --tw-blur: blur(0.6px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .blur-\[0\.8px\] {
  --tw-blur: blur(0.8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .\!grayscale {
  --tw-grayscale: grayscale(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .grayscale {
  --tw-grayscale: grayscale(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .saturate-\[\.6\] {
  --tw-saturate: saturate(.6) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .backdrop-blur {
  --tw-backdrop-blur: blur(8px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.xert-svelte .backdrop-blur-\[2px\] {
  --tw-backdrop-blur: blur(2px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.xert-svelte .backdrop-blur-none {
  --tw-backdrop-blur: !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.xert-svelte .backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.xert-svelte .backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.xert-svelte .transition {
  transition-property:
    color,
    background-color,
    border-color,
    text-decoration-color,
    fill,
    stroke,
    opacity,
    box-shadow,
    transform,
    filter,
    backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-\[border-width\,border-radius\] {
  transition-property: border-width, border-radius !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-\[filter\] {
  transition-property: filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-\[max-height\] {
  transition-property: max-height !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-\[width\] {
  transition-property: width !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-all {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-colors {
  transition-property:
    color,
    background-color,
    border-color,
    text-decoration-color,
    fill,
    stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-opacity {
  transition-property: opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-shadow {
  transition-property: box-shadow !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .transition-transform {
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.xert-svelte .delay-0 {
  transition-delay: 0s !important;
}
.xert-svelte .delay-150 {
  transition-delay: 150ms !important;
}
.xert-svelte .delay-300 {
  transition-delay: 300ms !important;
}
.xert-svelte .duration-0 {
  transition-duration: 0s !important;
}
.xert-svelte .duration-150 {
  transition-duration: 150ms !important;
}
.xert-svelte .duration-200 {
  transition-duration: 200ms !important;
}
.xert-svelte .duration-300 {
  transition-duration: 300ms !important;
}
.xert-svelte .duration-700 {
  transition-duration: 700ms !important;
}
.xert-svelte .duration-\[0\.05s\] {
  transition-duration: 0.05s !important;
}
.xert-svelte .ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.xert-svelte .ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.xert-svelte .will-change-transform {
  will-change: transform !important;
}
.xert-svelte .\@container {
  container-type: inline-size !important;
}
.xert-svelte .no-scrollbar::-webkit-scrollbar {
  display: none !important;
}
.xert-svelte .no-scrollbar {
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}
.xert-svelte .\[appearance\:textfield\] {
  appearance: textfield !important;
}
.xert-svelte .\[overflow-wrap\:anywhere\] {
  overflow-wrap: anywhere !important;
}
.xert-svelte .\[scrollbar-width\:none\] {
  scrollbar-width: none !important;
}
.xert-svelte .\[width\:100\] {
  width: 100 !important;
}
:root {
  font-size: 16px !important;
}
.xert-svelte .shadcn-root {
  font-size: 16px !important;
  color: hsl(var(--foreground)) !important;
}
.xert-svelte .file\:border-0::file-selector-button {
  border-width: 0px !important;
}
.xert-svelte .file\:bg-transparent::file-selector-button {
  background-color: transparent !important;
}
.xert-svelte .file\:text-sm::file-selector-button {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.xert-svelte .file\:font-medium::file-selector-button {
  font-weight: 500 !important;
}
.xert-svelte .placeholder\:text-muted-foreground::placeholder {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .after\:absolute::after {
  content: var(--tw-content) !important;
  position: absolute !important;
}
.xert-svelte .after\:inset-y-0::after {
  content: var(--tw-content) !important;
  top: 0px !important;
  bottom: 0px !important;
}
.xert-svelte .after\:left-1\/2::after {
  content: var(--tw-content) !important;
  left: 50% !important;
}
.xert-svelte .after\:w-1::after {
  content: var(--tw-content) !important;
  width: 0.25rem !important;
}
.xert-svelte .after\:-translate-x-1\/2::after {
  content: var(--tw-content) !important;
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .first\:ml-0:first-child {
  margin-left: 0px !important;
}
.xert-svelte .first\:mt-0:first-child {
  margin-top: 0px !important;
}
.xert-svelte .first\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px) !important;
  border-bottom-left-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .first\:pt-0:first-child {
  padding-top: 0px !important;
}
.xert-svelte .last\:hidden:last-child {
  display: none !important;
}
.xert-svelte .last\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px) !important;
  border-bottom-right-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .last\:border-0:last-child {
  border-width: 0px !important;
}
.xert-svelte .last\:pb-0:last-child {
  padding-bottom: 0px !important;
}
.xert-svelte .focus-within\:relative:focus-within {
  position: relative !important;
}
.xert-svelte .focus-within\:z-20:focus-within {
  z-index: 20 !important;
}
.xert-svelte .focus-within\:outline-none:focus-within {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.xert-svelte .focus-within\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus-within\:ring-primary:focus-within {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--primary) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .hover\:-translate-y-0\.5:hover {
  --tw-translate-y: -0.125rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .hover\:cursor-pointer:hover {
  cursor: pointer !important;
}
.xert-svelte .hover\:cursor-text:hover {
  cursor: text !important;
}
.xert-svelte .hover\:border-\[--color-xert-blue\]:hover {
  border-color: var(--color-xert-blue) !important;
}
.xert-svelte .hover\:border-input:hover {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--input) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .hover\:border-primary:hover {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .hover\:border-xerteal-300:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(128 199 200 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .hover\:border-xerteal-400:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(86 166 171 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .hover\:border-xerteal-500:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(60 138 144 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .hover\:border-xerteal-600:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(47 112 118 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .hover\:border-xerteal-600\/70:hover {
  border-color: rgb(47 112 118 / 0.7) !important;
}
.xert-svelte .hover\:bg-\[\#22c35e\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 195 94 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-\[\#5ee6e8\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(94 230 232 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-\[--color-xert-blue\]:hover {
  background-color: var(--color-xert-blue) !important;
}
.xert-svelte .hover\:bg-\[--color-xert-lime\]:hover {
  background-color: var(--color-xert-lime) !important;
}
.xert-svelte .hover\:bg-\[--color-xert-teal\]:hover {
  background-color: var(--color-xert-teal) !important;
}
.xert-svelte .hover\:bg-\[var\(--color-xss-deviation-alert\)\]:hover {
  background-color: var(--color-xss-deviation-alert) !important;
}
.xert-svelte .hover\:bg-\[var\(--color-xss-deviation-good\)\]:hover {
  background-color: var(--color-xss-deviation-good) !important;
}
.xert-svelte .hover\:bg-\[var\(--color-xss-deviation-warn\)\]:hover {
  background-color: var(--color-xss-deviation-warn) !important;
}
.xert-svelte .hover\:bg-accent:hover {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-black\/10:hover {
  background-color: rgb(0 0 0 / 0.1) !important;
}
.xert-svelte .hover\:bg-black\/30:hover {
  background-color: rgb(0 0 0 / 0.3) !important;
}
.xert-svelte .hover\:bg-blue-400:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-blue-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-destructive\/10:hover {
  background-color: hsl(var(--destructive) / 0.1) !important;
}
.xert-svelte .hover\:bg-destructive\/80:hover {
  background-color: hsl(var(--destructive) / 0.8) !important;
}
.xert-svelte .hover\:bg-destructive\/90:hover {
  background-color: hsl(var(--destructive) / 0.9) !important;
}
.xert-svelte .hover\:bg-gray-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-gray-300:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-green-400:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-green-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-muted:hover {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-muted\/30:hover {
  background-color: hsl(var(--muted) / 0.3) !important;
}
.xert-svelte .hover\:bg-muted\/40:hover {
  background-color: hsl(var(--muted) / 0.4) !important;
}
.xert-svelte .hover\:bg-muted\/50:hover {
  background-color: hsl(var(--muted) / 0.5) !important;
}
.xert-svelte .hover\:bg-muted\/60:hover {
  background-color: hsl(var(--muted) / 0.6) !important;
}
.xert-svelte .hover\:bg-muted\/70:hover {
  background-color: hsl(var(--muted) / 0.7) !important;
}
.xert-svelte .hover\:bg-orange-400:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-primary\/10:hover {
  background-color: hsl(var(--primary) / 0.1) !important;
}
.xert-svelte .hover\:bg-primary\/80:hover {
  background-color: hsl(var(--primary) / 0.8) !important;
}
.xert-svelte .hover\:bg-primary\/90:hover {
  background-color: hsl(var(--primary) / 0.9) !important;
}
.xert-svelte .hover\:bg-red-400:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-red-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-red-600:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-secondary\/80:hover {
  background-color: hsl(var(--secondary) / 0.8) !important;
}
.xert-svelte .hover\:bg-slate-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-slate-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-xerteal-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 250 249 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-xerteal-500:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(60 138 144 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-xertlime:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(126 211 33 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-yellow-400:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-yellow-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:bg-zinc-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .hover\:text-3xl:hover {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.xert-svelte .hover\:text-\[\#1f4f54\]:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(31 79 84 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-\[\#707377\]:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(112 115 119 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-accent-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-destructive:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--destructive) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-muted-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-orange-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-primary:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-red-700:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-slate-800:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-xerteal-600:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(47 112 118 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-xerteal-700:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(40 88 93 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-zinc-700:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:text-zinc-900:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .hover\:underline:hover {
  text-decoration-line: underline !important;
}
.xert-svelte .hover\:no-underline:hover {
  text-decoration-line: none !important;
}
.xert-svelte .hover\:decoration-solid:hover {
  text-decoration-style: solid !important;
}
.xert-svelte .hover\:opacity-100:hover {
  opacity: 1 !important;
}
.xert-svelte .hover\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .hover\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .hover\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .hover\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .hover\:brightness-110:hover {
  --tw-brightness: brightness(1.1) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .hover\:brightness-75:hover {
  --tw-brightness: brightness(.75) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .hover\:brightness-90:hover {
  --tw-brightness: brightness(.9) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .hover\:brightness-95:hover {
  --tw-brightness: brightness(.95) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.xert-svelte .focus\:text-inherit:focus {
  color: inherit !important;
}
.xert-svelte .focus\:outline-none:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.xert-svelte .focus\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus\:ring-ring:focus {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--ring) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .focus\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px !important;
}
.xert-svelte .focus-visible\:outline-none:focus-visible {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.xert-svelte .focus-visible\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus-visible\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus-visible\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .focus-visible\:ring-ring:focus-visible {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--ring) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .focus-visible\:ring-xerteal-400:focus-visible {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(86 166 171 / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .focus-visible\:ring-xerteal-700:focus-visible {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(40 88 93 / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .focus-visible\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px !important;
}
.xert-svelte .focus-visible\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px !important;
}
.xert-svelte .focus-visible\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background) / 1) !important;
}
.xert-svelte .active\:cursor-grabbing:active {
  cursor: grabbing !important;
}
.xert-svelte .disabled\:pointer-events-none:disabled {
  pointer-events: none !important;
}
.xert-svelte .disabled\:cursor-default:disabled {
  cursor: default !important;
}
.xert-svelte .disabled\:cursor-not-allowed:disabled {
  cursor: not-allowed !important;
}
.xert-svelte .disabled\:border-none:disabled {
  border-style: none !important;
}
.xert-svelte .disabled\:text-3xl:disabled {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.xert-svelte .disabled\:opacity-100:disabled {
  opacity: 1 !important;
}
.xert-svelte .disabled\:opacity-50:disabled {
  opacity: 0.5 !important;
}
.xert-svelte .disabled\:opacity-60:disabled {
  opacity: 0.6 !important;
}
.xert-svelte .group:focus-within .group-focus-within\:flex {
  display: flex !important;
}
.xert-svelte .group:focus-within .group-focus-within\:hidden {
  display: none !important;
}
.xert-svelte .group:hover .group-hover\:flex {
  display: flex !important;
}
.xert-svelte .group:hover .group-hover\:bg-xerteal-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(60 138 144 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .group:hover .group-hover\:underline {
  text-decoration-line: underline !important;
}
.xert-svelte .group:hover .group-hover\:no-underline {
  text-decoration-line: none !important;
}
.xert-svelte .group:hover .group-hover\:opacity-100 {
  opacity: 1 !important;
}
.xert-svelte .group:hover .group-hover\:shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .group:hover .group-hover\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .group:hover .group-hover\:ring-border {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: hsl(var(--border) / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .group:hover .group-hover\:ring-offset-2 {
  --tw-ring-offset-width: 2px !important;
}
.xert-svelte .group:hover .group-hover\:ring-offset-card {
  --tw-ring-offset-color: hsl(var(--card) / 1) !important;
}
.xert-svelte .group:has(button[data-state=checked]) .group-\[\:has\(button\[data-state\=\'checked\'\]\)\]\:border-primary {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .peer:checked ~ .peer-checked\:border-xerteal-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(47 112 118 / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .peer:checked ~ .peer-checked\:bg-xerteal-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(47 112 118 / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .peer:checked ~ .peer-checked\:font-semibold {
  font-weight: 600 !important;
}
.xert-svelte .peer:checked ~ .peer-checked\:text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .peer:focus-visible ~ .peer-focus-visible\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000) !important;
}
.xert-svelte .peer:focus-visible ~ .peer-focus-visible\:ring-xerteal-400 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(86 166 171 / var(--tw-ring-opacity, 1)) !important;
}
.xert-svelte .peer:disabled ~ .peer-disabled\:cursor-not-allowed {
  cursor: not-allowed !important;
}
.xert-svelte .peer:disabled ~ .peer-disabled\:opacity-50 {
  opacity: 0.5 !important;
}
.xert-svelte .peer:disabled ~ .peer-disabled\:opacity-70 {
  opacity: 0.7 !important;
}
.xert-svelte .aria-\[invalid\]\:border-destructive[aria-invalid] {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--destructive) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .data-\[disabled\]\:pointer-events-none[data-disabled] {
  pointer-events: none !important;
}
.xert-svelte .data-\[outside-month\]\:pointer-events-none[data-outside-month] {
  pointer-events: none !important;
}
.xert-svelte .data-\[direction\=vertical\]\:h-px[data-direction=vertical] {
  height: 1px !important;
}
.xert-svelte .data-\[direction\=vertical\]\:w-full[data-direction=vertical] {
  width: 100% !important;
}
.xert-svelte .data-\[state\=checked\]\:translate-x-4[data-state=checked] {
  --tw-translate-x: 1rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .data-\[state\=unchecked\]\:translate-x-0[data-state=unchecked] {
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .data-\[disabled\=true\]\:cursor-not-allowed[data-disabled=true] {
  cursor: not-allowed !important;
}
.xert-svelte .data-\[direction\=vertical\]\:flex-col[data-direction=vertical] {
  flex-direction: column !important;
}
.xert-svelte .data-\[state\=active\]\:border-primary[data-state=active] {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .data-\[highlighted\]\:bg-accent[data-highlighted] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[selected\]\:bg-primary[data-selected] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=active\]\:bg-background[data-state=active] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=active\]\:bg-transparent[data-state=active] {
  background-color: transparent !important;
}
.xert-svelte .data-\[state\=checked\]\:bg-primary[data-state=checked] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=on\]\:bg-accent[data-state=on] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=open\]\:bg-accent[data-state=open] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=open\]\:bg-secondary[data-state=open] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--secondary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=selected\]\:bg-muted[data-state=selected] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=unchecked\]\:bg-input[data-state=unchecked] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--input) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[disabled\]\:text-muted-foreground[data-disabled] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[enabled\=false\]\:text-slate-300[data-enabled=false] {
  --tw-text-opacity: 1 !important;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[highlighted\]\:text-accent-foreground[data-highlighted] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[outside-month\]\:text-muted-foreground[data-outside-month] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[selected\]\:text-primary-foreground[data-selected] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=active\]\:text-foreground[data-state=active] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=checked\]\:text-primary-foreground[data-state=checked] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=on\]\:text-accent-foreground[data-state=on] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=open\]\:text-accent-foreground[data-state=open] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[state\=open\]\:text-muted-foreground[data-state=open] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[unavailable\]\:text-destructive-foreground[data-unavailable] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--destructive-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[unavailable\]\:line-through[data-unavailable] {
  text-decoration-line: line-through !important;
}
.xert-svelte .data-\[disabled\=true\]\:opacity-50[data-disabled=true] {
  opacity: 0.5 !important;
}
.xert-svelte .data-\[disabled\]\:opacity-50[data-disabled] {
  opacity: 0.5 !important;
}
.xert-svelte .data-\[outside-month\]\:opacity-50[data-outside-month] {
  opacity: 0.5 !important;
}
.xert-svelte .data-\[selected\]\:opacity-100[data-selected] {
  opacity: 1 !important;
}
.xert-svelte .data-\[state\=active\]\:shadow[data-state=active] {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .data-\[state\=active\]\:shadow-none[data-state=active] {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}
.xert-svelte .data-\[direction\=vertical\]\:after\:left-0[data-direction=vertical]::after {
  content: var(--tw-content) !important;
  left: 0px !important;
}
.xert-svelte .data-\[direction\=vertical\]\:after\:h-1[data-direction=vertical]::after {
  content: var(--tw-content) !important;
  height: 0.25rem !important;
}
.xert-svelte .data-\[direction\=vertical\]\:after\:w-full[data-direction=vertical]::after {
  content: var(--tw-content) !important;
  width: 100% !important;
}
.xert-svelte .data-\[direction\=vertical\]\:after\:-translate-y-1\/2[data-direction=vertical]::after {
  content: var(--tw-content) !important;
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .data-\[direction\=vertical\]\:after\:translate-x-0[data-direction=vertical]::after {
  content: var(--tw-content) !important;
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .data-\[selected\]\:hover\:bg-primary:hover[data-selected] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[selected\]\:hover\:text-primary-foreground:hover[data-selected] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .data-\[selected\]\:focus\:bg-primary:focus[data-selected] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .data-\[selected\]\:focus\:text-primary-foreground:focus[data-selected] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .group\/crysball:hover .data-\[hover\=true\]\:group-hover\/crysball\:animate-\[hover-sparkle_2\.5s_linear_0\.5s_infinite\][data-hover=true] {
  animation: hover-sparkle 2.5s linear 0.5s infinite !important;
}
.xert-svelte .group\/crysball:hover .data-\[hover\=true\]\:group-hover\/crysball\:animate-\[hover-sparkle_2\.5s_linear_1s_infinite\][data-hover=true] {
  animation: hover-sparkle 2.5s linear 1s infinite !important;
}
.xert-svelte .group\/crysball:hover .data-\[hover\=true\]\:group-hover\/crysball\:animate-\[hover-sparkle_2\.5s_linear_infinite\][data-hover=true] {
  animation: hover-sparkle 2.5s linear infinite !important;
}
@container (min-width: 36rem) {
  .xert-svelte .\@xl\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .xert-svelte .\@xl\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
  .xert-svelte .\@xl\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }
  .xert-svelte .\@xl\:col-start-2 {
    grid-column-start: 2 !important;
  }
  .xert-svelte .\@xl\:col-start-3 {
    grid-column-start: 3 !important;
  }
  .xert-svelte .\@xl\:col-start-auto {
    grid-column-start: auto !important;
  }
  .xert-svelte .\@xl\:row-span-2 {
    grid-row: span 2 / span 2 !important;
  }
  .xert-svelte .\@xl\:row-start-1 {
    grid-row-start: 1 !important;
  }
  .xert-svelte .\@xl\:row-start-2 {
    grid-row-start: 2 !important;
  }
  .xert-svelte .\@xl\:row-start-auto {
    grid-row-start: auto !important;
  }
  .xert-svelte .\@xl\:mt-0 {
    margin-top: 0px !important;
  }
  .xert-svelte .\@xl\:hidden {
    display: none !important;
  }
  .xert-svelte .\@xl\:h-8 {
    height: 2rem !important;
  }
  .xert-svelte .\@xl\:w-14 {
    width: 3.5rem !important;
  }
  .xert-svelte .\@xl\:w-24 {
    width: 6rem !important;
  }
  .xert-svelte .\@xl\:w-60 {
    width: 15rem !important;
  }
  .xert-svelte .\@xl\:grid-cols-\[200px\,1fr\,auto\] {
    grid-template-columns: 200px 1fr auto !important;
  }
  .xert-svelte .\@xl\:grid-cols-\[200px\,auto\] {
    grid-template-columns: 200px auto !important;
  }
  .xert-svelte .\@xl\:grid-cols-\[225px\,1fr\] {
    grid-template-columns: 225px 1fr !important;
  }
  .xert-svelte .\@xl\:grid-cols-\[auto\,1fr\,auto\] {
    grid-template-columns: auto 1fr auto !important;
  }
  .xert-svelte .\@xl\:grid-rows-\[min-content\,1fr\,auto\,auto\] {
    grid-template-rows: min-content 1fr auto auto !important;
  }
  .xert-svelte .\@xl\:self-start {
    align-self: flex-start !important;
  }
  .xert-svelte .\@xl\:justify-self-end {
    justify-self: end !important;
  }
  .xert-svelte .\@xl\:pt-1\.5 {
    padding-top: 0.375rem !important;
  }
  .xert-svelte .\@xl\:pt-2 {
    padding-top: 0.5rem !important;
  }
  .xert-svelte .\@xl\:pt-3 {
    padding-top: 0.75rem !important;
  }
  .xert-svelte .\@xl\:text-4xl {
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }
  .xert-svelte .\@xl\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }
}
@container (min-width: 40rem) {
  .xert-svelte .\@\[40rem\]\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .xert-svelte .\@\[40rem\]\:col-span-4 {
    grid-column: span 4 / span 4 !important;
  }
  .xert-svelte .\@\[40rem\]\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }
  .xert-svelte .\@\[40rem\]\:w-40 {
    width: 10rem !important;
  }
  .xert-svelte .\@\[40rem\]\:grid-cols-\[auto\,auto\,auto\,1fr\,auto\] {
    grid-template-columns: auto auto auto 1fr auto !important;
  }
  .xert-svelte .\@\[40rem\]\:self-start {
    align-self: flex-start !important;
  }
  .xert-svelte .\@\[40rem\]\:pl-4 {
    padding-left: 1rem !important;
  }
  .xert-svelte .\@\[40rem\]\:pt-2\.5 {
    padding-top: 0.625rem !important;
  }
}
@container (min-width: 48rem) {
  .xert-svelte .\@3xl\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}
@container (min-width: 56rem) {
  .xert-svelte .\@4xl\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .xert-svelte .\@4xl\:col-start-2 {
    grid-column-start: 2 !important;
  }
  .xert-svelte .\@4xl\:col-start-3 {
    grid-column-start: 3 !important;
  }
  .xert-svelte .\@4xl\:row-span-2 {
    grid-row: span 2 / span 2 !important;
  }
  .xert-svelte .\@4xl\:row-span-3 {
    grid-row: span 3 / span 3 !important;
  }
  .xert-svelte .\@4xl\:row-start-1 {
    grid-row-start: 1 !important;
  }
  .xert-svelte .\@4xl\:grid-cols-\[200px\,2fr\,1fr\] {
    grid-template-columns: 200px 2fr 1fr !important;
  }
  .xert-svelte .\@4xl\:grid-rows-\[auto\,1fr\,auto\] {
    grid-template-rows: auto 1fr auto !important;
  }
}
@container (min-width: 100px) {
  .xert-svelte .\@\[100px\]\:flex {
    display: flex !important;
  }
}
@container (min-width: 130px) {
  .xert-svelte .\@\[130px\]\:flex {
    display: flex !important;
  }
}
@container (min-width: 640px) {
  .xert-svelte .\@\[640px\]\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
@media not all and (min-width: 640px) {
  .xert-svelte .max-sm\:w-full {
    width: 100% !important;
  }
}
@media (min-width: 640px) {
  .xert-svelte .sm\:sticky {
    position: sticky !important;
  }
  .xert-svelte .sm\:top-0 {
    top: 0px !important;
  }
  .xert-svelte .sm\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .xert-svelte .sm\:col-start-1 {
    grid-column-start: 1 !important;
  }
  .xert-svelte .sm\:col-start-3 {
    grid-column-start: 3 !important;
  }
  .xert-svelte .sm\:col-start-4 {
    grid-column-start: 4 !important;
  }
  .xert-svelte .sm\:row-start-1 {
    grid-row-start: 1 !important;
  }
  .xert-svelte .sm\:mx-5 {
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
  }
  .xert-svelte .sm\:mx-6 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
  .xert-svelte .sm\:mr-2 {
    margin-right: 0.5rem !important;
  }
  .xert-svelte .sm\:mt-0 {
    margin-top: 0px !important;
  }
  .xert-svelte .sm\:block {
    display: block !important;
  }
  .xert-svelte .sm\:inline {
    display: inline !important;
  }
  .xert-svelte .sm\:table-cell {
    display: table-cell !important;
  }
  .xert-svelte .sm\:grid {
    display: grid !important;
  }
  .xert-svelte .sm\:hidden {
    display: none !important;
  }
  .xert-svelte .sm\:h-12 {
    height: 3rem !important;
  }
  .xert-svelte .sm\:h-32 {
    height: 8rem !important;
  }
  .xert-svelte .sm\:h-\[300px\] {
    height: 300px !important;
  }
  .xert-svelte .sm\:w-\[260px\] {
    width: 260px !important;
  }
  .xert-svelte .sm\:min-w-\[170px\] {
    min-width: 170px !important;
  }
  .xert-svelte .sm\:min-w-\[180px\] {
    min-width: 180px !important;
  }
  .xert-svelte .sm\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .xert-svelte .sm\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .xert-svelte .sm\:grid-cols-\[1fr\,2rem\,1fr\] {
    grid-template-columns: 1fr 2rem 1fr !important;
  }
  .xert-svelte .sm\:grid-cols-\[auto\,1fr\,auto\,auto\] {
    grid-template-columns: auto 1fr auto auto !important;
  }
  .xert-svelte .sm\:grid-cols-\[min-content\,1fr\,min-content\,1fr\] {
    grid-template-columns: min-content 1fr min-content 1fr !important;
  }
  .xert-svelte .sm\:grid-cols-\[minmax\(0\,300px\)\,minmax\(0\,1fr\)\] {
    grid-template-columns: minmax(0, 300px) minmax(0, 1fr) !important;
  }
  .xert-svelte .sm\:flex-row {
    flex-direction: row !important;
  }
  .xert-svelte .sm\:flex-row-reverse {
    flex-direction: row-reverse !important;
  }
  .xert-svelte .sm\:flex-wrap {
    flex-wrap: wrap !important;
  }
  .xert-svelte .sm\:items-start {
    align-items: flex-start !important;
  }
  .xert-svelte .sm\:items-end {
    align-items: flex-end !important;
  }
  .xert-svelte .sm\:items-center {
    align-items: center !important;
  }
  .xert-svelte .sm\:justify-start {
    justify-content: flex-start !important;
  }
  .xert-svelte .sm\:justify-end {
    justify-content: flex-end !important;
  }
  .xert-svelte .sm\:justify-between {
    justify-content: space-between !important;
  }
  .xert-svelte .sm\:gap-1\.5 {
    gap: 0.375rem !important;
  }
  .xert-svelte .sm\:gap-2 {
    gap: 0.5rem !important;
  }
  .xert-svelte .sm\:gap-3 {
    gap: 0.75rem !important;
  }
  .xert-svelte .sm\:gap-4 {
    gap: 1rem !important;
  }
  .xert-svelte .sm\:gap-6 {
    gap: 1.5rem !important;
  }
  .xert-svelte .sm\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
  }
  .xert-svelte .sm\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
  }
  .xert-svelte .sm\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
  }
  .xert-svelte .sm\:self-auto {
    align-self: auto !important;
  }
  .xert-svelte .sm\:self-start {
    align-self: flex-start !important;
  }
  .xert-svelte .sm\:rounded-lg {
    border-radius: var(--radius) !important;
  }
  .xert-svelte .sm\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem !important;
    border-bottom-left-radius: 0.75rem !important;
  }
  .xert-svelte .sm\:p-6 {
    padding: 1.5rem !important;
  }
  .xert-svelte .sm\:px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .xert-svelte .sm\:px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }
  .xert-svelte .sm\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  .xert-svelte .sm\:px-8 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .xert-svelte .sm\:py-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .xert-svelte .sm\:py-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .xert-svelte .sm\:pb-10 {
    padding-bottom: 2.5rem !important;
  }
  .xert-svelte .sm\:text-left {
    text-align: left !important;
  }
  .xert-svelte .sm\:text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
  .xert-svelte .sm\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }
  .xert-svelte .sm\:text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }
}
@media (min-width: 768px) {
  .xert-svelte .md\:bottom-2 {
    bottom: 0.5rem !important;
  }
  .xert-svelte .md\:left-6 {
    left: 1.5rem !important;
  }
  .xert-svelte .md\:right-2 {
    right: 0.5rem !important;
  }
  .xert-svelte .md\:top-2 {
    top: 0.5rem !important;
  }
  .xert-svelte .md\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .xert-svelte .md\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }
  .xert-svelte .md\:col-start-2 {
    grid-column-start: 2 !important;
  }
  .xert-svelte .md\:col-start-3 {
    grid-column-start: 3 !important;
  }
  .xert-svelte .md\:row-start-1 {
    grid-row-start: 1 !important;
  }
  .xert-svelte .md\:row-start-2 {
    grid-row-start: 2 !important;
  }
  .xert-svelte .md\:row-start-3 {
    grid-row-start: 3 !important;
  }
  .xert-svelte .md\:row-start-4 {
    grid-row-start: 4 !important;
  }
  .xert-svelte .md\:row-start-5 {
    grid-row-start: 5 !important;
  }
  .xert-svelte .md\:ml-8 {
    margin-left: 2rem !important;
  }
  .xert-svelte .md\:block {
    display: block !important;
  }
  .xert-svelte .md\:flex {
    display: flex !important;
  }
  .xert-svelte .md\:table-cell {
    display: table-cell !important;
  }
  .xert-svelte .md\:grid {
    display: grid !important;
  }
  .xert-svelte .md\:hidden {
    display: none !important;
  }
  .xert-svelte .md\:h-\[360px\] {
    height: 360px !important;
  }
  .xert-svelte .md\:h-\[400px\] {
    height: 400px !important;
  }
  .xert-svelte .md\:h-\[600px\] {
    height: 600px !important;
  }
  .xert-svelte .md\:h-\[660px\] {
    height: 660px !important;
  }
  .xert-svelte .md\:h-auto {
    height: auto !important;
  }
  .xert-svelte .md\:w-1\/2 {
    width: 50% !important;
  }
  .xert-svelte .md\:w-\[340px\] {
    width: 340px !important;
  }
  .xert-svelte .md\:w-\[95vw\] {
    width: 95vw !important;
  }
  .xert-svelte .md\:w-full {
    width: 100% !important;
  }
  .xert-svelte .md\:w-px {
    width: 1px !important;
  }
  .xert-svelte .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .xert-svelte .md\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .xert-svelte .md\:grid-cols-\[1fr\,auto\,1fr\] {
    grid-template-columns: 1fr auto 1fr !important;
  }
  .xert-svelte .md\:grid-cols-\[1fr_auto\] {
    grid-template-columns: 1fr auto !important;
  }
  .xert-svelte .md\:grid-cols-\[2fr\,min-content\,3fr\] {
    grid-template-columns: 2fr min-content 3fr !important;
  }
  .xert-svelte .md\:flex-row {
    flex-direction: row !important;
  }
  .xert-svelte .md\:items-end {
    align-items: flex-end !important;
  }
  .xert-svelte .md\:items-center {
    align-items: center !important;
  }
  .xert-svelte .md\:justify-between {
    justify-content: space-between !important;
  }
  .xert-svelte .md\:gap-1 {
    gap: 0.25rem !important;
  }
  .xert-svelte .md\:gap-3 {
    gap: 0.75rem !important;
  }
  .xert-svelte .md\:gap-4 {
    gap: 1rem !important;
  }
  .xert-svelte .md\:gap-x-5 {
    column-gap: 1.25rem !important;
  }
  .xert-svelte .md\:gap-x-6 {
    column-gap: 1.5rem !important;
  }
  .xert-svelte .md\:gap-y-3 {
    row-gap: 0.75rem !important;
  }
  .xert-svelte .md\:justify-self-auto {
    justify-self: auto !important;
  }
  .xert-svelte .md\:overflow-x-auto {
    overflow-x: auto !important;
  }
  .xert-svelte .md\:overflow-y-hidden {
    overflow-y: hidden !important;
  }
  .xert-svelte .md\:whitespace-nowrap {
    white-space: nowrap !important;
  }
  .xert-svelte .md\:border-r {
    border-right-width: 1px !important;
  }
  .xert-svelte .md\:p-4 {
    padding: 1rem !important;
  }
  .xert-svelte .md\:px-10 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }
  .xert-svelte .md\:px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .xert-svelte .md\:px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }
  .xert-svelte .md\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  .xert-svelte .md\:px-8 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .xert-svelte .md\:py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .xert-svelte .md\:py-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .xert-svelte .md\:py-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .xert-svelte .md\:pb-0 {
    padding-bottom: 0px !important;
  }
  .xert-svelte .md\:pb-4 {
    padding-bottom: 1rem !important;
  }
  .xert-svelte .md\:pb-8 {
    padding-bottom: 2rem !important;
  }
  .xert-svelte .md\:pl-4 {
    padding-left: 1rem !important;
  }
  .xert-svelte .md\:pr-4 {
    padding-right: 1rem !important;
  }
  .xert-svelte .md\:pt-6 {
    padding-top: 1.5rem !important;
  }
  .xert-svelte .md\:pt-8 {
    padding-top: 2rem !important;
  }
  .xert-svelte .md\:text-left {
    text-align: left !important;
  }
  .xert-svelte .md\:text-right {
    text-align: right !important;
  }
  .xert-svelte .md\:text-3xl {
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
  }
  .xert-svelte .md\:text-4xl {
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }
  .xert-svelte .md\:text-6xl {
    font-size: 3.75rem !important;
    line-height: 1 !important;
  }
  .xert-svelte .md\:text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }
  .xert-svelte .md\:text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }
}
@media (min-width: 1024px) {
  .xert-svelte .lg\:sticky {
    position: sticky !important;
  }
  .xert-svelte .lg\:top-2 {
    top: 0.5rem !important;
  }
  .xert-svelte .lg\:top-4 {
    top: 1rem !important;
  }
  .xert-svelte .lg\:z-auto {
    z-index: auto !important;
  }
  .xert-svelte .lg\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
  .xert-svelte .lg\:mt-12 {
    margin-top: 3rem !important;
  }
  .xert-svelte .lg\:block {
    display: block !important;
  }
  .xert-svelte .lg\:flex {
    display: flex !important;
  }
  .xert-svelte .lg\:grid {
    display: grid !important;
  }
  .xert-svelte .lg\:hidden {
    display: none !important;
  }
  .xert-svelte .lg\:h-\[97dvh\] {
    height: 97dvh !important;
  }
  .xert-svelte .lg\:min-h-\[36px\] {
    min-height: 36px !important;
  }
  .xert-svelte .lg\:min-h-\[850px\] {
    min-height: 850px !important;
  }
  .xert-svelte .lg\:min-h-\[min\(640px\,70vh\)\] {
    min-height: min(640px, 70vh) !important;
  }
  .xert-svelte .lg\:w-\[340px\] {
    width: 340px !important;
  }
  .xert-svelte .lg\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .xert-svelte .lg\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .xert-svelte .lg\:grid-cols-\[350px\,1fr\] {
    grid-template-columns: 350px 1fr !important;
  }
  .xert-svelte .lg\:grid-cols-\[minmax\(0\,1\.15fr\)\,minmax\(0\,1fr\)\] {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr) !important;
  }
  .xert-svelte .lg\:flex-row {
    flex-direction: row !important;
  }
  .xert-svelte .lg\:items-end {
    align-items: flex-end !important;
  }
  .xert-svelte .lg\:justify-between {
    justify-content: space-between !important;
  }
  .xert-svelte .lg\:gap-8 {
    gap: 2rem !important;
  }
  .xert-svelte .lg\:self-start {
    align-self: flex-start !important;
  }
  .xert-svelte .lg\:px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .xert-svelte .lg\:px-10 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }
  .xert-svelte .lg\:px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .xert-svelte .lg\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  .xert-svelte .lg\:py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .xert-svelte .lg\:pb-12 {
    padding-bottom: 3rem !important;
  }
  .xert-svelte .lg\:pb-3 {
    padding-bottom: 0.75rem !important;
  }
  .xert-svelte .lg\:pb-4 {
    padding-bottom: 1rem !important;
  }
  .xert-svelte .lg\:pl-0 {
    padding-left: 0px !important;
  }
  .xert-svelte .lg\:text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }
  .xert-svelte .lg\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
}
@media (min-width: 1280px) {
  .xert-svelte .xl\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .xert-svelte .xl\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
  .xert-svelte .xl\:col-start-1 {
    grid-column-start: 1 !important;
  }
  .xert-svelte .xl\:col-start-5 {
    grid-column-start: 5 !important;
  }
  .xert-svelte .xl\:row-start-1 {
    grid-row-start: 1 !important;
  }
  .xert-svelte .xl\:row-start-2 {
    grid-row-start: 2 !important;
  }
  .xert-svelte .xl\:row-start-3 {
    grid-row-start: 3 !important;
  }
  .xert-svelte .xl\:float-right {
    float: right !important;
  }
  .xert-svelte .xl\:mb-2 {
    margin-bottom: 0.5rem !important;
  }
  .xert-svelte .xl\:ml-4 {
    margin-left: 1rem !important;
  }
  .xert-svelte .xl\:mr-0 {
    margin-right: 0px !important;
  }
  .xert-svelte .xl\:block {
    display: block !important;
  }
  .xert-svelte .xl\:grid {
    display: grid !important;
  }
  .xert-svelte .xl\:hidden {
    display: none !important;
  }
  .xert-svelte .xl\:h-auto {
    height: auto !important;
  }
  .xert-svelte .xl\:w-32 {
    width: 8rem !important;
  }
  .xert-svelte .xl\:w-60 {
    width: 15rem !important;
  }
  .xert-svelte .xl\:w-px {
    width: 1px !important;
  }
  .xert-svelte .xl\:grid-flow-row {
    grid-auto-flow: row !important;
  }
  .xert-svelte .xl\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .xert-svelte .xl\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .xert-svelte .xl\:grid-cols-\[1fr\,min-content\,3fr\] {
    grid-template-columns: 1fr min-content 3fr !important;
  }
  .xert-svelte .xl\:grid-cols-\[3fr\,min-content\,5fr\,min-content\,2fr\] {
    grid-template-columns: 3fr min-content 5fr min-content 2fr !important;
  }
  .xert-svelte .xl\:grid-cols-\[min-content\,auto\] {
    grid-template-columns: min-content auto !important;
  }
  .xert-svelte .xl\:grid-cols-\[minmax\(320px\,1fr\)_minmax\(0\,max-content\)\] {
    grid-template-columns: minmax(320px, 1fr) minmax(0, max-content) !important;
  }
  .xert-svelte .xl\:justify-items-center {
    justify-items: center !important;
  }
  .xert-svelte .xl\:gap-8 {
    gap: 2rem !important;
  }
  .xert-svelte .xl\:justify-self-stretch {
    justify-self: stretch !important;
  }
  .xert-svelte .xl\:text-center {
    text-align: center !important;
  }
  .xert-svelte .xl\:text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
  .xert-svelte .xl\:text-4xl {
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }
  .xert-svelte .xl\:text-5xl {
    font-size: 3rem !important;
    line-height: 1 !important;
  }
  .xert-svelte .xl\:text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }
  .xert-svelte .xl\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
  .xert-svelte .xl\:\!\[grid-template-columns\:subgrid\] {
    grid-template-columns: subgrid !important;
  }
  .xert-svelte .xl\:\[grid-template-columns\:subgrid\] {
    grid-template-columns: subgrid !important;
  }
}
@media (min-width: 1536px) {
  .xert-svelte .\32xl\:w-36 {
    width: 9rem !important;
  }
  .xert-svelte .\32xl\:w-72 {
    width: 18rem !important;
  }
  .xert-svelte .\32xl\:w-\[80\%\] {
    width: 80% !important;
  }
  .xert-svelte .\32xl\:gap-12 {
    gap: 3rem !important;
  }
  .xert-svelte .\32xl\:text-3xl {
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
  }
  .xert-svelte .\32xl\:text-5xl {
    font-size: 3rem !important;
    line-height: 1 !important;
  }
  .xert-svelte .\32xl\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
}
@media (prefers-color-scheme: dark) {
  .xert-svelte .dark\:text-gray-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
  }
}
@media print {
  .xert-svelte .print\:hidden {
    display: none !important;
  }
  .xert-svelte .print\:border {
    border-width: 1px !important;
  }
  .xert-svelte .print\:bg-none {
    background-image: none !important;
  }
  .xert-svelte .print\:text-black {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
  }
}
.xert-svelte .\[\&\:\:-webkit-inner-spin-button\]\:appearance-none::-webkit-inner-spin-button {
  appearance: none !important;
}
.xert-svelte .\[\&\:\:-webkit-outer-spin-button\]\:appearance-none::-webkit-outer-spin-button {
  appearance: none !important;
}
.xert-svelte .\[\&\:\:-webkit-scrollbar\]\:hidden::-webkit-scrollbar {
  display: none !important;
}
.xert-svelte .\[\&\:has\(\[data-selected\]\)\]\:rounded-md:has([data-selected]) {
  border-radius: calc(var(--radius) - 2px) !important;
}
.xert-svelte .\[\&\:has\(\[data-selected\]\)\]\:bg-accent:has([data-selected]) {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .\[\&\:has\(\[data-selected\]\[data-outside-month\]\)\]\:bg-accent\/50:has([data-selected][data-outside-month]) {
  background-color: hsl(var(--accent) / 0.5) !important;
}
.xert-svelte .\[\&\:has\(\[role\=checkbox\]\)\]\:pr-0:has([role=checkbox]) {
  padding-right: 0px !important;
}
.xert-svelte .\[\&\:has\(button\:disabled\)\]\:pointer-events-none:has(button:disabled) {
  pointer-events: none !important;
}
.xert-svelte .\[\&\:has\(button\:disabled\)\]\:opacity-50:has(button:disabled) {
  opacity: 0.5 !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:rounded-b-none:has(button[data-state=checked]) {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:border-b-0:has(button[data-state=checked]) {
  border-bottom-width: 0px !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:border-primary:has(button[data-state=checked]) {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1)) !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:bg-accent:has(button[data-state=checked]) {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:bg-primary:has(button[data-state=checked]) {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:text-accent-foreground:has(button[data-state=checked]) {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:text-primary-foreground:has(button[data-state=checked]) {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:delay-0:has(button[data-state=checked]) {
  transition-delay: 0s !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'checked\'\]\)\]\:duration-0:has(button[data-state=checked]) {
  transition-duration: 0s !important;
}
.xert-svelte .\[\&\:has\(button\[data-state\=\'unchecked\'\]\)\]\:opacity-50:has(button[data-state=unchecked]) {
  opacity: 0.5 !important;
}
.xert-svelte .\[\&\:not\(\:has\(button\[data-state\=\'checked\'\]\)\)\]\:bg-muted:not(:has(button[data-state=checked])) {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .\[\&\>\[role\=checkbox\]\]\:translate-y-\[2px\] > [role=checkbox] {
  --tw-translate-y: 2px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .\[\&\>span\]\:line-clamp-1 > span {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 1 !important;
}
.xert-svelte .data-\[placeholder\]\:\[\&\>span\]\:text-muted-foreground > span[data-placeholder] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&\[data-direction\=vertical\]\>div\]\:rotate-90[data-direction=vertical] > div {
  --tw-rotate: 90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.xert-svelte .\[\&\[data-outside-month\]\[data-selected\]\]\:bg-accent\/50[data-outside-month][data-selected] {
  background-color: hsl(var(--accent) / 0.5) !important;
}
.xert-svelte .\[\&\[data-outside-month\]\[data-selected\]\]\:text-muted-foreground[data-outside-month][data-selected] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&\[data-outside-month\]\[data-selected\]\]\:opacity-30[data-outside-month][data-selected] {
  opacity: 0.3 !important;
}
.xert-svelte .\[\&\[data-today\]\:not\(\[data-selected\]\)\]\:bg-accent[data-today]:not([data-selected]) {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1)) !important;
}
.xert-svelte .\[\&\[data-today\]\:not\(\[data-selected\]\)\]\:text-accent-foreground[data-today]:not([data-selected]) {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&_a\:hover\]\:underline a:hover {
  text-decoration-line: underline !important;
}
.xert-svelte .\[\&_a\]\:text-primary a {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--primary) / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&_a\]\:underline-offset-2 a {
  text-underline-offset: 2px !important;
}
.xert-svelte .\[\&_button\[data-dialog-close\]\]\:z-20 button[data-dialog-close] {
  z-index: 20 !important;
}
.xert-svelte .\[\&_button\[data-dialog-close\]\]\:opacity-100 button[data-dialog-close] {
  opacity: 1 !important;
}
.xert-svelte .\[\&_img\]\:max-w-none img {
  max-width: none !important;
}
.xert-svelte .\[\&_svg\[aria-label\=\'cross_2\,\'\]\]\:text-white svg[aria-label="cross 2,"] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.xert-svelte .\[\&_tr\:last-child\]\:border-0 tr:last-child {
  border-width: 0px !important;
}
.xert-svelte .\[\&_tr\]\:border-b tr {
  border-bottom-width: 1px !important;
}
@media (hover:none) {
  .xert-svelte .\[\@media\(hover\:none\)\]\:flex {
    display: flex !important;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/AchievementCard.esbuild-svelte-fake-css */
.animated-title.svelte-1yrddk {
  transition: transform 1200ms ease, height 1200ms ease;
}
.img-pop-in.svelte-1yrddk {
  transform-origin: center center;
  animation: svelte-1yrddk-img-pop-in-key 500ms ease-out both;
}
@keyframes svelte-1yrddk-img-pop-in-key {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.start-hidden.svelte-1yrddk {
  opacity: 0;
}
.slide-in-right.svelte-1yrddk {
  animation: svelte-1yrddk-slide-in-right-key 420ms ease-out both;
}
.slide-in-left.svelte-1yrddk {
  animation: svelte-1yrddk-slide-in-left-key 420ms ease-out both;
}
.slide-in-bottom.svelte-1yrddk {
  animation: svelte-1yrddk-slide-in-bottom-key 420ms ease-out both;
}
.slide-in-top.svelte-1yrddk {
  animation: svelte-1yrddk-slide-in-top-key 420ms ease-out both;
}
.anim-delay-200.svelte-1yrddk {
  animation-delay: 200ms;
}
.anim-delay-400.svelte-1yrddk {
  animation-delay: 400ms;
}
.anim-delay-600.svelte-1yrddk {
  animation-delay: 600ms;
}
.anim-delay-1000.svelte-1yrddk {
  animation-delay: 1000ms;
}
.anim-delay-1200.svelte-1yrddk {
  animation-delay: 1200ms;
}
@keyframes svelte-1yrddk-slide-in-right-key {
  0% {
    transform: translateX(24px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes svelte-1yrddk-slide-in-left-key {
  0% {
    transform: translateX(-24px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes svelte-1yrddk-slide-in-bottom-key {
  0% {
    transform: translateY(24px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes svelte-1yrddk-slide-in-top-key {
  0% {
    transform: translateY(-24px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/FactCard.esbuild-svelte-fake-css */
.animated-title.svelte-ban8vk {
  transition: transform 1200ms ease, height 1200ms ease;
}
.img-pop-in.svelte-ban8vk {
  transform-origin: center center;
  animation: svelte-ban8vk-img-pop-in-key 500ms ease-out both;
}
@keyframes svelte-ban8vk-img-pop-in-key {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.start-hidden.svelte-ban8vk {
  opacity: 0;
}
.slide-in-right.svelte-ban8vk {
  animation: svelte-ban8vk-slide-in-right-key 420ms ease-out both;
}
.slide-in-left.svelte-ban8vk {
  animation: svelte-ban8vk-slide-in-left-key 420ms ease-out both;
}
.slide-in-bottom.svelte-ban8vk {
  animation: svelte-ban8vk-slide-in-bottom-key 420ms ease-out both;
}
.slide-in-top.svelte-ban8vk {
  animation: svelte-ban8vk-slide-in-top-key 420ms ease-out both;
}
.anim-delay-200.svelte-ban8vk {
  animation-delay: 200ms;
}
.anim-delay-400.svelte-ban8vk {
  animation-delay: 400ms;
}
.anim-delay-600.svelte-ban8vk {
  animation-delay: 600ms;
}
.anim-delay-1300.svelte-ban8vk {
  animation-delay: 1300ms;
}
.anim-delay-1500.svelte-ban8vk {
  animation-delay: 1500ms;
}
@keyframes svelte-ban8vk-slide-in-right-key {
  0% {
    transform: translateX(24px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes svelte-ban8vk-slide-in-left-key {
  0% {
    transform: translateX(-24px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes svelte-ban8vk-slide-in-bottom-key {
  0% {
    transform: translateY(24px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes svelte-ban8vk-slide-in-top-key {
  0% {
    transform: translateY(-24px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TotalsActivityCard.esbuild-svelte-fake-css */
.activity-card-shell.svelte-8yxnhp.svelte-8yxnhp {
  background:
    linear-gradient(
      5deg,
      rgba(18, 20, 22, 1) 60%,
      rgba(40, 44, 48, 0.18) 85%,
      rgba(94, 230, 232, 0.10) 100%);
}
.activity-card-inner.svelte-8yxnhp.svelte-8yxnhp {
  background:
    radial-gradient(
      circle at 20% 15%,
      rgba(255, 255, 255, 0.06),
      transparent 40%),
    radial-gradient(
      circle at 80% 90%,
      rgba(255, 255, 255, 0.04),
      transparent 40%),
    linear-gradient(
      180deg,
      rgba(18, 20, 22, 0.95),
      rgba(8, 9, 10, 0.98));
  border-radius: 1rem;
}
.activity-wheel.svelte-8yxnhp.svelte-8yxnhp {
  position: relative;
  width: 160px;
  height: 160px;
  opacity: 0;
}
.wheel-pop.svelte-8yxnhp.svelte-8yxnhp {
  animation: svelte-8yxnhp-wheel-pop 520ms ease-out both;
}
.arc-svg.svelte-8yxnhp.svelte-8yxnhp {
  position: absolute;
  inset: 0;
  transform: rotate(-90deg);
}
.arc-base.svelte-8yxnhp.svelte-8yxnhp {
  fill: none;
  stroke: rgba(255, 255, 255, 0.08);
  stroke-width: 12;
}
.arc-indoor.svelte-8yxnhp.svelte-8yxnhp {
  fill: none;
  stroke: #ff4dcd;
  stroke-width: 12;
  transition: stroke-dashoffset 600ms ease-out;
}
.arc-outdoor.svelte-8yxnhp.svelte-8yxnhp {
  fill: none;
  stroke: #7cff4d;
  stroke-width: 12;
  transition: stroke-dashoffset 600ms ease-out;
}
.wheel-center.svelte-8yxnhp.svelte-8yxnhp {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.wheel-center.svelte-8yxnhp .count.svelte-8yxnhp {
  font-size: 1.8rem;
  font-weight: 800;
}
.wheel-center.svelte-8yxnhp .label.svelte-8yxnhp {
  font-size: 0.8rem;
  opacity: 0.8;
}
.micro-legend.svelte-8yxnhp.svelte-8yxnhp {
  display: flex;
  gap: 12px;
  align-items: center;
  opacity: 0;
  transform: translateY(8px);
}
.legend-in.svelte-8yxnhp.svelte-8yxnhp {
  animation: svelte-8yxnhp-legend-in 420ms 360ms ease-out forwards;
}
.legend-item.svelte-8yxnhp.svelte-8yxnhp {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
}
.dot.svelte-8yxnhp.svelte-8yxnhp {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-block;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.12);
}
.dot.indoor.svelte-8yxnhp.svelte-8yxnhp {
  background: #ff4dcd;
}
.dot.outdoor.svelte-8yxnhp.svelte-8yxnhp {
  background: #7cff4d;
}
.stat-chip.svelte-8yxnhp.svelte-8yxnhp {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.05);
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
  transform: translateX(-12px);
}
.stat-chip.svelte-8yxnhp i.svelte-8yxnhp {
  color: #cfd8dc;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.08);
}
.stat-chip.svelte-8yxnhp .text.svelte-8yxnhp {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.stat-chip.svelte-8yxnhp .value.svelte-8yxnhp {
  font-size: 1.4rem;
  font-weight: 800;
}
.stat-chip.svelte-8yxnhp .label.svelte-8yxnhp {
  font-size: 0.9rem;
  opacity: 0.85;
}
.mini.svelte-8yxnhp.svelte-8yxnhp {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.05);
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
  transform: translateY(12px);
}
.mini.svelte-8yxnhp i.svelte-8yxnhp {
  color: #cfd8dc;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.08);
}
.mini.svelte-8yxnhp .metric .value.svelte-8yxnhp {
  font-size: 1.25rem;
  font-weight: 700;
}
.mini.svelte-8yxnhp .metric .label.svelte-8yxnhp {
  font-size: 0.8rem;
  opacity: 0.8;
}
.cta.svelte-8yxnhp.svelte-8yxnhp {
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.05);
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  transform: translateY(12px);
}
.cta.svelte-8yxnhp .left.svelte-8yxnhp {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cta.svelte-8yxnhp .right.svelte-8yxnhp {
  font-size: 1.6rem;
  font-weight: 800;
}
.chip-in-1.svelte-8yxnhp.svelte-8yxnhp {
  animation: svelte-8yxnhp-chip-left 420ms 120ms ease-out forwards;
}
.chip-in-2.svelte-8yxnhp.svelte-8yxnhp {
  animation: svelte-8yxnhp-chip-up 420ms 200ms ease-out forwards;
}
.chip-in-3.svelte-8yxnhp.svelte-8yxnhp {
  animation: svelte-8yxnhp-chip-up 420ms 280ms ease-out forwards;
}
.cta-bounce.svelte-8yxnhp.svelte-8yxnhp {
  animation: svelte-8yxnhp-cta-rise 480ms 360ms ease-out forwards;
}
@keyframes svelte-8yxnhp-wheel-pop {
  0% {
    opacity: 0;
    transform: scale(0.92) rotate(-6deg);
  }
  70% {
    opacity: 1;
    transform: scale(1.02) rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}
@keyframes svelte-8yxnhp-legend-in {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes svelte-8yxnhp-chip-left {
  0% {
    opacity: 0;
    transform: translateX(-12px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes svelte-8yxnhp-chip-up {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes svelte-8yxnhp-cta-rise {
  0% {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  60% {
    opacity: 1;
    transform: translateY(-2px) scale(1.01);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TotalsTrainingCard.esbuild-svelte-fake-css */
.training-card-shell.svelte-75bd2a.svelte-75bd2a {
  background:
    linear-gradient(
      5deg,
      rgba(18, 20, 22, 1) 60%,
      rgba(40, 44, 48, 0.18) 85%,
      rgba(58, 134, 255, 0.10) 100%);
}
.training-card-inner.svelte-75bd2a.svelte-75bd2a {
  background:
    radial-gradient(
      circle at 24% 18%,
      rgba(255, 255, 255, 0.06),
      transparent 40%),
    radial-gradient(
      circle at 76% 88%,
      rgba(255, 255, 255, 0.04),
      transparent 40%),
    linear-gradient(
      180deg,
      rgba(18, 20, 22, 0.95),
      rgba(8, 9, 10, 0.98));
  border-radius: 1rem;
}
.ribbon.svelte-75bd2a.svelte-75bd2a {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.06),
      rgba(255, 255, 255, 0.03));
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.24), inset 0 0 8px rgba(255, 255, 255, 0.03);
  opacity: 0;
  transform: translateX(-14px) skewX(-3deg);
}
.icon-bubble.svelte-75bd2a.svelte-75bd2a {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: rgba(58, 134, 255, 0.12);
  border: 1px solid rgba(58, 134, 255, 0.25);
}
.icon-bubble.svelte-75bd2a i.svelte-75bd2a {
  color: #cfd8dc;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.08);
}
.ribbon-text.svelte-75bd2a .value.svelte-75bd2a {
  font-size: 1.15rem;
  font-weight: 800;
}
.ribbon-text.svelte-75bd2a .label.svelte-75bd2a {
  font-size: 0.85rem;
  opacity: 0.85;
}
.ribbon-in-1.svelte-75bd2a.svelte-75bd2a {
  animation: svelte-75bd2a-ribbon-in 420ms 80ms ease-out forwards;
}
.ribbon-in-2.svelte-75bd2a.svelte-75bd2a {
  animation: svelte-75bd2a-ribbon-in 420ms 160ms ease-out forwards;
}
.ribbon-in-3.svelte-75bd2a.svelte-75bd2a {
  animation: svelte-75bd2a-ribbon-in 420ms 240ms ease-out forwards;
}
.ribbon-in-4.svelte-75bd2a.svelte-75bd2a {
  animation: svelte-75bd2a-ribbon-in 420ms 320ms ease-out forwards;
}
@keyframes svelte-75bd2a-ribbon-in {
  0% {
    opacity: 0;
    transform: translateX(-14px) skewX(-3deg) scale(0.98);
  }
  70% {
    opacity: 1;
    transform: translateX(2px) skewX(0deg) scale(1.01);
  }
  100% {
    opacity: 1;
    transform: translateX(0) skewX(0deg) scale(1);
  }
}
.profile-strip.svelte-75bd2a.svelte-75bd2a {
  position: relative;
  height: 24px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  opacity: 0;
  transform: translateY(10px);
}
.profile-shape.svelte-75bd2a.svelte-75bd2a {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      180deg,
      rgba(58, 134, 255, 0.14),
      rgba(58, 134, 255, 0.06)),
    radial-gradient(
      120px 56px at 10% 100%,
      rgba(255, 255, 255, 0.06),
      transparent 60%),
    radial-gradient(
      160px 80px at 38% 100%,
      rgba(255, 255, 255, 0.06),
      transparent 60%),
    radial-gradient(
      200px 96px at 64% 100%,
      rgba(255, 255, 255, 0.06),
      transparent 60%),
    radial-gradient(
      180px 72px at 88% 100%,
      rgba(255, 255, 255, 0.06),
      transparent 60%);
  background-repeat: no-repeat;
  background-position: 0 0;
}
.profile-shimmer.svelte-75bd2a.svelte-75bd2a {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.02) 0%,
      rgba(255, 255, 255, 0.10) 12%,
      rgba(255, 255, 255, 0.02) 24%);
  mix-blend-mode: screen;
  filter: blur(0.6px);
  opacity: 0.0;
}
.profile-in.svelte-75bd2a.svelte-75bd2a {
  animation: svelte-75bd2a-profile-in 460ms 380ms ease-out forwards;
}
@keyframes svelte-75bd2a-profile-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.note.svelte-75bd2a.svelte-75bd2a {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 10px;
  opacity: 0;
  transform: translateY(10px);
}
.note-in.svelte-75bd2a.svelte-75bd2a {
  animation: svelte-75bd2a-note-in 420ms 420ms ease-out forwards;
}
@keyframes svelte-75bd2a-note-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TotalsNutritionCard.esbuild-svelte-fake-css */
.nutrition-card-shell.svelte-72mj4.svelte-72mj4 {
  background:
    linear-gradient(
      5deg,
      rgba(18, 20, 22, 1) 60%,
      rgba(40, 44, 48, 0.18) 85%,
      rgba(255, 209, 102, 0.10) 100%);
}
.nutrition-card-inner.svelte-72mj4.svelte-72mj4 {
  background:
    radial-gradient(
      circle at 80% 10%,
      rgba(255, 255, 255, 0.06),
      transparent 40%),
    radial-gradient(
      circle at 80% 90%,
      rgba(255, 255, 255, 0.04),
      transparent 40%),
    linear-gradient(
      180deg,
      rgba(18, 20, 22, 0.95),
      rgba(8, 9, 10, 0.98));
  border-radius: 1rem;
}
.donut-wrap.svelte-72mj4.svelte-72mj4 {
  position: relative;
  width: 180px;
  height: 180px;
  opacity: 0;
}
.donut-ring.svelte-72mj4.svelte-72mj4 {
  width: 180px;
  height: 180px;
  border-radius: 999px;
}
.donut-center.svelte-72mj4.svelte-72mj4 {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.donut-center.svelte-72mj4 .value.svelte-72mj4 {
  font-size: 1.4rem;
  font-weight: 800;
}
.donut-center.svelte-72mj4 .label.svelte-72mj4 {
  font-size: 0.85rem;
  opacity: 0.85;
}
.donut-pop.svelte-72mj4.svelte-72mj4 {
  animation: svelte-72mj4-donut-pop 520ms ease-out both;
}
@keyframes svelte-72mj4-donut-pop {
  0% {
    opacity: 0;
    transform: scale(0.92) rotate(-6deg);
  }
  70% {
    opacity: 1;
    transform: scale(1.02) rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}
.legend.svelte-72mj4.svelte-72mj4 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  opacity: 0;
  transform: translateY(8px);
}
.legend-in.svelte-72mj4.svelte-72mj4 {
  animation: svelte-72mj4-legend-in 420ms 360ms ease-out forwards;
}
.legend-item.svelte-72mj4.svelte-72mj4 {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 0.9rem;
}
.dot.svelte-72mj4.svelte-72mj4 {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.12);
}
.dot.carbs.svelte-72mj4.svelte-72mj4 {
  background: #03d5e7;
}
.dot.fat.svelte-72mj4.svelte-72mj4 {
  background: #fea2c5;
}
.sep.svelte-72mj4.svelte-72mj4 {
  opacity: 0.5;
}
.grams.svelte-72mj4.svelte-72mj4,
.kcals.svelte-72mj4.svelte-72mj4 {
  font-weight: 700;
}
@keyframes svelte-72mj4-legend-in {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.badge.svelte-72mj4.svelte-72mj4 {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.05);
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
  transform: translateY(12px);
}
.badge.svelte-72mj4 i.svelte-72mj4 {
  color: #cfd8dc;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.08);
}
.badge.svelte-72mj4 .metric .value.svelte-72mj4 {
  font-size: 1.25rem;
  font-weight: 800;
}
.badge.svelte-72mj4 .metric .label.svelte-72mj4 {
  font-size: 0.8rem;
  opacity: 0.8;
}
.badge-in-1.svelte-72mj4.svelte-72mj4 {
  animation: svelte-72mj4-badge-in 420ms 200ms ease-out forwards;
}
.badge-in-2.svelte-72mj4.svelte-72mj4 {
  animation: svelte-72mj4-badge-in 420ms 280ms ease-out forwards;
}
@keyframes svelte-72mj4-badge-in {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.cta.svelte-72mj4.svelte-72mj4 {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 10px;
  opacity: 0;
  transform: translateY(10px);
}
.cta-in.svelte-72mj4.svelte-72mj4 {
  animation: svelte-72mj4-cta-in 420ms 420ms ease-out forwards;
}
@keyframes svelte-72mj4-cta-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/RecordsStrainCard.esbuild-svelte-fake-css */
.marquee-card.svelte-9bmncs.svelte-9bmncs {
  background:
    radial-gradient(
      120% 90% at 50% 0%,
      rgba(10, 14, 24, 0.95),
      rgba(6, 8, 14, 1)),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.02),
      rgba(0, 0, 0, 0.02));
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  color: #e9edf5;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.35), 0 0 30px rgba(94, 230, 232, 0.2);
}
.mobile.marquee-card.svelte-9bmncs.svelte-9bmncs {
  width: 300px;
  max-height: 500px;
}
.desktop.marquee-card.svelte-9bmncs.svelte-9bmncs {
  width: 600px;
  max-height: 1000px;
}
.marquee-card.svelte-9bmncs.svelte-9bmncs::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(
      120% 80% at 50% 100%,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0) 60%),
    repeating-linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.02) 0px,
      rgba(255, 255, 255, 0.02) 2px,
      rgba(0, 0, 0, 0.02) 4px,
      rgba(0, 0, 0, 0.02) 6px);
  mix-blend-mode: soft-light;
}
.marquee-header.svelte-9bmncs.svelte-9bmncs {
  padding: 10px 12px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background:
    linear-gradient(
      180deg,
      rgba(18, 24, 38, 0.9),
      rgba(12, 18, 30, 0.9));
}
.marquee-header.svelte-9bmncs .title.svelte-9bmncs {
  font-weight: 700;
  letter-spacing: 0.4px;
  text-align: center;
  font-size: 14px;
  color: #f4f7fb;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.06);
}
.desktop.svelte-9bmncs .marquee-header.svelte-9bmncs {
  padding: 16px 18px 12px;
}
.desktop.svelte-9bmncs .marquee-header .title.svelte-9bmncs {
  font-size: 20px;
  letter-spacing: 0.6px;
}
.bulbs.svelte-9bmncs.svelte-9bmncs {
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  gap: 4px;
  margin-bottom: 6px;
}
.bulbs.bottom.svelte-9bmncs.svelte-9bmncs {
  margin-top: 6px;
  margin-bottom: 0;
}
.bulb.svelte-9bmncs.svelte-9bmncs {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle at 50% 30%,
      #ffd89b,
      #d6a85d);
  box-shadow: 0 0 6px rgba(255, 216, 155, 0.8);
  opacity: 0.65;
  animation: svelte-9bmncs-twinkle 2.6s ease-in-out infinite;
  animation-delay: var(--d, 0s);
}
.desktop.svelte-9bmncs .bulb.svelte-9bmncs {
  width: 12px;
  height: 12px;
  box-shadow: 0 0 8px rgba(255, 216, 155, 0.9);
}
@keyframes svelte-9bmncs-twinkle {
  0%, 100% {
    opacity: 0.55;
    filter: brightness(0.95);
  }
  50% {
    opacity: 0.9;
    filter: brightness(1.15);
  }
}
.posters.svelte-9bmncs.svelte-9bmncs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 12px;
}
.mobile.svelte-9bmncs .posters.svelte-9bmncs {
  grid-template-columns: 1fr;
}
.desktop.svelte-9bmncs .posters.svelte-9bmncs {
  gap: 14px;
  padding: 18px;
}
.poster.svelte-9bmncs.svelte-9bmncs {
  position: relative;
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.06),
      rgba(255, 255, 255, 0.02));
  border-radius: 10px;
  padding: 10px 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 6px 12px rgba(0, 0, 0, 0.25);
  opacity: 0;
  transform: translateY(12px);
}
.desktop.svelte-9bmncs .poster.svelte-9bmncs {
  padding: 18px 14px 20px;
  border-radius: 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 10px 18px rgba(0, 0, 0, 0.3);
}
.mobile.svelte-9bmncs .poster.svelte-9bmncs {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-auto-rows: auto;
  align-items: center;
}
.mobile.svelte-9bmncs .poster .poster-head.svelte-9bmncs {
  grid-column: 1;
  grid-row: 1;
  margin-bottom: 0;
}
.mobile.svelte-9bmncs .poster .number.svelte-9bmncs {
  grid-column: 2;
  grid-row: 1;
  justify-content: flex-end;
  margin-bottom: 0;
}
.mobile.svelte-9bmncs .poster .underline.svelte-9bmncs {
  grid-column: 1 / -1;
  grid-row: 2;
  margin-top: 6px;
}
.mobile.svelte-9bmncs .poster .subtitle.svelte-9bmncs {
  grid-column: 1 / -1;
  grid-row: 3;
  margin-top: 6px;
}
.poster.svelte-9bmncs.svelte-9bmncs::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(var(--accent-rgb, 255,255,255), 0.2), 0 0 12px rgba(var(--accent-rgb, 255,255,255), 0.15);
  opacity: 0;
}
.revealed.svelte-9bmncs .poster.svelte-9bmncs {
  animation: svelte-9bmncs-slideUp 520ms cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}
.revealed.svelte-9bmncs .poster.total.svelte-9bmncs {
  animation-delay: 60ms;
}
.revealed.svelte-9bmncs .poster.high.svelte-9bmncs {
  animation-delay: 140ms;
}
.revealed.svelte-9bmncs .poster.peak.svelte-9bmncs {
  animation-delay: 220ms;
}
.revealed.svelte-9bmncs .poster.svelte-9bmncs::after {
  animation: svelte-9bmncs-flicker 600ms ease-in-out 1 forwards;
}
.revealed.svelte-9bmncs .poster.total.svelte-9bmncs::after {
  animation-delay: 260ms;
}
.revealed.svelte-9bmncs .poster.high.svelte-9bmncs::after {
  animation-delay: 340ms;
}
.revealed.svelte-9bmncs .poster.peak.svelte-9bmncs::after {
  animation-delay: 420ms;
}
@keyframes svelte-9bmncs-slideUp {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes svelte-9bmncs-flicker {
  0% {
    opacity: 0;
    filter: brightness(1);
  }
  25% {
    opacity: 0.6;
    filter: brightness(1.15) contrast(1.05);
  }
  50% {
    opacity: 0.3;
    filter: brightness(0.95);
  }
  75% {
    opacity: 0.7;
    filter: brightness(1.1);
  }
  100% {
    opacity: 0;
    filter: brightness(1);
  }
}
.poster-head.svelte-9bmncs.svelte-9bmncs {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  margin-bottom: 8px;
  color: rgba(235, 240, 249, 0.92);
}
.desktop.svelte-9bmncs .poster-head.svelte-9bmncs {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}
.number.svelte-9bmncs.svelte-9bmncs {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  font-weight: 800;
  color: #f7fafc;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.05);
  margin-bottom: 6px;
}
.number.svelte-9bmncs .value.svelte-9bmncs {
  font-size: 24px;
  letter-spacing: -0.3px;
}
.number.svelte-9bmncs .unit.svelte-9bmncs {
  font-size: 12px;
  color: rgba(235, 240, 249, 0.8);
}
.desktop.svelte-9bmncs .number .value.svelte-9bmncs {
  font-size: 36px;
  letter-spacing: -0.4px;
}
.desktop.svelte-9bmncs .number .unit.svelte-9bmncs {
  font-size: 16px;
}
.mobile.svelte-9bmncs .number.svelte-9bmncs {
  justify-content: flex-end;
}
.underline.svelte-9bmncs.svelte-9bmncs {
  height: 2px;
  background: rgb(var(--accent-rgb, 200,200,200));
  border-radius: 2px;
  transform: scaleX(0);
  transform-origin: left;
  opacity: 0.85;
}
.desktop.svelte-9bmncs .underline.svelte-9bmncs {
  height: 3px;
}
.revealed.svelte-9bmncs .poster.total .underline.svelte-9bmncs {
  animation: svelte-9bmncs-drawLine 700ms cubicOut 1 forwards 320ms;
}
.revealed.svelte-9bmncs .poster.high .underline.svelte-9bmncs {
  animation: svelte-9bmncs-drawLine 700ms cubicOut 1 forwards 400ms;
}
.revealed.svelte-9bmncs .poster.peak .underline.svelte-9bmncs {
  animation: svelte-9bmncs-drawLine 700ms cubicOut 1 forwards 480ms;
}
@keyframes svelte-9bmncs-drawLine {
  to {
    transform: scaleX(1);
  }
}
.subtitle.svelte-9bmncs.svelte-9bmncs {
  margin-top: 6px;
  font-size: 10px;
  line-height: 1.2;
  color: rgba(235, 240, 249, 0.75);
  text-align: center;
}
.desktop.svelte-9bmncs .subtitle.svelte-9bmncs {
  font-size: 12px;
}
.poster.total.svelte-9bmncs.svelte-9bmncs {
  --accent:#0B5DBC;
  --accent-rgb:11,
    93,
    188;
}
.poster.high.svelte-9bmncs.svelte-9bmncs {
  --accent:#F5A623;
  --accent-rgb:245,
    166,
    35;
}
.poster.peak.svelte-9bmncs.svelte-9bmncs {
  --accent:#FF0000;
  --accent-rgb:255,
    0,
    0;
}
.poster.total.svelte-9bmncs .poster-head.svelte-9bmncs {
  color: rgba(173, 200, 240, 0.95);
}
.poster.high.svelte-9bmncs .poster-head.svelte-9bmncs {
  color: rgba(251, 209, 139, 0.95);
}
.poster.peak.svelte-9bmncs .poster-head.svelte-9bmncs {
  color: rgba(255, 170, 170, 0.95);
}
.poster.total.svelte-9bmncs .value.svelte-9bmncs {
  color: rgb(173, 200, 240);
}
.poster.high.svelte-9bmncs .value.svelte-9bmncs {
  color: rgb(251, 209, 139);
}
.poster.peak.svelte-9bmncs .value.svelte-9bmncs {
  color: rgb(255, 170, 170);
}
.poster.total.svelte-9bmncs .unit.svelte-9bmncs {
  color: rgb(173, 200, 240);
}
.poster.high.svelte-9bmncs .unit.svelte-9bmncs {
  color: rgb(251, 209, 139);
}
.poster.peak.svelte-9bmncs .unit.svelte-9bmncs {
  color: rgb(255, 170, 170);
}
.poster.total.svelte-9bmncs.svelte-9bmncs {
  box-shadow: inset 0 0 0 1px rgba(11, 93, 188, 0.4), 0 6px 12px rgba(11, 93, 188, 0.3);
}
.poster.high.svelte-9bmncs.svelte-9bmncs {
  box-shadow: inset 0 0 0 1px rgba(245, 166, 35, 0.4), 0 6px 12px rgba(245, 166, 35, 0.3);
}
.poster.peak.svelte-9bmncs.svelte-9bmncs {
  box-shadow: inset 0 0 0 1px rgba(255, 0, 0, 0.4), 0 6px 12px rgba(255, 0, 0, 0.3);
}
.footer.svelte-9bmncs.svelte-9bmncs {
  padding: 8px 12px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background:
    linear-gradient(
      180deg,
      rgba(12, 16, 26, 0.9),
      rgba(8, 12, 20, 0.95));
}
.footlights.svelte-9bmncs.svelte-9bmncs {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 6px;
}
.footlight.svelte-9bmncs.svelte-9bmncs {
  height: 6px;
  border-radius: 3px;
  background:
    radial-gradient(
      circle at 50% 50%,
      #b0c6ff,
      #6e85c7);
  box-shadow: 0 0 8px rgba(130, 160, 255, 0.6);
  opacity: 0.45;
  animation: svelte-9bmncs-pulse 2.2s ease-in-out infinite;
  animation-delay: var(--d, 0s);
}
@keyframes svelte-9bmncs-pulse {
  0%, 100% {
    opacity: 0.35;
  }
  50% {
    opacity: 0.7;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/RecordsPowerCard.esbuild-svelte-fake-css */
.power-card-shell.svelte-1kyb08q.svelte-1kyb08q {
  background:
    linear-gradient(
      180deg,
      rgba(12, 14, 16, 0.95),
      rgba(8, 10, 12, 0.98)),
    radial-gradient(
      120% 80% at 0% 0%,
      rgba(var(--accent-rgb), 0.08),
      transparent 60%),
    radial-gradient(
      100% 90% at 100% 100%,
      rgba(155, 93, 229, 0.06),
      transparent 55%),
    repeating-linear-gradient(
      45deg,
      rgba(var(--accent-rgb), 0.05) 0 8px,
      rgba(0, 0, 0, 0) 8px 16px);
  position: relative;
  overflow: hidden;
}
.power-card-inner.svelte-1kyb08q.svelte-1kyb08q {
  background:
    radial-gradient(
      circle at 24% 18%,
      rgba(255, 255, 255, 0.06),
      transparent 40%),
    radial-gradient(
      circle at 76% 88%,
      rgba(255, 255, 255, 0.04),
      transparent 40%),
    linear-gradient(
      180deg,
      rgba(18, 20, 22, 0.94),
      rgba(8, 9, 10, 0.98));
  border-radius: 1rem;
  position: relative;
}
.power-card-inner.svelte-1kyb08q.svelte-1kyb08q::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      80% 50% at 50% 0%,
      rgba(var(--accent-rgb), 0.0),
      rgba(var(--accent-rgb), 0.15) 60%,
      rgba(var(--accent-rgb), 0.0) 90%);
  opacity: 0;
  pointer-events: none;
}
.revealed.svelte-1kyb08q .power-card-inner.svelte-1kyb08q::before {
  animation: svelte-1kyb08q-bgfade 220ms ease-out forwards;
}
@keyframes svelte-1kyb08q-bgfade {
  to {
    opacity: 1;
  }
}
.header.svelte-1kyb08q i.bolt.svelte-1kyb08q {
  color: var(--accent);
  text-shadow: 0 0 22px rgba(var(--accent-rgb), 0.55);
  opacity: 0.9;
}
.revealed.svelte-1kyb08q .header i.bolt.svelte-1kyb08q {
  animation: svelte-1kyb08q-glowPulse 900ms ease-in-out 200ms 1;
}
@keyframes svelte-1kyb08q-glowPulse {
  0% {
    filter: drop-shadow(0 0 0 rgba(var(--accent-rgb), 0));
  }
  50% {
    filter: drop-shadow(0 0 16px rgba(var(--accent-rgb), 0.65));
  }
  100% {
    filter: drop-shadow(0 0 0 rgba(var(--accent-rgb), 0));
  }
}
.dial.svelte-1kyb08q.svelte-1kyb08q {
  position: relative;
  height: 140px;
  display: grid;
  place-items: center;
  opacity: 0;
  transform: scale(0.0);
}
.dial-in.svelte-1kyb08q.svelte-1kyb08q {
  animation: svelte-1kyb08q-dial-in 700ms 200ms ease-out forwards;
}
@keyframes svelte-1kyb08q-dial-in {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  60% {
    opacity: 1;
    transform: scale(1.06);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.dial-svg.svelte-1kyb08q.svelte-1kyb08q {
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.45));
}
.track.svelte-1kyb08q.svelte-1kyb08q {
  fill: none;
  stroke: rgba(255, 255, 255, 0.08);
  stroke-width: 6;
}
.meter.svelte-1kyb08q.svelte-1kyb08q {
  fill: none;
  stroke-linecap: round;
  transition: stroke-dashoffset 900ms cubic-bezier(0.22, 0.72, 0.25, 1);
}
.meter-max.svelte-1kyb08q.svelte-1kyb08q {
  stroke: var(--accent);
  stroke-width: 6;
  filter: drop-shadow(0 0 10px rgba(var(--accent-rgb), 0.35));
}
.meter-ftp.svelte-1kyb08q.svelte-1kyb08q {
  stroke: rgba(255, 255, 255, 0.85);
  stroke-width: 5;
  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.25));
}
.dial-center.svelte-1kyb08q.svelte-1kyb08q {
  position: absolute;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(var(--accent-rgb), 0.35);
  background: rgba(var(--accent-rgb), 0.12);
  box-shadow: 0 0 18px rgba(var(--accent-rgb), 0.22);
}
.dial-center.svelte-1kyb08q i.svelte-1kyb08q {
  color: #cfd8dc;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.08);
}
.eq.svelte-1kyb08q.svelte-1kyb08q {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 6px;
  height: 40px;
  margin-top: -4px;
  opacity: 0;
}
.eq-in.svelte-1kyb08q.svelte-1kyb08q {
  animation: svelte-1kyb08q-eqfade 200ms 200ms ease-out forwards;
}
@keyframes svelte-1kyb08q-eqfade {
  to {
    opacity: 1;
  }
}
.eq.svelte-1kyb08q .bar.svelte-1kyb08q {
  align-self: end;
  width: 100%;
  height: 0;
  border-radius: 3px;
  background:
    linear-gradient(
      180deg,
      rgba(var(--accent-rgb), 0.9),
      rgba(var(--accent-rgb), 0.5));
  box-shadow: 0 0 8px rgba(var(--accent-rgb), 0.35);
}
.revealed.svelte-1kyb08q .eq .bar.svelte-1kyb08q {
  animation: svelte-1kyb08q-bargrow 600ms cubic-bezier(0.22, 0.72, 0.25, 1) forwards;
  animation-delay: calc(200ms + var(--i) * 60ms);
}
@keyframes svelte-1kyb08q-bargrow {
  to {
    height: calc(var(--h) * 100%);
  }
}
.stat-line.svelte-1kyb08q.svelte-1kyb08q {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
  transform: translateY(12px);
}
.stat-line.svelte-1kyb08q i.svelte-1kyb08q {
  color: #cfd8dc;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.08);
}
.stat-line.svelte-1kyb08q .text.svelte-1kyb08q {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.stat-line.svelte-1kyb08q .value.svelte-1kyb08q {
  font-size: 1.3rem;
  font-weight: 800;
}
.stat-line.svelte-1kyb08q .label.svelte-1kyb08q {
  font-size: 0.85rem;
  opacity: 0.85;
}
.stat-line.svelte-1kyb08q.svelte-1kyb08q::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 3px;
  background:
    linear-gradient(
      90deg,
      rgba(var(--accent-rgb), 0.0),
      rgba(var(--accent-rgb), 0.35),
      rgba(var(--accent-rgb), 0.0));
  transform: scaleX(0);
  transform-origin: left;
  filter: blur(0.6px);
}
.stat-line.left.svelte-1kyb08q.svelte-1kyb08q::after {
  left: 0;
  right: 40%;
}
.stat-line.right.svelte-1kyb08q.svelte-1kyb08q::after {
  left: 40%;
  right: 0;
}
.line-in-1.svelte-1kyb08q.svelte-1kyb08q,
.line-in-2.svelte-1kyb08q.svelte-1kyb08q {
  animation: svelte-1kyb08q-stat-in 420ms ease-out forwards;
}
.line-in-1.svelte-1kyb08q.svelte-1kyb08q {
  animation-delay: 450ms;
}
.line-in-2.svelte-1kyb08q.svelte-1kyb08q {
  animation-delay: 600ms;
}
@keyframes svelte-1kyb08q-stat-in {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.line-in-1.svelte-1kyb08q.svelte-1kyb08q::after,
.line-in-2.svelte-1kyb08q.svelte-1kyb08q::after {
  animation: svelte-1kyb08q-underline-in 720ms ease-out forwards;
}
@keyframes svelte-1kyb08q-underline-in {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}
.caption.svelte-1kyb08q.svelte-1kyb08q {
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0;
  transform: translateY(10px);
}
.caption-in.svelte-1kyb08q.svelte-1kyb08q {
  animation: svelte-1kyb08q-caption-in 420ms 950ms ease-out forwards;
}
@keyframes svelte-1kyb08q-caption-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.shimmer.svelte-1kyb08q.svelte-1kyb08q {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}
.shimmer.svelte-1kyb08q.svelte-1kyb08q::before {
  content: "";
  position: absolute;
  top: -20%;
  left: -60%;
  width: 220%;
  height: 140%;
  opacity: 0;
  background:
    linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 45%,
      rgba(255, 255, 255, 0.12) 50%,
      rgba(255, 255, 255, 0) 55%);
  filter: blur(10px);
  transform: translateX(-30%);
  -webkit-mask-image:
    linear-gradient(
      to right,
      transparent 0%,
      black 12%,
      black 88%,
      transparent 100%);
  mask-image:
    linear-gradient(
      to right,
      transparent 0%,
      black 12%,
      black 88%,
      transparent 100%);
}
.shimmer-on.svelte-1kyb08q.svelte-1kyb08q::before {
  animation: svelte-1kyb08q-shimmer-beam 4.5s ease-in-out 1200ms infinite;
}
@keyframes svelte-1kyb08q-shimmer-beam {
  0% {
    opacity: 0.0;
    transform: translateX(-30%);
  }
  15% {
    opacity: 0.28;
  }
  50% {
    opacity: 0.14;
    transform: translateX(30%);
  }
  85% {
    opacity: 0.28;
  }
  100% {
    opacity: 0.0;
    transform: translateX(90%);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/RecordsTerrainCard.esbuild-svelte-fake-css */
.terrain-card.svelte-1oeq6nm.svelte-1oeq6nm {
  max-height: 500px;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.35);
  color: #f3f6fb;
  background:
    linear-gradient(
      180deg,
      #1c1220,
      #0d0a12);
}
.terrain-card.svelte-1oeq6nm .sky.svelte-1oeq6nm {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      120% 80% at 50% -10%,
      #ffcf9c 0%,
      rgba(255, 159, 80, 0.9) 30%,
      rgba(129, 73, 165, 0.85) 60%,
      rgba(15, 10, 20, 1) 100%);
  opacity: 0;
  animation: svelte-1oeq6nm-skyIn 220ms ease-out forwards;
}
.revealed.svelte-1oeq6nm .sky.svelte-1oeq6nm {
  animation-delay: 0ms;
}
@keyframes svelte-1oeq6nm-skyIn {
  to {
    opacity: 1;
  }
}
.cliff.svelte-1oeq6nm.svelte-1oeq6nm {
  position: absolute;
  left: 0;
  right: 0;
  height: 80%;
  opacity: 0;
  filter: blur(0.2px);
}
.layer1.svelte-1oeq6nm.svelte-1oeq6nm {
  bottom: -40%;
  background:
    linear-gradient(
      180deg,
      rgba(145, 78, 44, 0.7),
      rgba(90, 45, 25, 0.7));
  clip-path: polygon(0% 20%, 15% 15%, 30% 19%, 45% 14%, 60% 18%, 75% 12%, 90% 15%, 100% 11%, 100% 100%, 0% 100%);
  animation: svelte-1oeq6nm-cliffIn 260ms 40ms ease-out forwards;
}
.layer2.svelte-1oeq6nm.svelte-1oeq6nm {
  bottom: -22%;
  background:
    linear-gradient(
      180deg,
      rgba(176, 100, 60, 0.6),
      rgba(120, 60, 35, 0.6));
  clip-path: polygon(0% 25%, 20% 20%, 35% 24%, 55% 18%, 75% 22%, 90% 17%, 100% 19%, 100% 100%, 0% 100%);
  animation: svelte-1oeq6nm-cliffIn 260ms 80ms ease-out forwards;
}
.layer3.svelte-1oeq6nm.svelte-1oeq6nm {
  bottom: -8%;
  background:
    linear-gradient(
      180deg,
      rgba(210, 140, 90, 0.65),
      rgba(140, 80, 50, 0.65));
  clip-path: polygon(0% 20%, 20% 15%, 40% 19%, 60% 14%, 80% 18%, 100% 13%, 100% 100%, 0% 100%);
  animation: svelte-1oeq6nm-cliffIn 260ms 120ms ease-out forwards;
}
@keyframes svelte-1oeq6nm-cliffIn {
  to {
    opacity: 1;
  }
}
.clouds.svelte-1oeq6nm.svelte-1oeq6nm {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      60% 30% at 30% 20%,
      rgba(255, 255, 255, 0.06),
      transparent 60%),
    radial-gradient(
      50% 30% at 70% 25%,
      rgba(255, 255, 255, 0.05),
      transparent 70%);
  opacity: 0;
  animation: svelte-1oeq6nm-cloudsIn 220ms 60ms ease-out forwards, svelte-1oeq6nm-drift 12s 1.5s linear infinite;
  pointer-events: none;
}
@keyframes svelte-1oeq6nm-cloudsIn {
  to {
    opacity: 1;
  }
}
@keyframes svelte-1oeq6nm-drift {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-8px);
  }
  100% {
    transform: translateX(0);
  }
}
.scene.svelte-1oeq6nm.svelte-1oeq6nm {
  position: relative;
  z-index: 2;
  display: block;
  margin-top: 8px;
  overflow: visible;
}
.road.svelte-1oeq6nm.svelte-1oeq6nm {
  fill: none;
  stroke: #f6f7fb;
  stroke-width: 6;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));
  stroke-dasharray: 600;
  stroke-dashoffset: 600;
}
.revealed.svelte-1oeq6nm .road.svelte-1oeq6nm {
  animation: svelte-1oeq6nm-drawRoad 2800ms 160ms cubic-bezier(0.22, 0.72, 0.25, 1) forwards;
}
@keyframes svelte-1oeq6nm-drawRoad {
  to {
    stroke-dashoffset: 0;
  }
}
.marker.svelte-1oeq6nm.svelte-1oeq6nm {
  fill: #ffd074;
  opacity: 0;
}
.revealed.svelte-1oeq6nm .marker.svelte-1oeq6nm {
  animation: svelte-1oeq6nm-markerPop 960ms 880ms ease-out forwards;
}
@keyframes svelte-1oeq6nm-markerPop {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.rider.svelte-1oeq6nm .rider-dot.svelte-1oeq6nm {
  fill: #ffefcf;
  stroke: rgba(0, 0, 0, 0.25);
  stroke-width: 1;
  filter: drop-shadow(0 0 6px rgba(255, 239, 207, 0.55));
}
.rider.svelte-1oeq6nm .rider-icon.svelte-1oeq6nm {
  font-size: 26px;
}
.rider.svelte-1oeq6nm.svelte-1oeq6nm {
  opacity: 0;
}
.revealed.svelte-1oeq6nm .rider.svelte-1oeq6nm {
  animation: svelte-1oeq6nm-riderIn 880ms 200ms ease-out forwards;
}
@keyframes svelte-1oeq6nm-riderIn {
  to {
    opacity: 1;
  }
}
.highway-sign.svelte-1oeq6nm .board.svelte-1oeq6nm {
  fill: #1f6d3e;
  stroke: #e8f5e9;
  stroke-width: 2;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}
.highway-sign.svelte-1oeq6nm .board-title.svelte-1oeq6nm {
  font:
    700 12px/1.2 system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  fill: #e8f5e9;
  letter-spacing: 0.3px;
}
.highway-sign.svelte-1oeq6nm .board-value.svelte-1oeq6nm {
  font:
    800 14px/1.2 system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  fill: #ffffff;
}
.highway-sign.svelte-1oeq6nm .post.svelte-1oeq6nm {
  fill: #6d5a43;
}
.highway-sign.svelte-1oeq6nm .board-in.svelte-1oeq6nm {
  transform-origin: 220px 124px;
  transform-box: fill-box;
  opacity: 0;
}
.revealed.svelte-1oeq6nm .highway-sign .board-in.svelte-1oeq6nm {
  animation: svelte-1oeq6nm-signIn 1040ms 1500ms cubic-bezier(0.22, 0.72, 0.25, 1) forwards;
}
@keyframes svelte-1oeq6nm-signIn {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
  60% {
    opacity: 1;
    transform: translateY(0) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.warn-sign.svelte-1oeq6nm .warn-board.svelte-1oeq6nm {
  fill: #ffd35a;
  stroke: #7a4e00;
  stroke-width: 2;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}
.warn-sign.svelte-1oeq6nm .warn-post.svelte-1oeq6nm {
  fill: #6d5a43;
}
.warn-sign.svelte-1oeq6nm .warn-value.svelte-1oeq6nm {
  font:
    800 12px/1.2 system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  fill: #2a1a00;
}
.warn-sign.svelte-1oeq6nm .warn-plate.svelte-1oeq6nm {
  fill: #ffd35a;
  stroke: #7a4e00;
  stroke-width: 2;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}
.warn-sign.svelte-1oeq6nm .warn-plate-text.svelte-1oeq6nm {
  font:
    700 10px/1.2 system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  fill: #2a1a00;
  letter-spacing: 0.2px;
}
.warn-sign.svelte-1oeq6nm .warn-tilt.svelte-1oeq6nm {
  opacity: 0;
  transform-origin: 0 0;
}
.revealed.svelte-1oeq6nm .warn-sign .warn-tilt.svelte-1oeq6nm {
  animation: svelte-1oeq6nm-warnIn 1200ms 1000ms cubic-bezier(0.22, 0.72, 0.25, 1) forwards;
}
@keyframes svelte-1oeq6nm-warnIn {
  0% {
    opacity: 0;
    transform: translateY(6px) rotate(-10deg) scale(0.96);
  }
  60% {
    opacity: 1;
    transform: translateY(0) rotate(6deg) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) rotate(0) scale(1);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TrainingPlanRestCard.esbuild-svelte-fake-css */
.hang-swing.svelte-1cy270i {
  animation: svelte-1cy270i-swing 1400ms ease-in-out 200ms 1 both;
}
@keyframes svelte-1cy270i-swing {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(8deg);
  }
  45% {
    transform: rotate(-6deg);
  }
  65% {
    transform: rotate(3deg);
  }
  85% {
    transform: rotate(-1.5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.zz.svelte-1cy270i {
  position: relative;
  display: inline-block;
  font-weight: 700;
}
.zz.svelte-1cy270i::after {
  content: "z";
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.2;
}
.zz.svelte-1cy270i {
  animation: svelte-1cy270i-drift 4s ease-in-out infinite;
}
.zz.delay-150.svelte-1cy270i {
  animation-delay: 150ms;
}
.zz.delay-300.svelte-1cy270i {
  animation-delay: 300ms;
}
@keyframes svelte-1cy270i-drift {
  0% {
    transform: translateY(0) translateX(0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  100% {
    transform: translateY(-22px) translateX(6px);
    opacity: 0;
  }
}
.draw.svelte-1cy270i {
  opacity: 1 !important;
  stroke-dasharray: 460;
  stroke-dashoffset: 460;
  animation: svelte-1cy270i-pathdraw 1400ms ease-out 300ms forwards;
}
@keyframes svelte-1cy270i-pathdraw {
  to {
    stroke-dashoffset: 0;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TrainingPlanAdherenceCard.esbuild-svelte-fake-css */
.stamp.svelte-1692h9w {
  opacity: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 12px;
  transform: rotate(-4deg);
  color: #fff;
  font-family: "Impact", sans-serif;
  inset: -2px;
  border: 2px solid rgba(255, 255, 255, 0.92);
  border-radius: 2px;
}
.stamp-long.svelte-1692h9w {
  margin-left: 24px;
  margin-right: auto;
}
.stamp-short.svelte-1692h9w {
  margin-left: auto;
  margin-right: 24px;
}
.stamp-title.svelte-1692h9w {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  opacity: 0.98;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.35);
}
.stamp-number.svelte-1692h9w {
  color: #c4fdc4;
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 42px;
  line-height: 1;
  letter-spacing: 0.02em;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.42), 0 0 12px rgba(255, 255, 255, 0.16);
}
.stamp-number.small.svelte-1692h9w {
  color: #fcb3b3;
  font-size: 30px;
}
.stamp.svelte-1692h9w::before {
  content: "";
  position: absolute;
  inset: 2px;
  border: 1px solid rgba(255, 255, 255, 0.92);
  border-radius: 1px;
  opacity: 0.9;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.6) inset;
}
.stamp-in.svelte-1692h9w {
  animation: svelte-1692h9w-stampdrop 720ms cubic-bezier(0.22, 0.95, 0.4, 1) var(--delay, 500ms) both;
}
.stamp-in.svelte-1692h9w::before {
  animation: svelte-1692h9w-ringflash 520ms ease-out var(--delay, 500ms) both;
}
.stamp-in.svelte-1692h9w::after {
  animation: svelte-1692h9w-scufffade 900ms ease-out var(--delay, 500ms) both;
}
@keyframes svelte-1692h9w-stampdrop {
  0% {
    transform: translateY(-24px) scale(0.92) rotate(-14deg);
    opacity: 0;
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.0));
  }
  45% {
    transform: translateY(0) scale(1.08) rotate(-6deg);
    opacity: 1;
    filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.52));
  }
  70% {
    transform: translateY(0) scale(0.96, 0.98) rotate(-7deg);
    opacity: 0.9;
  }
  100% {
    transform: translateY(0) scale(1.0) rotate(-6deg);
    opacity: 0.9;
  }
}
@keyframes svelte-1692h9w-ringflash {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.0) inset;
  }
  50% {
    box-shadow: 0 0 12px 2px rgba(255, 255, 255, 0.55) inset;
  }
  100% {
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.65) inset;
  }
}
@keyframes svelte-1692h9w-scufffade {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.35;
  }
}
.hole.svelte-1692h9w {
  transform: scale(0.6);
  opacity: 0;
}
.hole-pop.svelte-1692h9w {
  animation: svelte-1692h9w-holepop 400ms ease-out calc(200ms + (var(--i) * 60ms)) both;
}
@keyframes svelte-1692h9w-holepop {
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.grow-in.svelte-1692h9w {
  animation: svelte-1692h9w-widthgrow 900ms ease-out 300ms both;
}
@keyframes svelte-1692h9w-widthgrow {
  from {
    width: 0%;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TrainingPlanStreakCard.esbuild-svelte-fake-css */
.dashdraw.svelte-1b2r2m2 {
  opacity: 1 !important;
  stroke-dasharray: 520;
  stroke-dashoffset: 520;
  animation: svelte-1b2r2m2-dash 1200ms ease-out 200ms forwards;
}
@keyframes svelte-1b2r2m2-dash {
  to {
    stroke-dashoffset: 0;
  }
}
.green-dot.svelte-1b2r2m2 {
  opacity: 0;
}
.pip-pop.svelte-1b2r2m2 {
  transform-box: fill-box;
  transform-origin: center;
  transform: scale(0.8);
  opacity: 0;
  animation: svelte-1b2r2m2-pip 400ms ease-out calc(200ms + (var(--i) * 60ms)) both;
}
@keyframes svelte-1b2r2m2-pip {
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.comet.svelte-1b2r2m2 {
  offset-path: path("M 6 180 C 40 90, 120 80, 170 140 S 250 210, 294 60");
  offset-distance: 0%;
  animation: svelte-1b2r2m2-race 1400ms ease-in-out 300ms both;
  filter: drop-shadow(0 0 6px rgba(94, 230, 232, 0.55));
}
@keyframes svelte-1b2r2m2-race {
  to {
    offset-distance: 100%;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/GroupActivitiesCard.esbuild-svelte-fake-css */
.group.svelte-1dzh7yw.svelte-1dzh7yw {
  --accent:#FF6B6B;
  --accent-rgb:255,107,107;
}
.card-bg.svelte-1dzh7yw.svelte-1dzh7yw {
  background:
    radial-gradient(
      circle at 12px 12px,
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px),
    radial-gradient(
      circle at 36px 24px,
      rgba(255, 255, 255, 0.04) 1px,
      transparent 1px),
    radial-gradient(
      circle at 18px 36px,
      rgba(255, 255, 255, 0.03) 1px,
      transparent 1px),
    repeating-linear-gradient(
      45deg,
      rgba(var(--accent-rgb), 0.035) 0 6px,
      rgba(var(--accent-rgb), 0) 6px 14px),
    radial-gradient(
      120% 80% at 0% 0%,
      rgba(var(--accent-rgb), 0.09) 0%,
      rgba(0, 0, 0, 0) 60%),
    radial-gradient(
      100% 90% at 100% 100%,
      rgba(155, 93, 229, 0.07) 0%,
      rgba(0, 0, 0, 0) 55%),
    linear-gradient(
      180deg,
      #0a151a 0%,
      #0d1f26 55%,
      #0a1418 100%);
  background-size:
    48px 48px,
    48px 48px,
    48px 48px,
    auto,
    auto,
    auto,
    auto;
}
.peloton.svelte-1dzh7yw.svelte-1dzh7yw {
  width: 100%;
  height: 100%;
  background-image:
    radial-gradient(
      circle at 20% 60%,
      rgba(255, 255, 255, 0.25) 2px,
      transparent 3px),
    radial-gradient(
      circle at 40% 40%,
      rgba(255, 255, 255, 0.25) 2px,
      transparent 3px),
    radial-gradient(
      circle at 60% 55%,
      rgba(255, 255, 255, 0.25) 2px,
      transparent 3px),
    radial-gradient(
      circle at 80% 35%,
      rgba(255, 255, 255, 0.25) 2px,
      transparent 3px),
    radial-gradient(
      circle at 30% 70%,
      rgba(255, 255, 255, 0.25) 2px,
      transparent 3px),
    radial-gradient(
      circle at 70% 30%,
      rgba(255, 255, 255, 0.25) 2px,
      transparent 3px);
  background-size: 100% 100%;
  opacity: 0.8;
}
@keyframes svelte-1dzh7yw-pelotonDriftLeft {
  0% {
    transform: translateX(0px) translateY(0px);
  }
  50% {
    transform: translateX(-8px) translateY(-2px);
  }
  100% {
    transform: translateX(0px) translateY(0px);
  }
}
@keyframes svelte-1dzh7yw-pelotonDriftRight {
  0% {
    transform: translateX(0px) translateY(0px);
  }
  50% {
    transform: translateX(10px) translateY(2px);
  }
  100% {
    transform: translateX(0px) translateY(0px);
  }
}
.animate-peloton-left.svelte-1dzh7yw.svelte-1dzh7yw {
  animation: svelte-1dzh7yw-pelotonDriftLeft 5s ease-in-out infinite;
}
.animate-peloton-right.svelte-1dzh7yw.svelte-1dzh7yw {
  animation: svelte-1dzh7yw-pelotonDriftRight 6s ease-in-out infinite;
}
.ribbon.svelte-1dzh7yw.svelte-1dzh7yw {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 8px 12px;
  color: #d9e7ea;
  transform: translateY(8px);
  opacity: 0;
}
.ribbon.svelte-1dzh7yw.svelte-1dzh7yw::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background:
    linear-gradient(
      90deg,
      rgba(var(--accent-rgb), 0.16),
      rgba(var(--accent-rgb), 0.08) 60%,
      rgba(var(--accent-rgb), 0.02));
  clip-path: polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%);
}
.ribbon-left.svelte-1dzh7yw.svelte-1dzh7yw::before {
  clip-path: polygon(0% 0%, 90% 0%, 95% 50%, 90% 100%, 0% 100%);
}
.ribbon-right.svelte-1dzh7yw.svelte-1dzh7yw::before {
  clip-path: polygon(5% 0%, 100% 0%, 100% 100%, 5% 100%, 0% 50%);
}
.ribbon-label.svelte-1dzh7yw.svelte-1dzh7yw {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.85;
  position: relative;
}
.ribbon-value.svelte-1dzh7yw.svelte-1dzh7yw {
  font-size: 20px;
  font-weight: 800;
  color: var(--accent);
  position: relative;
  letter-spacing: 0.02em;
}
.ribbon-unit.svelte-1dzh7yw.svelte-1dzh7yw {
  font-size: 11px;
  opacity: 0.8;
  position: relative;
}
@keyframes svelte-1dzh7yw-ribbonInLeft {
  0% {
    transform: translateX(-16px) translateY(8px) scale(0.98);
    opacity: 0;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    opacity: 1;
  }
}
@keyframes svelte-1dzh7yw-ribbonInRight {
  0% {
    transform: translateX(16px) translateY(8px) scale(0.98);
    opacity: 0;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    opacity: 1;
  }
}
.ribbon-in.svelte-1dzh7yw.svelte-1dzh7yw {
  animation-duration: 650ms;
  animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
  animation-fill-mode: forwards;
  animation-delay: var(--delay, 0ms);
}
.ribbon-left.ribbon-in.svelte-1dzh7yw.svelte-1dzh7yw {
  animation-name: svelte-1dzh7yw-ribbonInLeft;
}
.ribbon-right.ribbon-in.svelte-1dzh7yw.svelte-1dzh7yw {
  animation-name: svelte-1dzh7yw-ribbonInRight;
}
.divider.svelte-1dzh7yw.svelte-1dzh7yw {
  height: 1px;
  margin: 2px 8px;
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.12),
      rgba(255, 255, 255, 0));
}
.map-frame.svelte-1dzh7yw.svelte-1dzh7yw {
  position: relative;
  opacity: 0;
}
.map-overlay.svelte-1dzh7yw.svelte-1dzh7yw {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      60% 60% at 50% 50%,
      rgba(0, 0, 0, 0.18) 0%,
      rgba(0, 0, 0, 0.0) 70%);
  pointer-events: none;
}
@keyframes svelte-1dzh7yw-mapIn {
  0% {
    transform: scale(0.96) translateY(10px);
    opacity: 0;
  }
  100% {
    transform: scale(1.0) translateY(0px);
    opacity: 1;
  }
}
.map-in.svelte-1dzh7yw img.svelte-1dzh7yw {
  transform-origin: 50% 50%;
}
.map-in.svelte-1dzh7yw.svelte-1dzh7yw {
  animation: svelte-1dzh7yw-mapIn 900ms cubic-bezier(0.22, 0.72, 0.25, 1) forwards;
  animation-delay: 150ms;
}
.img-pop-in.svelte-1dzh7yw.svelte-1dzh7yw {
  transform-origin: center center;
  animation: svelte-1dzh7yw-img-pop-in-key 800ms ease-out both;
}
.map-frame.svelte-1dzh7yw img.svelte-1dzh7yw {
  opacity: 0;
}
@keyframes svelte-1dzh7yw-img-pop-in-key {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.06);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.meta-line.svelte-1dzh7yw.svelte-1dzh7yw {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d9e7ea;
  transform: translateY(8px);
  opacity: 0;
}
@keyframes svelte-1dzh7yw-flowIn {
  0% {
    transform: translateY(8px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
.flow-in.svelte-1dzh7yw.svelte-1dzh7yw {
  animation: svelte-1dzh7yw-flowIn 560ms ease-out forwards;
  animation-delay: var(--delay, 0ms);
}
.peloton-strip.svelte-1dzh7yw.svelte-1dzh7yw {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6px;
  display: flex;
  gap: 18px;
  justify-content: center;
  align-items: center;
  opacity: 0.18;
  pointer-events: none;
}
.peloton-bike.svelte-1dzh7yw.svelte-1dzh7yw {
  color: var(--accent);
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.35));
  animation: svelte-1dzh7yw-bike-glide linear infinite;
}
@keyframes svelte-1dzh7yw-bike-glide {
  0% {
    transform: translateX(300px) translateY(0) scale(1);
  }
  100% {
    transform: translateX(-300px) translateY(0) scale(1);
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/TotalDistanceCard.esbuild-svelte-fake-css */
.passport-paper.svelte-92rqkk.svelte-92rqkk {
  --paper:#f8f6ef;
  --ink-a:165,
    198,
    225;
  --ink-b:255,
    215,
    161;
  background-color: var(--paper);
  position: relative;
  background-image:
    radial-gradient(
      140% 120% at 20% 20%,
      rgba(255, 255, 255, 0.65) 0%,
      rgba(255, 255, 255, 0.38) 55%,
      rgba(0, 0, 0, 0.06) 100%),
    repeating-linear-gradient(
      32deg,
      rgba(var(--ink-a), 0.06) 0 1px,
      transparent 1px 7px),
    repeating-linear-gradient(
      -32deg,
      rgba(var(--ink-b), 0.06) 0 1px,
      transparent 1px 7px);
}
.passport-paper.svelte-92rqkk.svelte-92rqkk::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: radial-gradient(rgba(0, 0, 0, 0.2) 1px, transparent 1px);
  background-size: 3px 3px;
  opacity: 0.45;
  mix-blend-mode: multiply;
}
.passport-paper.svelte-92rqkk .watermark.svelte-92rqkk {
  position: absolute;
  left: clamp(0.75rem, 3vw, 1.25rem);
  top: clamp(0.5rem, 3vw, 1rem);
  width: clamp(10rem, 28vw, 20rem);
  height: clamp(10rem, 28vw, 20rem);
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.25;
  filter: blur(0.4px);
  mix-blend-mode: multiply;
  background-image:
    repeating-conic-gradient(
      from 0deg,
      rgba(var(--ink-a), 0.08) 0deg 10deg,
      rgba(var(--ink-b), 0.08) 10deg 20deg);
  -webkit-mask-image:
    radial-gradient(
      circle at 50% 50%,
      transparent 0% 28%,
      black 30% 62%,
      transparent 70% 100%);
  mask-image:
    radial-gradient(
      circle at 50% 50%,
      transparent 0% 28%,
      black 30% 62%,
      transparent 70% 100%);
}
.passport-paper.svelte-92rqkk .grid.svelte-92rqkk {
  gap: 0.5rem;
}
.passport-stamp.svelte-92rqkk.svelte-92rqkk {
  opacity: 0;
}
.passport-stamp-in.svelte-92rqkk.svelte-92rqkk {
  animation: svelte-92rqkk-stampdrop 720ms cubic-bezier(0.22, 0.95, 0.4, 1) var(--delay, 500ms) both;
}
@keyframes svelte-92rqkk-stampdrop {
  0% {
    transform: translateY(-24px) scale(0.92) rotate(calc(var(--rotation, -6deg) - 8deg));
    opacity: 0;
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.0));
  }
  45% {
    transform: translateY(0) scale(1.08) rotate(var(--rotation, -6deg));
    opacity: 1;
    filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.52));
  }
  70% {
    transform: translateY(0) scale(0.96, 0.98) rotate(calc(var(--rotation, -6deg) - 1deg));
    opacity: 0.9;
  }
  100% {
    transform: translateY(0) scale(1.0) rotate(var(--rotation, -6deg));
    opacity: 0.9;
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/GlobalAverageSignatureCard.esbuild-svelte-fake-css */
.card-shell.svelte-tp8c61 {
  position: relative;
}
.card-inner.svelte-tp8c61 {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.06), 0 14px 28px rgba(0, 0, 0, 0.35);
  background:
    linear-gradient(
      135deg,
      rgba(12, 14, 18, 0.95) 0%,
      rgba(14, 16, 20, 0.96) 35%,
      rgba(18, 20, 26, 0.96) 100%),
    radial-gradient(
      120px 160px at 20% 15%,
      rgba(255, 255, 255, 0.06),
      transparent 60%),
    radial-gradient(
      120px 160px at 80% 90%,
      rgba(255, 255, 255, 0.04),
      transparent 60%);
  outline: 1px solid rgba(255, 255, 255, 0.05);
}
.drop-in.svelte-tp8c61 {
  animation: svelte-tp8c61-drop-in 520ms ease-out both;
}
@keyframes svelte-tp8c61-drop-in {
  0% {
    opacity: 0;
    transform: translateY(3px) scale(0.98);
  }
  60% {
    opacity: 1;
    transform: translateY(-1px) scale(1.01);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.glow-lines.svelte-tp8c61 {
  position: absolute;
  inset: 0;
  pointer-events: none;
  will-change: transform;
}
.glow-lines.svelte-tp8c61::before,
.glow-lines.svelte-tp8c61::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      140deg,
      rgba(94, 230, 232, 0.18) 0%,
      rgba(94, 230, 232, 0.05) 35%,
      transparent 65%),
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.05) 0px,
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px,
      transparent 6px);
  mix-blend-mode: screen;
  filter: blur(0.2px);
}
.glow-lines.svelte-tp8c61::after {
  background:
    linear-gradient(
      30deg,
      rgba(124, 250, 198, 0.22) 0%,
      rgba(124, 250, 198, 0.06) 35%,
      transparent 70%),
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.04) 0px,
      rgba(255, 255, 255, 0.04) 1px,
      transparent 1px,
      transparent 10px);
  opacity: 0.8;
}
.woven.svelte-tp8c61 {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.018) 0 12px,
      rgba(255, 255, 255, 0.03) 12px 24px,
      rgba(255, 255, 255, 0.018) 24px 36px);
  opacity: 0.7;
}
.header.svelte-tp8c61 {
  height: 60px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title.svelte-tp8c61 {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.legend.svelte-tp8c61 {
  display: flex;
  gap: 8px;
  align-items: center;
}
.chip.svelte-tp8c61 {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 0.85rem;
  padding: 6px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.dot.svelte-tp8c61 {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.12);
}
.metric-block.svelte-tp8c61 {
  position: relative;
  padding: 10px 14px;
}
.label-row.svelte-tp8c61 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 2px;
}
.label.svelte-tp8c61 {
  font-weight: 700;
  opacity: 0.95;
}
.delta-chip.svelte-tp8c61 {
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid;
  background: rgba(255, 255, 255, 0.04);
}
.grid-bg.svelte-tp8c61 {
  position: absolute;
  inset: 42px 14px 26px 14px;
  border-radius: 10px;
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.02),
      rgba(255, 255, 255, 0.01)),
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.06) 0 1px,
      transparent 1px 38px);
  opacity: 0.35;
}
.bars.svelte-tp8c61 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0px;
}
.bar-row.svelte-tp8c61 {
  position: relative;
  height: 13px;
}
.bar.svelte-tp8c61 {
  position: absolute;
  left: 14px;
  right: 14px;
  height: 100%;
  min-width: 13px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 0 8px rgba(255, 255, 255, 0.06);
}
.bar.svelte-tp8c61::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0%;
  border-radius: 999px;
  background:
    linear-gradient(
      90deg,
      var(--bar-clr),
      color-mix(in srgb, var(--bar-clr), white 12%));
  box-shadow: 0 0 8px color-mix(in srgb, var(--bar-clr), white 24%);
  transition: width 560ms ease-out;
  width: var(--target, 0%);
}
.end-label.svelte-tp8c61 {
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
}
.global.svelte-tp8c61 {
  filter: saturate(90%);
}
.you.svelte-tp8c61 {
  filter: saturate(100%);
}
.bar.svelte-tp8c61:not(.last-year)::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0%;
  border-radius: 999px;
  background:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.3) 0px,
      rgba(255, 255, 255, 0.3) 2px,
      transparent 2px,
      transparent 8px);
  transition: width 560ms ease-out;
  width: var(--target, 0%);
}
.tooltip.svelte-tp8c61 {
  position: absolute;
  left: -18px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  opacity: 0.7;
}
.footer.svelte-tp8c61 {
  height: 34px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  opacity: 0.9;
}
.note.svelte-tp8c61 {
  opacity: 0.85;
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/BreakThroughsCard.esbuild-svelte-fake-css */
.vignette.svelte-1gbjiv2 {
  box-shadow: inset 0 0 120px rgba(0, 0, 0, 0.6);
}
.stars.svelte-1gbjiv2::before {
  content: "";
  position: absolute;
  inset: 0;
  background: transparent;
  box-shadow:
    10px 20px 0 0 rgba(255, 255, 255, 0.15),
    60px 40px 0 0 rgba(255, 255, 255, 0.10),
    120px 80px 0 0 rgba(255, 255, 255, 0.12),
    160px 30px 0 0 rgba(255, 255, 255, 0.08),
    200px 110px 0 0 rgba(255, 255, 255, 0.10),
    260px 70px 0 0 rgba(255, 255, 255, 0.14);
}
.trophy.svelte-1gbjiv2 {
  overflow: hidden;
}
.shine.svelte-1gbjiv2 {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(
      120deg,
      transparent 20%,
      rgba(255, 255, 255, 0.6) 35%,
      transparent 50%);
  transform: translateX(-100%);
  animation: svelte-1gbjiv2-shine-sweep 1200ms ease-out both;
  opacity: 0.7;
}
@keyframes svelte-1gbjiv2-shine-sweep {
  0% {
    transform: translateX(-120%);
    opacity: 0;
  }
  15% {
    opacity: 0.7;
  }
  60% {
    opacity: 0.5;
  }
  100% {
    transform: translateX(120%);
    opacity: 0;
  }
}
.orbit.svelte-1gbjiv2 {
  position: absolute;
  border-radius: 9999px;
  border: 1px dashed rgba(255, 255, 255, 0.18);
}
.orbit-1.svelte-1gbjiv2 {
  width: 180px;
  height: 180px;
  animation: svelte-1gbjiv2-orbit-rotate 12s linear infinite;
}
.orbit-2.svelte-1gbjiv2 {
  width: 210px;
  height: 210px;
  animation: svelte-1gbjiv2-orbit-rotate 18s linear infinite reverse;
}
@keyframes svelte-1gbjiv2-orbit-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.gold-glow.svelte-1gbjiv2 {
  box-shadow: 0 0 18px 6px rgba(255, 215, 0, 0.45) inset, 0 0 28px rgba(255, 215, 0, 0.35);
  animation: svelte-1gbjiv2-glow-pulse 2.2s ease-in-out infinite;
}
@keyframes svelte-1gbjiv2-glow-pulse {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}
.counter-chip.svelte-1gbjiv2 {
  display: grid;
  grid-template-columns: 24px 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 9999px;
  backdrop-filter: blur(6px);
}
.chip-icon.svelte-1gbjiv2 {
  display: grid;
  place-items: center;
}
.chip-label.svelte-1gbjiv2 {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}
.chip-value.svelte-1gbjiv2 {
  font-weight: 700;
  font-size: 14px;
  color: #fff;
}
.confetti.svelte-1gbjiv2 {
  position: absolute;
  width: 6px;
  height: 10px;
  left: calc(var(--x) * 1%);
  top: calc(var(--y) * 1%);
  background: hsl(var(--h), var(--s), 60%);
  transform: translate(calc(var(--dx) * 1px), calc(var(--dy) * 1px)) rotate(var(--rot));
  animation: svelte-1gbjiv2-confetti-fall 900ms ease-out forwards;
  border-radius: 2px;
}
@keyframes svelte-1gbjiv2-confetti-fall {
  0% {
    opacity: 1;
    transform: translate(0, 0) rotate(0deg);
  }
  100% {
    opacity: 0;
    transform: translate(var(--dx), var(--dy)) rotate(var(--rot));
  }
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/GlobalAverageOtherCard.esbuild-svelte-fake-css */
.card-shell.svelte-95lmt5 {
  position: relative;
}
.card-inner.svelte-95lmt5 {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.06), 0 14px 28px rgba(0, 0, 0, 0.35);
  background:
    linear-gradient(
      135deg,
      rgba(12, 14, 18, 0.95) 0%,
      rgba(14, 16, 20, 0.96) 35%,
      rgba(18, 20, 26, 0.96) 100%),
    radial-gradient(
      120px 160px at 20% 15%,
      rgba(255, 255, 255, 0.06),
      transparent 60%),
    radial-gradient(
      120px 160px at 80% 90%,
      rgba(255, 255, 255, 0.04),
      transparent 60%);
  outline: 1px solid rgba(255, 255, 255, 0.05);
}
.drop-in.svelte-95lmt5 {
  animation: svelte-95lmt5-drop-in 520ms ease-out both;
}
@keyframes svelte-95lmt5-drop-in {
  0% {
    opacity: 0;
    transform: translateY(3px) scale(0.98);
  }
  60% {
    opacity: 1;
    transform: translateY(-1px) scale(1.01);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.glow-lines.svelte-95lmt5 {
  position: absolute;
  inset: 0;
  pointer-events: none;
  will-change: transform;
}
.glow-lines.svelte-95lmt5::before,
.glow-lines.svelte-95lmt5::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      140deg,
      rgba(94, 230, 232, 0.18) 0%,
      rgba(94, 230, 232, 0.05) 35%,
      transparent 65%),
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.05) 0px,
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px,
      transparent 6px);
  mix-blend-mode: screen;
  filter: blur(0.2px);
}
.glow-lines.svelte-95lmt5::after {
  background:
    linear-gradient(
      30deg,
      rgba(124, 250, 198, 0.22) 0%,
      rgba(124, 250, 198, 0.06) 35%,
      transparent 70%),
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.04) 0px,
      rgba(255, 255, 255, 0.04) 1px,
      transparent 1px,
      transparent 10px);
  opacity: 0.8;
}
.woven.svelte-95lmt5 {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.018) 0 12px,
      rgba(255, 255, 255, 0.03) 12px 24px,
      rgba(255, 255, 255, 0.018) 24px 36px);
  opacity: 0.7;
}
.header.svelte-95lmt5 {
  height: 60px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title.svelte-95lmt5 {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.legend.svelte-95lmt5 {
  display: flex;
  gap: 8px;
  align-items: center;
}
.chip.svelte-95lmt5 {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 0.85rem;
  padding: 6px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.dot.svelte-95lmt5 {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.12);
}
.metric-block.svelte-95lmt5 {
  position: relative;
  padding: 10px 14px;
}
.label-row.svelte-95lmt5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 2px;
}
.label.svelte-95lmt5 {
  font-weight: 700;
  opacity: 0.95;
}
.delta-chip.svelte-95lmt5 {
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid;
  background: rgba(255, 255, 255, 0.04);
}
.grid-bg.svelte-95lmt5 {
  position: absolute;
  inset: 42px 14px 26px 14px;
  border-radius: 10px;
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.02),
      rgba(255, 255, 255, 0.01)),
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.06) 0 1px,
      transparent 1px 38px);
  opacity: 0.35;
}
.bars.svelte-95lmt5 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0px;
}
.bar-row.svelte-95lmt5 {
  position: relative;
  height: 13px;
}
.bar-row.big.svelte-95lmt5 {
  height: 26px;
}
.bar.svelte-95lmt5 {
  position: absolute;
  left: 14px;
  right: 14px;
  height: 100%;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 0 8px rgba(255, 255, 255, 0.06);
}
.bar.svelte-95lmt5::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0%;
  border-radius: 999px;
  background:
    linear-gradient(
      90deg,
      var(--bar-clr),
      color-mix(in srgb, var(--bar-clr), white 12%));
  box-shadow: 0 0 8px color-mix(in srgb, var(--bar-clr), white 24%);
  transition: width 560ms ease-out;
  width: var(--target, 0%);
}
.end-label.svelte-95lmt5 {
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
}
.global.svelte-95lmt5 {
  filter: saturate(90%);
}
.you.svelte-95lmt5 {
  filter: saturate(100%);
}
.bar.last-year.svelte-95lmt5 {
  opacity: 0.8;
}
.bar.svelte-95lmt5:not(.last-year)::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0%;
  border-radius: 999px;
  background:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.3) 0px,
      rgba(255, 255, 255, 0.3) 2px,
      transparent 2px,
      transparent 8px);
  transition: width 560ms ease-out;
  width: var(--target, 0%);
}
.tooltip.svelte-95lmt5 {
  position: absolute;
  left: -18px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  opacity: 0.7;
}
.footer.svelte-95lmt5 {
  height: 34px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  opacity: 0.9;
}
.note.svelte-95lmt5 {
  opacity: 0.85;
}

/* fakecss:/home/forge/alpha/svelte-components/src/YearlyReport/YearlyReport.esbuild-svelte-fake-css */
.montserrat.svelte-rvl0xm {
  font-family: "Montserrat", sans-serif;
}
.pop-in.svelte-rvl0xm {
  transform-origin: center center;
  animation: svelte-rvl0xm-pop-in-key 500ms ease-out both;
}
@keyframes svelte-rvl0xm-pop-in-key {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.card-hidden.svelte-rvl0xm {
  opacity: 0;
}
.fade-in.svelte-rvl0xm {
  animation: svelte-rvl0xm-fade-in-key 1000ms ease-out both;
}
@keyframes svelte-rvl0xm-fade-in-key {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fade-out.svelte-rvl0xm {
  animation: svelte-rvl0xm-fade-out-key 1000ms ease-out both;
}
@keyframes svelte-rvl0xm-fade-out-key {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
/*! Bundled license information:

cropperjs/dist/cropper.css:
  (*!
   * Cropper.js v1.6.2
   * https://fengyuanchen.github.io/cropperjs
   *
   * Copyright 2015-present Chen Fengyuan
   * Released under the MIT license
   *
   * Date: 2024-04-21T07:43:02.731Z
   *)
*/
/*# sourceMappingURL=main.css.map */
